var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var src = {exports: {}};

var konva = {exports: {}};

var hasRequiredKonva;

function requireKonva () {
	if (hasRequiredKonva) return konva.exports;
	hasRequiredKonva = 1;
	(function (module, exports) {
		(function (global, factory) {
		  module.exports = factory() ;
		})(commonjsGlobal, (function () {
		  /*
		   * Konva JavaScript Framework v9.2.2
		   * http://konvajs.org/
		   * Licensed under the MIT
		   * Date: Mon Oct 09 2023
		   *
		   * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
		   * Modified work Copyright (C) 2014 - present by Anton Lavrenov (Konva)
		   *
		   * @license
		   */
		  const PI_OVER_180 = Math.PI / 180;
		  /**
		   * @namespace Konva
		   */
		  function detectBrowser() {
		      return (typeof window !== 'undefined' &&
		          // browser case
		          ({}.toString.call(window) === '[object Window]' ||
		              // electron case
		              {}.toString.call(window) === '[object global]'));
		  }
		  const glob = typeof commonjsGlobal !== 'undefined'
		      ? commonjsGlobal
		      : typeof window !== 'undefined'
		          ? window
		          : typeof WorkerGlobalScope !== 'undefined'
		              ? self
		              : {};
		  const Konva$2 = {
		      _global: glob,
		      version: '9.2.2',
		      isBrowser: detectBrowser(),
		      isUnminified: /param/.test(function (param) { }.toString()),
		      dblClickWindow: 400,
		      getAngle(angle) {
		          return Konva$2.angleDeg ? angle * PI_OVER_180 : angle;
		      },
		      enableTrace: false,
		      pointerEventsEnabled: true,
		      /**
		       * Should Konva automatically update canvas on any changes. Default is true.
		       * @property autoDrawEnabled
		       * @default true
		       * @name autoDrawEnabled
		       * @memberof Konva
		       * @example
		       * Konva.autoDrawEnabled = true;
		       */
		      autoDrawEnabled: true,
		      /**
		       * Should we enable hit detection while dragging? For performance reasons, by default it is false.
		       * But on some rare cases you want to see hit graph and check intersections. Just set it to true.
		       * @property hitOnDragEnabled
		       * @default false
		       * @name hitOnDragEnabled
		       * @memberof Konva
		       * @example
		       * Konva.hitOnDragEnabled = true;
		       */
		      hitOnDragEnabled: false,
		      /**
		       * Should we capture touch events and bind them to the touchstart target? That is how it works on DOM elements.
		       * The case: we touchstart on div1, then touchmove out of that element into another element div2.
		       * DOM will continue trigger touchmove events on div1 (not div2). Because events are "captured" into initial target.
		       * By default Konva do not do that and will trigger touchmove on another element, while pointer is moving.
		       * @property capturePointerEventsEnabled
		       * @default false
		       * @name capturePointerEventsEnabled
		       * @memberof Konva
		       * @example
		       * Konva.capturePointerEventsEnabled = true;
		       */
		      capturePointerEventsEnabled: false,
		      _mouseListenClick: false,
		      _touchListenClick: false,
		      _pointerListenClick: false,
		      _mouseInDblClickWindow: false,
		      _touchInDblClickWindow: false,
		      _pointerInDblClickWindow: false,
		      _mouseDblClickPointerId: null,
		      _touchDblClickPointerId: null,
		      _pointerDblClickPointerId: null,
		      /**
		       * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
		       * But you may override such property, if you want to use your value. Set this value before any components initializations.
		       * @property pixelRatio
		       * @default undefined
		       * @name pixelRatio
		       * @memberof Konva
		       * @example
		       * // before any Konva code:
		       * Konva.pixelRatio = 1;
		       */
		      pixelRatio: (typeof window !== 'undefined' && window.devicePixelRatio) || 1,
		      /**
		       * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point,
		       * only then start dragging. Default is 3px.
		       * @property dragDistance
		       * @default 0
		       * @memberof Konva
		       * @example
		       * Konva.dragDistance = 10;
		       */
		      dragDistance: 3,
		      /**
		       * Use degree values for angle properties. You may set this property to false if you want to use radian values.
		       * @property angleDeg
		       * @default true
		       * @memberof Konva
		       * @example
		       * node.rotation(45); // 45 degrees
		       * Konva.angleDeg = false;
		       * node.rotation(Math.PI / 2); // PI/2 radian
		       */
		      angleDeg: true,
		      /**
		       * Show different warnings about errors or wrong API usage
		       * @property showWarnings
		       * @default true
		       * @memberof Konva
		       * @example
		       * Konva.showWarnings = false;
		       */
		      showWarnings: true,
		      /**
		       * Configure what mouse buttons can be used for drag and drop.
		       * Default value is [0] - only left mouse button.
		       * @property dragButtons
		       * @default true
		       * @memberof Konva
		       * @example
		       * // enable left and right mouse buttons
		       * Konva.dragButtons = [0, 2];
		       */
		      dragButtons: [0, 1],
		      /**
		       * returns whether or not drag and drop is currently active
		       * @method
		       * @memberof Konva
		       */
		      isDragging() {
		          return Konva$2['DD'].isDragging;
		      },
		      /**
		       * returns whether or not a drag and drop operation is ready, but may
		       *  not necessarily have started
		       * @method
		       * @memberof Konva
		       */
		      isDragReady() {
		          return !!Konva$2['DD'].node;
		      },
		      /**
		       * Should Konva release canvas elements on destroy. Default is true.
		       * Useful to avoid memory leak issues in Safari on macOS/iOS.
		       * @property releaseCanvasOnDestroy
		       * @default true
		       * @name releaseCanvasOnDestroy
		       * @memberof Konva
		       * @example
		       * Konva.releaseCanvasOnDestroy = true;
		       */
		      releaseCanvasOnDestroy: true,
		      // user agent
		      document: glob.document,
		      // insert Konva into global namespace (window)
		      // it is required for npm packages
		      _injectGlobal(Konva) {
		          glob.Konva = Konva;
		      },
		  };
		  const _registerNode = (NodeClass) => {
		      Konva$2[NodeClass.prototype.getClassName()] = NodeClass;
		  };
		  Konva$2._injectGlobal(Konva$2);

		  /*
		   * Last updated November 2011
		   * By Simon Sarris
		   * www.simonsarris.com
		   * sarris@acm.org
		   *
		   * Free to use and distribute at will
		   * So long as you are nice to people, etc
		   */
		  /*
		   * The usage of this class was inspired by some of the work done by a forked
		   * project, KineticJS-Ext by Wappworks, which is based on Simon's Transform
		   * class.  Modified by Eric Rowell
		   */
		  /**
		   * Transform constructor.
		   * In most of the cases you don't need to use it in your app. Because it is for internal usage in Konva core.
		   * But there is a documentation for that class in case you still want
		   * to make some manual calculations.
		   * @constructor
		   * @param {Array} [m] Optional six-element matrix
		   * @memberof Konva
		   */
		  class Transform {
		      constructor(m = [1, 0, 0, 1, 0, 0]) {
		          this.dirty = false;
		          this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
		      }
		      reset() {
		          this.m[0] = 1;
		          this.m[1] = 0;
		          this.m[2] = 0;
		          this.m[3] = 1;
		          this.m[4] = 0;
		          this.m[5] = 0;
		      }
		      /**
		       * Copy Konva.Transform object
		       * @method
		       * @name Konva.Transform#copy
		       * @returns {Konva.Transform}
		       * @example
		       * const tr = shape.getTransform().copy()
		       */
		      copy() {
		          return new Transform(this.m);
		      }
		      copyInto(tr) {
		          tr.m[0] = this.m[0];
		          tr.m[1] = this.m[1];
		          tr.m[2] = this.m[2];
		          tr.m[3] = this.m[3];
		          tr.m[4] = this.m[4];
		          tr.m[5] = this.m[5];
		      }
		      /**
		       * Transform point
		       * @method
		       * @name Konva.Transform#point
		       * @param {Object} point 2D point(x, y)
		       * @returns {Object} 2D point(x, y)
		       */
		      point(point) {
		          var m = this.m;
		          return {
		              x: m[0] * point.x + m[2] * point.y + m[4],
		              y: m[1] * point.x + m[3] * point.y + m[5],
		          };
		      }
		      /**
		       * Apply translation
		       * @method
		       * @name Konva.Transform#translate
		       * @param {Number} x
		       * @param {Number} y
		       * @returns {Konva.Transform}
		       */
		      translate(x, y) {
		          this.m[4] += this.m[0] * x + this.m[2] * y;
		          this.m[5] += this.m[1] * x + this.m[3] * y;
		          return this;
		      }
		      /**
		       * Apply scale
		       * @method
		       * @name Konva.Transform#scale
		       * @param {Number} sx
		       * @param {Number} sy
		       * @returns {Konva.Transform}
		       */
		      scale(sx, sy) {
		          this.m[0] *= sx;
		          this.m[1] *= sx;
		          this.m[2] *= sy;
		          this.m[3] *= sy;
		          return this;
		      }
		      /**
		       * Apply rotation
		       * @method
		       * @name Konva.Transform#rotate
		       * @param {Number} rad  Angle in radians
		       * @returns {Konva.Transform}
		       */
		      rotate(rad) {
		          var c = Math.cos(rad);
		          var s = Math.sin(rad);
		          var m11 = this.m[0] * c + this.m[2] * s;
		          var m12 = this.m[1] * c + this.m[3] * s;
		          var m21 = this.m[0] * -s + this.m[2] * c;
		          var m22 = this.m[1] * -s + this.m[3] * c;
		          this.m[0] = m11;
		          this.m[1] = m12;
		          this.m[2] = m21;
		          this.m[3] = m22;
		          return this;
		      }
		      /**
		       * Returns the translation
		       * @method
		       * @name Konva.Transform#getTranslation
		       * @returns {Object} 2D point(x, y)
		       */
		      getTranslation() {
		          return {
		              x: this.m[4],
		              y: this.m[5],
		          };
		      }
		      /**
		       * Apply skew
		       * @method
		       * @name Konva.Transform#skew
		       * @param {Number} sx
		       * @param {Number} sy
		       * @returns {Konva.Transform}
		       */
		      skew(sx, sy) {
		          var m11 = this.m[0] + this.m[2] * sy;
		          var m12 = this.m[1] + this.m[3] * sy;
		          var m21 = this.m[2] + this.m[0] * sx;
		          var m22 = this.m[3] + this.m[1] * sx;
		          this.m[0] = m11;
		          this.m[1] = m12;
		          this.m[2] = m21;
		          this.m[3] = m22;
		          return this;
		      }
		      /**
		       * Transform multiplication
		       * @method
		       * @name Konva.Transform#multiply
		       * @param {Konva.Transform} matrix
		       * @returns {Konva.Transform}
		       */
		      multiply(matrix) {
		          var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
		          var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
		          var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
		          var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
		          var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
		          var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
		          this.m[0] = m11;
		          this.m[1] = m12;
		          this.m[2] = m21;
		          this.m[3] = m22;
		          this.m[4] = dx;
		          this.m[5] = dy;
		          return this;
		      }
		      /**
		       * Invert the matrix
		       * @method
		       * @name Konva.Transform#invert
		       * @returns {Konva.Transform}
		       */
		      invert() {
		          var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
		          var m0 = this.m[3] * d;
		          var m1 = -this.m[1] * d;
		          var m2 = -this.m[2] * d;
		          var m3 = this.m[0] * d;
		          var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
		          var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
		          this.m[0] = m0;
		          this.m[1] = m1;
		          this.m[2] = m2;
		          this.m[3] = m3;
		          this.m[4] = m4;
		          this.m[5] = m5;
		          return this;
		      }
		      /**
		       * return matrix
		       * @method
		       * @name Konva.Transform#getMatrix
		       */
		      getMatrix() {
		          return this.m;
		      }
		      /**
		       * convert transformation matrix back into node's attributes
		       * @method
		       * @name Konva.Transform#decompose
		       * @returns {Konva.Transform}
		       */
		      decompose() {
		          var a = this.m[0];
		          var b = this.m[1];
		          var c = this.m[2];
		          var d = this.m[3];
		          var e = this.m[4];
		          var f = this.m[5];
		          var delta = a * d - b * c;
		          let result = {
		              x: e,
		              y: f,
		              rotation: 0,
		              scaleX: 0,
		              scaleY: 0,
		              skewX: 0,
		              skewY: 0,
		          };
		          // Apply the QR-like decomposition.
		          if (a != 0 || b != 0) {
		              var r = Math.sqrt(a * a + b * b);
		              result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
		              result.scaleX = r;
		              result.scaleY = delta / r;
		              result.skewX = (a * c + b * d) / delta;
		              result.skewY = 0;
		          }
		          else if (c != 0 || d != 0) {
		              var s = Math.sqrt(c * c + d * d);
		              result.rotation =
		                  Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
		              result.scaleX = delta / s;
		              result.scaleY = s;
		              result.skewX = 0;
		              result.skewY = (a * c + b * d) / delta;
		          }
		          else ;
		          result.rotation = Util._getRotation(result.rotation);
		          return result;
		      }
		  }
		  // CONSTANTS
		  var OBJECT_ARRAY = '[object Array]', OBJECT_NUMBER = '[object Number]', OBJECT_STRING = '[object String]', OBJECT_BOOLEAN = '[object Boolean]', PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH$1 = '#', EMPTY_STRING$1 = '', ZERO = '0', KONVA_WARNING = 'Konva warning: ', KONVA_ERROR = 'Konva error: ', RGB_PAREN = 'rgb(', COLORS = {
		      aliceblue: [240, 248, 255],
		      antiquewhite: [250, 235, 215],
		      aqua: [0, 255, 255],
		      aquamarine: [127, 255, 212],
		      azure: [240, 255, 255],
		      beige: [245, 245, 220],
		      bisque: [255, 228, 196],
		      black: [0, 0, 0],
		      blanchedalmond: [255, 235, 205],
		      blue: [0, 0, 255],
		      blueviolet: [138, 43, 226],
		      brown: [165, 42, 42],
		      burlywood: [222, 184, 135],
		      cadetblue: [95, 158, 160],
		      chartreuse: [127, 255, 0],
		      chocolate: [210, 105, 30],
		      coral: [255, 127, 80],
		      cornflowerblue: [100, 149, 237],
		      cornsilk: [255, 248, 220],
		      crimson: [220, 20, 60],
		      cyan: [0, 255, 255],
		      darkblue: [0, 0, 139],
		      darkcyan: [0, 139, 139],
		      darkgoldenrod: [184, 132, 11],
		      darkgray: [169, 169, 169],
		      darkgreen: [0, 100, 0],
		      darkgrey: [169, 169, 169],
		      darkkhaki: [189, 183, 107],
		      darkmagenta: [139, 0, 139],
		      darkolivegreen: [85, 107, 47],
		      darkorange: [255, 140, 0],
		      darkorchid: [153, 50, 204],
		      darkred: [139, 0, 0],
		      darksalmon: [233, 150, 122],
		      darkseagreen: [143, 188, 143],
		      darkslateblue: [72, 61, 139],
		      darkslategray: [47, 79, 79],
		      darkslategrey: [47, 79, 79],
		      darkturquoise: [0, 206, 209],
		      darkviolet: [148, 0, 211],
		      deeppink: [255, 20, 147],
		      deepskyblue: [0, 191, 255],
		      dimgray: [105, 105, 105],
		      dimgrey: [105, 105, 105],
		      dodgerblue: [30, 144, 255],
		      firebrick: [178, 34, 34],
		      floralwhite: [255, 255, 240],
		      forestgreen: [34, 139, 34],
		      fuchsia: [255, 0, 255],
		      gainsboro: [220, 220, 220],
		      ghostwhite: [248, 248, 255],
		      gold: [255, 215, 0],
		      goldenrod: [218, 165, 32],
		      gray: [128, 128, 128],
		      green: [0, 128, 0],
		      greenyellow: [173, 255, 47],
		      grey: [128, 128, 128],
		      honeydew: [240, 255, 240],
		      hotpink: [255, 105, 180],
		      indianred: [205, 92, 92],
		      indigo: [75, 0, 130],
		      ivory: [255, 255, 240],
		      khaki: [240, 230, 140],
		      lavender: [230, 230, 250],
		      lavenderblush: [255, 240, 245],
		      lawngreen: [124, 252, 0],
		      lemonchiffon: [255, 250, 205],
		      lightblue: [173, 216, 230],
		      lightcoral: [240, 128, 128],
		      lightcyan: [224, 255, 255],
		      lightgoldenrodyellow: [250, 250, 210],
		      lightgray: [211, 211, 211],
		      lightgreen: [144, 238, 144],
		      lightgrey: [211, 211, 211],
		      lightpink: [255, 182, 193],
		      lightsalmon: [255, 160, 122],
		      lightseagreen: [32, 178, 170],
		      lightskyblue: [135, 206, 250],
		      lightslategray: [119, 136, 153],
		      lightslategrey: [119, 136, 153],
		      lightsteelblue: [176, 196, 222],
		      lightyellow: [255, 255, 224],
		      lime: [0, 255, 0],
		      limegreen: [50, 205, 50],
		      linen: [250, 240, 230],
		      magenta: [255, 0, 255],
		      maroon: [128, 0, 0],
		      mediumaquamarine: [102, 205, 170],
		      mediumblue: [0, 0, 205],
		      mediumorchid: [186, 85, 211],
		      mediumpurple: [147, 112, 219],
		      mediumseagreen: [60, 179, 113],
		      mediumslateblue: [123, 104, 238],
		      mediumspringgreen: [0, 250, 154],
		      mediumturquoise: [72, 209, 204],
		      mediumvioletred: [199, 21, 133],
		      midnightblue: [25, 25, 112],
		      mintcream: [245, 255, 250],
		      mistyrose: [255, 228, 225],
		      moccasin: [255, 228, 181],
		      navajowhite: [255, 222, 173],
		      navy: [0, 0, 128],
		      oldlace: [253, 245, 230],
		      olive: [128, 128, 0],
		      olivedrab: [107, 142, 35],
		      orange: [255, 165, 0],
		      orangered: [255, 69, 0],
		      orchid: [218, 112, 214],
		      palegoldenrod: [238, 232, 170],
		      palegreen: [152, 251, 152],
		      paleturquoise: [175, 238, 238],
		      palevioletred: [219, 112, 147],
		      papayawhip: [255, 239, 213],
		      peachpuff: [255, 218, 185],
		      peru: [205, 133, 63],
		      pink: [255, 192, 203],
		      plum: [221, 160, 203],
		      powderblue: [176, 224, 230],
		      purple: [128, 0, 128],
		      rebeccapurple: [102, 51, 153],
		      red: [255, 0, 0],
		      rosybrown: [188, 143, 143],
		      royalblue: [65, 105, 225],
		      saddlebrown: [139, 69, 19],
		      salmon: [250, 128, 114],
		      sandybrown: [244, 164, 96],
		      seagreen: [46, 139, 87],
		      seashell: [255, 245, 238],
		      sienna: [160, 82, 45],
		      silver: [192, 192, 192],
		      skyblue: [135, 206, 235],
		      slateblue: [106, 90, 205],
		      slategray: [119, 128, 144],
		      slategrey: [119, 128, 144],
		      snow: [255, 255, 250],
		      springgreen: [0, 255, 127],
		      steelblue: [70, 130, 180],
		      tan: [210, 180, 140],
		      teal: [0, 128, 128],
		      thistle: [216, 191, 216],
		      transparent: [255, 255, 255, 0],
		      tomato: [255, 99, 71],
		      turquoise: [64, 224, 208],
		      violet: [238, 130, 238],
		      wheat: [245, 222, 179],
		      white: [255, 255, 255],
		      whitesmoke: [245, 245, 245],
		      yellow: [255, 255, 0],
		      yellowgreen: [154, 205, 5],
		  }, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, animQueue = [];
		  const req = (typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame) ||
		      function (f) {
		          setTimeout(f, 60);
		      };
		  /**
		   * @namespace Util
		   * @memberof Konva
		   */
		  const Util = {
		      /*
		       * cherry-picked utilities from underscore.js
		       */
		      _isElement(obj) {
		          return !!(obj && obj.nodeType == 1);
		      },
		      _isFunction(obj) {
		          return !!(obj && obj.constructor && obj.call && obj.apply);
		      },
		      _isPlainObject(obj) {
		          return !!obj && obj.constructor === Object;
		      },
		      _isArray(obj) {
		          return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
		      },
		      _isNumber(obj) {
		          return (Object.prototype.toString.call(obj) === OBJECT_NUMBER &&
		              !isNaN(obj) &&
		              isFinite(obj));
		      },
		      _isString(obj) {
		          return Object.prototype.toString.call(obj) === OBJECT_STRING;
		      },
		      _isBoolean(obj) {
		          return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
		      },
		      // arrays are objects too
		      isObject(val) {
		          return val instanceof Object;
		      },
		      isValidSelector(selector) {
		          if (typeof selector !== 'string') {
		              return false;
		          }
		          var firstChar = selector[0];
		          return (firstChar === '#' ||
		              firstChar === '.' ||
		              firstChar === firstChar.toUpperCase());
		      },
		      _sign(number) {
		          if (number === 0) {
		              // that is not what sign usually returns
		              // but that is what we need
		              return 1;
		          }
		          if (number > 0) {
		              return 1;
		          }
		          else {
		              return -1;
		          }
		      },
		      requestAnimFrame(callback) {
		          animQueue.push(callback);
		          if (animQueue.length === 1) {
		              req(function () {
		                  const queue = animQueue;
		                  animQueue = [];
		                  queue.forEach(function (cb) {
		                      cb();
		                  });
		              });
		          }
		      },
		      createCanvasElement() {
		          var canvas = document.createElement('canvas');
		          // on some environments canvas.style is readonly
		          try {
		              canvas.style = canvas.style || {};
		          }
		          catch (e) { }
		          return canvas;
		      },
		      createImageElement() {
		          return document.createElement('img');
		      },
		      _isInDocument(el) {
		          while ((el = el.parentNode)) {
		              if (el == document) {
		                  return true;
		              }
		          }
		          return false;
		      },
		      /*
		       * arg can be an image object or image data
		       */
		      _urlToImage(url, callback) {
		          // if arg is a string, then it's a data url
		          var imageObj = Util.createImageElement();
		          imageObj.onload = function () {
		              callback(imageObj);
		          };
		          imageObj.src = url;
		      },
		      _rgbToHex(r, g, b) {
		          return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
		      },
		      _hexToRgb(hex) {
		          hex = hex.replace(HASH$1, EMPTY_STRING$1);
		          var bigint = parseInt(hex, 16);
		          return {
		              r: (bigint >> 16) & 255,
		              g: (bigint >> 8) & 255,
		              b: bigint & 255,
		          };
		      },
		      /**
		       * return random hex color
		       * @method
		       * @memberof Konva.Util
		       * @example
		       * shape.fill(Konva.Util.getRandomColor());
		       */
		      getRandomColor() {
		          var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
		          while (randColor.length < 6) {
		              randColor = ZERO + randColor;
		          }
		          return HASH$1 + randColor;
		      },
		      /**
		       * get RGB components of a color
		       * @method
		       * @memberof Konva.Util
		       * @param {String} color
		       * @example
		       * // each of the following examples return {r:0, g:0, b:255}
		       * var rgb = Konva.Util.getRGB('blue');
		       * var rgb = Konva.Util.getRGB('#0000ff');
		       * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
		       */
		      getRGB(color) {
		          var rgb;
		          // color string
		          if (color in COLORS) {
		              rgb = COLORS[color];
		              return {
		                  r: rgb[0],
		                  g: rgb[1],
		                  b: rgb[2],
		              };
		          }
		          else if (color[0] === HASH$1) {
		              // hex
		              return this._hexToRgb(color.substring(1));
		          }
		          else if (color.substr(0, 4) === RGB_PAREN) {
		              // rgb string
		              rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
		              return {
		                  r: parseInt(rgb[1], 10),
		                  g: parseInt(rgb[2], 10),
		                  b: parseInt(rgb[3], 10),
		              };
		          }
		          else {
		              // default
		              return {
		                  r: 0,
		                  g: 0,
		                  b: 0,
		              };
		          }
		      },
		      // convert any color string to RGBA object
		      // from https://github.com/component/color-parser
		      colorToRGBA(str) {
		          str = str || 'black';
		          return (Util._namedColorToRBA(str) ||
		              Util._hex3ColorToRGBA(str) ||
		              Util._hex4ColorToRGBA(str) ||
		              Util._hex6ColorToRGBA(str) ||
		              Util._hex8ColorToRGBA(str) ||
		              Util._rgbColorToRGBA(str) ||
		              Util._rgbaColorToRGBA(str) ||
		              Util._hslColorToRGBA(str));
		      },
		      // Parse named css color. Like "green"
		      _namedColorToRBA(str) {
		          var c = COLORS[str.toLowerCase()];
		          if (!c) {
		              return null;
		          }
		          return {
		              r: c[0],
		              g: c[1],
		              b: c[2],
		              a: 1,
		          };
		      },
		      // Parse rgb(n, n, n)
		      _rgbColorToRGBA(str) {
		          if (str.indexOf('rgb(') === 0) {
		              str = str.match(/rgb\(([^)]+)\)/)[1];
		              var parts = str.split(/ *, */).map(Number);
		              return {
		                  r: parts[0],
		                  g: parts[1],
		                  b: parts[2],
		                  a: 1,
		              };
		          }
		      },
		      // Parse rgba(n, n, n, n)
		      _rgbaColorToRGBA(str) {
		          if (str.indexOf('rgba(') === 0) {
		              str = str.match(/rgba\(([^)]+)\)/)[1];
		              var parts = str.split(/ *, */).map((n, index) => {
		                  if (n.slice(-1) === '%') {
		                      return index === 3 ? parseInt(n) / 100 : (parseInt(n) / 100) * 255;
		                  }
		                  return Number(n);
		              });
		              return {
		                  r: parts[0],
		                  g: parts[1],
		                  b: parts[2],
		                  a: parts[3],
		              };
		          }
		      },
		      // Parse #nnnnnnnn
		      _hex8ColorToRGBA(str) {
		          if (str[0] === '#' && str.length === 9) {
		              return {
		                  r: parseInt(str.slice(1, 3), 16),
		                  g: parseInt(str.slice(3, 5), 16),
		                  b: parseInt(str.slice(5, 7), 16),
		                  a: parseInt(str.slice(7, 9), 16) / 0xff,
		              };
		          }
		      },
		      // Parse #nnnnnn
		      _hex6ColorToRGBA(str) {
		          if (str[0] === '#' && str.length === 7) {
		              return {
		                  r: parseInt(str.slice(1, 3), 16),
		                  g: parseInt(str.slice(3, 5), 16),
		                  b: parseInt(str.slice(5, 7), 16),
		                  a: 1,
		              };
		          }
		      },
		      // Parse #nnnn
		      _hex4ColorToRGBA(str) {
		          if (str[0] === '#' && str.length === 5) {
		              return {
		                  r: parseInt(str[1] + str[1], 16),
		                  g: parseInt(str[2] + str[2], 16),
		                  b: parseInt(str[3] + str[3], 16),
		                  a: parseInt(str[4] + str[4], 16) / 0xff,
		              };
		          }
		      },
		      // Parse #nnn
		      _hex3ColorToRGBA(str) {
		          if (str[0] === '#' && str.length === 4) {
		              return {
		                  r: parseInt(str[1] + str[1], 16),
		                  g: parseInt(str[2] + str[2], 16),
		                  b: parseInt(str[3] + str[3], 16),
		                  a: 1,
		              };
		          }
		      },
		      // Code adapted from https://github.com/Qix-/color-convert/blob/master/conversions.js#L244
		      _hslColorToRGBA(str) {
		          // Check hsl() format
		          if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
		              // Extract h, s, l
		              const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
		              const h = Number(hsl[0]) / 360;
		              const s = Number(hsl[1]) / 100;
		              const l = Number(hsl[2]) / 100;
		              let t2;
		              let t3;
		              let val;
		              if (s === 0) {
		                  val = l * 255;
		                  return {
		                      r: Math.round(val),
		                      g: Math.round(val),
		                      b: Math.round(val),
		                      a: 1,
		                  };
		              }
		              if (l < 0.5) {
		                  t2 = l * (1 + s);
		              }
		              else {
		                  t2 = l + s - l * s;
		              }
		              const t1 = 2 * l - t2;
		              const rgb = [0, 0, 0];
		              for (let i = 0; i < 3; i++) {
		                  t3 = h + (1 / 3) * -(i - 1);
		                  if (t3 < 0) {
		                      t3++;
		                  }
		                  if (t3 > 1) {
		                      t3--;
		                  }
		                  if (6 * t3 < 1) {
		                      val = t1 + (t2 - t1) * 6 * t3;
		                  }
		                  else if (2 * t3 < 1) {
		                      val = t2;
		                  }
		                  else if (3 * t3 < 2) {
		                      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		                  }
		                  else {
		                      val = t1;
		                  }
		                  rgb[i] = val * 255;
		              }
		              return {
		                  r: Math.round(rgb[0]),
		                  g: Math.round(rgb[1]),
		                  b: Math.round(rgb[2]),
		                  a: 1,
		              };
		          }
		      },
		      /**
		       * check intersection of two client rectangles
		       * @method
		       * @memberof Konva.Util
		       * @param {Object} r1 - { x, y, width, height } client rectangle
		       * @param {Object} r2 - { x, y, width, height } client rectangle
		       * @example
		       * const overlapping = Konva.Util.haveIntersection(shape1.getClientRect(), shape2.getClientRect());
		       */
		      haveIntersection(r1, r2) {
		          return !(r2.x > r1.x + r1.width ||
		              r2.x + r2.width < r1.x ||
		              r2.y > r1.y + r1.height ||
		              r2.y + r2.height < r1.y);
		      },
		      cloneObject(obj) {
		          var retObj = {};
		          for (var key in obj) {
		              if (this._isPlainObject(obj[key])) {
		                  retObj[key] = this.cloneObject(obj[key]);
		              }
		              else if (this._isArray(obj[key])) {
		                  retObj[key] = this.cloneArray(obj[key]);
		              }
		              else {
		                  retObj[key] = obj[key];
		              }
		          }
		          return retObj;
		      },
		      cloneArray(arr) {
		          return arr.slice(0);
		      },
		      degToRad(deg) {
		          return deg * PI_OVER_DEG180;
		      },
		      radToDeg(rad) {
		          return rad * DEG180_OVER_PI;
		      },
		      _degToRad(deg) {
		          Util.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
		          return Util.degToRad(deg);
		      },
		      _radToDeg(rad) {
		          Util.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
		          return Util.radToDeg(rad);
		      },
		      _getRotation(radians) {
		          return Konva$2.angleDeg ? Util.radToDeg(radians) : radians;
		      },
		      _capitalize(str) {
		          return str.charAt(0).toUpperCase() + str.slice(1);
		      },
		      throw(str) {
		          throw new Error(KONVA_ERROR + str);
		      },
		      error(str) {
		          console.error(KONVA_ERROR + str);
		      },
		      warn(str) {
		          if (!Konva$2.showWarnings) {
		              return;
		          }
		          console.warn(KONVA_WARNING + str);
		      },
		      each(obj, func) {
		          for (var key in obj) {
		              func(key, obj[key]);
		          }
		      },
		      _inRange(val, left, right) {
		          return left <= val && val < right;
		      },
		      _getProjectionToSegment(x1, y1, x2, y2, x3, y3) {
		          var x, y, dist;
		          var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
		          if (pd2 == 0) {
		              x = x1;
		              y = y1;
		              dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
		          }
		          else {
		              var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
		              if (u < 0) {
		                  x = x1;
		                  y = y1;
		                  dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
		              }
		              else if (u > 1.0) {
		                  x = x2;
		                  y = y2;
		                  dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
		              }
		              else {
		                  x = x1 + u * (x2 - x1);
		                  y = y1 + u * (y2 - y1);
		                  dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
		              }
		          }
		          return [x, y, dist];
		      },
		      // line as array of points.
		      // line might be closed
		      _getProjectionToLine(pt, line, isClosed) {
		          var pc = Util.cloneObject(pt);
		          var dist = Number.MAX_VALUE;
		          line.forEach(function (p1, i) {
		              if (!isClosed && i === line.length - 1) {
		                  return;
		              }
		              var p2 = line[(i + 1) % line.length];
		              var proj = Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
		              var px = proj[0], py = proj[1], pdist = proj[2];
		              if (pdist < dist) {
		                  pc.x = px;
		                  pc.y = py;
		                  dist = pdist;
		              }
		          });
		          return pc;
		      },
		      _prepareArrayForTween(startArray, endArray, isClosed) {
		          var n, start = [], end = [];
		          if (startArray.length > endArray.length) {
		              var temp = endArray;
		              endArray = startArray;
		              startArray = temp;
		          }
		          for (n = 0; n < startArray.length; n += 2) {
		              start.push({
		                  x: startArray[n],
		                  y: startArray[n + 1],
		              });
		          }
		          for (n = 0; n < endArray.length; n += 2) {
		              end.push({
		                  x: endArray[n],
		                  y: endArray[n + 1],
		              });
		          }
		          var newStart = [];
		          end.forEach(function (point) {
		              var pr = Util._getProjectionToLine(point, start, isClosed);
		              newStart.push(pr.x);
		              newStart.push(pr.y);
		          });
		          return newStart;
		      },
		      _prepareToStringify(obj) {
		          var desc;
		          obj.visitedByCircularReferenceRemoval = true;
		          for (var key in obj) {
		              if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) {
		                  continue;
		              }
		              desc = Object.getOwnPropertyDescriptor(obj, key);
		              if (obj[key].visitedByCircularReferenceRemoval ||
		                  Util._isElement(obj[key])) {
		                  if (desc.configurable) {
		                      delete obj[key];
		                  }
		                  else {
		                      return null;
		                  }
		              }
		              else if (Util._prepareToStringify(obj[key]) === null) {
		                  if (desc.configurable) {
		                      delete obj[key];
		                  }
		                  else {
		                      return null;
		                  }
		              }
		          }
		          delete obj.visitedByCircularReferenceRemoval;
		          return obj;
		      },
		      // very simplified version of Object.assign
		      _assign(target, source) {
		          for (var key in source) {
		              target[key] = source[key];
		          }
		          return target;
		      },
		      _getFirstPointerId(evt) {
		          if (!evt.touches) {
		              // try to use pointer id or fake id
		              return evt.pointerId || 999;
		          }
		          else {
		              return evt.changedTouches[0].identifier;
		          }
		      },
		      releaseCanvas(...canvases) {
		          if (!Konva$2.releaseCanvasOnDestroy)
		              return;
		          canvases.forEach((c) => {
		              c.width = 0;
		              c.height = 0;
		          });
		      },
		      drawRoundedRectPath(context, width, height, cornerRadius) {
		          let topLeft = 0;
		          let topRight = 0;
		          let bottomLeft = 0;
		          let bottomRight = 0;
		          if (typeof cornerRadius === 'number') {
		              topLeft =
		                  topRight =
		                      bottomLeft =
		                          bottomRight =
		                              Math.min(cornerRadius, width / 2, height / 2);
		          }
		          else {
		              topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
		              topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
		              bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
		              bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
		          }
		          context.moveTo(topLeft, 0);
		          context.lineTo(width - topRight, 0);
		          context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
		          context.lineTo(width, height - bottomRight);
		          context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
		          context.lineTo(bottomLeft, height);
		          context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
		          context.lineTo(0, topLeft);
		          context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
		      },
		  };

		  function _formatValue(val) {
		      if (Util._isString(val)) {
		          return '"' + val + '"';
		      }
		      if (Object.prototype.toString.call(val) === '[object Number]') {
		          return val;
		      }
		      if (Util._isBoolean(val)) {
		          return val;
		      }
		      return Object.prototype.toString.call(val);
		  }
		  function RGBComponent(val) {
		      if (val > 255) {
		          return 255;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      return Math.round(val);
		  }
		  function getNumberValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              if (!Util._isNumber(val)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a number.');
		              }
		              return val;
		          };
		      }
		  }
		  function getNumberOrArrayOfNumbersValidator(noOfElements) {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              let isNumber = Util._isNumber(val);
		              let isValidArray = Util._isArray(val) && val.length == noOfElements;
		              if (!isNumber && !isValidArray) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a number or Array<number>(' +
		                      noOfElements +
		                      ')');
		              }
		              return val;
		          };
		      }
		  }
		  function getNumberOrAutoValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              var isNumber = Util._isNumber(val);
		              var isAuto = val === 'auto';
		              if (!(isNumber || isAuto)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a number or "auto".');
		              }
		              return val;
		          };
		      }
		  }
		  function getStringValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              if (!Util._isString(val)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a string.');
		              }
		              return val;
		          };
		      }
		  }
		  function getStringOrGradientValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              const isString = Util._isString(val);
		              const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' ||
		                  (val && val.addColorStop);
		              if (!(isString || isGradient)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a string or a native gradient.');
		              }
		              return val;
		          };
		      }
		  }
		  function getNumberArrayValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              // Retrieve TypedArray constructor as found in MDN (if TypedArray is available)
		              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray#description
		              const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
		              if (TypedArray && val instanceof TypedArray) {
		                  return val;
		              }
		              if (!Util._isArray(val)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a array of numbers.');
		              }
		              else {
		                  val.forEach(function (item) {
		                      if (!Util._isNumber(item)) {
		                          Util.warn('"' +
		                              attr +
		                              '" attribute has non numeric element ' +
		                              item +
		                              '. Make sure that all elements are numbers.');
		                      }
		                  });
		              }
		              return val;
		          };
		      }
		  }
		  function getBooleanValidator() {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              var isBool = val === true || val === false;
		              if (!isBool) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be a boolean.');
		              }
		              return val;
		          };
		      }
		  }
		  function getComponentValidator(components) {
		      if (Konva$2.isUnminified) {
		          return function (val, attr) {
		              // ignore validation on undefined value, because it will reset to defalt
		              if (val === undefined || val === null) {
		                  return val;
		              }
		              if (!Util.isObject(val)) {
		                  Util.warn(_formatValue(val) +
		                      ' is a not valid value for "' +
		                      attr +
		                      '" attribute. The value should be an object with properties ' +
		                      components);
		              }
		              return val;
		          };
		      }
		  }

		  var GET = 'get', SET$1 = 'set';
		  const Factory = {
		      addGetterSetter(constructor, attr, def, validator, after) {
		          Factory.addGetter(constructor, attr, def);
		          Factory.addSetter(constructor, attr, validator, after);
		          Factory.addOverloadedGetterSetter(constructor, attr);
		      },
		      addGetter(constructor, attr, def) {
		          var method = GET + Util._capitalize(attr);
		          constructor.prototype[method] =
		              constructor.prototype[method] ||
		                  function () {
		                      var val = this.attrs[attr];
		                      return val === undefined ? def : val;
		                  };
		      },
		      addSetter(constructor, attr, validator, after) {
		          var method = SET$1 + Util._capitalize(attr);
		          if (!constructor.prototype[method]) {
		              Factory.overWriteSetter(constructor, attr, validator, after);
		          }
		      },
		      overWriteSetter(constructor, attr, validator, after) {
		          var method = SET$1 + Util._capitalize(attr);
		          constructor.prototype[method] = function (val) {
		              if (validator && val !== undefined && val !== null) {
		                  val = validator.call(this, val, attr);
		              }
		              this._setAttr(attr, val);
		              if (after) {
		                  after.call(this);
		              }
		              return this;
		          };
		      },
		      addComponentsGetterSetter(constructor, attr, components, validator, after) {
		          var len = components.length, capitalize = Util._capitalize, getter = GET + capitalize(attr), setter = SET$1 + capitalize(attr), n, component;
		          // getter
		          constructor.prototype[getter] = function () {
		              var ret = {};
		              for (n = 0; n < len; n++) {
		                  component = components[n];
		                  ret[component] = this.getAttr(attr + capitalize(component));
		              }
		              return ret;
		          };
		          var basicValidator = getComponentValidator(components);
		          // setter
		          constructor.prototype[setter] = function (val) {
		              var oldVal = this.attrs[attr], key;
		              if (validator) {
		                  val = validator.call(this, val);
		              }
		              if (basicValidator) {
		                  basicValidator.call(this, val, attr);
		              }
		              for (key in val) {
		                  if (!val.hasOwnProperty(key)) {
		                      continue;
		                  }
		                  this._setAttr(attr + capitalize(key), val[key]);
		              }
		              if (!val) {
		                  components.forEach((component) => {
		                      this._setAttr(attr + capitalize(component), undefined);
		                  });
		              }
		              this._fireChangeEvent(attr, oldVal, val);
		              if (after) {
		                  after.call(this);
		              }
		              return this;
		          };
		          Factory.addOverloadedGetterSetter(constructor, attr);
		      },
		      addOverloadedGetterSetter(constructor, attr) {
		          var capitalizedAttr = Util._capitalize(attr), setter = SET$1 + capitalizedAttr, getter = GET + capitalizedAttr;
		          constructor.prototype[attr] = function () {
		              // setting
		              if (arguments.length) {
		                  this[setter](arguments[0]);
		                  return this;
		              }
		              // getting
		              return this[getter]();
		          };
		      },
		      addDeprecatedGetterSetter(constructor, attr, def, validator) {
		          Util.error('Adding deprecated ' + attr);
		          var method = GET + Util._capitalize(attr);
		          var message = attr +
		              ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
		          constructor.prototype[method] = function () {
		              Util.error(message);
		              var val = this.attrs[attr];
		              return val === undefined ? def : val;
		          };
		          Factory.addSetter(constructor, attr, validator, function () {
		              Util.error(message);
		          });
		          Factory.addOverloadedGetterSetter(constructor, attr);
		      },
		      backCompat(constructor, methods) {
		          Util.each(methods, function (oldMethodName, newMethodName) {
		              var method = constructor.prototype[newMethodName];
		              var oldGetter = GET + Util._capitalize(oldMethodName);
		              var oldSetter = SET$1 + Util._capitalize(oldMethodName);
		              function deprecated() {
		                  method.apply(this, arguments);
		                  Util.error('"' +
		                      oldMethodName +
		                      '" method is deprecated and will be removed soon. Use ""' +
		                      newMethodName +
		                      '" instead.');
		              }
		              constructor.prototype[oldMethodName] = deprecated;
		              constructor.prototype[oldGetter] = deprecated;
		              constructor.prototype[oldSetter] = deprecated;
		          });
		      },
		      afterSetFilter() {
		          this._filterUpToDate = false;
		      },
		  };

		  function simplifyArray(arr) {
		      var retArr = [], len = arr.length, util = Util, n, val;
		      for (n = 0; n < len; n++) {
		          val = arr[n];
		          if (util._isNumber(val)) {
		              val = Math.round(val * 1000) / 1000;
		          }
		          else if (!util._isString(val)) {
		              val = val + '';
		          }
		          retArr.push(val);
		      }
		      return retArr;
		  }
		  var COMMA = ',', OPEN_PAREN = '(', CLOSE_PAREN = ')', OPEN_PAREN_BRACKET = '([', CLOSE_BRACKET_PAREN = '])', SEMICOLON = ';', DOUBLE_PAREN = '()', 
		  // EMPTY_STRING = '',
		  EQUALS = '=', 
		  // SET = 'set',
		  CONTEXT_METHODS = [
		      'arc',
		      'arcTo',
		      'beginPath',
		      'bezierCurveTo',
		      'clearRect',
		      'clip',
		      'closePath',
		      'createLinearGradient',
		      'createPattern',
		      'createRadialGradient',
		      'drawImage',
		      'ellipse',
		      'fill',
		      'fillText',
		      'getImageData',
		      'createImageData',
		      'lineTo',
		      'moveTo',
		      'putImageData',
		      'quadraticCurveTo',
		      'rect',
		      'restore',
		      'rotate',
		      'save',
		      'scale',
		      'setLineDash',
		      'setTransform',
		      'stroke',
		      'strokeText',
		      'transform',
		      'translate',
		  ];
		  var CONTEXT_PROPERTIES = [
		      'fillStyle',
		      'strokeStyle',
		      'shadowColor',
		      'shadowBlur',
		      'shadowOffsetX',
		      'shadowOffsetY',
		      'letterSpacing',
		      'lineCap',
		      'lineDashOffset',
		      'lineJoin',
		      'lineWidth',
		      'miterLimit',
		      'direction',
		      'font',
		      'textAlign',
		      'textBaseline',
		      'globalAlpha',
		      'globalCompositeOperation',
		      'imageSmoothingEnabled',
		  ];
		  const traceArrMax = 100;
		  /**
		   * Konva wrapper around native 2d canvas context. It has almost the same API of 2d context with some additional functions.
		   * With core Konva shapes you don't need to use this object. But you will use it if you want to create
		   * a [custom shape](/docs/react/Custom_Shape.html) or a [custom hit regions](/docs/events/Custom_Hit_Region.html).
		   * For full information about each 2d context API use [MDN documentation](https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D)
		   * @constructor
		   * @memberof Konva
		   * @example
		   * const rect = new Konva.Shape({
		   *    fill: 'red',
		   *    width: 100,
		   *    height: 100,
		   *    sceneFunc: (ctx, shape) => {
		   *      // ctx - is context wrapper
		   *      // shape - is instance of Konva.Shape, so it equals to "rect" variable
		   *      ctx.rect(0, 0, shape.getAttr('width'), shape.getAttr('height'));
		   *
		   *      // automatically fill shape from props and draw hit region
		   *      ctx.fillStrokeShape(shape);
		   *    }
		   * })
		   */
		  class Context {
		      constructor(canvas) {
		          this.canvas = canvas;
		          if (Konva$2.enableTrace) {
		              this.traceArr = [];
		              this._enableTrace();
		          }
		      }
		      /**
		       * fill shape
		       * @method
		       * @name Konva.Context#fillShape
		       * @param {Konva.Shape} shape
		       */
		      fillShape(shape) {
		          if (shape.fillEnabled()) {
		              this._fill(shape);
		          }
		      }
		      _fill(shape) {
		          // abstract
		      }
		      /**
		       * stroke shape
		       * @method
		       * @name Konva.Context#strokeShape
		       * @param {Konva.Shape} shape
		       */
		      strokeShape(shape) {
		          if (shape.hasStroke()) {
		              this._stroke(shape);
		          }
		      }
		      _stroke(shape) {
		          // abstract
		      }
		      /**
		       * fill then stroke
		       * @method
		       * @name Konva.Context#fillStrokeShape
		       * @param {Konva.Shape} shape
		       */
		      fillStrokeShape(shape) {
		          if (shape.attrs.fillAfterStrokeEnabled) {
		              this.strokeShape(shape);
		              this.fillShape(shape);
		          }
		          else {
		              this.fillShape(shape);
		              this.strokeShape(shape);
		          }
		      }
		      getTrace(relaxed, rounded) {
		          var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
		          for (n = 0; n < len; n++) {
		              trace = traceArr[n];
		              method = trace.method;
		              // methods
		              if (method) {
		                  args = trace.args;
		                  str += method;
		                  if (relaxed) {
		                      str += DOUBLE_PAREN;
		                  }
		                  else {
		                      if (Util._isArray(args[0])) {
		                          str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
		                      }
		                      else {
		                          if (rounded) {
		                              args = args.map((a) => typeof a === 'number' ? Math.floor(a) : a);
		                          }
		                          str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
		                      }
		                  }
		              }
		              else {
		                  // properties
		                  str += trace.property;
		                  if (!relaxed) {
		                      str += EQUALS + trace.val;
		                  }
		              }
		              str += SEMICOLON;
		          }
		          return str;
		      }
		      clearTrace() {
		          this.traceArr = [];
		      }
		      _trace(str) {
		          var traceArr = this.traceArr, len;
		          traceArr.push(str);
		          len = traceArr.length;
		          if (len >= traceArrMax) {
		              traceArr.shift();
		          }
		      }
		      /**
		       * reset canvas context transform
		       * @method
		       * @name Konva.Context#reset
		       */
		      reset() {
		          var pixelRatio = this.getCanvas().getPixelRatio();
		          this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
		      }
		      /**
		       * get canvas wrapper
		       * @method
		       * @name Konva.Context#getCanvas
		       * @returns {Konva.Canvas}
		       */
		      getCanvas() {
		          return this.canvas;
		      }
		      /**
		       * clear canvas
		       * @method
		       * @name Konva.Context#clear
		       * @param {Object} [bounds]
		       * @param {Number} [bounds.x]
		       * @param {Number} [bounds.y]
		       * @param {Number} [bounds.width]
		       * @param {Number} [bounds.height]
		       */
		      clear(bounds) {
		          var canvas = this.getCanvas();
		          if (bounds) {
		              this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
		          }
		          else {
		              this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
		          }
		      }
		      _applyLineCap(shape) {
		          const lineCap = shape.attrs.lineCap;
		          if (lineCap) {
		              this.setAttr('lineCap', lineCap);
		          }
		      }
		      _applyOpacity(shape) {
		          var absOpacity = shape.getAbsoluteOpacity();
		          if (absOpacity !== 1) {
		              this.setAttr('globalAlpha', absOpacity);
		          }
		      }
		      _applyLineJoin(shape) {
		          const lineJoin = shape.attrs.lineJoin;
		          if (lineJoin) {
		              this.setAttr('lineJoin', lineJoin);
		          }
		      }
		      setAttr(attr, val) {
		          this._context[attr] = val;
		      }
		      /**
		       * arc function.
		       * @method
		       * @name Konva.Context#arc
		       */
		      arc(x, y, radius, startAngle, endAngle, counterClockwise) {
		          this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
		      }
		      /**
		       * arcTo function.
		       * @method
		       * @name Konva.Context#arcTo
		       *
		       */
		      arcTo(x1, y1, x2, y2, radius) {
		          this._context.arcTo(x1, y1, x2, y2, radius);
		      }
		      /**
		       * beginPath function.
		       * @method
		       * @name Konva.Context#beginPath
		       */
		      beginPath() {
		          this._context.beginPath();
		      }
		      /**
		       * bezierCurveTo function.
		       * @method
		       * @name Konva.Context#bezierCurveTo
		       */
		      bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
		          this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
		      }
		      /**
		       * clearRect function.
		       * @method
		       * @name Konva.Context#clearRect
		       */
		      clearRect(x, y, width, height) {
		          this._context.clearRect(x, y, width, height);
		      }
		      clip(...args) {
		          this._context.clip.apply(this._context, args);
		      }
		      /**
		       * closePath function.
		       * @method
		       * @name Konva.Context#closePath
		       */
		      closePath() {
		          this._context.closePath();
		      }
		      /**
		       * createImageData function.
		       * @method
		       * @name Konva.Context#createImageData
		       */
		      createImageData(width, height) {
		          var a = arguments;
		          if (a.length === 2) {
		              return this._context.createImageData(width, height);
		          }
		          else if (a.length === 1) {
		              return this._context.createImageData(width);
		          }
		      }
		      /**
		       * createLinearGradient function.
		       * @method
		       * @name Konva.Context#createLinearGradient
		       */
		      createLinearGradient(x0, y0, x1, y1) {
		          return this._context.createLinearGradient(x0, y0, x1, y1);
		      }
		      /**
		       * createPattern function.
		       * @method
		       * @name Konva.Context#createPattern
		       */
		      createPattern(image, repetition) {
		          return this._context.createPattern(image, repetition);
		      }
		      /**
		       * createRadialGradient function.
		       * @method
		       * @name Konva.Context#createRadialGradient
		       */
		      createRadialGradient(x0, y0, r0, x1, y1, r1) {
		          return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
		      }
		      /**
		       * drawImage function.
		       * @method
		       * @name Konva.Context#drawImage
		       */
		      drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
		          // this._context.drawImage(...arguments);
		          var a = arguments, _context = this._context;
		          if (a.length === 3) {
		              _context.drawImage(image, sx, sy);
		          }
		          else if (a.length === 5) {
		              _context.drawImage(image, sx, sy, sWidth, sHeight);
		          }
		          else if (a.length === 9) {
		              _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
		          }
		      }
		      /**
		       * ellipse function.
		       * @method
		       * @name Konva.Context#ellipse
		       */
		      ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
		          this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
		      }
		      /**
		       * isPointInPath function.
		       * @method
		       * @name Konva.Context#isPointInPath
		       */
		      isPointInPath(x, y, path, fillRule) {
		          if (path) {
		              return this._context.isPointInPath(path, x, y, fillRule);
		          }
		          return this._context.isPointInPath(x, y, fillRule);
		      }
		      fill(...args) {
		          // this._context.fill();
		          this._context.fill.apply(this._context, args);
		      }
		      /**
		       * fillRect function.
		       * @method
		       * @name Konva.Context#fillRect
		       */
		      fillRect(x, y, width, height) {
		          this._context.fillRect(x, y, width, height);
		      }
		      /**
		       * strokeRect function.
		       * @method
		       * @name Konva.Context#strokeRect
		       */
		      strokeRect(x, y, width, height) {
		          this._context.strokeRect(x, y, width, height);
		      }
		      /**
		       * fillText function.
		       * @method
		       * @name Konva.Context#fillText
		       */
		      fillText(text, x, y, maxWidth) {
		          if (maxWidth) {
		              this._context.fillText(text, x, y, maxWidth);
		          }
		          else {
		              this._context.fillText(text, x, y);
		          }
		      }
		      /**
		       * measureText function.
		       * @method
		       * @name Konva.Context#measureText
		       */
		      measureText(text) {
		          return this._context.measureText(text);
		      }
		      /**
		       * getImageData function.
		       * @method
		       * @name Konva.Context#getImageData
		       */
		      getImageData(sx, sy, sw, sh) {
		          return this._context.getImageData(sx, sy, sw, sh);
		      }
		      /**
		       * lineTo function.
		       * @method
		       * @name Konva.Context#lineTo
		       */
		      lineTo(x, y) {
		          this._context.lineTo(x, y);
		      }
		      /**
		       * moveTo function.
		       * @method
		       * @name Konva.Context#moveTo
		       */
		      moveTo(x, y) {
		          this._context.moveTo(x, y);
		      }
		      /**
		       * rect function.
		       * @method
		       * @name Konva.Context#rect
		       */
		      rect(x, y, width, height) {
		          this._context.rect(x, y, width, height);
		      }
		      /**
		       * putImageData function.
		       * @method
		       * @name Konva.Context#putImageData
		       */
		      putImageData(imageData, dx, dy) {
		          this._context.putImageData(imageData, dx, dy);
		      }
		      /**
		       * quadraticCurveTo function.
		       * @method
		       * @name Konva.Context#quadraticCurveTo
		       */
		      quadraticCurveTo(cpx, cpy, x, y) {
		          this._context.quadraticCurveTo(cpx, cpy, x, y);
		      }
		      /**
		       * restore function.
		       * @method
		       * @name Konva.Context#restore
		       */
		      restore() {
		          this._context.restore();
		      }
		      /**
		       * rotate function.
		       * @method
		       * @name Konva.Context#rotate
		       */
		      rotate(angle) {
		          this._context.rotate(angle);
		      }
		      /**
		       * save function.
		       * @method
		       * @name Konva.Context#save
		       */
		      save() {
		          this._context.save();
		      }
		      /**
		       * scale function.
		       * @method
		       * @name Konva.Context#scale
		       */
		      scale(x, y) {
		          this._context.scale(x, y);
		      }
		      /**
		       * setLineDash function.
		       * @method
		       * @name Konva.Context#setLineDash
		       */
		      setLineDash(segments) {
		          // works for Chrome and IE11
		          if (this._context.setLineDash) {
		              this._context.setLineDash(segments);
		          }
		          else if ('mozDash' in this._context) {
		              // verified that this works in firefox
		              this._context['mozDash'] = segments;
		          }
		          else if ('webkitLineDash' in this._context) {
		              // does not currently work for Safari
		              this._context['webkitLineDash'] = segments;
		          }
		          // no support for IE9 and IE10
		      }
		      /**
		       * getLineDash function.
		       * @method
		       * @name Konva.Context#getLineDash
		       */
		      getLineDash() {
		          return this._context.getLineDash();
		      }
		      /**
		       * setTransform function.
		       * @method
		       * @name Konva.Context#setTransform
		       */
		      setTransform(a, b, c, d, e, f) {
		          this._context.setTransform(a, b, c, d, e, f);
		      }
		      /**
		       * stroke function.
		       * @method
		       * @name Konva.Context#stroke
		       */
		      stroke(path2d) {
		          if (path2d) {
		              this._context.stroke(path2d);
		          }
		          else {
		              this._context.stroke();
		          }
		      }
		      /**
		       * strokeText function.
		       * @method
		       * @name Konva.Context#strokeText
		       */
		      strokeText(text, x, y, maxWidth) {
		          this._context.strokeText(text, x, y, maxWidth);
		      }
		      /**
		       * transform function.
		       * @method
		       * @name Konva.Context#transform
		       */
		      transform(a, b, c, d, e, f) {
		          this._context.transform(a, b, c, d, e, f);
		      }
		      /**
		       * translate function.
		       * @method
		       * @name Konva.Context#translate
		       */
		      translate(x, y) {
		          this._context.translate(x, y);
		      }
		      _enableTrace() {
		          var that = this, len = CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
		          // to prevent creating scope function at each loop
		          var func = function (methodName) {
		              var origMethod = that[methodName], ret;
		              that[methodName] = function () {
		                  args = simplifyArray(Array.prototype.slice.call(arguments, 0));
		                  ret = origMethod.apply(that, arguments);
		                  that._trace({
		                      method: methodName,
		                      args: args,
		                  });
		                  return ret;
		              };
		          };
		          // methods
		          for (n = 0; n < len; n++) {
		              func(CONTEXT_METHODS[n]);
		          }
		          // attrs
		          that.setAttr = function () {
		              origSetter.apply(that, arguments);
		              var prop = arguments[0];
		              var val = arguments[1];
		              if (prop === 'shadowOffsetX' ||
		                  prop === 'shadowOffsetY' ||
		                  prop === 'shadowBlur') {
		                  val = val / this.canvas.getPixelRatio();
		              }
		              that._trace({
		                  property: prop,
		                  val: val,
		              });
		          };
		      }
		      _applyGlobalCompositeOperation(node) {
		          const op = node.attrs.globalCompositeOperation;
		          var def = !op || op === 'source-over';
		          if (!def) {
		              this.setAttr('globalCompositeOperation', op);
		          }
		      }
		  }
		  CONTEXT_PROPERTIES.forEach(function (prop) {
		      Object.defineProperty(Context.prototype, prop, {
		          get() {
		              return this._context[prop];
		          },
		          set(val) {
		              this._context[prop] = val;
		          },
		      });
		  });
		  class SceneContext extends Context {
		      constructor(canvas, { willReadFrequently = false } = {}) {
		          super(canvas);
		          this._context = canvas._canvas.getContext('2d', {
		              willReadFrequently,
		          });
		      }
		      _fillColor(shape) {
		          var fill = shape.fill();
		          this.setAttr('fillStyle', fill);
		          shape._fillFunc(this);
		      }
		      _fillPattern(shape) {
		          this.setAttr('fillStyle', shape._getFillPattern());
		          shape._fillFunc(this);
		      }
		      _fillLinearGradient(shape) {
		          var grd = shape._getLinearGradient();
		          if (grd) {
		              this.setAttr('fillStyle', grd);
		              shape._fillFunc(this);
		          }
		      }
		      _fillRadialGradient(shape) {
		          const grd = shape._getRadialGradient();
		          if (grd) {
		              this.setAttr('fillStyle', grd);
		              shape._fillFunc(this);
		          }
		      }
		      _fill(shape) {
		          const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
		          // priority fills
		          if (hasColor && fillPriority === 'color') {
		              this._fillColor(shape);
		              return;
		          }
		          const hasPattern = shape.getFillPatternImage();
		          if (hasPattern && fillPriority === 'pattern') {
		              this._fillPattern(shape);
		              return;
		          }
		          const hasLinearGradient = shape.getFillLinearGradientColorStops();
		          if (hasLinearGradient && fillPriority === 'linear-gradient') {
		              this._fillLinearGradient(shape);
		              return;
		          }
		          const hasRadialGradient = shape.getFillRadialGradientColorStops();
		          if (hasRadialGradient && fillPriority === 'radial-gradient') {
		              this._fillRadialGradient(shape);
		              return;
		          }
		          // now just try and fill with whatever is available
		          if (hasColor) {
		              this._fillColor(shape);
		          }
		          else if (hasPattern) {
		              this._fillPattern(shape);
		          }
		          else if (hasLinearGradient) {
		              this._fillLinearGradient(shape);
		          }
		          else if (hasRadialGradient) {
		              this._fillRadialGradient(shape);
		          }
		      }
		      _strokeLinearGradient(shape) {
		          const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
		          if (colorStops) {
		              // build color stops
		              for (var n = 0; n < colorStops.length; n += 2) {
		                  grd.addColorStop(colorStops[n], colorStops[n + 1]);
		              }
		              this.setAttr('strokeStyle', grd);
		          }
		      }
		      _stroke(shape) {
		          var dash = shape.dash(), 
		          // ignore strokeScaleEnabled for Text
		          strokeScaleEnabled = shape.getStrokeScaleEnabled();
		          if (shape.hasStroke()) {
		              if (!strokeScaleEnabled) {
		                  this.save();
		                  var pixelRatio = this.getCanvas().getPixelRatio();
		                  this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		              }
		              this._applyLineCap(shape);
		              if (dash && shape.dashEnabled()) {
		                  this.setLineDash(dash);
		                  this.setAttr('lineDashOffset', shape.dashOffset());
		              }
		              this.setAttr('lineWidth', shape.strokeWidth());
		              if (!shape.getShadowForStrokeEnabled()) {
		                  this.setAttr('shadowColor', 'rgba(0,0,0,0)');
		              }
		              var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
		              if (hasLinearGradient) {
		                  this._strokeLinearGradient(shape);
		              }
		              else {
		                  this.setAttr('strokeStyle', shape.stroke());
		              }
		              shape._strokeFunc(this);
		              if (!strokeScaleEnabled) {
		                  this.restore();
		              }
		          }
		      }
		      _applyShadow(shape) {
		          var _a, _b, _c;
		          var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
		              x: 0,
		              y: 0,
		          }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
		          this.setAttr('shadowColor', color);
		          this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
		          this.setAttr('shadowOffsetX', offset.x * scaleX);
		          this.setAttr('shadowOffsetY', offset.y * scaleY);
		      }
		  }
		  class HitContext extends Context {
		      constructor(canvas) {
		          super(canvas);
		          this._context = canvas._canvas.getContext('2d', {
		              willReadFrequently: true,
		          });
		      }
		      _fill(shape) {
		          this.save();
		          this.setAttr('fillStyle', shape.colorKey);
		          shape._fillFuncHit(this);
		          this.restore();
		      }
		      strokeShape(shape) {
		          if (shape.hasHitStroke()) {
		              this._stroke(shape);
		          }
		      }
		      _stroke(shape) {
		          if (shape.hasHitStroke()) {
		              // ignore strokeScaleEnabled for Text
		              const strokeScaleEnabled = shape.getStrokeScaleEnabled();
		              if (!strokeScaleEnabled) {
		                  this.save();
		                  var pixelRatio = this.getCanvas().getPixelRatio();
		                  this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		              }
		              this._applyLineCap(shape);
		              var hitStrokeWidth = shape.hitStrokeWidth();
		              var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
		              this.setAttr('lineWidth', strokeWidth);
		              this.setAttr('strokeStyle', shape.colorKey);
		              shape._strokeFuncHit(this);
		              if (!strokeScaleEnabled) {
		                  this.restore();
		              }
		          }
		      }
		  }

		  // calculate pixel ratio
		  var _pixelRatio;
		  function getDevicePixelRatio() {
		      if (_pixelRatio) {
		          return _pixelRatio;
		      }
		      var canvas = Util.createCanvasElement();
		      var context = canvas.getContext('2d');
		      _pixelRatio = (function () {
		          var devicePixelRatio = Konva$2._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio ||
		              context.mozBackingStorePixelRatio ||
		              context.msBackingStorePixelRatio ||
		              context.oBackingStorePixelRatio ||
		              context.backingStorePixelRatio ||
		              1;
		          return devicePixelRatio / backingStoreRatio;
		      })();
		      Util.releaseCanvas(canvas);
		      return _pixelRatio;
		  }
		  /**
		   * Canvas Renderer constructor. It is a wrapper around native canvas element.
		   * Usually you don't need to use it manually.
		   * @constructor
		   * @abstract
		   * @memberof Konva
		   * @param {Object} config
		   * @param {Number} config.width
		   * @param {Number} config.height
		   * @param {Number} config.pixelRatio
		   */
		  class Canvas {
		      constructor(config) {
		          this.pixelRatio = 1;
		          this.width = 0;
		          this.height = 0;
		          this.isCache = false;
		          var conf = config || {};
		          var pixelRatio = conf.pixelRatio || Konva$2.pixelRatio || getDevicePixelRatio();
		          this.pixelRatio = pixelRatio;
		          this._canvas = Util.createCanvasElement();
		          // set inline styles
		          this._canvas.style.padding = '0';
		          this._canvas.style.margin = '0';
		          this._canvas.style.border = '0';
		          this._canvas.style.background = 'transparent';
		          this._canvas.style.position = 'absolute';
		          this._canvas.style.top = '0';
		          this._canvas.style.left = '0';
		      }
		      /**
		       * get canvas context
		       * @method
		       * @name Konva.Canvas#getContext
		       * @returns {CanvasContext} context
		       */
		      getContext() {
		          return this.context;
		      }
		      getPixelRatio() {
		          return this.pixelRatio;
		      }
		      setPixelRatio(pixelRatio) {
		          var previousRatio = this.pixelRatio;
		          this.pixelRatio = pixelRatio;
		          this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
		      }
		      setWidth(width) {
		          // take into account pixel ratio
		          this.width = this._canvas.width = width * this.pixelRatio;
		          this._canvas.style.width = width + 'px';
		          var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
		          _context.scale(pixelRatio, pixelRatio);
		      }
		      setHeight(height) {
		          // take into account pixel ratio
		          this.height = this._canvas.height = height * this.pixelRatio;
		          this._canvas.style.height = height + 'px';
		          var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
		          _context.scale(pixelRatio, pixelRatio);
		      }
		      getWidth() {
		          return this.width;
		      }
		      getHeight() {
		          return this.height;
		      }
		      setSize(width, height) {
		          this.setWidth(width || 0);
		          this.setHeight(height || 0);
		      }
		      /**
		       * to data url
		       * @method
		       * @name Konva.Canvas#toDataURL
		       * @param {String} mimeType
		       * @param {Number} quality between 0 and 1 for jpg mime types
		       * @returns {String} data url string
		       */
		      toDataURL(mimeType, quality) {
		          try {
		              // If this call fails (due to browser bug, like in Firefox 3.6),
		              // then revert to previous no-parameter image/png behavior
		              return this._canvas.toDataURL(mimeType, quality);
		          }
		          catch (e) {
		              try {
		                  return this._canvas.toDataURL();
		              }
		              catch (err) {
		                  Util.error('Unable to get data URL. ' +
		                      err.message +
		                      ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
		                  return '';
		              }
		          }
		      }
		  }
		  /**
		   * get/set pixel ratio.
		   * KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
		   *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
		   *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
		   *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
		   *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
		   *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
		   *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
		   * @name Konva.Canvas#pixelRatio
		   * @method
		   * @param {Number} pixelRatio
		   * @returns {Number}
		   * @example
		   * // get
		   * var pixelRatio = layer.getCanvas.pixelRatio();
		   *
		   * // set
		   * layer.getCanvas().pixelRatio(3);
		   */
		  Factory.addGetterSetter(Canvas, 'pixelRatio', undefined, getNumberValidator());
		  class SceneCanvas extends Canvas {
		      constructor(config = { width: 0, height: 0, willReadFrequently: false }) {
		          super(config);
		          this.context = new SceneContext(this, {
		              willReadFrequently: config.willReadFrequently,
		          });
		          this.setSize(config.width, config.height);
		      }
		  }
		  class HitCanvas extends Canvas {
		      constructor(config = { width: 0, height: 0 }) {
		          super(config);
		          this.hitCanvas = true;
		          this.context = new HitContext(this);
		          this.setSize(config.width, config.height);
		      }
		  }

		  const DD = {
		      get isDragging() {
		          var flag = false;
		          DD._dragElements.forEach((elem) => {
		              if (elem.dragStatus === 'dragging') {
		                  flag = true;
		              }
		          });
		          return flag;
		      },
		      justDragged: false,
		      get node() {
		          // return first dragging node
		          var node;
		          DD._dragElements.forEach((elem) => {
		              node = elem.node;
		          });
		          return node;
		      },
		      _dragElements: new Map(),
		      // methods
		      _drag(evt) {
		          const nodesToFireEvents = [];
		          DD._dragElements.forEach((elem, key) => {
		              const { node } = elem;
		              // we need to find pointer relative to that node
		              const stage = node.getStage();
		              stage.setPointersPositions(evt);
		              // it is possible that user call startDrag without any event
		              // it that case we need to detect first movable pointer and attach it into the node
		              if (elem.pointerId === undefined) {
		                  elem.pointerId = Util._getFirstPointerId(evt);
		              }
		              const pos = stage._changedPointerPositions.find((pos) => pos.id === elem.pointerId);
		              // not related pointer
		              if (!pos) {
		                  return;
		              }
		              if (elem.dragStatus !== 'dragging') {
		                  var dragDistance = node.dragDistance();
		                  var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
		                  if (distance < dragDistance) {
		                      return;
		                  }
		                  node.startDrag({ evt });
		                  // a user can stop dragging inside `dragstart`
		                  if (!node.isDragging()) {
		                      return;
		                  }
		              }
		              node._setDragPosition(evt, elem);
		              nodesToFireEvents.push(node);
		          });
		          // call dragmove only after ALL positions are changed
		          nodesToFireEvents.forEach((node) => {
		              node.fire('dragmove', {
		                  type: 'dragmove',
		                  target: node,
		                  evt: evt,
		              }, true);
		          });
		      },
		      // dragBefore and dragAfter allows us to set correct order of events
		      // setup all in dragbefore, and stop dragging only after pointerup triggered.
		      _endDragBefore(evt) {
		          const drawNodes = [];
		          DD._dragElements.forEach((elem) => {
		              const { node } = elem;
		              // we need to find pointer relative to that node
		              const stage = node.getStage();
		              if (evt) {
		                  stage.setPointersPositions(evt);
		              }
		              const pos = stage._changedPointerPositions.find((pos) => pos.id === elem.pointerId);
		              // that pointer is not related
		              if (!pos) {
		                  return;
		              }
		              if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
		                  // if a node is stopped manually we still need to reset events:
		                  DD.justDragged = true;
		                  Konva$2._mouseListenClick = false;
		                  Konva$2._touchListenClick = false;
		                  Konva$2._pointerListenClick = false;
		                  elem.dragStatus = 'stopped';
		              }
		              const drawNode = elem.node.getLayer() ||
		                  (elem.node instanceof Konva$2['Stage'] && elem.node);
		              if (drawNode && drawNodes.indexOf(drawNode) === -1) {
		                  drawNodes.push(drawNode);
		              }
		          });
		          // draw in a sync way
		          // because mousemove event may trigger BEFORE batch draw is called
		          // but as we have not hit canvas updated yet, it will trigger incorrect mouseover/mouseout events
		          drawNodes.forEach((drawNode) => {
		              drawNode.draw();
		          });
		      },
		      _endDragAfter(evt) {
		          DD._dragElements.forEach((elem, key) => {
		              if (elem.dragStatus === 'stopped') {
		                  elem.node.fire('dragend', {
		                      type: 'dragend',
		                      target: elem.node,
		                      evt: evt,
		                  }, true);
		              }
		              if (elem.dragStatus !== 'dragging') {
		                  DD._dragElements.delete(key);
		              }
		          });
		      },
		  };
		  if (Konva$2.isBrowser) {
		      window.addEventListener('mouseup', DD._endDragBefore, true);
		      window.addEventListener('touchend', DD._endDragBefore, true);
		      window.addEventListener('mousemove', DD._drag);
		      window.addEventListener('touchmove', DD._drag);
		      window.addEventListener('mouseup', DD._endDragAfter, false);
		      window.addEventListener('touchend', DD._endDragAfter, false);
		  }

		  // CONSTANTS
		  var ABSOLUTE_OPACITY = 'absoluteOpacity', ALL_LISTENERS = 'allEventListeners', ABSOLUTE_TRANSFORM = 'absoluteTransform', ABSOLUTE_SCALE = 'absoluteScale', CANVAS = 'canvas', CHANGE = 'Change', CHILDREN = 'children', KONVA = 'konva', LISTENING = 'listening', MOUSEENTER$1 = 'mouseenter', MOUSELEAVE$1 = 'mouseleave', SET = 'set', SHAPE = 'Shape', SPACE$1 = ' ', STAGE$1 = 'stage', TRANSFORM = 'transform', UPPER_STAGE = 'Stage', VISIBLE = 'visible', TRANSFORM_CHANGE_STR$1 = [
		      'xChange.konva',
		      'yChange.konva',
		      'scaleXChange.konva',
		      'scaleYChange.konva',
		      'skewXChange.konva',
		      'skewYChange.konva',
		      'rotationChange.konva',
		      'offsetXChange.konva',
		      'offsetYChange.konva',
		      'transformsEnabledChange.konva',
		  ].join(SPACE$1);
		  let idCounter$1 = 1;
		  /**
		   * Node constructor. Nodes are entities that can be transformed, layered,
		   * and have bound events. The stage, layers, groups, and shapes all extend Node.
		   * @constructor
		   * @memberof Konva
		   * @param {Object} config
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   */
		  class Node {
		      constructor(config) {
		          this._id = idCounter$1++;
		          this.eventListeners = {};
		          this.attrs = {};
		          this.index = 0;
		          this._allEventListeners = null;
		          this.parent = null;
		          this._cache = new Map();
		          this._attachedDepsListeners = new Map();
		          this._lastPos = null;
		          this._batchingTransformChange = false;
		          this._needClearTransformCache = false;
		          this._filterUpToDate = false;
		          this._isUnderCache = false;
		          this._dragEventId = null;
		          this._shouldFireChangeEvents = false;
		          // on initial set attrs wi don't need to fire change events
		          // because nobody is listening to them yet
		          this.setAttrs(config);
		          this._shouldFireChangeEvents = true;
		          // all change event listeners are attached to the prototype
		      }
		      hasChildren() {
		          return false;
		      }
		      _clearCache(attr) {
		          // if we want to clear transform cache
		          // we don't really need to remove it from the cache
		          // but instead mark as "dirty"
		          // so we don't need to create a new instance next time
		          if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) &&
		              this._cache.get(attr)) {
		              this._cache.get(attr).dirty = true;
		          }
		          else if (attr) {
		              this._cache.delete(attr);
		          }
		          else {
		              this._cache.clear();
		          }
		      }
		      _getCache(attr, privateGetter) {
		          var cache = this._cache.get(attr);
		          // for transform the cache can be NOT empty
		          // but we still need to recalculate it if it is dirty
		          var isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
		          var invalid = cache === undefined || (isTransform && cache.dirty === true);
		          // if not cached, we need to set it using the private getter method.
		          if (invalid) {
		              cache = privateGetter.call(this);
		              this._cache.set(attr, cache);
		          }
		          return cache;
		      }
		      _calculate(name, deps, getter) {
		          // if we are trying to calculate function for the first time
		          // we need to attach listeners for change events
		          if (!this._attachedDepsListeners.get(name)) {
		              const depsString = deps.map((dep) => dep + 'Change.konva').join(SPACE$1);
		              this.on(depsString, () => {
		                  this._clearCache(name);
		              });
		              this._attachedDepsListeners.set(name, true);
		          }
		          // just use cache function
		          return this._getCache(name, getter);
		      }
		      _getCanvasCache() {
		          return this._cache.get(CANVAS);
		      }
		      /*
		       * when the logic for a cached result depends on ancestor propagation, use this
		       * method to clear self and children cache
		       */
		      _clearSelfAndDescendantCache(attr) {
		          this._clearCache(attr);
		          // trigger clear cache, so transformer can use it
		          if (attr === ABSOLUTE_TRANSFORM) {
		              this.fire('absoluteTransformChange');
		          }
		      }
		      /**
		       * clear cached canvas
		       * @method
		       * @name Konva.Node#clearCache
		       * @returns {Konva.Node}
		       * @example
		       * node.clearCache();
		       */
		      clearCache() {
		          if (this._cache.has(CANVAS)) {
		              const { scene, filter, hit } = this._cache.get(CANVAS);
		              Util.releaseCanvas(scene, filter, hit);
		              this._cache.delete(CANVAS);
		          }
		          this._clearSelfAndDescendantCache();
		          this._requestDraw();
		          return this;
		      }
		      /**
		       *  cache node to improve drawing performance, apply filters, or create more accurate
		       *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
		       *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
		       *  properties. Look at [https://konvajs.org/docs/performance/Shape_Caching.html](https://konvajs.org/docs/performance/Shape_Caching.html) for more information.
		       * @method
		       * @name Konva.Node#cache
		       * @param {Object} [config]
		       * @param {Number} [config.x]
		       * @param {Number} [config.y]
		       * @param {Number} [config.width]
		       * @param {Number} [config.height]
		       * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
		       * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
		       *  region for debugging purposes
		       * @param {Number} [config.pixelRatio] change quality (or pixel ratio) of cached image. pixelRatio = 2 will produce 2x sized cache.
		       * @param {Boolean} [config.imageSmoothingEnabled] control imageSmoothingEnabled property of created canvas for cache
		       * @param {Number} [config.hitCanvasPixelRatio] change quality (or pixel ratio) of cached hit canvas.
		       * @returns {Konva.Node}
		       * @example
		       * // cache a shape with the x,y position of the bounding box at the center and
		       * // the width and height of the bounding box equal to the width and height of
		       * // the shape obtained from shape.width() and shape.height()
		       * image.cache();
		       *
		       * // cache a node and define the bounding box position and size
		       * node.cache({
		       *   x: -30,
		       *   y: -30,
		       *   width: 100,
		       *   height: 200
		       * });
		       *
		       * // cache a node and draw a red border around the bounding box
		       * // for debugging purposes
		       * node.cache({
		       *   x: -30,
		       *   y: -30,
		       *   width: 100,
		       *   height: 200,
		       *   offset : 10,
		       *   drawBorder: true
		       * });
		       */
		      cache(config) {
		          var conf = config || {};
		          var rect = {};
		          // don't call getClientRect if we have all attributes
		          // it means call it only if have one undefined
		          if (conf.x === undefined ||
		              conf.y === undefined ||
		              conf.width === undefined ||
		              conf.height === undefined) {
		              rect = this.getClientRect({
		                  skipTransform: true,
		                  relativeTo: this.getParent() || undefined,
		              });
		          }
		          var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
		          if (!width || !height) {
		              Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
		              return;
		          }
		          // let's just add 1 pixel extra,
		          // because using Math.floor on x, y position may shift drawing
		          width += offset * 2 + 1;
		          height += offset * 2 + 1;
		          x -= offset;
		          y -= offset;
		          // if (Math.floor(x) < x) {
		          //   x = Math.floor(x);
		          //   // width += 1;
		          // }
		          // if (Math.floor(y) < y) {
		          //   y = Math.floor(y);
		          //   // height += 1;
		          // }
		          // console.log({ x, y, width, height }, rect);
		          var cachedSceneCanvas = new SceneCanvas({
		              pixelRatio: pixelRatio,
		              width: width,
		              height: height,
		          }), cachedFilterCanvas = new SceneCanvas({
		              pixelRatio: pixelRatio,
		              width: 0,
		              height: 0,
		              willReadFrequently: true,
		          }), cachedHitCanvas = new HitCanvas({
		              pixelRatio: hitCanvasPixelRatio,
		              width: width,
		              height: height,
		          }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
		          cachedHitCanvas.isCache = true;
		          cachedSceneCanvas.isCache = true;
		          this._cache.delete(CANVAS);
		          this._filterUpToDate = false;
		          if (conf.imageSmoothingEnabled === false) {
		              cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
		              cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
		          }
		          sceneContext.save();
		          hitContext.save();
		          sceneContext.translate(-x, -y);
		          hitContext.translate(-x, -y);
		          // extra flag to skip on getAbsolute opacity calc
		          this._isUnderCache = true;
		          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		          this.drawScene(cachedSceneCanvas, this);
		          this.drawHit(cachedHitCanvas, this);
		          this._isUnderCache = false;
		          sceneContext.restore();
		          hitContext.restore();
		          // this will draw a red border around the cached box for
		          // debugging purposes
		          if (drawBorder) {
		              sceneContext.save();
		              sceneContext.beginPath();
		              sceneContext.rect(0, 0, width, height);
		              sceneContext.closePath();
		              sceneContext.setAttr('strokeStyle', 'red');
		              sceneContext.setAttr('lineWidth', 5);
		              sceneContext.stroke();
		              sceneContext.restore();
		          }
		          this._cache.set(CANVAS, {
		              scene: cachedSceneCanvas,
		              filter: cachedFilterCanvas,
		              hit: cachedHitCanvas,
		              x: x,
		              y: y,
		          });
		          this._requestDraw();
		          return this;
		      }
		      /**
		       * determine if node is currently cached
		       * @method
		       * @name Konva.Node#isCached
		       * @returns {Boolean}
		       */
		      isCached() {
		          return this._cache.has(CANVAS);
		      }
		      /**
		       * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
		       * The purpose of the method is similar to getBoundingClientRect API of the DOM.
		       * @method
		       * @name Konva.Node#getClientRect
		       * @param {Object} config
		       * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
		       * @param {Boolean} [config.skipShadow] should we apply shadow to the node for calculating bound box?
		       * @param {Boolean} [config.skipStroke] should we apply stroke to the node for calculating bound box?
		       * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
		       * @returns {Object} rect with {x, y, width, height} properties
		       * @example
		       * var rect = new Konva.Rect({
		       *      width : 100,
		       *      height : 100,
		       *      x : 50,
		       *      y : 50,
		       *      strokeWidth : 4,
		       *      stroke : 'black',
		       *      offsetX : 50,
		       *      scaleY : 2
		       * });
		       *
		       * // get client rect without think off transformations (position, rotation, scale, offset, etc)
		       * rect.getClientRect({ skipTransform: true});
		       * // returns {
		       * //     x : -2,   // two pixels for stroke / 2
		       * //     y : -2,
		       * //     width : 104, // increased by 4 for stroke
		       * //     height : 104
		       * //}
		       *
		       * // get client rect with transformation applied
		       * rect.getClientRect();
		       * // returns Object {x: -2, y: 46, width: 104, height: 208}
		       */
		      getClientRect(config) {
		          // abstract method
		          // redefine in Container and Shape
		          throw new Error('abstract "getClientRect" method call');
		      }
		      _transformedRect(rect, top) {
		          var points = [
		              { x: rect.x, y: rect.y },
		              { x: rect.x + rect.width, y: rect.y },
		              { x: rect.x + rect.width, y: rect.y + rect.height },
		              { x: rect.x, y: rect.y + rect.height },
		          ];
		          var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
		          var trans = this.getAbsoluteTransform(top);
		          points.forEach(function (point) {
		              var transformed = trans.point(point);
		              if (minX === undefined) {
		                  minX = maxX = transformed.x;
		                  minY = maxY = transformed.y;
		              }
		              minX = Math.min(minX, transformed.x);
		              minY = Math.min(minY, transformed.y);
		              maxX = Math.max(maxX, transformed.x);
		              maxY = Math.max(maxY, transformed.y);
		          });
		          return {
		              x: minX,
		              y: minY,
		              width: maxX - minX,
		              height: maxY - minY,
		          };
		      }
		      _drawCachedSceneCanvas(context) {
		          context.save();
		          context._applyOpacity(this);
		          context._applyGlobalCompositeOperation(this);
		          const canvasCache = this._getCanvasCache();
		          context.translate(canvasCache.x, canvasCache.y);
		          var cacheCanvas = this._getCachedSceneCanvas();
		          var ratio = cacheCanvas.pixelRatio;
		          context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
		          context.restore();
		      }
		      _drawCachedHitCanvas(context) {
		          var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
		          context.save();
		          context.translate(canvasCache.x, canvasCache.y);
		          context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
		          context.restore();
		      }
		      _getCachedSceneCanvas() {
		          var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
		          if (filters) {
		              if (!this._filterUpToDate) {
		                  var ratio = sceneCanvas.pixelRatio;
		                  filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
		                  try {
		                      len = filters.length;
		                      filterContext.clear();
		                      // copy cached canvas onto filter context
		                      filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
		                      imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
		                      // apply filters to filter context
		                      for (n = 0; n < len; n++) {
		                          filter = filters[n];
		                          if (typeof filter !== 'function') {
		                              Util.error('Filter should be type of function, but got ' +
		                                  typeof filter +
		                                  ' instead. Please check correct filters');
		                              continue;
		                          }
		                          filter.call(this, imageData);
		                          filterContext.putImageData(imageData, 0, 0);
		                      }
		                  }
		                  catch (e) {
		                      Util.error('Unable to apply filter. ' +
		                          e.message +
		                          ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
		                  }
		                  this._filterUpToDate = true;
		              }
		              return filterCanvas;
		          }
		          return sceneCanvas;
		      }
		      /**
		       * bind events to the node. KonvaJS supports mouseover, mousemove,
		       *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, contextmenu, click, dblclick, touchstart, touchmove,
		       *  touchend, tap, dbltap, dragstart, dragmove, and dragend events.
		       *  Pass in a string of events delimited by a space to bind multiple events at once
		       *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
		       *  event by name such as 'click.foobar'.
		       * @method
		       * @name Konva.Node#on
		       * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
		       * @param {Function} handler The handler function. The first argument of that function is event object. Event object has `target` as main target of the event, `currentTarget` as current node listener and `evt` as native browser event.
		       * @returns {Konva.Node}
		       * @example
		       * // add click listener
		       * node.on('click', function() {
		       *   console.log('you clicked me!');
		       * });
		       *
		       * // get the target node
		       * node.on('click', function(evt) {
		       *   console.log(evt.target);
		       * });
		       *
		       * // stop event propagation
		       * node.on('click', function(evt) {
		       *   evt.cancelBubble = true;
		       * });
		       *
		       * // bind multiple listeners
		       * node.on('click touchstart', function() {
		       *   console.log('you clicked/touched me!');
		       * });
		       *
		       * // namespace listener
		       * node.on('click.foo', function() {
		       *   console.log('you clicked/touched me!');
		       * });
		       *
		       * // get the event type
		       * node.on('click tap', function(evt) {
		       *   var eventType = evt.type;
		       * });
		       *
		       * // get native event object
		       * node.on('click tap', function(evt) {
		       *   var nativeEvent = evt.evt;
		       * });
		       *
		       * // for change events, get the old and new val
		       * node.on('xChange', function(evt) {
		       *   var oldVal = evt.oldVal;
		       *   var newVal = evt.newVal;
		       * });
		       *
		       * // get event targets
		       * // with event delegations
		       * layer.on('click', 'Group', function(evt) {
		       *   var shape = evt.target;
		       *   var group = evt.currentTarget;
		       * });
		       */
		      on(evtStr, handler) {
		          this._cache && this._cache.delete(ALL_LISTENERS);
		          if (arguments.length === 3) {
		              return this._delegate.apply(this, arguments);
		          }
		          var events = evtStr.split(SPACE$1), len = events.length, n, event, parts, baseEvent, name;
		          /*
		           * loop through types and attach event listeners to
		           * each one.  eg. 'click mouseover.namespace mouseout'
		           * will create three event bindings
		           */
		          for (n = 0; n < len; n++) {
		              event = events[n];
		              parts = event.split('.');
		              baseEvent = parts[0];
		              name = parts[1] || '';
		              // create events array if it doesn't exist
		              if (!this.eventListeners[baseEvent]) {
		                  this.eventListeners[baseEvent] = [];
		              }
		              this.eventListeners[baseEvent].push({
		                  name: name,
		                  handler: handler,
		              });
		          }
		          return this;
		      }
		      /**
		       * remove event bindings from the node. Pass in a string of
		       *  event types delimmited by a space to remove multiple event
		       *  bindings at once such as 'mousedown mouseup mousemove'.
		       *  include a namespace to remove an event binding by name
		       *  such as 'click.foobar'. If you only give a name like '.foobar',
		       *  all events in that namespace will be removed.
		       * @method
		       * @name Konva.Node#off
		       * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
		       * @returns {Konva.Node}
		       * @example
		       * // remove listener
		       * node.off('click');
		       *
		       * // remove multiple listeners
		       * node.off('click touchstart');
		       *
		       * // remove listener by name
		       * node.off('click.foo');
		       */
		      off(evtStr, callback) {
		          var events = (evtStr || '').split(SPACE$1), len = events.length, n, t, event, parts, baseEvent, name;
		          this._cache && this._cache.delete(ALL_LISTENERS);
		          if (!evtStr) {
		              // remove all events
		              for (t in this.eventListeners) {
		                  this._off(t);
		              }
		          }
		          for (n = 0; n < len; n++) {
		              event = events[n];
		              parts = event.split('.');
		              baseEvent = parts[0];
		              name = parts[1];
		              if (baseEvent) {
		                  if (this.eventListeners[baseEvent]) {
		                      this._off(baseEvent, name, callback);
		                  }
		              }
		              else {
		                  for (t in this.eventListeners) {
		                      this._off(t, name, callback);
		                  }
		              }
		          }
		          return this;
		      }
		      // some event aliases for third party integration like HammerJS
		      dispatchEvent(evt) {
		          var e = {
		              target: this,
		              type: evt.type,
		              evt: evt,
		          };
		          this.fire(evt.type, e);
		          return this;
		      }
		      addEventListener(type, handler) {
		          // we have to pass native event to handler
		          this.on(type, function (evt) {
		              handler.call(this, evt.evt);
		          });
		          return this;
		      }
		      removeEventListener(type) {
		          this.off(type);
		          return this;
		      }
		      // like node.on
		      _delegate(event, selector, handler) {
		          var stopNode = this;
		          this.on(event, function (evt) {
		              var targets = evt.target.findAncestors(selector, true, stopNode);
		              for (var i = 0; i < targets.length; i++) {
		                  evt = Util.cloneObject(evt);
		                  evt.currentTarget = targets[i];
		                  handler.call(targets[i], evt);
		              }
		          });
		      }
		      /**
		       * remove a node from parent, but don't destroy. You can reuse the node later.
		       * @method
		       * @name Konva.Node#remove
		       * @returns {Konva.Node}
		       * @example
		       * node.remove();
		       */
		      remove() {
		          if (this.isDragging()) {
		              this.stopDrag();
		          }
		          // we can have drag element but that is not dragged yet
		          // so just clear it
		          DD._dragElements.delete(this._id);
		          this._remove();
		          return this;
		      }
		      _clearCaches() {
		          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		          this._clearSelfAndDescendantCache(STAGE$1);
		          this._clearSelfAndDescendantCache(VISIBLE);
		          this._clearSelfAndDescendantCache(LISTENING);
		      }
		      _remove() {
		          // every cached attr that is calculated via node tree
		          // traversal must be cleared when removing a node
		          this._clearCaches();
		          var parent = this.getParent();
		          if (parent && parent.children) {
		              parent.children.splice(this.index, 1);
		              parent._setChildrenIndices();
		              this.parent = null;
		          }
		      }
		      /**
		       * remove and destroy a node. Kill it and delete forever! You should not reuse node after destroy().
		       * If the node is a container (Group, Stage or Layer) it will destroy all children too.
		       * @method
		       * @name Konva.Node#destroy
		       * @example
		       * node.destroy();
		       */
		      destroy() {
		          this.remove();
		          this.clearCache();
		          return this;
		      }
		      /**
		       * get attr
		       * @method
		       * @name Konva.Node#getAttr
		       * @param {String} attr
		       * @returns {Integer|String|Object|Array}
		       * @example
		       * var x = node.getAttr('x');
		       */
		      getAttr(attr) {
		          var method = 'get' + Util._capitalize(attr);
		          if (Util._isFunction(this[method])) {
		              return this[method]();
		          }
		          // otherwise get directly
		          return this.attrs[attr];
		      }
		      /**
		       * get ancestors
		       * @method
		       * @name Konva.Node#getAncestors
		       * @returns {Array}
		       * @example
		       * shape.getAncestors().forEach(function(node) {
		       *   console.log(node.getId());
		       * })
		       */
		      getAncestors() {
		          var parent = this.getParent(), ancestors = [];
		          while (parent) {
		              ancestors.push(parent);
		              parent = parent.getParent();
		          }
		          return ancestors;
		      }
		      /**
		       * get attrs object literal
		       * @method
		       * @name Konva.Node#getAttrs
		       * @returns {Object}
		       */
		      getAttrs() {
		          return this.attrs || {};
		      }
		      /**
		       * set multiple attrs at once using an object literal
		       * @method
		       * @name Konva.Node#setAttrs
		       * @param {Object} config object containing key value pairs
		       * @returns {Konva.Node}
		       * @example
		       * node.setAttrs({
		       *   x: 5,
		       *   fill: 'red'
		       * });
		       */
		      setAttrs(config) {
		          this._batchTransformChanges(() => {
		              var key, method;
		              if (!config) {
		                  return this;
		              }
		              for (key in config) {
		                  if (key === CHILDREN) {
		                      continue;
		                  }
		                  method = SET + Util._capitalize(key);
		                  // use setter if available
		                  if (Util._isFunction(this[method])) {
		                      this[method](config[key]);
		                  }
		                  else {
		                      // otherwise set directly
		                      this._setAttr(key, config[key]);
		                  }
		              }
		          });
		          return this;
		      }
		      /**
		       * determine if node is listening for events by taking into account ancestors.
		       *
		       * Parent    | Self      | isListening
		       * listening | listening |
		       * ----------+-----------+------------
		       * T         | T         | T
		       * T         | F         | F
		       * F         | T         | F
		       * F         | F         | F
		       *
		       * @method
		       * @name Konva.Node#isListening
		       * @returns {Boolean}
		       */
		      isListening() {
		          return this._getCache(LISTENING, this._isListening);
		      }
		      _isListening(relativeTo) {
		          const listening = this.listening();
		          if (!listening) {
		              return false;
		          }
		          const parent = this.getParent();
		          if (parent && parent !== relativeTo && this !== relativeTo) {
		              return parent._isListening(relativeTo);
		          }
		          else {
		              return true;
		          }
		      }
		      /**
		       * determine if node is visible by taking into account ancestors.
		       *
		       * Parent    | Self      | isVisible
		       * visible   | visible   |
		       * ----------+-----------+------------
		       * T         | T         | T
		       * T         | F         | F
		       * F         | T         | F
		       * F         | F         | F
		       * @method
		       * @name Konva.Node#isVisible
		       * @returns {Boolean}
		       */
		      isVisible() {
		          return this._getCache(VISIBLE, this._isVisible);
		      }
		      _isVisible(relativeTo) {
		          const visible = this.visible();
		          if (!visible) {
		              return false;
		          }
		          const parent = this.getParent();
		          if (parent && parent !== relativeTo && this !== relativeTo) {
		              return parent._isVisible(relativeTo);
		          }
		          else {
		              return true;
		          }
		      }
		      shouldDrawHit(top, skipDragCheck = false) {
		          if (top) {
		              return this._isVisible(top) && this._isListening(top);
		          }
		          var layer = this.getLayer();
		          var layerUnderDrag = false;
		          DD._dragElements.forEach((elem) => {
		              if (elem.dragStatus !== 'dragging') {
		                  return;
		              }
		              else if (elem.node.nodeType === 'Stage') {
		                  layerUnderDrag = true;
		              }
		              else if (elem.node.getLayer() === layer) {
		                  layerUnderDrag = true;
		              }
		          });
		          var dragSkip = !skipDragCheck && !Konva$2.hitOnDragEnabled && layerUnderDrag;
		          return this.isListening() && this.isVisible() && !dragSkip;
		      }
		      /**
		       * show node. set visible = true
		       * @method
		       * @name Konva.Node#show
		       * @returns {Konva.Node}
		       */
		      show() {
		          this.visible(true);
		          return this;
		      }
		      /**
		       * hide node.  Hidden nodes are no longer detectable
		       * @method
		       * @name Konva.Node#hide
		       * @returns {Konva.Node}
		       */
		      hide() {
		          this.visible(false);
		          return this;
		      }
		      getZIndex() {
		          return this.index || 0;
		      }
		      /**
		       * get absolute z-index which takes into account sibling
		       *  and ancestor indices
		       * @method
		       * @name Konva.Node#getAbsoluteZIndex
		       * @returns {Integer}
		       */
		      getAbsoluteZIndex() {
		          var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
		          function addChildren(children) {
		              nodes = [];
		              len = children.length;
		              for (n = 0; n < len; n++) {
		                  child = children[n];
		                  index++;
		                  if (child.nodeType !== SHAPE) {
		                      nodes = nodes.concat(child.getChildren().slice());
		                  }
		                  if (child._id === that._id) {
		                      n = len;
		                  }
		              }
		              if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
		                  addChildren(nodes);
		              }
		          }
		          const stage = this.getStage();
		          if (that.nodeType !== UPPER_STAGE && stage) {
		              addChildren(stage.getChildren());
		          }
		          return index;
		      }
		      /**
		       * get node depth in node tree.  Returns an integer.
		       *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
		       *  be >= 2
		       * @method
		       * @name Konva.Node#getDepth
		       * @returns {Integer}
		       */
		      getDepth() {
		          var depth = 0, parent = this.parent;
		          while (parent) {
		              depth++;
		              parent = parent.parent;
		          }
		          return depth;
		      }
		      // sometimes we do several attributes changes
		      // like node.position(pos)
		      // for performance reasons, lets batch transform reset
		      // so it work faster
		      _batchTransformChanges(func) {
		          this._batchingTransformChange = true;
		          func();
		          this._batchingTransformChange = false;
		          if (this._needClearTransformCache) {
		              this._clearCache(TRANSFORM);
		              this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		          }
		          this._needClearTransformCache = false;
		      }
		      setPosition(pos) {
		          this._batchTransformChanges(() => {
		              this.x(pos.x);
		              this.y(pos.y);
		          });
		          return this;
		      }
		      getPosition() {
		          return {
		              x: this.x(),
		              y: this.y(),
		          };
		      }
		      /**
		       * get position of first pointer (like mouse or first touch) relative to local coordinates of current node
		       * @method
		       * @name Konva.Node#getRelativePointerPosition
		       * @returns {Konva.Node}
		       * @example
		       *
		       * // let's think we have a rectangle at position x = 10, y = 10
		       * // now we clicked at x = 15, y = 15 of the stage
		       * // if you want to know position of the click, related to the rectangle you can use
		       * rect.getRelativePointerPosition();
		       */
		      getRelativePointerPosition() {
		          const stage = this.getStage();
		          if (!stage) {
		              return null;
		          }
		          // get pointer (say mouse or touch) position
		          var pos = stage.getPointerPosition();
		          if (!pos) {
		              return null;
		          }
		          var transform = this.getAbsoluteTransform().copy();
		          // to detect relative position we need to invert transform
		          transform.invert();
		          // now we can find relative point
		          return transform.point(pos);
		      }
		      /**
		       * get absolute position of a node. That function can be used to calculate absolute position, but relative to any ancestor
		       * @method
		       * @name Konva.Node#getAbsolutePosition
		       * @param {Object} Ancestor optional ancestor node
		       * @returns {Konva.Node}
		       * @example
		       *
		       * // returns absolute position relative to top-left corner of canvas
		       * node.getAbsolutePosition();
		       *
		       * // calculate absolute position of node, inside stage
		       * // so stage transforms are ignored
		       * node.getAbsolutePosition(stage)
		       */
		      getAbsolutePosition(top) {
		          let haveCachedParent = false;
		          let parent = this.parent;
		          while (parent) {
		              if (parent.isCached()) {
		                  haveCachedParent = true;
		                  break;
		              }
		              parent = parent.parent;
		          }
		          if (haveCachedParent && !top) {
		              // make fake top element
		              // "true" is not a node, but it will just allow skip all caching
		              top = true;
		          }
		          var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Transform(), offset = this.offset();
		          // clone the matrix array
		          absoluteTransform.m = absoluteMatrix.slice();
		          absoluteTransform.translate(offset.x, offset.y);
		          return absoluteTransform.getTranslation();
		      }
		      setAbsolutePosition(pos) {
		          const { x, y, ...origTrans } = this._clearTransform();
		          // don't clear translation
		          this.attrs.x = x;
		          this.attrs.y = y;
		          // important, use non cached value
		          this._clearCache(TRANSFORM);
		          var it = this._getAbsoluteTransform().copy();
		          it.invert();
		          it.translate(pos.x, pos.y);
		          pos = {
		              x: this.attrs.x + it.getTranslation().x,
		              y: this.attrs.y + it.getTranslation().y,
		          };
		          this._setTransform(origTrans);
		          this.setPosition({ x: pos.x, y: pos.y });
		          this._clearCache(TRANSFORM);
		          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		          return this;
		      }
		      _setTransform(trans) {
		          var key;
		          for (key in trans) {
		              this.attrs[key] = trans[key];
		          }
		          // this._clearCache(TRANSFORM);
		          // this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		      }
		      _clearTransform() {
		          var trans = {
		              x: this.x(),
		              y: this.y(),
		              rotation: this.rotation(),
		              scaleX: this.scaleX(),
		              scaleY: this.scaleY(),
		              offsetX: this.offsetX(),
		              offsetY: this.offsetY(),
		              skewX: this.skewX(),
		              skewY: this.skewY(),
		          };
		          this.attrs.x = 0;
		          this.attrs.y = 0;
		          this.attrs.rotation = 0;
		          this.attrs.scaleX = 1;
		          this.attrs.scaleY = 1;
		          this.attrs.offsetX = 0;
		          this.attrs.offsetY = 0;
		          this.attrs.skewX = 0;
		          this.attrs.skewY = 0;
		          // return original transform
		          return trans;
		      }
		      /**
		       * move node by an amount relative to its current position
		       * @method
		       * @name Konva.Node#move
		       * @param {Object} change
		       * @param {Number} change.x
		       * @param {Number} change.y
		       * @returns {Konva.Node}
		       * @example
		       * // move node in x direction by 1px and y direction by 2px
		       * node.move({
		       *   x: 1,
		       *   y: 2
		       * });
		       */
		      move(change) {
		          var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
		          if (changeX !== undefined) {
		              x += changeX;
		          }
		          if (changeY !== undefined) {
		              y += changeY;
		          }
		          this.setPosition({ x: x, y: y });
		          return this;
		      }
		      _eachAncestorReverse(func, top) {
		          var family = [], parent = this.getParent(), len, n;
		          // if top node is defined, and this node is top node,
		          // there's no need to build a family tree.  just execute
		          // func with this because it will be the only node
		          if (top && top._id === this._id) {
		              // func(this);
		              return;
		          }
		          family.unshift(this);
		          while (parent && (!top || parent._id !== top._id)) {
		              family.unshift(parent);
		              parent = parent.parent;
		          }
		          len = family.length;
		          for (n = 0; n < len; n++) {
		              func(family[n]);
		          }
		      }
		      /**
		       * rotate node by an amount in degrees relative to its current rotation
		       * @method
		       * @name Konva.Node#rotate
		       * @param {Number} theta
		       * @returns {Konva.Node}
		       */
		      rotate(theta) {
		          this.rotation(this.rotation() + theta);
		          return this;
		      }
		      /**
		       * move node to the top of its siblings
		       * @method
		       * @name Konva.Node#moveToTop
		       * @returns {Boolean}
		       */
		      moveToTop() {
		          if (!this.parent) {
		              Util.warn('Node has no parent. moveToTop function is ignored.');
		              return false;
		          }
		          var index = this.index, len = this.parent.getChildren().length;
		          if (index < len - 1) {
		              this.parent.children.splice(index, 1);
		              this.parent.children.push(this);
		              this.parent._setChildrenIndices();
		              return true;
		          }
		          return false;
		      }
		      /**
		       * move node up
		       * @method
		       * @name Konva.Node#moveUp
		       * @returns {Boolean} flag is moved or not
		       */
		      moveUp() {
		          if (!this.parent) {
		              Util.warn('Node has no parent. moveUp function is ignored.');
		              return false;
		          }
		          var index = this.index, len = this.parent.getChildren().length;
		          if (index < len - 1) {
		              this.parent.children.splice(index, 1);
		              this.parent.children.splice(index + 1, 0, this);
		              this.parent._setChildrenIndices();
		              return true;
		          }
		          return false;
		      }
		      /**
		       * move node down
		       * @method
		       * @name Konva.Node#moveDown
		       * @returns {Boolean}
		       */
		      moveDown() {
		          if (!this.parent) {
		              Util.warn('Node has no parent. moveDown function is ignored.');
		              return false;
		          }
		          var index = this.index;
		          if (index > 0) {
		              this.parent.children.splice(index, 1);
		              this.parent.children.splice(index - 1, 0, this);
		              this.parent._setChildrenIndices();
		              return true;
		          }
		          return false;
		      }
		      /**
		       * move node to the bottom of its siblings
		       * @method
		       * @name Konva.Node#moveToBottom
		       * @returns {Boolean}
		       */
		      moveToBottom() {
		          if (!this.parent) {
		              Util.warn('Node has no parent. moveToBottom function is ignored.');
		              return false;
		          }
		          var index = this.index;
		          if (index > 0) {
		              this.parent.children.splice(index, 1);
		              this.parent.children.unshift(this);
		              this.parent._setChildrenIndices();
		              return true;
		          }
		          return false;
		      }
		      setZIndex(zIndex) {
		          if (!this.parent) {
		              Util.warn('Node has no parent. zIndex parameter is ignored.');
		              return this;
		          }
		          if (zIndex < 0 || zIndex >= this.parent.children.length) {
		              Util.warn('Unexpected value ' +
		                  zIndex +
		                  ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' +
		                  (this.parent.children.length - 1) +
		                  '.');
		          }
		          var index = this.index;
		          this.parent.children.splice(index, 1);
		          this.parent.children.splice(zIndex, 0, this);
		          this.parent._setChildrenIndices();
		          return this;
		      }
		      /**
		       * get absolute opacity
		       * @method
		       * @name Konva.Node#getAbsoluteOpacity
		       * @returns {Number}
		       */
		      getAbsoluteOpacity() {
		          return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
		      }
		      _getAbsoluteOpacity() {
		          var absOpacity = this.opacity();
		          var parent = this.getParent();
		          if (parent && !parent._isUnderCache) {
		              absOpacity *= parent.getAbsoluteOpacity();
		          }
		          return absOpacity;
		      }
		      /**
		       * move node to another container
		       * @method
		       * @name Konva.Node#moveTo
		       * @param {Container} newContainer
		       * @returns {Konva.Node}
		       * @example
		       * // move node from current layer into layer2
		       * node.moveTo(layer2);
		       */
		      moveTo(newContainer) {
		          // do nothing if new container is already parent
		          if (this.getParent() !== newContainer) {
		              this._remove();
		              newContainer.add(this);
		          }
		          return this;
		      }
		      /**
		       * convert Node into an object for serialization.  Returns an object.
		       * @method
		       * @name Konva.Node#toObject
		       * @returns {Object}
		       */
		      toObject() {
		          var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
		          obj.attrs = {};
		          for (key in attrs) {
		              val = attrs[key];
		              // if value is object and object is not plain
		              // like class instance, we should skip it and to not include
		              nonPlainObject =
		                  Util.isObject(val) && !Util._isPlainObject(val) && !Util._isArray(val);
		              if (nonPlainObject) {
		                  continue;
		              }
		              getter = typeof this[key] === 'function' && this[key];
		              // remove attr value so that we can extract the default value from the getter
		              delete attrs[key];
		              defaultValue = getter ? getter.call(this) : null;
		              // restore attr value
		              attrs[key] = val;
		              if (defaultValue !== val) {
		                  obj.attrs[key] = val;
		              }
		          }
		          obj.className = this.getClassName();
		          return Util._prepareToStringify(obj);
		      }
		      /**
		       * convert Node into a JSON string.  Returns a JSON string.
		       * @method
		       * @name Konva.Node#toJSON
		       * @returns {String}
		       */
		      toJSON() {
		          return JSON.stringify(this.toObject());
		      }
		      /**
		       * get parent container
		       * @method
		       * @name Konva.Node#getParent
		       * @returns {Konva.Node}
		       */
		      getParent() {
		          return this.parent;
		      }
		      /**
		       * get all ancestors (parent then parent of the parent, etc) of the node
		       * @method
		       * @name Konva.Node#findAncestors
		       * @param {String} selector selector for search
		       * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
		       * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
		       * @returns {Array} [ancestors]
		       * @example
		       * // get one of the parent group
		       * var parentGroups = node.findAncestors('Group');
		       */
		      findAncestors(selector, includeSelf, stopNode) {
		          var res = [];
		          if (includeSelf && this._isMatch(selector)) {
		              res.push(this);
		          }
		          var ancestor = this.parent;
		          while (ancestor) {
		              if (ancestor === stopNode) {
		                  return res;
		              }
		              if (ancestor._isMatch(selector)) {
		                  res.push(ancestor);
		              }
		              ancestor = ancestor.parent;
		          }
		          return res;
		      }
		      isAncestorOf(node) {
		          return false;
		      }
		      /**
		       * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
		       * @method
		       * @name Konva.Node#findAncestor
		       * @param {String} selector selector for search
		       * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
		       * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
		       * @returns {Konva.Node} ancestor
		       * @example
		       * // get one of the parent group
		       * var group = node.findAncestors('.mygroup');
		       */
		      findAncestor(selector, includeSelf, stopNode) {
		          return this.findAncestors(selector, includeSelf, stopNode)[0];
		      }
		      // is current node match passed selector?
		      _isMatch(selector) {
		          if (!selector) {
		              return false;
		          }
		          if (typeof selector === 'function') {
		              return selector(this);
		          }
		          var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
		          for (n = 0; n < len; n++) {
		              sel = selectorArr[n];
		              if (!Util.isValidSelector(sel)) {
		                  Util.warn('Selector "' +
		                      sel +
		                      '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
		                  Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
		                  Util.warn('Konva is awesome, right?');
		              }
		              // id selector
		              if (sel.charAt(0) === '#') {
		                  if (this.id() === sel.slice(1)) {
		                      return true;
		                  }
		              }
		              else if (sel.charAt(0) === '.') {
		                  // name selector
		                  if (this.hasName(sel.slice(1))) {
		                      return true;
		                  }
		              }
		              else if (this.className === sel || this.nodeType === sel) {
		                  return true;
		              }
		          }
		          return false;
		      }
		      /**
		       * get layer ancestor
		       * @method
		       * @name Konva.Node#getLayer
		       * @returns {Konva.Layer}
		       */
		      getLayer() {
		          var parent = this.getParent();
		          return parent ? parent.getLayer() : null;
		      }
		      /**
		       * get stage ancestor
		       * @method
		       * @name Konva.Node#getStage
		       * @returns {Konva.Stage}
		       */
		      getStage() {
		          return this._getCache(STAGE$1, this._getStage);
		      }
		      _getStage() {
		          var parent = this.getParent();
		          if (parent) {
		              return parent.getStage();
		          }
		          else {
		              return null;
		          }
		      }
		      /**
		       * fire event
		       * @method
		       * @name Konva.Node#fire
		       * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
		       * @param {Event} [evt] event object
		       * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
		       *  not bubbling.  Setting the value to true will result in the event bubbling.
		       * @returns {Konva.Node}
		       * @example
		       * // manually fire click event
		       * node.fire('click');
		       *
		       * // fire custom event
		       * node.fire('foo');
		       *
		       * // fire custom event with custom event object
		       * node.fire('foo', {
		       *   bar: 10
		       * });
		       *
		       * // fire click event that bubbles
		       * node.fire('click', null, true);
		       */
		      fire(eventType, evt = {}, bubble) {
		          evt.target = evt.target || this;
		          // bubble
		          if (bubble) {
		              this._fireAndBubble(eventType, evt);
		          }
		          else {
		              // no bubble
		              this._fire(eventType, evt);
		          }
		          return this;
		      }
		      /**
		       * get absolute transform of the node which takes into
		       *  account its ancestor transforms
		       * @method
		       * @name Konva.Node#getAbsoluteTransform
		       * @returns {Konva.Transform}
		       */
		      getAbsoluteTransform(top) {
		          // if using an argument, we can't cache the result.
		          if (top) {
		              return this._getAbsoluteTransform(top);
		          }
		          else {
		              // if no argument, we can cache the result
		              return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
		          }
		      }
		      _getAbsoluteTransform(top) {
		          var at;
		          // we we need position relative to an ancestor, we will iterate for all
		          if (top) {
		              at = new Transform();
		              // start with stage and traverse downwards to self
		              this._eachAncestorReverse(function (node) {
		                  var transformsEnabled = node.transformsEnabled();
		                  if (transformsEnabled === 'all') {
		                      at.multiply(node.getTransform());
		                  }
		                  else if (transformsEnabled === 'position') {
		                      at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
		                  }
		              }, top);
		              return at;
		          }
		          else {
		              // try to use a cached value
		              at = this._cache.get(ABSOLUTE_TRANSFORM) || new Transform();
		              if (this.parent) {
		                  // transform will be cached
		                  this.parent.getAbsoluteTransform().copyInto(at);
		              }
		              else {
		                  at.reset();
		              }
		              var transformsEnabled = this.transformsEnabled();
		              if (transformsEnabled === 'all') {
		                  at.multiply(this.getTransform());
		              }
		              else if (transformsEnabled === 'position') {
		                  // use "attrs" directly, because it is a bit faster
		                  const x = this.attrs.x || 0;
		                  const y = this.attrs.y || 0;
		                  const offsetX = this.attrs.offsetX || 0;
		                  const offsetY = this.attrs.offsetY || 0;
		                  at.translate(x - offsetX, y - offsetY);
		              }
		              at.dirty = false;
		              return at;
		          }
		      }
		      /**
		       * get absolute scale of the node which takes into
		       *  account its ancestor scales
		       * @method
		       * @name Konva.Node#getAbsoluteScale
		       * @returns {Object}
		       * @example
		       * // get absolute scale x
		       * var scaleX = node.getAbsoluteScale().x;
		       */
		      getAbsoluteScale(top) {
		          // do not cache this calculations,
		          // because it use cache transform
		          // this is special logic for caching with some shapes with shadow
		          var parent = this;
		          while (parent) {
		              if (parent._isUnderCache) {
		                  top = parent;
		              }
		              parent = parent.getParent();
		          }
		          const transform = this.getAbsoluteTransform(top);
		          const attrs = transform.decompose();
		          return {
		              x: attrs.scaleX,
		              y: attrs.scaleY,
		          };
		      }
		      /**
		       * get absolute rotation of the node which takes into
		       *  account its ancestor rotations
		       * @method
		       * @name Konva.Node#getAbsoluteRotation
		       * @returns {Number}
		       * @example
		       * // get absolute rotation
		       * var rotation = node.getAbsoluteRotation();
		       */
		      getAbsoluteRotation() {
		          // var parent: Node = this;
		          // var rotation = 0;
		          // while (parent) {
		          //   rotation += parent.rotation();
		          //   parent = parent.getParent();
		          // }
		          // return rotation;
		          return this.getAbsoluteTransform().decompose().rotation;
		      }
		      /**
		       * get transform of the node
		       * @method
		       * @name Konva.Node#getTransform
		       * @returns {Konva.Transform}
		       */
		      getTransform() {
		          return this._getCache(TRANSFORM, this._getTransform);
		      }
		      _getTransform() {
		          var _a, _b;
		          var m = this._cache.get(TRANSFORM) || new Transform();
		          m.reset();
		          // I was trying to use attributes directly here
		          // but it doesn't work for Transformer well
		          // because it overwrite x,y getters
		          var x = this.x(), y = this.y(), rotation = Konva$2.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
		          if (x !== 0 || y !== 0) {
		              m.translate(x, y);
		          }
		          if (rotation !== 0) {
		              m.rotate(rotation);
		          }
		          if (skewX !== 0 || skewY !== 0) {
		              m.skew(skewX, skewY);
		          }
		          if (scaleX !== 1 || scaleY !== 1) {
		              m.scale(scaleX, scaleY);
		          }
		          if (offsetX !== 0 || offsetY !== 0) {
		              m.translate(-1 * offsetX, -1 * offsetY);
		          }
		          m.dirty = false;
		          return m;
		      }
		      /**
		       * clone node.  Returns a new Node instance with identical attributes.  You can also override
		       *  the node properties with an object literal, enabling you to use an existing node as a template
		       *  for another node
		       * @method
		       * @name Konva.Node#clone
		       * @param {Object} obj override attrs
		       * @returns {Konva.Node}
		       * @example
		       * // simple clone
		       * var clone = node.clone();
		       *
		       * // clone a node and override the x position
		       * var clone = rect.clone({
		       *   x: 5
		       * });
		       */
		      clone(obj) {
		          // instantiate new node
		          var attrs = Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
		          // apply attr overrides
		          for (key in obj) {
		              attrs[key] = obj[key];
		          }
		          var node = new this.constructor(attrs);
		          // copy over listeners
		          for (key in this.eventListeners) {
		              allListeners = this.eventListeners[key];
		              len = allListeners.length;
		              for (n = 0; n < len; n++) {
		                  listener = allListeners[n];
		                  /*
		                   * don't include konva namespaced listeners because
		                   *  these are generated by the constructors
		                   */
		                  if (listener.name.indexOf(KONVA) < 0) {
		                      // if listeners array doesn't exist, then create it
		                      if (!node.eventListeners[key]) {
		                          node.eventListeners[key] = [];
		                      }
		                      node.eventListeners[key].push(listener);
		                  }
		              }
		          }
		          return node;
		      }
		      _toKonvaCanvas(config) {
		          config = config || {};
		          var box = this.getClientRect();
		          var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new SceneCanvas({
		              width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
		              height: config.height ||
		                  Math.ceil(box.height) ||
		                  (stage ? stage.height() : 0),
		              pixelRatio: pixelRatio,
		          }), context = canvas.getContext();
		          if (config.imageSmoothingEnabled === false) {
		              context._context.imageSmoothingEnabled = false;
		          }
		          context.save();
		          if (x || y) {
		              context.translate(-1 * x, -1 * y);
		          }
		          this.drawScene(canvas);
		          context.restore();
		          return canvas;
		      }
		      /**
		       * converts node into an canvas element.
		       * @method
		       * @name Konva.Node#toCanvas
		       * @param {Object} config
		       * @param {Function} config.callback function executed when the composite has completed
		       * @param {Number} [config.x] x position of canvas section
		       * @param {Number} [config.y] y position of canvas section
		       * @param {Number} [config.width] width of canvas section
		       * @param {Number} [config.height] height of canvas section
		       * @param {Number} [config.pixelRatio] pixelRatio of output canvas. Default is 1.
		       * You can use that property to increase quality of the image, for example for super hight quality exports
		       * or usage on retina (or similar) displays. pixelRatio will be used to multiply the size of exported image.
		       * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
		       * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
		       * @example
		       * var canvas = node.toCanvas();
		       */
		      toCanvas(config) {
		          return this._toKonvaCanvas(config)._canvas;
		      }
		      /**
		       * Creates a composite data URL (base64 string). If MIME type is not
		       * specified, then "image/png" will result. For "image/jpeg", specify a quality
		       * level as quality (range 0.0 - 1.0)
		       * @method
		       * @name Konva.Node#toDataURL
		       * @param {Object} config
		       * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
		       *  "image/png" is the default
		       * @param {Number} [config.x] x position of canvas section
		       * @param {Number} [config.y] y position of canvas section
		       * @param {Number} [config.width] width of canvas section
		       * @param {Number} [config.height] height of canvas section
		       * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
		       *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
		       *  is very high quality
		       * @param {Number} [config.pixelRatio] pixelRatio of output image url. Default is 1.
		       * You can use that property to increase quality of the image, for example for super hight quality exports
		       * or usage on retina (or similar) displays. pixelRatio will be used to multiply the size of exported image.
		       * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
		       * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
		       * @returns {String}
		       */
		      toDataURL(config) {
		          config = config || {};
		          var mimeType = config.mimeType || null, quality = config.quality || null;
		          var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
		          if (config.callback) {
		              config.callback(url);
		          }
		          return url;
		      }
		      /**
		       * converts node into an image.  Since the toImage
		       *  method is asynchronous, the resulting image can only be retrieved from the config callback
		       *  or the returned Promise.  toImage is most commonly used
		       *  to cache complex drawings as an image so that they don't have to constantly be redrawn
		       * @method
		       * @name Konva.Node#toImage
		       * @param {Object} config
		       * @param {Function} [config.callback] function executed when the composite has completed
		       * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
		       *  "image/png" is the default
		       * @param {Number} [config.x] x position of canvas section
		       * @param {Number} [config.y] y position of canvas section
		       * @param {Number} [config.width] width of canvas section
		       * @param {Number} [config.height] height of canvas section
		       * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
		       *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
		       *  is very high quality
		       * @param {Number} [config.pixelRatio] pixelRatio of output image. Default is 1.
		       * You can use that property to increase quality of the image, for example for super hight quality exports
		       * or usage on retina (or similar) displays. pixelRatio will be used to multiply the size of exported image.
		       * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
		       * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
		       * @return {Promise<Image>}
		       * @example
		       * var image = node.toImage({
		       *   callback(img) {
		       *     // do stuff with img
		       *   }
		       * });
		       */
		      toImage(config) {
		          return new Promise((resolve, reject) => {
		              try {
		                  const callback = config === null || config === void 0 ? void 0 : config.callback;
		                  if (callback)
		                      delete config.callback;
		                  Util._urlToImage(this.toDataURL(config), function (img) {
		                      resolve(img);
		                      callback === null || callback === void 0 ? void 0 : callback(img);
		                  });
		              }
		              catch (err) {
		                  reject(err);
		              }
		          });
		      }
		      /**
		       * Converts node into a blob.  Since the toBlob method is asynchronous,
		       *  the resulting blob can only be retrieved from the config callback
		       *  or the returned Promise.
		       * @method
		       * @name Konva.Node#toBlob
		       * @param {Object} config
		       * @param {Function} [config.callback] function executed when the composite has completed
		       * @param {Number} [config.x] x position of canvas section
		       * @param {Number} [config.y] y position of canvas section
		       * @param {Number} [config.width] width of canvas section
		       * @param {Number} [config.height] height of canvas section
		       * @param {Number} [config.pixelRatio] pixelRatio of output canvas. Default is 1.
		       * You can use that property to increase quality of the image, for example for super hight quality exports
		       * or usage on retina (or similar) displays. pixelRatio will be used to multiply the size of exported image.
		       * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
		       * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
		       * @example
		       * var blob = await node.toBlob({});
		       * @returns {Promise<Blob>}
		       */
		      toBlob(config) {
		          return new Promise((resolve, reject) => {
		              try {
		                  const callback = config === null || config === void 0 ? void 0 : config.callback;
		                  if (callback)
		                      delete config.callback;
		                  this.toCanvas(config).toBlob((blob) => {
		                      resolve(blob);
		                      callback === null || callback === void 0 ? void 0 : callback(blob);
		                  });
		              }
		              catch (err) {
		                  reject(err);
		              }
		          });
		      }
		      setSize(size) {
		          this.width(size.width);
		          this.height(size.height);
		          return this;
		      }
		      getSize() {
		          return {
		              width: this.width(),
		              height: this.height(),
		          };
		      }
		      /**
		       * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
		       * @method
		       * @name Konva.Node#getClassName
		       * @returns {String}
		       */
		      getClassName() {
		          return this.className || this.nodeType;
		      }
		      /**
		       * get the node type, which may return Stage, Layer, Group, or Shape
		       * @method
		       * @name Konva.Node#getType
		       * @returns {String}
		       */
		      getType() {
		          return this.nodeType;
		      }
		      getDragDistance() {
		          // compare with undefined because we need to track 0 value
		          if (this.attrs.dragDistance !== undefined) {
		              return this.attrs.dragDistance;
		          }
		          else if (this.parent) {
		              return this.parent.getDragDistance();
		          }
		          else {
		              return Konva$2.dragDistance;
		          }
		      }
		      _off(type, name, callback) {
		          var evtListeners = this.eventListeners[type], i, evtName, handler;
		          for (i = 0; i < evtListeners.length; i++) {
		              evtName = evtListeners[i].name;
		              handler = evtListeners[i].handler;
		              // the following two conditions must be true in order to remove a handler:
		              // 1) the current event name cannot be konva unless the event name is konva
		              //    this enables developers to force remove a konva specific listener for whatever reason
		              // 2) an event name is not specified, or if one is specified, it matches the current event name
		              if ((evtName !== 'konva' || name === 'konva') &&
		                  (!name || evtName === name) &&
		                  (!callback || callback === handler)) {
		                  evtListeners.splice(i, 1);
		                  if (evtListeners.length === 0) {
		                      delete this.eventListeners[type];
		                      break;
		                  }
		                  i--;
		              }
		          }
		      }
		      _fireChangeEvent(attr, oldVal, newVal) {
		          this._fire(attr + CHANGE, {
		              oldVal: oldVal,
		              newVal: newVal,
		          });
		      }
		      /**
		       * add name to node
		       * @method
		       * @name Konva.Node#addName
		       * @param {String} name
		       * @returns {Konva.Node}
		       * @example
		       * node.name('red');
		       * node.addName('selected');
		       * node.name(); // return 'red selected'
		       */
		      addName(name) {
		          if (!this.hasName(name)) {
		              var oldName = this.name();
		              var newName = oldName ? oldName + ' ' + name : name;
		              this.name(newName);
		          }
		          return this;
		      }
		      /**
		       * check is node has name
		       * @method
		       * @name Konva.Node#hasName
		       * @param {String} name
		       * @returns {Boolean}
		       * @example
		       * node.name('red');
		       * node.hasName('red');   // return true
		       * node.hasName('selected'); // return false
		       * node.hasName(''); // return false
		       */
		      hasName(name) {
		          if (!name) {
		              return false;
		          }
		          const fullName = this.name();
		          if (!fullName) {
		              return false;
		          }
		          // if name is '' the "names" will be [''], so I added extra check above
		          var names = (fullName || '').split(/\s/g);
		          return names.indexOf(name) !== -1;
		      }
		      /**
		       * remove name from node
		       * @method
		       * @name Konva.Node#removeName
		       * @param {String} name
		       * @returns {Konva.Node}
		       * @example
		       * node.name('red selected');
		       * node.removeName('selected');
		       * node.hasName('selected'); // return false
		       * node.name(); // return 'red'
		       */
		      removeName(name) {
		          var names = (this.name() || '').split(/\s/g);
		          var index = names.indexOf(name);
		          if (index !== -1) {
		              names.splice(index, 1);
		              this.name(names.join(' '));
		          }
		          return this;
		      }
		      /**
		       * set attr
		       * @method
		       * @name Konva.Node#setAttr
		       * @param {String} attr
		       * @param {*} val
		       * @returns {Konva.Node}
		       * @example
		       * node.setAttr('x', 5);
		       */
		      setAttr(attr, val) {
		          var func = this[SET + Util._capitalize(attr)];
		          if (Util._isFunction(func)) {
		              func.call(this, val);
		          }
		          else {
		              // otherwise set directly
		              this._setAttr(attr, val);
		          }
		          return this;
		      }
		      _requestDraw() {
		          if (Konva$2.autoDrawEnabled) {
		              const drawNode = this.getLayer() || this.getStage();
		              drawNode === null || drawNode === void 0 ? void 0 : drawNode.batchDraw();
		          }
		      }
		      _setAttr(key, val) {
		          var oldVal = this.attrs[key];
		          if (oldVal === val && !Util.isObject(val)) {
		              return;
		          }
		          if (val === undefined || val === null) {
		              delete this.attrs[key];
		          }
		          else {
		              this.attrs[key] = val;
		          }
		          if (this._shouldFireChangeEvents) {
		              this._fireChangeEvent(key, oldVal, val);
		          }
		          this._requestDraw();
		      }
		      _setComponentAttr(key, component, val) {
		          var oldVal;
		          if (val !== undefined) {
		              oldVal = this.attrs[key];
		              if (!oldVal) {
		                  // set value to default value using getAttr
		                  this.attrs[key] = this.getAttr(key);
		              }
		              this.attrs[key][component] = val;
		              this._fireChangeEvent(key, oldVal, val);
		          }
		      }
		      _fireAndBubble(eventType, evt, compareShape) {
		          if (evt && this.nodeType === SHAPE) {
		              evt.target = this;
		          }
		          var shouldStop = (eventType === MOUSEENTER$1 || eventType === MOUSELEAVE$1) &&
		              ((compareShape &&
		                  (this === compareShape ||
		                      (this.isAncestorOf && this.isAncestorOf(compareShape)))) ||
		                  (this.nodeType === 'Stage' && !compareShape));
		          if (!shouldStop) {
		              this._fire(eventType, evt);
		              // simulate event bubbling
		              var stopBubble = (eventType === MOUSEENTER$1 || eventType === MOUSELEAVE$1) &&
		                  compareShape &&
		                  compareShape.isAncestorOf &&
		                  compareShape.isAncestorOf(this) &&
		                  !compareShape.isAncestorOf(this.parent);
		              if (((evt && !evt.cancelBubble) || !evt) &&
		                  this.parent &&
		                  this.parent.isListening() &&
		                  !stopBubble) {
		                  if (compareShape && compareShape.parent) {
		                      this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
		                  }
		                  else {
		                      this._fireAndBubble.call(this.parent, eventType, evt);
		                  }
		              }
		          }
		      }
		      _getProtoListeners(eventType) {
		          var _a, _b, _c;
		          const allListeners = (_a = this._cache.get(ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
		          let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
		          if (events === undefined) {
		              //recalculate cache
		              events = [];
		              let obj = Object.getPrototypeOf(this);
		              while (obj) {
		                  const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
		                  events.push(...hierarchyEvents);
		                  obj = Object.getPrototypeOf(obj);
		              }
		              // update cache
		              allListeners[eventType] = events;
		              this._cache.set(ALL_LISTENERS, allListeners);
		          }
		          return events;
		      }
		      _fire(eventType, evt) {
		          evt = evt || {};
		          evt.currentTarget = this;
		          evt.type = eventType;
		          const topListeners = this._getProtoListeners(eventType);
		          if (topListeners) {
		              for (var i = 0; i < topListeners.length; i++) {
		                  topListeners[i].handler.call(this, evt);
		              }
		          }
		          // it is important to iterate over self listeners without cache
		          // because events can be added/removed while firing
		          const selfListeners = this.eventListeners[eventType];
		          if (selfListeners) {
		              for (var i = 0; i < selfListeners.length; i++) {
		                  selfListeners[i].handler.call(this, evt);
		              }
		          }
		      }
		      /**
		       * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
		       * @method
		       * @name Konva.Node#draw
		       * @returns {Konva.Node}
		       */
		      draw() {
		          this.drawScene();
		          this.drawHit();
		          return this;
		      }
		      // drag & drop
		      _createDragElement(evt) {
		          var pointerId = evt ? evt.pointerId : undefined;
		          var stage = this.getStage();
		          var ap = this.getAbsolutePosition();
		          if (!stage) {
		              return;
		          }
		          var pos = stage._getPointerById(pointerId) ||
		              stage._changedPointerPositions[0] ||
		              ap;
		          DD._dragElements.set(this._id, {
		              node: this,
		              startPointerPos: pos,
		              offset: {
		                  x: pos.x - ap.x,
		                  y: pos.y - ap.y,
		              },
		              dragStatus: 'ready',
		              pointerId,
		          });
		      }
		      /**
		       * initiate drag and drop.
		       * @method
		       * @name Konva.Node#startDrag
		       */
		      startDrag(evt, bubbleEvent = true) {
		          if (!DD._dragElements.has(this._id)) {
		              this._createDragElement(evt);
		          }
		          const elem = DD._dragElements.get(this._id);
		          elem.dragStatus = 'dragging';
		          this.fire('dragstart', {
		              type: 'dragstart',
		              target: this,
		              evt: evt && evt.evt,
		          }, bubbleEvent);
		      }
		      _setDragPosition(evt, elem) {
		          // const pointers = this.getStage().getPointersPositions();
		          // const pos = pointers.find(p => p.id === this._dragEventId);
		          const pos = this.getStage()._getPointerById(elem.pointerId);
		          if (!pos) {
		              return;
		          }
		          var newNodePos = {
		              x: pos.x - elem.offset.x,
		              y: pos.y - elem.offset.y,
		          };
		          var dbf = this.dragBoundFunc();
		          if (dbf !== undefined) {
		              const bounded = dbf.call(this, newNodePos, evt);
		              if (!bounded) {
		                  Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
		              }
		              else {
		                  newNodePos = bounded;
		              }
		          }
		          if (!this._lastPos ||
		              this._lastPos.x !== newNodePos.x ||
		              this._lastPos.y !== newNodePos.y) {
		              this.setAbsolutePosition(newNodePos);
		              this._requestDraw();
		          }
		          this._lastPos = newNodePos;
		      }
		      /**
		       * stop drag and drop
		       * @method
		       * @name Konva.Node#stopDrag
		       */
		      stopDrag(evt) {
		          const elem = DD._dragElements.get(this._id);
		          if (elem) {
		              elem.dragStatus = 'stopped';
		          }
		          DD._endDragBefore(evt);
		          DD._endDragAfter(evt);
		      }
		      setDraggable(draggable) {
		          this._setAttr('draggable', draggable);
		          this._dragChange();
		      }
		      /**
		       * determine if node is currently in drag and drop mode
		       * @method
		       * @name Konva.Node#isDragging
		       */
		      isDragging() {
		          const elem = DD._dragElements.get(this._id);
		          return elem ? elem.dragStatus === 'dragging' : false;
		      }
		      _listenDrag() {
		          this._dragCleanup();
		          this.on('mousedown.konva touchstart.konva', function (evt) {
		              var shouldCheckButton = evt.evt['button'] !== undefined;
		              var canDrag = !shouldCheckButton || Konva$2.dragButtons.indexOf(evt.evt['button']) >= 0;
		              if (!canDrag) {
		                  return;
		              }
		              if (this.isDragging()) {
		                  return;
		              }
		              var hasDraggingChild = false;
		              DD._dragElements.forEach((elem) => {
		                  if (this.isAncestorOf(elem.node)) {
		                      hasDraggingChild = true;
		                  }
		              });
		              // nested drag can be started
		              // in that case we don't need to start new drag
		              if (!hasDraggingChild) {
		                  this._createDragElement(evt);
		              }
		          });
		      }
		      _dragChange() {
		          if (this.attrs.draggable) {
		              this._listenDrag();
		          }
		          else {
		              // remove event listeners
		              this._dragCleanup();
		              /*
		               * force drag and drop to end
		               * if this node is currently in
		               * drag and drop mode
		               */
		              var stage = this.getStage();
		              if (!stage) {
		                  return;
		              }
		              const dragElement = DD._dragElements.get(this._id);
		              const isDragging = dragElement && dragElement.dragStatus === 'dragging';
		              const isReady = dragElement && dragElement.dragStatus === 'ready';
		              if (isDragging) {
		                  this.stopDrag();
		              }
		              else if (isReady) {
		                  DD._dragElements.delete(this._id);
		              }
		          }
		      }
		      _dragCleanup() {
		          this.off('mousedown.konva');
		          this.off('touchstart.konva');
		      }
		      /**
		       * determine if node (at least partially) is currently in user-visible area
		       * @method
		       * @param {(Number | Object)} margin optional margin in pixels
		       * @param {Number} margin.x
		       * @param {Number} margin.y
		       * @returns {Boolean}
		       * @name Konva.Node#isClientRectOnScreen
		       * @example
		       * // get index
		       * // default calculations
		       * var isOnScreen = node.isClientRectOnScreen()
		       * // increase object size (or screen size) for cases when objects close to the screen still need to be marked as "visible"
		       * var isOnScreen = node.isClientRectOnScreen({ x: stage.width(), y: stage.height() })
		       */
		      isClientRectOnScreen(margin = { x: 0, y: 0 }) {
		          const stage = this.getStage();
		          if (!stage) {
		              return false;
		          }
		          const screenRect = {
		              x: -margin.x,
		              y: -margin.y,
		              width: stage.width() + 2 * margin.x,
		              height: stage.height() + 2 * margin.y,
		          };
		          return Util.haveIntersection(screenRect, this.getClientRect());
		      }
		      /**
		       * create node with JSON string or an Object.  De-serializtion does not generate custom
		       *  shape drawing functions, images, or event handlers (this would make the
		       *  serialized object huge).  If your app uses custom shapes, images, and
		       *  event handlers (it probably does), then you need to select the appropriate
		       *  shapes after loading the stage and set these properties via on(), setSceneFunc(),
		       *  and setImage() methods
		       * @method
		       * @memberof Konva.Node
		       * @param {String|Object} json string or object
		       * @param {Element} [container] optional container dom element used only if you're
		       *  creating a stage node
		       */
		      static create(data, container) {
		          if (Util._isString(data)) {
		              data = JSON.parse(data);
		          }
		          return this._createNode(data, container);
		      }
		      static _createNode(obj, container) {
		          var className = Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
		          // if container was passed in, add it to attrs
		          if (container) {
		              obj.attrs.container = container;
		          }
		          if (!Konva$2[className]) {
		              Util.warn('Can not find a node with class name "' +
		                  className +
		                  '". Fallback to "Shape".');
		              className = 'Shape';
		          }
		          const Class = Konva$2[className];
		          no = new Class(obj.attrs);
		          if (children) {
		              len = children.length;
		              for (n = 0; n < len; n++) {
		                  no.add(Node._createNode(children[n]));
		              }
		          }
		          return no;
		      }
		  }
		  Node.prototype.nodeType = 'Node';
		  Node.prototype._attrsAffectingSize = [];
		  // attache events listeners once into prototype
		  // that way we don't spend too much time on making an new instance
		  Node.prototype.eventListeners = {};
		  Node.prototype.on.call(Node.prototype, TRANSFORM_CHANGE_STR$1, function () {
		      if (this._batchingTransformChange) {
		          this._needClearTransformCache = true;
		          return;
		      }
		      this._clearCache(TRANSFORM);
		      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		  });
		  Node.prototype.on.call(Node.prototype, 'visibleChange.konva', function () {
		      this._clearSelfAndDescendantCache(VISIBLE);
		  });
		  Node.prototype.on.call(Node.prototype, 'listeningChange.konva', function () {
		      this._clearSelfAndDescendantCache(LISTENING);
		  });
		  Node.prototype.on.call(Node.prototype, 'opacityChange.konva', function () {
		      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		  });
		  const addGetterSetter = Factory.addGetterSetter;
		  /**
		   * get/set zIndex relative to the node's siblings who share the same parent.
		   * Please remember that zIndex is not absolute (like in CSS). It is relative to parent element only.
		   * @name Konva.Node#zIndex
		   * @method
		   * @param {Number} index
		   * @returns {Number}
		   * @example
		   * // get index
		   * var index = node.zIndex();
		   *
		   * // set index
		   * node.zIndex(2);
		   */
		  addGetterSetter(Node, 'zIndex');
		  /**
		   * get/set node absolute position
		   * @name Konva.Node#absolutePosition
		   * @method
		   * @param {Object} pos
		   * @param {Number} pos.x
		   * @param {Number} pos.y
		   * @returns {Object}
		   * @example
		   * // get position
		   * var position = node.absolutePosition();
		   *
		   * // set position
		   * node.absolutePosition({
		   *   x: 5,
		   *   y: 10
		   * });
		   */
		  addGetterSetter(Node, 'absolutePosition');
		  addGetterSetter(Node, 'position');
		  /**
		   * get/set node position relative to parent
		   * @name Konva.Node#position
		   * @method
		   * @param {Object} pos
		   * @param {Number} pos.x
		   * @param {Number} pos.y
		   * @returns {Object}
		   * @example
		   * // get position
		   * var position = node.position();
		   *
		   * // set position
		   * node.position({
		   *   x: 5,
		   *   y: 10
		   * });
		   */
		  addGetterSetter(Node, 'x', 0, getNumberValidator());
		  /**
		   * get/set x position
		   * @name Konva.Node#x
		   * @method
		   * @param {Number} x
		   * @returns {Object}
		   * @example
		   * // get x
		   * var x = node.x();
		   *
		   * // set x
		   * node.x(5);
		   */
		  addGetterSetter(Node, 'y', 0, getNumberValidator());
		  /**
		   * get/set y position
		   * @name Konva.Node#y
		   * @method
		   * @param {Number} y
		   * @returns {Integer}
		   * @example
		   * // get y
		   * var y = node.y();
		   *
		   * // set y
		   * node.y(5);
		   */
		  addGetterSetter(Node, 'globalCompositeOperation', 'source-over', getStringValidator());
		  /**
		   * get/set globalCompositeOperation of a node. globalCompositeOperation DOESN'T affect hit graph of nodes. So they are still trigger to events as they have default "source-over" globalCompositeOperation.
		   * @name Konva.Node#globalCompositeOperation
		   * @method
		   * @param {String} type
		   * @returns {String}
		   * @example
		   * // get globalCompositeOperation
		   * var globalCompositeOperation = shape.globalCompositeOperation();
		   *
		   * // set globalCompositeOperation
		   * shape.globalCompositeOperation('source-in');
		   */
		  addGetterSetter(Node, 'opacity', 1, getNumberValidator());
		  /**
		   * get/set opacity.  Opacity values range from 0 to 1.
		   *  A node with an opacity of 0 is fully transparent, and a node
		   *  with an opacity of 1 is fully opaque
		   * @name Konva.Node#opacity
		   * @method
		   * @param {Object} opacity
		   * @returns {Number}
		   * @example
		   * // get opacity
		   * var opacity = node.opacity();
		   *
		   * // set opacity
		   * node.opacity(0.5);
		   */
		  addGetterSetter(Node, 'name', '', getStringValidator());
		  /**
		   * get/set name.
		   * @name Konva.Node#name
		   * @method
		   * @param {String} name
		   * @returns {String}
		   * @example
		   * // get name
		   * var name = node.name();
		   *
		   * // set name
		   * node.name('foo');
		   *
		   * // also node may have multiple names (as css classes)
		   * node.name('foo bar');
		   */
		  addGetterSetter(Node, 'id', '', getStringValidator());
		  /**
		   * get/set id. Id is global for whole page.
		   * @name Konva.Node#id
		   * @method
		   * @param {String} id
		   * @returns {String}
		   * @example
		   * // get id
		   * var name = node.id();
		   *
		   * // set id
		   * node.id('foo');
		   */
		  addGetterSetter(Node, 'rotation', 0, getNumberValidator());
		  /**
		   * get/set rotation in degrees
		   * @name Konva.Node#rotation
		   * @method
		   * @param {Number} rotation
		   * @returns {Number}
		   * @example
		   * // get rotation in degrees
		   * var rotation = node.rotation();
		   *
		   * // set rotation in degrees
		   * node.rotation(45);
		   */
		  Factory.addComponentsGetterSetter(Node, 'scale', ['x', 'y']);
		  /**
		   * get/set scale
		   * @name Konva.Node#scale
		   * @param {Object} scale
		   * @param {Number} scale.x
		   * @param {Number} scale.y
		   * @method
		   * @returns {Object}
		   * @example
		   * // get scale
		   * var scale = node.scale();
		   *
		   * // set scale
		   * shape.scale({
		   *   x: 2,
		   *   y: 3
		   * });
		   */
		  addGetterSetter(Node, 'scaleX', 1, getNumberValidator());
		  /**
		   * get/set scale x
		   * @name Konva.Node#scaleX
		   * @param {Number} x
		   * @method
		   * @returns {Number}
		   * @example
		   * // get scale x
		   * var scaleX = node.scaleX();
		   *
		   * // set scale x
		   * node.scaleX(2);
		   */
		  addGetterSetter(Node, 'scaleY', 1, getNumberValidator());
		  /**
		   * get/set scale y
		   * @name Konva.Node#scaleY
		   * @param {Number} y
		   * @method
		   * @returns {Number}
		   * @example
		   * // get scale y
		   * var scaleY = node.scaleY();
		   *
		   * // set scale y
		   * node.scaleY(2);
		   */
		  Factory.addComponentsGetterSetter(Node, 'skew', ['x', 'y']);
		  /**
		   * get/set skew
		   * @name Konva.Node#skew
		   * @param {Object} skew
		   * @param {Number} skew.x
		   * @param {Number} skew.y
		   * @method
		   * @returns {Object}
		   * @example
		   * // get skew
		   * var skew = node.skew();
		   *
		   * // set skew
		   * node.skew({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  addGetterSetter(Node, 'skewX', 0, getNumberValidator());
		  /**
		   * get/set skew x
		   * @name Konva.Node#skewX
		   * @param {Number} x
		   * @method
		   * @returns {Number}
		   * @example
		   * // get skew x
		   * var skewX = node.skewX();
		   *
		   * // set skew x
		   * node.skewX(3);
		   */
		  addGetterSetter(Node, 'skewY', 0, getNumberValidator());
		  /**
		   * get/set skew y
		   * @name Konva.Node#skewY
		   * @param {Number} y
		   * @method
		   * @returns {Number}
		   * @example
		   * // get skew y
		   * var skewY = node.skewY();
		   *
		   * // set skew y
		   * node.skewY(3);
		   */
		  Factory.addComponentsGetterSetter(Node, 'offset', ['x', 'y']);
		  /**
		   * get/set offset.  Offsets the default position and rotation point
		   * @method
		   * @param {Object} offset
		   * @param {Number} offset.x
		   * @param {Number} offset.y
		   * @returns {Object}
		   * @example
		   * // get offset
		   * var offset = node.offset();
		   *
		   * // set offset
		   * node.offset({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  addGetterSetter(Node, 'offsetX', 0, getNumberValidator());
		  /**
		   * get/set offset x
		   * @name Konva.Node#offsetX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get offset x
		   * var offsetX = node.offsetX();
		   *
		   * // set offset x
		   * node.offsetX(3);
		   */
		  addGetterSetter(Node, 'offsetY', 0, getNumberValidator());
		  /**
		   * get/set offset y
		   * @name Konva.Node#offsetY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get offset y
		   * var offsetY = node.offsetY();
		   *
		   * // set offset y
		   * node.offsetY(3);
		   */
		  addGetterSetter(Node, 'dragDistance', null, getNumberValidator());
		  /**
		   * get/set drag distance
		   * @name Konva.Node#dragDistance
		   * @method
		   * @param {Number} distance
		   * @returns {Number}
		   * @example
		   * // get drag distance
		   * var dragDistance = node.dragDistance();
		   *
		   * // set distance
		   * // node starts dragging only if pointer moved more then 3 pixels
		   * node.dragDistance(3);
		   * // or set globally
		   * Konva.dragDistance = 3;
		   */
		  addGetterSetter(Node, 'width', 0, getNumberValidator());
		  /**
		   * get/set width
		   * @name Konva.Node#width
		   * @method
		   * @param {Number} width
		   * @returns {Number}
		   * @example
		   * // get width
		   * var width = node.width();
		   *
		   * // set width
		   * node.width(100);
		   */
		  addGetterSetter(Node, 'height', 0, getNumberValidator());
		  /**
		   * get/set height
		   * @name Konva.Node#height
		   * @method
		   * @param {Number} height
		   * @returns {Number}
		   * @example
		   * // get height
		   * var height = node.height();
		   *
		   * // set height
		   * node.height(100);
		   */
		  addGetterSetter(Node, 'listening', true, getBooleanValidator());
		  /**
		   * get/set listening attr.  If you need to determine if a node is listening or not
		   *   by taking into account its parents, use the isListening() method
		   * @name Konva.Node#listening
		   * @method
		   * @param {Boolean} listening Can be true, or false.  The default is true.
		   * @returns {Boolean}
		   * @example
		   * // get listening attr
		   * var listening = node.listening();
		   *
		   * // stop listening for events, remove node and all its children from hit graph
		   * node.listening(false);
		   *
		   * // listen to events according to the parent
		   * node.listening(true);
		   */
		  /**
		   * get/set preventDefault
		   * By default all shapes will prevent default behavior
		   * of a browser on a pointer move or tap.
		   * that will prevent native scrolling when you are trying to drag&drop a node
		   * but sometimes you may need to enable default actions
		   * in that case you can set the property to false
		   * @name Konva.Node#preventDefault
		   * @method
		   * @param {Boolean} preventDefault
		   * @returns {Boolean}
		   * @example
		   * // get preventDefault
		   * var shouldPrevent = shape.preventDefault();
		   *
		   * // set preventDefault
		   * shape.preventDefault(false);
		   */
		  addGetterSetter(Node, 'preventDefault', true, getBooleanValidator());
		  addGetterSetter(Node, 'filters', null, function (val) {
		      this._filterUpToDate = false;
		      return val;
		  });
		  /**
		   * get/set filters.  Filters are applied to cached canvases
		   * @name Konva.Node#filters
		   * @method
		   * @param {Array} filters array of filters
		   * @returns {Array}
		   * @example
		   * // get filters
		   * var filters = node.filters();
		   *
		   * // set a single filter
		   * node.cache();
		   * node.filters([Konva.Filters.Blur]);
		   *
		   * // set multiple filters
		   * node.cache();
		   * node.filters([
		   *   Konva.Filters.Blur,
		   *   Konva.Filters.Sepia,
		   *   Konva.Filters.Invert
		   * ]);
		   */
		  addGetterSetter(Node, 'visible', true, getBooleanValidator());
		  /**
		   * get/set visible attr.  Can be true, or false.  The default is true.
		   *   If you need to determine if a node is visible or not
		   *   by taking into account its parents, use the isVisible() method
		   * @name Konva.Node#visible
		   * @method
		   * @param {Boolean} visible
		   * @returns {Boolean}
		   * @example
		   * // get visible attr
		   * var visible = node.visible();
		   *
		   * // make invisible
		   * node.visible(false);
		   *
		   * // make visible (according to the parent)
		   * node.visible(true);
		   *
		   */
		  addGetterSetter(Node, 'transformsEnabled', 'all', getStringValidator());
		  /**
		   * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
		   *  is "all"
		   * @name Konva.Node#transformsEnabled
		   * @method
		   * @param {String} enabled
		   * @returns {String}
		   * @example
		   * // enable position transform only to improve draw performance
		   * node.transformsEnabled('position');
		   *
		   * // enable all transforms
		   * node.transformsEnabled('all');
		   */
		  /**
		   * get/set node size
		   * @name Konva.Node#size
		   * @method
		   * @param {Object} size
		   * @param {Number} size.width
		   * @param {Number} size.height
		   * @returns {Object}
		   * @example
		   * // get node size
		   * var size = node.size();
		   * var width = size.width;
		   * var height = size.height;
		   *
		   * // set size
		   * node.size({
		   *   width: 100,
		   *   height: 200
		   * });
		   */
		  addGetterSetter(Node, 'size');
		  /**
		   * get/set drag bound function.  This is used to override the default
		   *  drag and drop position.
		   * @name Konva.Node#dragBoundFunc
		   * @method
		   * @param {Function} dragBoundFunc
		   * @returns {Function}
		   * @example
		   * // get drag bound function
		   * var dragBoundFunc = node.dragBoundFunc();
		   *
		   * // create vertical drag and drop
		   * node.dragBoundFunc(function(pos){
		   *   // important pos - is absolute position of the node
		   *   // you should return absolute position too
		   *   return {
		   *     x: this.absolutePosition().x,
		   *     y: pos.y
		   *   };
		   * });
		   */
		  addGetterSetter(Node, 'dragBoundFunc');
		  /**
		   * get/set draggable flag
		   * @name Konva.Node#draggable
		   * @method
		   * @param {Boolean} draggable
		   * @returns {Boolean}
		   * @example
		   * // get draggable flag
		   * var draggable = node.draggable();
		   *
		   * // enable drag and drop
		   * node.draggable(true);
		   *
		   * // disable drag and drop
		   * node.draggable(false);
		   */
		  addGetterSetter(Node, 'draggable', false, getBooleanValidator());
		  Factory.backCompat(Node, {
		      rotateDeg: 'rotate',
		      setRotationDeg: 'setRotation',
		      getRotationDeg: 'getRotation',
		  });

		  /**
		   * Container constructor.&nbsp; Containers are used to contain nodes or other containers
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Node
		   * @abstract
		   * @param {Object} config
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * * @param {Object} [config.clip] set clip
		     * @param {Number} [config.clipX] set clip x
		     * @param {Number} [config.clipY] set clip y
		     * @param {Number} [config.clipWidth] set clip width
		     * @param {Number} [config.clipHeight] set clip height
		     * @param {Function} [config.clipFunc] set clip func

		   */
		  class Container extends Node {
		      constructor() {
		          super(...arguments);
		          this.children = [];
		      }
		      /**
		       * returns an array of direct descendant nodes
		       * @method
		       * @name Konva.Container#getChildren
		       * @param {Function} [filterFunc] filter function
		       * @returns {Array}
		       * @example
		       * // get all children
		       * var children = layer.getChildren();
		       *
		       * // get only circles
		       * var circles = layer.getChildren(function(node){
		       *    return node.getClassName() === 'Circle';
		       * });
		       */
		      getChildren(filterFunc) {
		          if (!filterFunc) {
		              return this.children || [];
		          }
		          const children = this.children || [];
		          var results = [];
		          children.forEach(function (child) {
		              if (filterFunc(child)) {
		                  results.push(child);
		              }
		          });
		          return results;
		      }
		      /**
		       * determine if node has children
		       * @method
		       * @name Konva.Container#hasChildren
		       * @returns {Boolean}
		       */
		      hasChildren() {
		          return this.getChildren().length > 0;
		      }
		      /**
		       * remove all children. Children will be still in memory.
		       * If you want to completely destroy all children please use "destroyChildren" method instead
		       * @method
		       * @name Konva.Container#removeChildren
		       */
		      removeChildren() {
		          this.getChildren().forEach((child) => {
		              // reset parent to prevent many _setChildrenIndices calls
		              child.parent = null;
		              child.index = 0;
		              child.remove();
		          });
		          this.children = [];
		          // because all children were detached from parent, request draw via container
		          this._requestDraw();
		          return this;
		      }
		      /**
		       * destroy all children nodes.
		       * @method
		       * @name Konva.Container#destroyChildren
		       */
		      destroyChildren() {
		          this.getChildren().forEach((child) => {
		              // reset parent to prevent many _setChildrenIndices calls
		              child.parent = null;
		              child.index = 0;
		              child.destroy();
		          });
		          this.children = [];
		          // because all children were detached from parent, request draw via container
		          this._requestDraw();
		          return this;
		      }
		      /**
		       * add a child and children into container
		       * @name Konva.Container#add
		       * @method
		       * @param {...Konva.Node} children
		       * @returns {Container}
		       * @example
		       * layer.add(rect);
		       * layer.add(shape1, shape2, shape3);
		       * // empty arrays are accepted, though each individual child must be defined
		       * layer.add(...shapes);
		       * // remember to redraw layer if you changed something
		       * layer.draw();
		       */
		      add(...children) {
		          if (children.length === 0) {
		              return this;
		          }
		          if (children.length > 1) {
		              for (var i = 0; i < children.length; i++) {
		                  this.add(children[i]);
		              }
		              return this;
		          }
		          const child = children[0];
		          if (child.getParent()) {
		              child.moveTo(this);
		              return this;
		          }
		          this._validateAdd(child);
		          child.index = this.getChildren().length;
		          child.parent = this;
		          child._clearCaches();
		          this.getChildren().push(child);
		          this._fire('add', {
		              child: child,
		          });
		          this._requestDraw();
		          // chainable
		          return this;
		      }
		      destroy() {
		          if (this.hasChildren()) {
		              this.destroyChildren();
		          }
		          super.destroy();
		          return this;
		      }
		      /**
		       * return an array of nodes that match the selector.
		       * You can provide a string with '#' for id selections and '.' for name selections.
		       * Or a function that will return true/false when a node is passed through.  See example below.
		       * With strings you can also select by type or class name. Pass multiple selectors
		       * separated by a comma.
		       * @method
		       * @name Konva.Container#find
		       * @param {String | Function} selector
		       * @returns {Array}
		       * @example
		       *
		       * Passing a string as a selector
		       * // select node with id foo
		       * var node = stage.find('#foo');
		       *
		       * // select nodes with name bar inside layer
		       * var nodes = layer.find('.bar');
		       *
		       * // select all groups inside layer
		       * var nodes = layer.find('Group');
		       *
		       * // select all rectangles inside layer
		       * var nodes = layer.find('Rect');
		       *
		       * // select node with an id of foo or a name of bar inside layer
		       * var nodes = layer.find('#foo, .bar');
		       *
		       * Passing a function as a selector
		       *
		       * // get all groups with a function
		       * var groups = stage.find(node => {
		       *  return node.getType() === 'Group';
		       * });
		       *
		       * // get only Nodes with partial opacity
		       * var alphaNodes = layer.find(node => {
		       *  return node.getType() === 'Node' && node.getAbsoluteOpacity() < 1;
		       * });
		       */
		      find(selector) {
		          // protecting _generalFind to prevent user from accidentally adding
		          // second argument and getting unexpected `findOne` result
		          return this._generalFind(selector, false);
		      }
		      /**
		       * return a first node from `find` method
		       * @method
		       * @name Konva.Container#findOne
		       * @param {String | Function} selector
		       * @returns {Konva.Node | Undefined}
		       * @example
		       * // select node with id foo
		       * var node = stage.findOne('#foo');
		       *
		       * // select node with name bar inside layer
		       * var nodes = layer.findOne('.bar');
		       *
		       * // select the first node to return true in a function
		       * var node = stage.findOne(node => {
		       *  return node.getType() === 'Shape'
		       * })
		       */
		      findOne(selector) {
		          var result = this._generalFind(selector, true);
		          return result.length > 0 ? result[0] : undefined;
		      }
		      _generalFind(selector, findOne) {
		          var retArr = [];
		          this._descendants((node) => {
		              const valid = node._isMatch(selector);
		              if (valid) {
		                  retArr.push(node);
		              }
		              if (valid && findOne) {
		                  return true;
		              }
		              return false;
		          });
		          return retArr;
		      }
		      _descendants(fn) {
		          let shouldStop = false;
		          const children = this.getChildren();
		          for (const child of children) {
		              shouldStop = fn(child);
		              if (shouldStop) {
		                  return true;
		              }
		              if (!child.hasChildren()) {
		                  continue;
		              }
		              shouldStop = child._descendants(fn);
		              if (shouldStop) {
		                  return true;
		              }
		          }
		          return false;
		      }
		      // extenders
		      toObject() {
		          var obj = Node.prototype.toObject.call(this);
		          obj.children = [];
		          this.getChildren().forEach((child) => {
		              obj.children.push(child.toObject());
		          });
		          return obj;
		      }
		      /**
		       * determine if node is an ancestor
		       * of descendant
		       * @method
		       * @name Konva.Container#isAncestorOf
		       * @param {Konva.Node} node
		       */
		      isAncestorOf(node) {
		          var parent = node.getParent();
		          while (parent) {
		              if (parent._id === this._id) {
		                  return true;
		              }
		              parent = parent.getParent();
		          }
		          return false;
		      }
		      clone(obj) {
		          // call super method
		          var node = Node.prototype.clone.call(this, obj);
		          this.getChildren().forEach(function (no) {
		              node.add(no.clone());
		          });
		          return node;
		      }
		      /**
		       * get all shapes that intersect a point.  Note: because this method must clear a temporary
		       * canvas and redraw every shape inside the container, it should only be used for special situations
		       * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
		       * because it performs much better
		       * @method
		       * @name Konva.Container#getAllIntersections
		       * @param {Object} pos
		       * @param {Number} pos.x
		       * @param {Number} pos.y
		       * @returns {Array} array of shapes
		       */
		      getAllIntersections(pos) {
		          var arr = [];
		          this.find('Shape').forEach((shape) => {
		              if (shape.isVisible() && shape.intersects(pos)) {
		                  arr.push(shape);
		              }
		          });
		          return arr;
		      }
		      _clearSelfAndDescendantCache(attr) {
		          var _a;
		          super._clearSelfAndDescendantCache(attr);
		          // skip clearing if node is cached with canvas
		          // for performance reasons !!!
		          if (this.isCached()) {
		              return;
		          }
		          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (node) {
		              node._clearSelfAndDescendantCache(attr);
		          });
		      }
		      _setChildrenIndices() {
		          var _a;
		          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child, n) {
		              child.index = n;
		          });
		          this._requestDraw();
		      }
		      drawScene(can, top) {
		          var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas()), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
		          var caching = canvas && canvas.isCache;
		          if (!this.isVisible() && !caching) {
		              return this;
		          }
		          if (cachedSceneCanvas) {
		              context.save();
		              var m = this.getAbsoluteTransform(top).getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		              this._drawCachedSceneCanvas(context);
		              context.restore();
		          }
		          else {
		              this._drawChildren('drawScene', canvas, top);
		          }
		          return this;
		      }
		      drawHit(can, top) {
		          if (!this.shouldDrawHit(top)) {
		              return this;
		          }
		          var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
		          if (cachedHitCanvas) {
		              context.save();
		              var m = this.getAbsoluteTransform(top).getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		              this._drawCachedHitCanvas(context);
		              context.restore();
		          }
		          else {
		              this._drawChildren('drawHit', canvas, top);
		          }
		          return this;
		      }
		      _drawChildren(drawMethod, canvas, top) {
		          var _a;
		          var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = (clipWidth && clipHeight) || clipFunc;
		          const selfCache = top === this;
		          if (hasClip) {
		              context.save();
		              var transform = this.getAbsoluteTransform(top);
		              var m = transform.getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		              context.beginPath();
		              let clipArgs;
		              if (clipFunc) {
		                  clipArgs = clipFunc.call(this, context, this);
		              }
		              else {
		                  var clipX = this.clipX();
		                  var clipY = this.clipY();
		                  context.rect(clipX, clipY, clipWidth, clipHeight);
		              }
		              context.clip.apply(context, clipArgs);
		              m = transform.copy().invert().getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		          }
		          var hasComposition = !selfCache &&
		              this.globalCompositeOperation() !== 'source-over' &&
		              drawMethod === 'drawScene';
		          if (hasComposition) {
		              context.save();
		              context._applyGlobalCompositeOperation(this);
		          }
		          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
		              child[drawMethod](canvas, top);
		          });
		          if (hasComposition) {
		              context.restore();
		          }
		          if (hasClip) {
		              context.restore();
		          }
		      }
		      getClientRect(config = {}) {
		          var _a;
		          var skipTransform = config.skipTransform;
		          var relativeTo = config.relativeTo;
		          var minX, minY, maxX, maxY;
		          var selfRect = {
		              x: Infinity,
		              y: Infinity,
		              width: 0,
		              height: 0,
		          };
		          var that = this;
		          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
		              // skip invisible children
		              if (!child.visible()) {
		                  return;
		              }
		              var rect = child.getClientRect({
		                  relativeTo: that,
		                  skipShadow: config.skipShadow,
		                  skipStroke: config.skipStroke,
		              });
		              // skip invisible children (like empty groups)
		              if (rect.width === 0 && rect.height === 0) {
		                  return;
		              }
		              if (minX === undefined) {
		                  // initial value for first child
		                  minX = rect.x;
		                  minY = rect.y;
		                  maxX = rect.x + rect.width;
		                  maxY = rect.y + rect.height;
		              }
		              else {
		                  minX = Math.min(minX, rect.x);
		                  minY = Math.min(minY, rect.y);
		                  maxX = Math.max(maxX, rect.x + rect.width);
		                  maxY = Math.max(maxY, rect.y + rect.height);
		              }
		          });
		          // if child is group we need to make sure it has visible shapes inside
		          var shapes = this.find('Shape');
		          var hasVisible = false;
		          for (var i = 0; i < shapes.length; i++) {
		              var shape = shapes[i];
		              if (shape._isVisible(this)) {
		                  hasVisible = true;
		                  break;
		              }
		          }
		          if (hasVisible && minX !== undefined) {
		              selfRect = {
		                  x: minX,
		                  y: minY,
		                  width: maxX - minX,
		                  height: maxY - minY,
		              };
		          }
		          else {
		              selfRect = {
		                  x: 0,
		                  y: 0,
		                  width: 0,
		                  height: 0,
		              };
		          }
		          if (!skipTransform) {
		              return this._transformedRect(selfRect, relativeTo);
		          }
		          return selfRect;
		      }
		  }
		  // add getters setters
		  Factory.addComponentsGetterSetter(Container, 'clip', [
		      'x',
		      'y',
		      'width',
		      'height',
		  ]);
		  /**
		   * get/set clip
		   * @method
		   * @name Konva.Container#clip
		   * @param {Object} clip
		   * @param {Number} clip.x
		   * @param {Number} clip.y
		   * @param {Number} clip.width
		   * @param {Number} clip.height
		   * @returns {Object}
		   * @example
		   * // get clip
		   * var clip = container.clip();
		   *
		   * // set clip
		   * container.clip({
		   *   x: 20,
		   *   y: 20,
		   *   width: 20,
		   *   height: 20
		   * });
		   */
		  Factory.addGetterSetter(Container, 'clipX', undefined, getNumberValidator());
		  /**
		   * get/set clip x
		   * @name Konva.Container#clipX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get clip x
		   * var clipX = container.clipX();
		   *
		   * // set clip x
		   * container.clipX(10);
		   */
		  Factory.addGetterSetter(Container, 'clipY', undefined, getNumberValidator());
		  /**
		   * get/set clip y
		   * @name Konva.Container#clipY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get clip y
		   * var clipY = container.clipY();
		   *
		   * // set clip y
		   * container.clipY(10);
		   */
		  Factory.addGetterSetter(Container, 'clipWidth', undefined, getNumberValidator());
		  /**
		   * get/set clip width
		   * @name Konva.Container#clipWidth
		   * @method
		   * @param {Number} width
		   * @returns {Number}
		   * @example
		   * // get clip width
		   * var clipWidth = container.clipWidth();
		   *
		   * // set clip width
		   * container.clipWidth(100);
		   */
		  Factory.addGetterSetter(Container, 'clipHeight', undefined, getNumberValidator());
		  /**
		   * get/set clip height
		   * @name Konva.Container#clipHeight
		   * @method
		   * @param {Number} height
		   * @returns {Number}
		   * @example
		   * // get clip height
		   * var clipHeight = container.clipHeight();
		   *
		   * // set clip height
		   * container.clipHeight(100);
		   */
		  Factory.addGetterSetter(Container, 'clipFunc');
		  /**
		   * get/set clip function
		   * @name Konva.Container#clipFunc
		   * @method
		   * @param {Function} function
		   * @returns {Function}
		   * @example
		   * // get clip function
		   * var clipFunction = container.clipFunc();
		   *
		   * // set clip function
		   * container.clipFunc(function(ctx) {
		   *   ctx.rect(0, 0, 100, 100);
		   * });
		   *
		   * container.clipFunc(function(ctx) {
		   *   // optionally return a clip Path2D and clip-rule or just the clip-rule
		   *   return [new Path2D('M0 0v50h50Z'), 'evenodd']
		   * });
		   */

		  const Captures = new Map();
		  // we may use this module for capturing touch events too
		  // so make sure we don't do something super specific to pointer
		  const SUPPORT_POINTER_EVENTS = Konva$2._global['PointerEvent'] !== undefined;
		  function getCapturedShape(pointerId) {
		      return Captures.get(pointerId);
		  }
		  function createEvent(evt) {
		      return {
		          evt,
		          pointerId: evt.pointerId,
		      };
		  }
		  function hasPointerCapture(pointerId, shape) {
		      return Captures.get(pointerId) === shape;
		  }
		  function setPointerCapture(pointerId, shape) {
		      releaseCapture(pointerId);
		      const stage = shape.getStage();
		      if (!stage)
		          return;
		      Captures.set(pointerId, shape);
		      if (SUPPORT_POINTER_EVENTS) {
		          shape._fire('gotpointercapture', createEvent(new PointerEvent('gotpointercapture')));
		      }
		  }
		  function releaseCapture(pointerId, target) {
		      const shape = Captures.get(pointerId);
		      if (!shape)
		          return;
		      const stage = shape.getStage();
		      if (stage && stage.content) ;
		      Captures.delete(pointerId);
		      if (SUPPORT_POINTER_EVENTS) {
		          shape._fire('lostpointercapture', createEvent(new PointerEvent('lostpointercapture')));
		      }
		  }

		  // CONSTANTS
		  var STAGE = 'Stage', STRING = 'string', PX = 'px', MOUSEOUT = 'mouseout', MOUSELEAVE = 'mouseleave', MOUSEOVER = 'mouseover', MOUSEENTER = 'mouseenter', MOUSEMOVE = 'mousemove', MOUSEDOWN = 'mousedown', MOUSEUP = 'mouseup', POINTERMOVE = 'pointermove', POINTERDOWN = 'pointerdown', POINTERUP = 'pointerup', POINTERCANCEL = 'pointercancel', LOSTPOINTERCAPTURE = 'lostpointercapture', POINTEROUT = 'pointerout', POINTERLEAVE = 'pointerleave', POINTEROVER = 'pointerover', POINTERENTER = 'pointerenter', CONTEXTMENU = 'contextmenu', TOUCHSTART = 'touchstart', TOUCHEND = 'touchend', TOUCHMOVE = 'touchmove', TOUCHCANCEL = 'touchcancel', WHEEL = 'wheel', MAX_LAYERS_NUMBER = 5, EVENTS = [
		      [MOUSEENTER, '_pointerenter'],
		      [MOUSEDOWN, '_pointerdown'],
		      [MOUSEMOVE, '_pointermove'],
		      [MOUSEUP, '_pointerup'],
		      [MOUSELEAVE, '_pointerleave'],
		      [TOUCHSTART, '_pointerdown'],
		      [TOUCHMOVE, '_pointermove'],
		      [TOUCHEND, '_pointerup'],
		      [TOUCHCANCEL, '_pointercancel'],
		      [MOUSEOVER, '_pointerover'],
		      [WHEEL, '_wheel'],
		      [CONTEXTMENU, '_contextmenu'],
		      [POINTERDOWN, '_pointerdown'],
		      [POINTERMOVE, '_pointermove'],
		      [POINTERUP, '_pointerup'],
		      [POINTERCANCEL, '_pointercancel'],
		      [LOSTPOINTERCAPTURE, '_lostpointercapture'],
		  ];
		  const EVENTS_MAP = {
		      mouse: {
		          [POINTEROUT]: MOUSEOUT,
		          [POINTERLEAVE]: MOUSELEAVE,
		          [POINTEROVER]: MOUSEOVER,
		          [POINTERENTER]: MOUSEENTER,
		          [POINTERMOVE]: MOUSEMOVE,
		          [POINTERDOWN]: MOUSEDOWN,
		          [POINTERUP]: MOUSEUP,
		          [POINTERCANCEL]: 'mousecancel',
		          pointerclick: 'click',
		          pointerdblclick: 'dblclick',
		      },
		      touch: {
		          [POINTEROUT]: 'touchout',
		          [POINTERLEAVE]: 'touchleave',
		          [POINTEROVER]: 'touchover',
		          [POINTERENTER]: 'touchenter',
		          [POINTERMOVE]: TOUCHMOVE,
		          [POINTERDOWN]: TOUCHSTART,
		          [POINTERUP]: TOUCHEND,
		          [POINTERCANCEL]: TOUCHCANCEL,
		          pointerclick: 'tap',
		          pointerdblclick: 'dbltap',
		      },
		      pointer: {
		          [POINTEROUT]: POINTEROUT,
		          [POINTERLEAVE]: POINTERLEAVE,
		          [POINTEROVER]: POINTEROVER,
		          [POINTERENTER]: POINTERENTER,
		          [POINTERMOVE]: POINTERMOVE,
		          [POINTERDOWN]: POINTERDOWN,
		          [POINTERUP]: POINTERUP,
		          [POINTERCANCEL]: POINTERCANCEL,
		          pointerclick: 'pointerclick',
		          pointerdblclick: 'pointerdblclick',
		      },
		  };
		  const getEventType = (type) => {
		      if (type.indexOf('pointer') >= 0) {
		          return 'pointer';
		      }
		      if (type.indexOf('touch') >= 0) {
		          return 'touch';
		      }
		      return 'mouse';
		  };
		  const getEventsMap = (eventType) => {
		      const type = getEventType(eventType);
		      if (type === 'pointer') {
		          return Konva$2.pointerEventsEnabled && EVENTS_MAP.pointer;
		      }
		      if (type === 'touch') {
		          return EVENTS_MAP.touch;
		      }
		      if (type === 'mouse') {
		          return EVENTS_MAP.mouse;
		      }
		  };
		  function checkNoClip(attrs = {}) {
		      if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
		          Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
		      }
		      return attrs;
		  }
		  const NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
		  const stages = [];
		  /**
		   * Stage constructor.  A stage is used to contain multiple layers
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Container
		   * @param {Object} config
		   * @param {String|Element} config.container Container selector or DOM element
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var stage = new Konva.Stage({
		   *   width: 500,
		   *   height: 800,
		   *   container: 'containerId' // or "#containerId" or ".containerClass"
		   * });
		   */
		  class Stage extends Container {
		      constructor(config) {
		          super(checkNoClip(config));
		          this._pointerPositions = [];
		          this._changedPointerPositions = [];
		          this._buildDOM();
		          this._bindContentEvents();
		          stages.push(this);
		          this.on('widthChange.konva heightChange.konva', this._resizeDOM);
		          this.on('visibleChange.konva', this._checkVisibility);
		          this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', () => {
		              checkNoClip(this.attrs);
		          });
		          this._checkVisibility();
		      }
		      _validateAdd(child) {
		          const isLayer = child.getType() === 'Layer';
		          const isFastLayer = child.getType() === 'FastLayer';
		          const valid = isLayer || isFastLayer;
		          if (!valid) {
		              Util.throw('You may only add layers to the stage.');
		          }
		      }
		      _checkVisibility() {
		          if (!this.content) {
		              return;
		          }
		          const style = this.visible() ? '' : 'none';
		          this.content.style.display = style;
		      }
		      /**
		       * set container dom element which contains the stage wrapper div element
		       * @method
		       * @name Konva.Stage#setContainer
		       * @param {DomElement} container can pass in a dom element or id string
		       */
		      setContainer(container) {
		          if (typeof container === STRING) {
		              if (container.charAt(0) === '.') {
		                  var className = container.slice(1);
		                  container = document.getElementsByClassName(className)[0];
		              }
		              else {
		                  var id;
		                  if (container.charAt(0) !== '#') {
		                      id = container;
		                  }
		                  else {
		                      id = container.slice(1);
		                  }
		                  container = document.getElementById(id);
		              }
		              if (!container) {
		                  throw 'Can not find container in document with id ' + id;
		              }
		          }
		          this._setAttr('container', container);
		          if (this.content) {
		              if (this.content.parentElement) {
		                  this.content.parentElement.removeChild(this.content);
		              }
		              container.appendChild(this.content);
		          }
		          return this;
		      }
		      shouldDrawHit() {
		          return true;
		      }
		      /**
		       * clear all layers
		       * @method
		       * @name Konva.Stage#clear
		       */
		      clear() {
		          var layers = this.children, len = layers.length, n;
		          for (n = 0; n < len; n++) {
		              layers[n].clear();
		          }
		          return this;
		      }
		      clone(obj) {
		          if (!obj) {
		              obj = {};
		          }
		          obj.container =
		              typeof document !== 'undefined' && document.createElement('div');
		          return Container.prototype.clone.call(this, obj);
		      }
		      destroy() {
		          super.destroy();
		          var content = this.content;
		          if (content && Util._isInDocument(content)) {
		              this.container().removeChild(content);
		          }
		          var index = stages.indexOf(this);
		          if (index > -1) {
		              stages.splice(index, 1);
		          }
		          Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
		          return this;
		      }
		      /**
		       * returns ABSOLUTE pointer position which can be a touch position or mouse position
		       * pointer position doesn't include any transforms (such as scale) of the stage
		       * it is just a plain position of pointer relative to top-left corner of the canvas
		       * @method
		       * @name Konva.Stage#getPointerPosition
		       * @returns {Vector2d|null}
		       */
		      getPointerPosition() {
		          const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
		          if (!pos) {
		              Util.warn(NO_POINTERS_MESSAGE);
		              return null;
		          }
		          return {
		              x: pos.x,
		              y: pos.y,
		          };
		      }
		      _getPointerById(id) {
		          return this._pointerPositions.find((p) => p.id === id);
		      }
		      getPointersPositions() {
		          return this._pointerPositions;
		      }
		      getStage() {
		          return this;
		      }
		      getContent() {
		          return this.content;
		      }
		      _toKonvaCanvas(config) {
		          config = config || {};
		          config.x = config.x || 0;
		          config.y = config.y || 0;
		          config.width = config.width || this.width();
		          config.height = config.height || this.height();
		          var canvas = new SceneCanvas({
		              width: config.width,
		              height: config.height,
		              pixelRatio: config.pixelRatio || 1,
		          });
		          var _context = canvas.getContext()._context;
		          var layers = this.children;
		          if (config.x || config.y) {
		              _context.translate(-1 * config.x, -1 * config.y);
		          }
		          layers.forEach(function (layer) {
		              if (!layer.isVisible()) {
		                  return;
		              }
		              var layerCanvas = layer._toKonvaCanvas(config);
		              _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
		          });
		          return canvas;
		      }
		      /**
		       * get visible intersection shape. This is the preferred
		       *  method for determining if a point intersects a shape or not
		       * @method
		       * @name Konva.Stage#getIntersection
		       * @param {Object} pos
		       * @param {Number} pos.x
		       * @param {Number} pos.y
		       * @returns {Konva.Node}
		       * @example
		       * var shape = stage.getIntersection({x: 50, y: 50});
		       */
		      getIntersection(pos) {
		          if (!pos) {
		              return null;
		          }
		          var layers = this.children, len = layers.length, end = len - 1, n;
		          for (n = end; n >= 0; n--) {
		              const shape = layers[n].getIntersection(pos);
		              if (shape) {
		                  return shape;
		              }
		          }
		          return null;
		      }
		      _resizeDOM() {
		          var width = this.width();
		          var height = this.height();
		          if (this.content) {
		              // set content dimensions
		              this.content.style.width = width + PX;
		              this.content.style.height = height + PX;
		          }
		          this.bufferCanvas.setSize(width, height);
		          this.bufferHitCanvas.setSize(width, height);
		          // set layer dimensions
		          this.children.forEach((layer) => {
		              layer.setSize({ width, height });
		              layer.draw();
		          });
		      }
		      add(layer, ...rest) {
		          if (arguments.length > 1) {
		              for (var i = 0; i < arguments.length; i++) {
		                  this.add(arguments[i]);
		              }
		              return this;
		          }
		          super.add(layer);
		          var length = this.children.length;
		          if (length > MAX_LAYERS_NUMBER) {
		              Util.warn('The stage has ' +
		                  length +
		                  ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
		          }
		          layer.setSize({ width: this.width(), height: this.height() });
		          // draw layer and append canvas to container
		          layer.draw();
		          if (Konva$2.isBrowser) {
		              this.content.appendChild(layer.canvas._canvas);
		          }
		          // chainable
		          return this;
		      }
		      getParent() {
		          return null;
		      }
		      getLayer() {
		          return null;
		      }
		      hasPointerCapture(pointerId) {
		          return hasPointerCapture(pointerId, this);
		      }
		      setPointerCapture(pointerId) {
		          setPointerCapture(pointerId, this);
		      }
		      releaseCapture(pointerId) {
		          releaseCapture(pointerId);
		      }
		      /**
		       * returns an array of layers
		       * @method
		       * @name Konva.Stage#getLayers
		       */
		      getLayers() {
		          return this.children;
		      }
		      _bindContentEvents() {
		          if (!Konva$2.isBrowser) {
		              return;
		          }
		          EVENTS.forEach(([event, methodName]) => {
		              this.content.addEventListener(event, (evt) => {
		                  this[methodName](evt);
		              }, { passive: false });
		          });
		      }
		      _pointerenter(evt) {
		          this.setPointersPositions(evt);
		          const events = getEventsMap(evt.type);
		          if (events) {
		              this._fire(events.pointerenter, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		          }
		      }
		      _pointerover(evt) {
		          this.setPointersPositions(evt);
		          const events = getEventsMap(evt.type);
		          if (events) {
		              this._fire(events.pointerover, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		          }
		      }
		      _getTargetShape(evenType) {
		          let shape = this[evenType + 'targetShape'];
		          if (shape && !shape.getStage()) {
		              shape = null;
		          }
		          return shape;
		      }
		      _pointerleave(evt) {
		          const events = getEventsMap(evt.type);
		          const eventType = getEventType(evt.type);
		          if (!events) {
		              return;
		          }
		          this.setPointersPositions(evt);
		          var targetShape = this._getTargetShape(eventType);
		          var eventsEnabled = !DD.isDragging || Konva$2.hitOnDragEnabled;
		          if (targetShape && eventsEnabled) {
		              targetShape._fireAndBubble(events.pointerout, { evt: evt });
		              targetShape._fireAndBubble(events.pointerleave, { evt: evt });
		              this._fire(events.pointerleave, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		              this[eventType + 'targetShape'] = null;
		          }
		          else if (eventsEnabled) {
		              this._fire(events.pointerleave, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		              this._fire(events.pointerout, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		          }
		          this.pointerPos = null;
		          this._pointerPositions = [];
		      }
		      _pointerdown(evt) {
		          const events = getEventsMap(evt.type);
		          const eventType = getEventType(evt.type);
		          if (!events) {
		              return;
		          }
		          this.setPointersPositions(evt);
		          var triggeredOnShape = false;
		          this._changedPointerPositions.forEach((pos) => {
		              var shape = this.getIntersection(pos);
		              DD.justDragged = false;
		              // probably we are staring a click
		              Konva$2['_' + eventType + 'ListenClick'] = true;
		              // no shape detected? do nothing
		              if (!shape || !shape.isListening()) {
		                  return;
		              }
		              if (Konva$2.capturePointerEventsEnabled) {
		                  shape.setPointerCapture(pos.id);
		              }
		              // save where we started the click
		              this[eventType + 'ClickStartShape'] = shape;
		              shape._fireAndBubble(events.pointerdown, {
		                  evt: evt,
		                  pointerId: pos.id,
		              });
		              triggeredOnShape = true;
		              // TODO: test in iframe
		              // only call preventDefault if the shape is listening for events
		              const isTouch = evt.type.indexOf('touch') >= 0;
		              if (shape.preventDefault() && evt.cancelable && isTouch) {
		                  evt.preventDefault();
		              }
		          });
		          // trigger down on stage if not already
		          if (!triggeredOnShape) {
		              this._fire(events.pointerdown, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		                  pointerId: this._pointerPositions[0].id,
		              });
		          }
		      }
		      _pointermove(evt) {
		          const events = getEventsMap(evt.type);
		          const eventType = getEventType(evt.type);
		          if (!events) {
		              return;
		          }
		          if (DD.isDragging && DD.node.preventDefault() && evt.cancelable) {
		              evt.preventDefault();
		          }
		          this.setPointersPositions(evt);
		          var eventsEnabled = !DD.isDragging || Konva$2.hitOnDragEnabled;
		          if (!eventsEnabled) {
		              return;
		          }
		          var processedShapesIds = {};
		          let triggeredOnShape = false;
		          var targetShape = this._getTargetShape(eventType);
		          this._changedPointerPositions.forEach((pos) => {
		              const shape = (getCapturedShape(pos.id) ||
		                  this.getIntersection(pos));
		              const pointerId = pos.id;
		              const event = { evt: evt, pointerId };
		              var differentTarget = targetShape !== shape;
		              if (differentTarget && targetShape) {
		                  targetShape._fireAndBubble(events.pointerout, { ...event }, shape);
		                  targetShape._fireAndBubble(events.pointerleave, { ...event }, shape);
		              }
		              if (shape) {
		                  if (processedShapesIds[shape._id]) {
		                      return;
		                  }
		                  processedShapesIds[shape._id] = true;
		              }
		              if (shape && shape.isListening()) {
		                  triggeredOnShape = true;
		                  if (differentTarget) {
		                      shape._fireAndBubble(events.pointerover, { ...event }, targetShape);
		                      shape._fireAndBubble(events.pointerenter, { ...event }, targetShape);
		                      this[eventType + 'targetShape'] = shape;
		                  }
		                  shape._fireAndBubble(events.pointermove, { ...event });
		              }
		              else {
		                  if (targetShape) {
		                      this._fire(events.pointerover, {
		                          evt: evt,
		                          target: this,
		                          currentTarget: this,
		                          pointerId,
		                      });
		                      this[eventType + 'targetShape'] = null;
		                  }
		              }
		          });
		          if (!triggeredOnShape) {
		              this._fire(events.pointermove, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		                  pointerId: this._changedPointerPositions[0].id,
		              });
		          }
		      }
		      _pointerup(evt) {
		          const events = getEventsMap(evt.type);
		          const eventType = getEventType(evt.type);
		          if (!events) {
		              return;
		          }
		          this.setPointersPositions(evt);
		          const clickStartShape = this[eventType + 'ClickStartShape'];
		          const clickEndShape = this[eventType + 'ClickEndShape'];
		          var processedShapesIds = {};
		          let triggeredOnShape = false;
		          this._changedPointerPositions.forEach((pos) => {
		              const shape = (getCapturedShape(pos.id) ||
		                  this.getIntersection(pos));
		              if (shape) {
		                  shape.releaseCapture(pos.id);
		                  if (processedShapesIds[shape._id]) {
		                      return;
		                  }
		                  processedShapesIds[shape._id] = true;
		              }
		              const pointerId = pos.id;
		              const event = { evt: evt, pointerId };
		              let fireDblClick = false;
		              if (Konva$2['_' + eventType + 'InDblClickWindow']) {
		                  fireDblClick = true;
		                  clearTimeout(this[eventType + 'DblTimeout']);
		              }
		              else if (!DD.justDragged) {
		                  // don't set inDblClickWindow after dragging
		                  Konva$2['_' + eventType + 'InDblClickWindow'] = true;
		                  clearTimeout(this[eventType + 'DblTimeout']);
		              }
		              this[eventType + 'DblTimeout'] = setTimeout(function () {
		                  Konva$2['_' + eventType + 'InDblClickWindow'] = false;
		              }, Konva$2.dblClickWindow);
		              if (shape && shape.isListening()) {
		                  triggeredOnShape = true;
		                  this[eventType + 'ClickEndShape'] = shape;
		                  shape._fireAndBubble(events.pointerup, { ...event });
		                  // detect if click or double click occurred
		                  if (Konva$2['_' + eventType + 'ListenClick'] &&
		                      clickStartShape &&
		                      clickStartShape === shape) {
		                      shape._fireAndBubble(events.pointerclick, { ...event });
		                      if (fireDblClick && clickEndShape && clickEndShape === shape) {
		                          shape._fireAndBubble(events.pointerdblclick, { ...event });
		                      }
		                  }
		              }
		              else {
		                  this[eventType + 'ClickEndShape'] = null;
		                  if (Konva$2['_' + eventType + 'ListenClick']) {
		                      this._fire(events.pointerclick, {
		                          evt: evt,
		                          target: this,
		                          currentTarget: this,
		                          pointerId,
		                      });
		                  }
		                  if (fireDblClick) {
		                      this._fire(events.pointerdblclick, {
		                          evt: evt,
		                          target: this,
		                          currentTarget: this,
		                          pointerId,
		                      });
		                  }
		              }
		          });
		          if (!triggeredOnShape) {
		              this._fire(events.pointerup, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		                  pointerId: this._changedPointerPositions[0].id,
		              });
		          }
		          Konva$2['_' + eventType + 'ListenClick'] = false;
		          // always call preventDefault for desktop events because some browsers
		          // try to drag and drop the canvas element
		          // TODO: are we sure we need to prevent default at all?
		          // do not call this function on mobile because it prevent "click" event on all parent containers
		          // but apps may listen to it.
		          if (evt.cancelable && eventType !== 'touch') {
		              evt.preventDefault();
		          }
		      }
		      _contextmenu(evt) {
		          this.setPointersPositions(evt);
		          var shape = this.getIntersection(this.getPointerPosition());
		          if (shape && shape.isListening()) {
		              shape._fireAndBubble(CONTEXTMENU, { evt: evt });
		          }
		          else {
		              this._fire(CONTEXTMENU, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		          }
		      }
		      _wheel(evt) {
		          this.setPointersPositions(evt);
		          var shape = this.getIntersection(this.getPointerPosition());
		          if (shape && shape.isListening()) {
		              shape._fireAndBubble(WHEEL, { evt: evt });
		          }
		          else {
		              this._fire(WHEEL, {
		                  evt: evt,
		                  target: this,
		                  currentTarget: this,
		              });
		          }
		      }
		      _pointercancel(evt) {
		          this.setPointersPositions(evt);
		          const shape = getCapturedShape(evt.pointerId) ||
		              this.getIntersection(this.getPointerPosition());
		          if (shape) {
		              shape._fireAndBubble(POINTERUP, createEvent(evt));
		          }
		          releaseCapture(evt.pointerId);
		      }
		      _lostpointercapture(evt) {
		          releaseCapture(evt.pointerId);
		      }
		      /**
		       * manually register pointers positions (mouse/touch) in the stage.
		       * So you can use stage.getPointerPosition(). Usually you don't need to use that method
		       * because all internal events are automatically registered. It may be useful if event
		       * is triggered outside of the stage, but you still want to use Konva methods to get pointers position.
		       * @method
		       * @name Konva.Stage#setPointersPositions
		       * @param {Object} event Event object
		       * @example
		       *
		       * window.addEventListener('mousemove', (e) => {
		       *   stage.setPointersPositions(e);
		       * });
		       */
		      setPointersPositions(evt) {
		          var contentPosition = this._getContentPosition(), x = null, y = null;
		          evt = evt ? evt : window.event;
		          // touch events
		          if (evt.touches !== undefined) {
		              // touchlist has not support for map method
		              // so we have to iterate
		              this._pointerPositions = [];
		              this._changedPointerPositions = [];
		              Array.prototype.forEach.call(evt.touches, (touch) => {
		                  this._pointerPositions.push({
		                      id: touch.identifier,
		                      x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
		                      y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
		                  });
		              });
		              Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch) => {
		                  this._changedPointerPositions.push({
		                      id: touch.identifier,
		                      x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
		                      y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
		                  });
		              });
		          }
		          else {
		              // mouse events
		              x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
		              y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
		              this.pointerPos = {
		                  x: x,
		                  y: y,
		              };
		              this._pointerPositions = [{ x, y, id: Util._getFirstPointerId(evt) }];
		              this._changedPointerPositions = [
		                  { x, y, id: Util._getFirstPointerId(evt) },
		              ];
		          }
		      }
		      _setPointerPosition(evt) {
		          Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
		          this.setPointersPositions(evt);
		      }
		      _getContentPosition() {
		          if (!this.content || !this.content.getBoundingClientRect) {
		              return {
		                  top: 0,
		                  left: 0,
		                  scaleX: 1,
		                  scaleY: 1,
		              };
		          }
		          var rect = this.content.getBoundingClientRect();
		          return {
		              top: rect.top,
		              left: rect.left,
		              // sometimes clientWidth can be equals to 0
		              // i saw it in react-konva test, looks like it is because of hidden testing element
		              scaleX: rect.width / this.content.clientWidth || 1,
		              scaleY: rect.height / this.content.clientHeight || 1,
		          };
		      }
		      _buildDOM() {
		          this.bufferCanvas = new SceneCanvas({
		              width: this.width(),
		              height: this.height(),
		          });
		          this.bufferHitCanvas = new HitCanvas({
		              pixelRatio: 1,
		              width: this.width(),
		              height: this.height(),
		          });
		          if (!Konva$2.isBrowser) {
		              return;
		          }
		          var container = this.container();
		          if (!container) {
		              throw 'Stage has no container. A container is required.';
		          }
		          // clear content inside container
		          container.innerHTML = '';
		          // content
		          this.content = document.createElement('div');
		          this.content.style.position = 'relative';
		          this.content.style.userSelect = 'none';
		          this.content.className = 'konvajs-content';
		          this.content.setAttribute('role', 'presentation');
		          container.appendChild(this.content);
		          this._resizeDOM();
		      }
		      // currently cache function is now working for stage, because stage has no its own canvas element
		      cache() {
		          Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
		          return this;
		      }
		      clearCache() {
		          return this;
		      }
		      /**
		       * batch draw
		       * @method
		       * @name Konva.Stage#batchDraw
		       * @return {Konva.Stage} this
		       */
		      batchDraw() {
		          this.getChildren().forEach(function (layer) {
		              layer.batchDraw();
		          });
		          return this;
		      }
		  }
		  Stage.prototype.nodeType = STAGE;
		  _registerNode(Stage);
		  /**
		   * get/set container DOM element
		   * @method
		   * @name Konva.Stage#container
		   * @returns {DomElement} container
		   * @example
		   * // get container
		   * var container = stage.container();
		   * // set container
		   * var container = document.createElement('div');
		   * body.appendChild(container);
		   * stage.container(container);
		   */
		  Factory.addGetterSetter(Stage, 'container');

		  var HAS_SHADOW = 'hasShadow';
		  var SHADOW_RGBA = 'shadowRGBA';
		  var patternImage = 'patternImage';
		  var linearGradient = 'linearGradient';
		  var radialGradient = 'radialGradient';
		  let dummyContext$1;
		  function getDummyContext$1() {
		      if (dummyContext$1) {
		          return dummyContext$1;
		      }
		      dummyContext$1 = Util.createCanvasElement().getContext('2d');
		      return dummyContext$1;
		  }
		  const shapes = {};
		  // TODO: idea - use only "remove" (or destroy method)
		  // how? on add, check that every inner shape has reference in konva store with color
		  // on remove - clear that reference
		  // the approach is good. But what if we want to cache the shape before we add it into the stage
		  // what color to use for hit test?
		  function _fillFunc$2(context) {
		      const fillRule = this.attrs.fillRule;
		      if (fillRule) {
		          context.fill(fillRule);
		      }
		      else {
		          context.fill();
		      }
		  }
		  function _strokeFunc$2(context) {
		      context.stroke();
		  }
		  function _fillFuncHit(context) {
		      context.fill();
		  }
		  function _strokeFuncHit(context) {
		      context.stroke();
		  }
		  function _clearHasShadowCache() {
		      this._clearCache(HAS_SHADOW);
		  }
		  function _clearGetShadowRGBACache() {
		      this._clearCache(SHADOW_RGBA);
		  }
		  function _clearFillPatternCache() {
		      this._clearCache(patternImage);
		  }
		  function _clearLinearGradientCache() {
		      this._clearCache(linearGradient);
		  }
		  function _clearRadialGradientCache() {
		      this._clearCache(radialGradient);
		  }
		  /**
		   * Shape constructor.  Shapes are primitive objects such as rectangles,
		   *  circles, text, lines, etc.
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Node
		   * @param {Object} config
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var customShape = new Konva.Shape({
		   *   x: 5,
		   *   y: 10,
		   *   fill: 'red',
		   *   // a Konva.Canvas renderer is passed into the sceneFunc function
		   *   sceneFunc (context, shape) {
		   *     context.beginPath();
		   *     context.moveTo(200, 50);
		   *     context.lineTo(420, 80);
		   *     context.quadraticCurveTo(300, 100, 260, 170);
		   *     context.closePath();
		   *     // Konva specific method
		   *     context.fillStrokeShape(shape);
		   *   }
		   *});
		   */
		  class Shape extends Node {
		      constructor(config) {
		          super(config);
		          // set colorKey
		          let key;
		          while (true) {
		              key = Util.getRandomColor();
		              if (key && !(key in shapes)) {
		                  break;
		              }
		          }
		          this.colorKey = key;
		          shapes[key] = this;
		      }
		      getContext() {
		          Util.warn('shape.getContext() method is deprecated. Please do not use it.');
		          return this.getLayer().getContext();
		      }
		      getCanvas() {
		          Util.warn('shape.getCanvas() method is deprecated. Please do not use it.');
		          return this.getLayer().getCanvas();
		      }
		      getSceneFunc() {
		          return this.attrs.sceneFunc || this['_sceneFunc'];
		      }
		      getHitFunc() {
		          return this.attrs.hitFunc || this['_hitFunc'];
		      }
		      /**
		       * returns whether or not a shadow will be rendered
		       * @method
		       * @name Konva.Shape#hasShadow
		       * @returns {Boolean}
		       */
		      hasShadow() {
		          return this._getCache(HAS_SHADOW, this._hasShadow);
		      }
		      _hasShadow() {
		          return (this.shadowEnabled() &&
		              this.shadowOpacity() !== 0 &&
		              !!(this.shadowColor() ||
		                  this.shadowBlur() ||
		                  this.shadowOffsetX() ||
		                  this.shadowOffsetY()));
		      }
		      _getFillPattern() {
		          return this._getCache(patternImage, this.__getFillPattern);
		      }
		      __getFillPattern() {
		          if (this.fillPatternImage()) {
		              var ctx = getDummyContext$1();
		              const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
		              if (pattern && pattern.setTransform) {
		                  const tr = new Transform();
		                  tr.translate(this.fillPatternX(), this.fillPatternY());
		                  tr.rotate(Konva$2.getAngle(this.fillPatternRotation()));
		                  tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
		                  tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
		                  const m = tr.getMatrix();
		                  const matrix = typeof DOMMatrix === 'undefined'
		                      ? {
		                          a: m[0],
		                          b: m[1],
		                          c: m[2],
		                          d: m[3],
		                          e: m[4],
		                          f: m[5], // Vertical translation (moving).
		                      }
		                      : new DOMMatrix(m);
		                  pattern.setTransform(matrix);
		              }
		              return pattern;
		          }
		      }
		      _getLinearGradient() {
		          return this._getCache(linearGradient, this.__getLinearGradient);
		      }
		      __getLinearGradient() {
		          var colorStops = this.fillLinearGradientColorStops();
		          if (colorStops) {
		              var ctx = getDummyContext$1();
		              var start = this.fillLinearGradientStartPoint();
		              var end = this.fillLinearGradientEndPoint();
		              var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
		              // build color stops
		              for (var n = 0; n < colorStops.length; n += 2) {
		                  grd.addColorStop(colorStops[n], colorStops[n + 1]);
		              }
		              return grd;
		          }
		      }
		      _getRadialGradient() {
		          return this._getCache(radialGradient, this.__getRadialGradient);
		      }
		      __getRadialGradient() {
		          var colorStops = this.fillRadialGradientColorStops();
		          if (colorStops) {
		              var ctx = getDummyContext$1();
		              var start = this.fillRadialGradientStartPoint();
		              var end = this.fillRadialGradientEndPoint();
		              var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
		              // build color stops
		              for (var n = 0; n < colorStops.length; n += 2) {
		                  grd.addColorStop(colorStops[n], colorStops[n + 1]);
		              }
		              return grd;
		          }
		      }
		      getShadowRGBA() {
		          return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
		      }
		      _getShadowRGBA() {
		          if (!this.hasShadow()) {
		              return;
		          }
		          var rgba = Util.colorToRGBA(this.shadowColor());
		          if (rgba) {
		              return ('rgba(' +
		                  rgba.r +
		                  ',' +
		                  rgba.g +
		                  ',' +
		                  rgba.b +
		                  ',' +
		                  rgba.a * (this.shadowOpacity() || 1) +
		                  ')');
		          }
		      }
		      /**
		       * returns whether or not the shape will be filled
		       * @method
		       * @name Konva.Shape#hasFill
		       * @returns {Boolean}
		       */
		      hasFill() {
		          return this._calculate('hasFill', [
		              'fillEnabled',
		              'fill',
		              'fillPatternImage',
		              'fillLinearGradientColorStops',
		              'fillRadialGradientColorStops',
		          ], () => {
		              return (this.fillEnabled() &&
		                  !!(this.fill() ||
		                      this.fillPatternImage() ||
		                      this.fillLinearGradientColorStops() ||
		                      this.fillRadialGradientColorStops()));
		          });
		      }
		      /**
		       * returns whether or not the shape will be stroked
		       * @method
		       * @name Konva.Shape#hasStroke
		       * @returns {Boolean}
		       */
		      hasStroke() {
		          return this._calculate('hasStroke', [
		              'strokeEnabled',
		              'strokeWidth',
		              'stroke',
		              'strokeLinearGradientColorStops',
		          ], () => {
		              return (this.strokeEnabled() &&
		                  this.strokeWidth() &&
		                  !!(this.stroke() || this.strokeLinearGradientColorStops())
		              // this.getStrokeRadialGradientColorStops()
		              );
		          });
		          // return (
		          //   this.strokeEnabled() &&
		          //   this.strokeWidth() &&
		          //   !!(this.stroke() || this.strokeLinearGradientColorStops())
		          //   // this.getStrokeRadialGradientColorStops()
		          // );
		      }
		      hasHitStroke() {
		          const width = this.hitStrokeWidth();
		          // on auto just check by stroke
		          if (width === 'auto') {
		              return this.hasStroke();
		          }
		          // we should enable hit stroke if stroke is enabled
		          // and we have some value from width
		          return this.strokeEnabled() && !!width;
		      }
		      /**
		       * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
		       *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
		       *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
		       *  because it performs much better
		       * @method
		       * @name Konva.Shape#intersects
		       * @param {Object} point
		       * @param {Number} point.x
		       * @param {Number} point.y
		       * @returns {Boolean}
		       */
		      intersects(point) {
		          var stage = this.getStage();
		          if (!stage) {
		              return false;
		          }
		          const bufferHitCanvas = stage.bufferHitCanvas;
		          bufferHitCanvas.getContext().clear();
		          this.drawHit(bufferHitCanvas, undefined, true);
		          const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
		          return p[3] > 0;
		      }
		      destroy() {
		          Node.prototype.destroy.call(this);
		          delete shapes[this.colorKey];
		          delete this.colorKey;
		          return this;
		      }
		      // why do we need buffer canvas?
		      // it give better result when a shape has
		      // stroke with fill and with some opacity
		      _useBufferCanvas(forceFill) {
		          // image and sprite still has "fill" as image
		          // so they use that method with forced fill
		          // it probably will be simpler, then copy/paste the code
		          var _a;
		          // buffer canvas is available only inside the stage
		          if (!this.getStage()) {
		              return false;
		          }
		          // force skip buffer canvas
		          const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
		          if (!perfectDrawEnabled) {
		              return false;
		          }
		          const hasFill = forceFill || this.hasFill();
		          const hasStroke = this.hasStroke();
		          const isTransparent = this.getAbsoluteOpacity() !== 1;
		          if (hasFill && hasStroke && isTransparent) {
		              return true;
		          }
		          const hasShadow = this.hasShadow();
		          const strokeForShadow = this.shadowForStrokeEnabled();
		          if (hasFill && hasStroke && hasShadow && strokeForShadow) {
		              return true;
		          }
		          return false;
		      }
		      setStrokeHitEnabled(val) {
		          Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
		          if (val) {
		              this.hitStrokeWidth('auto');
		          }
		          else {
		              this.hitStrokeWidth(0);
		          }
		      }
		      getStrokeHitEnabled() {
		          if (this.hitStrokeWidth() === 0) {
		              return false;
		          }
		          else {
		              return true;
		          }
		      }
		      /**
		       * return self rectangle (x, y, width, height) of shape.
		       * This method are not taken into account transformation and styles.
		       * @method
		       * @name Konva.Shape#getSelfRect
		       * @returns {Object} rect with {x, y, width, height} properties
		       * @example
		       *
		       * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
		       * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
		       *
		       */
		      getSelfRect() {
		          var size = this.size();
		          return {
		              x: this._centroid ? -size.width / 2 : 0,
		              y: this._centroid ? -size.height / 2 : 0,
		              width: size.width,
		              height: size.height,
		          };
		      }
		      getClientRect(config = {}) {
		          const skipTransform = config.skipTransform;
		          const relativeTo = config.relativeTo;
		          const fillRect = this.getSelfRect();
		          const applyStroke = !config.skipStroke && this.hasStroke();
		          const strokeWidth = (applyStroke && this.strokeWidth()) || 0;
		          const fillAndStrokeWidth = fillRect.width + strokeWidth;
		          const fillAndStrokeHeight = fillRect.height + strokeWidth;
		          const applyShadow = !config.skipShadow && this.hasShadow();
		          const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
		          const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
		          const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
		          const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
		          const blurRadius = (applyShadow && this.shadowBlur()) || 0;
		          const width = preWidth + blurRadius * 2;
		          const height = preHeight + blurRadius * 2;
		          const rect = {
		              width: width,
		              height: height,
		              x: -(strokeWidth / 2 + blurRadius) +
		                  Math.min(shadowOffsetX, 0) +
		                  fillRect.x,
		              y: -(strokeWidth / 2 + blurRadius) +
		                  Math.min(shadowOffsetY, 0) +
		                  fillRect.y,
		          };
		          if (!skipTransform) {
		              return this._transformedRect(rect, relativeTo);
		          }
		          return rect;
		      }
		      drawScene(can, top) {
		          // basically there are 3 drawing modes
		          // 1 - simple drawing when nothing is cached.
		          // 2 - when we are caching current
		          // 3 - when node is cached and we need to draw it into layer
		          var layer = this.getLayer();
		          var canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
		          var skipBuffer = canvas.isCache;
		          var cachingSelf = top === this;
		          if (!this.isVisible() && !cachingSelf) {
		              return this;
		          }
		          // if node is cached we just need to draw from cache
		          if (cachedCanvas) {
		              context.save();
		              var m = this.getAbsoluteTransform(top).getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		              this._drawCachedSceneCanvas(context);
		              context.restore();
		              return this;
		          }
		          if (!drawFunc) {
		              return this;
		          }
		          context.save();
		          // if buffer canvas is needed
		          if (this._useBufferCanvas() && !skipBuffer) {
		              stage = this.getStage();
		              bufferCanvas = stage.bufferCanvas;
		              bufferContext = bufferCanvas.getContext();
		              bufferContext.clear();
		              bufferContext.save();
		              bufferContext._applyLineJoin(this);
		              // layer might be undefined if we are using cache before adding to layer
		              var o = this.getAbsoluteTransform(top).getMatrix();
		              bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		              drawFunc.call(this, bufferContext, this);
		              bufferContext.restore();
		              var ratio = bufferCanvas.pixelRatio;
		              if (hasShadow) {
		                  context._applyShadow(this);
		              }
		              context._applyOpacity(this);
		              context._applyGlobalCompositeOperation(this);
		              context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
		          }
		          else {
		              context._applyLineJoin(this);
		              if (!cachingSelf) {
		                  var o = this.getAbsoluteTransform(top).getMatrix();
		                  context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		                  context._applyOpacity(this);
		                  context._applyGlobalCompositeOperation(this);
		              }
		              if (hasShadow) {
		                  context._applyShadow(this);
		              }
		              drawFunc.call(this, context, this);
		          }
		          context.restore();
		          return this;
		      }
		      drawHit(can, top, skipDragCheck = false) {
		          if (!this.shouldDrawHit(top, skipDragCheck)) {
		              return this;
		          }
		          var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
		          if (!this.colorKey) {
		              Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
		          }
		          if (cachedHitCanvas) {
		              context.save();
		              var m = this.getAbsoluteTransform(top).getMatrix();
		              context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		              this._drawCachedHitCanvas(context);
		              context.restore();
		              return this;
		          }
		          if (!drawFunc) {
		              return this;
		          }
		          context.save();
		          context._applyLineJoin(this);
		          const selfCache = this === top;
		          if (!selfCache) {
		              var o = this.getAbsoluteTransform(top).getMatrix();
		              context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		          }
		          drawFunc.call(this, context, this);
		          context.restore();
		          return this;
		      }
		      /**
		       * draw hit graph using the cached scene canvas
		       * @method
		       * @name Konva.Shape#drawHitFromCache
		       * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
		       *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
		       *  The default is 0
		       * @returns {Konva.Shape}
		       * @example
		       * shape.cache();
		       * shape.drawHitFromCache();
		       */
		      drawHitFromCache(alphaThreshold = 0) {
		          var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
		          hitContext.clear();
		          hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
		          try {
		              hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
		              hitData = hitImageData.data;
		              len = hitData.length;
		              rgbColorKey = Util._hexToRgb(this.colorKey);
		              // replace non transparent pixels with color key
		              for (i = 0; i < len; i += 4) {
		                  alpha = hitData[i + 3];
		                  if (alpha > alphaThreshold) {
		                      hitData[i] = rgbColorKey.r;
		                      hitData[i + 1] = rgbColorKey.g;
		                      hitData[i + 2] = rgbColorKey.b;
		                      hitData[i + 3] = 255;
		                  }
		                  else {
		                      hitData[i + 3] = 0;
		                  }
		              }
		              hitContext.putImageData(hitImageData, 0, 0);
		          }
		          catch (e) {
		              Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
		          }
		          return this;
		      }
		      hasPointerCapture(pointerId) {
		          return hasPointerCapture(pointerId, this);
		      }
		      setPointerCapture(pointerId) {
		          setPointerCapture(pointerId, this);
		      }
		      releaseCapture(pointerId) {
		          releaseCapture(pointerId);
		      }
		  }
		  Shape.prototype._fillFunc = _fillFunc$2;
		  Shape.prototype._strokeFunc = _strokeFunc$2;
		  Shape.prototype._fillFuncHit = _fillFuncHit;
		  Shape.prototype._strokeFuncHit = _strokeFuncHit;
		  Shape.prototype._centroid = false;
		  Shape.prototype.nodeType = 'Shape';
		  _registerNode(Shape);
		  Shape.prototype.eventListeners = {};
		  Shape.prototype.on.call(Shape.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearHasShadowCache);
		  Shape.prototype.on.call(Shape.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearGetShadowRGBACache);
		  Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', _clearFillPatternCache);
		  Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', _clearLinearGradientCache);
		  Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', _clearRadialGradientCache);
		  // add getters and setters
		  Factory.addGetterSetter(Shape, 'stroke', undefined, getStringOrGradientValidator());
		  /**
		   * get/set stroke color
		   * @name Konva.Shape#stroke
		   * @method
		   * @param {String} color
		   * @returns {String}
		   * @example
		   * // get stroke color
		   * var stroke = shape.stroke();
		   *
		   * // set stroke color with color string
		   * shape.stroke('green');
		   *
		   * // set stroke color with hex
		   * shape.stroke('#00ff00');
		   *
		   * // set stroke color with rgb
		   * shape.stroke('rgb(0,255,0)');
		   *
		   * // set stroke color with rgba and make it 50% opaque
		   * shape.stroke('rgba(0,255,0,0.5');
		   */
		  Factory.addGetterSetter(Shape, 'strokeWidth', 2, getNumberValidator());
		  /**
		   * get/set stroke width
		   * @name Konva.Shape#strokeWidth
		   * @method
		   * @param {Number} strokeWidth
		   * @returns {Number}
		   * @example
		   * // get stroke width
		   * var strokeWidth = shape.strokeWidth();
		   *
		   * // set stroke width
		   * shape.strokeWidth(10);
		   */
		  Factory.addGetterSetter(Shape, 'fillAfterStrokeEnabled', false);
		  /**
		   * get/set fillAfterStrokeEnabled property. By default Konva is drawing filling first, then stroke on top of the fill.
		   * In rare situations you may want a different behavior. When you have a stroke first then fill on top of it.
		   * Especially useful for Text objects.
		   * Default is false.
		   * @name Konva.Shape#fillAfterStrokeEnabled
		   * @method
		   * @param {Boolean} fillAfterStrokeEnabled
		   * @returns {Boolean}
		   * @example
		   * // get stroke width
		   * var fillAfterStrokeEnabled = shape.fillAfterStrokeEnabled();
		   *
		   * // set stroke width
		   * shape.fillAfterStrokeEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'hitStrokeWidth', 'auto', getNumberOrAutoValidator());
		  /**
		   * get/set stroke width for hit detection. Default value is "auto", it means it will be equals to strokeWidth
		   * @name Konva.Shape#hitStrokeWidth
		   * @method
		   * @param {Number} hitStrokeWidth
		   * @returns {Number}
		   * @example
		   * // get stroke width
		   * var hitStrokeWidth = shape.hitStrokeWidth();
		   *
		   * // set hit stroke width
		   * shape.hitStrokeWidth(20);
		   * // set hit stroke width always equals to scene stroke width
		   * shape.hitStrokeWidth('auto');
		   */
		  Factory.addGetterSetter(Shape, 'strokeHitEnabled', true, getBooleanValidator());
		  /**
		   * **deprecated, use hitStrokeWidth instead!** get/set strokeHitEnabled property. Useful for performance optimization.
		   * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
		   * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
		   * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
		   * Default value is true.
		   * @name Konva.Shape#strokeHitEnabled
		   * @method
		   * @param {Boolean} strokeHitEnabled
		   * @returns {Boolean}
		   * @example
		   * // get strokeHitEnabled
		   * var strokeHitEnabled = shape.strokeHitEnabled();
		   *
		   * // set strokeHitEnabled
		   * shape.strokeHitEnabled();
		   */
		  Factory.addGetterSetter(Shape, 'perfectDrawEnabled', true, getBooleanValidator());
		  /**
		   * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
		   * See http://konvajs.org/docs/performance/Disable_Perfect_Draw.html for more information.
		   * Default value is true
		   * @name Konva.Shape#perfectDrawEnabled
		   * @method
		   * @param {Boolean} perfectDrawEnabled
		   * @returns {Boolean}
		   * @example
		   * // get perfectDrawEnabled
		   * var perfectDrawEnabled = shape.perfectDrawEnabled();
		   *
		   * // set perfectDrawEnabled
		   * shape.perfectDrawEnabled();
		   */
		  Factory.addGetterSetter(Shape, 'shadowForStrokeEnabled', true, getBooleanValidator());
		  /**
		   * get/set shadowForStrokeEnabled. Useful for performance optimization.
		   * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will no effect shadow.
		   * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line will have no shadow!.
		   * Default value is true
		   * @name Konva.Shape#shadowForStrokeEnabled
		   * @method
		   * @param {Boolean} shadowForStrokeEnabled
		   * @returns {Boolean}
		   * @example
		   * // get shadowForStrokeEnabled
		   * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
		   *
		   * // set shadowForStrokeEnabled
		   * shape.shadowForStrokeEnabled();
		   */
		  Factory.addGetterSetter(Shape, 'lineJoin');
		  /**
		   * get/set line join.  Can be miter, round, or bevel.  The
		   *  default is miter
		   * @name Konva.Shape#lineJoin
		   * @method
		   * @param {String} lineJoin
		   * @returns {String}
		   * @example
		   * // get line join
		   * var lineJoin = shape.lineJoin();
		   *
		   * // set line join
		   * shape.lineJoin('round');
		   */
		  Factory.addGetterSetter(Shape, 'lineCap');
		  /**
		   * get/set line cap.  Can be butt, round, or square
		   * @name Konva.Shape#lineCap
		   * @method
		   * @param {String} lineCap
		   * @returns {String}
		   * @example
		   * // get line cap
		   * var lineCap = shape.lineCap();
		   *
		   * // set line cap
		   * shape.lineCap('round');
		   */
		  Factory.addGetterSetter(Shape, 'sceneFunc');
		  /**
		   * get/set scene draw function. That function is used to draw the shape on a canvas.
		   * Also that function will be used to draw hit area of the shape, in case if hitFunc is not defined.
		   * @name Konva.Shape#sceneFunc
		   * @method
		   * @param {Function} drawFunc drawing function
		   * @returns {Function}
		   * @example
		   * // get scene draw function
		   * var sceneFunc = shape.sceneFunc();
		   *
		   * // set scene draw function
		   * shape.sceneFunc(function(context, shape) {
		   *   context.beginPath();
		   *   context.rect(0, 0, shape.width(), shape.height());
		   *   context.closePath();
		   *   // important Konva method that fill and stroke shape from its properties
		   *   // like stroke and fill
		   *   context.fillStrokeShape(shape);
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'hitFunc');
		  /**
		   * get/set hit draw function. That function is used to draw custom hit area of a shape.
		   * @name Konva.Shape#hitFunc
		   * @method
		   * @param {Function} drawFunc drawing function
		   * @returns {Function}
		   * @example
		   * // get hit draw function
		   * var hitFunc = shape.hitFunc();
		   *
		   * // set hit draw function
		   * shape.hitFunc(function(context) {
		   *   context.beginPath();
		   *   context.rect(0, 0, shape.width(), shape.height());
		   *   context.closePath();
		   *   // important Konva method that fill and stroke shape from its properties
		   *   context.fillStrokeShape(shape);
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'dash');
		  /**
		   * get/set dash array for stroke.
		   * @name Konva.Shape#dash
		   * @method
		   * @param {Array} dash
		   * @returns {Array}
		   * @example
		   *  // apply dashed stroke that is 10px long and 5 pixels apart
		   *  line.dash([10, 5]);
		   *  // apply dashed stroke that is made up of alternating dashed
		   *  // lines that are 10px long and 20px apart, and dots that have
		   *  // a radius of 5px and are 20px apart
		   *  line.dash([10, 20, 0.001, 20]);
		   */
		  Factory.addGetterSetter(Shape, 'dashOffset', 0, getNumberValidator());
		  /**
		   * get/set dash offset for stroke.
		   * @name Konva.Shape#dash
		   * @method
		   * @param {Number} dash offset
		   * @returns {Number}
		   * @example
		   *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
		   *  line.dash([10, 5]);
		   *  line.dashOffset(5);
		   */
		  Factory.addGetterSetter(Shape, 'shadowColor', undefined, getStringValidator());
		  /**
		   * get/set shadow color
		   * @name Konva.Shape#shadowColor
		   * @method
		   * @param {String} color
		   * @returns {String}
		   * @example
		   * // get shadow color
		   * var shadow = shape.shadowColor();
		   *
		   * // set shadow color with color string
		   * shape.shadowColor('green');
		   *
		   * // set shadow color with hex
		   * shape.shadowColor('#00ff00');
		   *
		   * // set shadow color with rgb
		   * shape.shadowColor('rgb(0,255,0)');
		   *
		   * // set shadow color with rgba and make it 50% opaque
		   * shape.shadowColor('rgba(0,255,0,0.5');
		   */
		  Factory.addGetterSetter(Shape, 'shadowBlur', 0, getNumberValidator());
		  /**
		   * get/set shadow blur
		   * @name Konva.Shape#shadowBlur
		   * @method
		   * @param {Number} blur
		   * @returns {Number}
		   * @example
		   * // get shadow blur
		   * var shadowBlur = shape.shadowBlur();
		   *
		   * // set shadow blur
		   * shape.shadowBlur(10);
		   */
		  Factory.addGetterSetter(Shape, 'shadowOpacity', 1, getNumberValidator());
		  /**
		   * get/set shadow opacity.  must be a value between 0 and 1
		   * @name Konva.Shape#shadowOpacity
		   * @method
		   * @param {Number} opacity
		   * @returns {Number}
		   * @example
		   * // get shadow opacity
		   * var shadowOpacity = shape.shadowOpacity();
		   *
		   * // set shadow opacity
		   * shape.shadowOpacity(0.5);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'shadowOffset', ['x', 'y']);
		  /**
		   * get/set shadow offset
		   * @name Konva.Shape#shadowOffset
		   * @method
		   * @param {Object} offset
		   * @param {Number} offset.x
		   * @param {Number} offset.y
		   * @returns {Object}
		   * @example
		   * // get shadow offset
		   * var shadowOffset = shape.shadowOffset();
		   *
		   * // set shadow offset
		   * shape.shadowOffset({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'shadowOffsetX', 0, getNumberValidator());
		  /**
		   * get/set shadow offset x
		   * @name Konva.Shape#shadowOffsetX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get shadow offset x
		   * var shadowOffsetX = shape.shadowOffsetX();
		   *
		   * // set shadow offset x
		   * shape.shadowOffsetX(5);
		   */
		  Factory.addGetterSetter(Shape, 'shadowOffsetY', 0, getNumberValidator());
		  /**
		   * get/set shadow offset y
		   * @name Konva.Shape#shadowOffsetY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get shadow offset y
		   * var shadowOffsetY = shape.shadowOffsetY();
		   *
		   * // set shadow offset y
		   * shape.shadowOffsetY(5);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternImage');
		  /**
		   * get/set fill pattern image
		   * @name Konva.Shape#fillPatternImage
		   * @method
		   * @param {Image} image object
		   * @returns {Image}
		   * @example
		   * // get fill pattern image
		   * var fillPatternImage = shape.fillPatternImage();
		   *
		   * // set fill pattern image
		   * var imageObj = new Image();
		   * imageObj.onload = function() {
		   *   shape.fillPatternImage(imageObj);
		   * };
		   * imageObj.src = 'path/to/image/jpg';
		   */
		  Factory.addGetterSetter(Shape, 'fill', undefined, getStringOrGradientValidator());
		  /**
		   * get/set fill color
		   * @name Konva.Shape#fill
		   * @method
		   * @param {String} color
		   * @returns {String}
		   * @example
		   * // get fill color
		   * var fill = shape.fill();
		   *
		   * // set fill color with color string
		   * shape.fill('green');
		   *
		   * // set fill color with hex
		   * shape.fill('#00ff00');
		   *
		   * // set fill color with rgb
		   * shape.fill('rgb(0,255,0)');
		   *
		   * // set fill color with rgba and make it 50% opaque
		   * shape.fill('rgba(0,255,0,0.5');
		   *
		   * // shape without fill
		   * shape.fill(null);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternX', 0, getNumberValidator());
		  /**
		   * get/set fill pattern x
		   * @name Konva.Shape#fillPatternX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill pattern x
		   * var fillPatternX = shape.fillPatternX();
		   * // set fill pattern x
		   * shape.fillPatternX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternY', 0, getNumberValidator());
		  /**
		   * get/set fill pattern y
		   * @name Konva.Shape#fillPatternY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill pattern y
		   * var fillPatternY = shape.fillPatternY();
		   * // set fill pattern y
		   * shape.fillPatternY(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillLinearGradientColorStops');
		  /**
		   * get/set fill linear gradient color stops
		   * @name Konva.Shape#fillLinearGradientColorStops
		   * @method
		   * @param {Array} colorStops
		   * @returns {Array} colorStops
		   * @example
		   * // get fill linear gradient color stops
		   * var colorStops = shape.fillLinearGradientColorStops();
		   *
		   * // create a linear gradient that starts with red, changes to blue
		   * // halfway through, and then changes to green
		   * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
		   */
		  Factory.addGetterSetter(Shape, 'strokeLinearGradientColorStops');
		  /**
		   * get/set stroke linear gradient color stops
		   * @name Konva.Shape#strokeLinearGradientColorStops
		   * @method
		   * @param {Array} colorStops
		   * @returns {Array} colorStops
		   * @example
		   * // get stroke linear gradient color stops
		   * var colorStops = shape.strokeLinearGradientColorStops();
		   *
		   * // create a linear gradient that starts with red, changes to blue
		   * // halfway through, and then changes to green
		   * shape.strokeLinearGradientColorStops([0, 'red', 0.5, 'blue', 1, 'green']);
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientStartRadius', 0);
		  /**
		   * get/set fill radial gradient start radius
		   * @name Konva.Shape#fillRadialGradientStartRadius
		   * @method
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get radial gradient start radius
		   * var startRadius = shape.fillRadialGradientStartRadius();
		   *
		   * // set radial gradient start radius
		   * shape.fillRadialGradientStartRadius(0);
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientEndRadius', 0);
		  /**
		   * get/set fill radial gradient end radius
		   * @name Konva.Shape#fillRadialGradientEndRadius
		   * @method
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get radial gradient end radius
		   * var endRadius = shape.fillRadialGradientEndRadius();
		   *
		   * // set radial gradient end radius
		   * shape.fillRadialGradientEndRadius(100);
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientColorStops');
		  /**
		   * get/set fill radial gradient color stops
		   * @name Konva.Shape#fillRadialGradientColorStops
		   * @method
		   * @param {Number} colorStops
		   * @returns {Array}
		   * @example
		   * // get fill radial gradient color stops
		   * var colorStops = shape.fillRadialGradientColorStops();
		   *
		   * // create a radial gradient that starts with red, changes to blue
		   * // halfway through, and then changes to green
		   * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternRepeat', 'repeat');
		  /**
		   * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
		   * @name Konva.Shape#fillPatternRepeat
		   * @method
		   * @param {String} repeat
		   * @returns {String}
		   * @example
		   * // get fill pattern repeat
		   * var repeat = shape.fillPatternRepeat();
		   *
		   * // repeat pattern in x direction only
		   * shape.fillPatternRepeat('repeat-x');
		   *
		   * // do not repeat the pattern
		   * shape.fillPatternRepeat('no-repeat');
		   */
		  Factory.addGetterSetter(Shape, 'fillEnabled', true);
		  /**
		   * get/set fill enabled flag
		   * @name Konva.Shape#fillEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get fill enabled flag
		   * var fillEnabled = shape.fillEnabled();
		   *
		   * // disable fill
		   * shape.fillEnabled(false);
		   *
		   * // enable fill
		   * shape.fillEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'strokeEnabled', true);
		  /**
		   * get/set stroke enabled flag
		   * @name Konva.Shape#strokeEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get stroke enabled flag
		   * var strokeEnabled = shape.strokeEnabled();
		   *
		   * // disable stroke
		   * shape.strokeEnabled(false);
		   *
		   * // enable stroke
		   * shape.strokeEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'shadowEnabled', true);
		  /**
		   * get/set shadow enabled flag
		   * @name Konva.Shape#shadowEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get shadow enabled flag
		   * var shadowEnabled = shape.shadowEnabled();
		   *
		   * // disable shadow
		   * shape.shadowEnabled(false);
		   *
		   * // enable shadow
		   * shape.shadowEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'dashEnabled', true);
		  /**
		   * get/set dash enabled flag
		   * @name Konva.Shape#dashEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get dash enabled flag
		   * var dashEnabled = shape.dashEnabled();
		   *
		   * // disable dash
		   * shape.dashEnabled(false);
		   *
		   * // enable dash
		   * shape.dashEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'strokeScaleEnabled', true);
		  /**
		   * get/set strokeScale enabled flag
		   * @name Konva.Shape#strokeScaleEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get stroke scale enabled flag
		   * var strokeScaleEnabled = shape.strokeScaleEnabled();
		   *
		   * // disable stroke scale
		   * shape.strokeScaleEnabled(false);
		   *
		   * // enable stroke scale
		   * shape.strokeScaleEnabled(true);
		   */
		  Factory.addGetterSetter(Shape, 'fillPriority', 'color');
		  /**
		   * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
		   *   This is handy if you want to toggle between different fill types.
		   * @name Konva.Shape#fillPriority
		   * @method
		   * @param {String} priority
		   * @returns {String}
		   * @example
		   * // get fill priority
		   * var fillPriority = shape.fillPriority();
		   *
		   * // set fill priority
		   * shape.fillPriority('linear-gradient');
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillPatternOffset', ['x', 'y']);
		  /**
		   * get/set fill pattern offset
		   * @name Konva.Shape#fillPatternOffset
		   * @method
		   * @param {Object} offset
		   * @param {Number} offset.x
		   * @param {Number} offset.y
		   * @returns {Object}
		   * @example
		   * // get fill pattern offset
		   * var patternOffset = shape.fillPatternOffset();
		   *
		   * // set fill pattern offset
		   * shape.fillPatternOffset({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternOffsetX', 0, getNumberValidator());
		  /**
		   * get/set fill pattern offset x
		   * @name Konva.Shape#fillPatternOffsetX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill pattern offset x
		   * var patternOffsetX = shape.fillPatternOffsetX();
		   *
		   * // set fill pattern offset x
		   * shape.fillPatternOffsetX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternOffsetY', 0, getNumberValidator());
		  /**
		   * get/set fill pattern offset y
		   * @name Konva.Shape#fillPatternOffsetY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill pattern offset y
		   * var patternOffsetY = shape.fillPatternOffsetY();
		   *
		   * // set fill pattern offset y
		   * shape.fillPatternOffsetY(10);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillPatternScale', ['x', 'y']);
		  /**
		   * get/set fill pattern scale
		   * @name Konva.Shape#fillPatternScale
		   * @method
		   * @param {Object} scale
		   * @param {Number} scale.x
		   * @param {Number} scale.y
		   * @returns {Object}
		   * @example
		   * // get fill pattern scale
		   * var patternScale = shape.fillPatternScale();
		   *
		   * // set fill pattern scale
		   * shape.fillPatternScale({
		   *   x: 2,
		   *   y: 2
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternScaleX', 1, getNumberValidator());
		  /**
		   * get/set fill pattern scale x
		   * @name Konva.Shape#fillPatternScaleX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill pattern scale x
		   * var patternScaleX = shape.fillPatternScaleX();
		   *
		   * // set fill pattern scale x
		   * shape.fillPatternScaleX(2);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternScaleY', 1, getNumberValidator());
		  /**
		   * get/set fill pattern scale y
		   * @name Konva.Shape#fillPatternScaleY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill pattern scale y
		   * var patternScaleY = shape.fillPatternScaleY();
		   *
		   * // set fill pattern scale y
		   * shape.fillPatternScaleY(2);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientStartPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set fill linear gradient start point
		   * @name Konva.Shape#fillLinearGradientStartPoint
		   * @method
		   * @param {Object} startPoint
		   * @param {Number} startPoint.x
		   * @param {Number} startPoint.y
		   * @returns {Object}
		   * @example
		   * // get fill linear gradient start point
		   * var startPoint = shape.fillLinearGradientStartPoint();
		   *
		   * // set fill linear gradient start point
		   * shape.fillLinearGradientStartPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientStartPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set stroke linear gradient start point
		   * @name Konva.Shape#strokeLinearGradientStartPoint
		   * @method
		   * @param {Object} startPoint
		   * @param {Number} startPoint.x
		   * @param {Number} startPoint.y
		   * @returns {Object}
		   * @example
		   * // get stroke linear gradient start point
		   * var startPoint = shape.strokeLinearGradientStartPoint();
		   *
		   * // set stroke linear gradient start point
		   * shape.strokeLinearGradientStartPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointX', 0);
		  /**
		   * get/set fill linear gradient start point x
		   * @name Konva.Shape#fillLinearGradientStartPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill linear gradient start point x
		   * var startPointX = shape.fillLinearGradientStartPointX();
		   *
		   * // set fill linear gradient start point x
		   * shape.fillLinearGradientStartPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointX', 0);
		  /**
		   * get/set stroke linear gradient start point x
		   * @name Konva.Shape#linearLinearGradientStartPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get stroke linear gradient start point x
		   * var startPointX = shape.strokeLinearGradientStartPointX();
		   *
		   * // set stroke linear gradient start point x
		   * shape.strokeLinearGradientStartPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointY', 0);
		  /**
		   * get/set fill linear gradient start point y
		   * @name Konva.Shape#fillLinearGradientStartPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill linear gradient start point y
		   * var startPointY = shape.fillLinearGradientStartPointY();
		   *
		   * // set fill linear gradient start point y
		   * shape.fillLinearGradientStartPointY(20);
		   */
		  Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointY', 0);
		  /**
		   * get/set stroke linear gradient start point y
		   * @name Konva.Shape#strokeLinearGradientStartPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get stroke linear gradient start point y
		   * var startPointY = shape.strokeLinearGradientStartPointY();
		   *
		   * // set stroke linear gradient start point y
		   * shape.strokeLinearGradientStartPointY(20);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientEndPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set fill linear gradient end point
		   * @name Konva.Shape#fillLinearGradientEndPoint
		   * @method
		   * @param {Object} endPoint
		   * @param {Number} endPoint.x
		   * @param {Number} endPoint.y
		   * @returns {Object}
		   * @example
		   * // get fill linear gradient end point
		   * var endPoint = shape.fillLinearGradientEndPoint();
		   *
		   * // set fill linear gradient end point
		   * shape.fillLinearGradientEndPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientEndPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set stroke linear gradient end point
		   * @name Konva.Shape#strokeLinearGradientEndPoint
		   * @method
		   * @param {Object} endPoint
		   * @param {Number} endPoint.x
		   * @param {Number} endPoint.y
		   * @returns {Object}
		   * @example
		   * // get stroke linear gradient end point
		   * var endPoint = shape.strokeLinearGradientEndPoint();
		   *
		   * // set stroke linear gradient end point
		   * shape.strokeLinearGradientEndPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointX', 0);
		  /**
		   * get/set fill linear gradient end point x
		   * @name Konva.Shape#fillLinearGradientEndPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill linear gradient end point x
		   * var endPointX = shape.fillLinearGradientEndPointX();
		   *
		   * // set fill linear gradient end point x
		   * shape.fillLinearGradientEndPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointX', 0);
		  /**
		   * get/set fill linear gradient end point x
		   * @name Konva.Shape#strokeLinearGradientEndPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get stroke linear gradient end point x
		   * var endPointX = shape.strokeLinearGradientEndPointX();
		   *
		   * // set stroke linear gradient end point x
		   * shape.strokeLinearGradientEndPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointY', 0);
		  /**
		   * get/set fill linear gradient end point y
		   * @name Konva.Shape#fillLinearGradientEndPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill linear gradient end point y
		   * var endPointY = shape.fillLinearGradientEndPointY();
		   *
		   * // set fill linear gradient end point y
		   * shape.fillLinearGradientEndPointY(20);
		   */
		  Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointY', 0);
		  /**
		   * get/set stroke linear gradient end point y
		   * @name Konva.Shape#strokeLinearGradientEndPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get stroke linear gradient end point y
		   * var endPointY = shape.strokeLinearGradientEndPointY();
		   *
		   * // set stroke linear gradient end point y
		   * shape.strokeLinearGradientEndPointY(20);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientStartPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set fill radial gradient start point
		   * @name Konva.Shape#fillRadialGradientStartPoint
		   * @method
		   * @param {Object} startPoint
		   * @param {Number} startPoint.x
		   * @param {Number} startPoint.y
		   * @returns {Object}
		   * @example
		   * // get fill radial gradient start point
		   * var startPoint = shape.fillRadialGradientStartPoint();
		   *
		   * // set fill radial gradient start point
		   * shape.fillRadialGradientStartPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointX', 0);
		  /**
		   * get/set fill radial gradient start point x
		   * @name Konva.Shape#fillRadialGradientStartPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill radial gradient start point x
		   * var startPointX = shape.fillRadialGradientStartPointX();
		   *
		   * // set fill radial gradient start point x
		   * shape.fillRadialGradientStartPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointY', 0);
		  /**
		   * get/set fill radial gradient start point y
		   * @name Konva.Shape#fillRadialGradientStartPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill radial gradient start point y
		   * var startPointY = shape.fillRadialGradientStartPointY();
		   *
		   * // set fill radial gradient start point y
		   * shape.fillRadialGradientStartPointY(20);
		   */
		  Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientEndPoint', [
		      'x',
		      'y',
		  ]);
		  /**
		   * get/set fill radial gradient end point
		   * @name Konva.Shape#fillRadialGradientEndPoint
		   * @method
		   * @param {Object} endPoint
		   * @param {Number} endPoint.x
		   * @param {Number} endPoint.y
		   * @returns {Object}
		   * @example
		   * // get fill radial gradient end point
		   * var endPoint = shape.fillRadialGradientEndPoint();
		   *
		   * // set fill radial gradient end point
		   * shape.fillRadialGradientEndPoint({
		   *   x: 20,
		   *   y: 10
		   * });
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointX', 0);
		  /**
		   * get/set fill radial gradient end point x
		   * @name Konva.Shape#fillRadialGradientEndPointX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get fill radial gradient end point x
		   * var endPointX = shape.fillRadialGradientEndPointX();
		   *
		   * // set fill radial gradient end point x
		   * shape.fillRadialGradientEndPointX(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointY', 0);
		  /**
		   * get/set fill radial gradient end point y
		   * @name Konva.Shape#fillRadialGradientEndPointY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get fill radial gradient end point y
		   * var endPointY = shape.fillRadialGradientEndPointY();
		   *
		   * // set fill radial gradient end point y
		   * shape.fillRadialGradientEndPointY(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillPatternRotation', 0);
		  /**
		   * get/set fill pattern rotation in degrees
		   * @name Konva.Shape#fillPatternRotation
		   * @method
		   * @param {Number} rotation
		   * @returns {Konva.Shape}
		   * @example
		   * // get fill pattern rotation
		   * var patternRotation = shape.fillPatternRotation();
		   *
		   * // set fill pattern rotation
		   * shape.fillPatternRotation(20);
		   */
		  Factory.addGetterSetter(Shape, 'fillRule', undefined, getStringValidator());
		  /**
		   * get/set fill rule
		   * @name Konva.Shape#fillRule
		   * @method
		   * @param {CanvasFillRule} rotation
		   * @returns {Konva.Shape}
		   * @example
		   * // get fill rule
		   * var fillRule = shape.fillRule();
		   *
		   * // set fill rule
		   * shape.fillRule('evenodd');
		   */
		  Factory.backCompat(Shape, {
		      dashArray: 'dash',
		      getDashArray: 'getDash',
		      setDashArray: 'getDash',
		      drawFunc: 'sceneFunc',
		      getDrawFunc: 'getSceneFunc',
		      setDrawFunc: 'setSceneFunc',
		      drawHitFunc: 'hitFunc',
		      getDrawHitFunc: 'getHitFunc',
		      setDrawHitFunc: 'setHitFunc',
		  });

		  // constants
		  var HASH = '#', BEFORE_DRAW = 'beforeDraw', DRAW = 'draw', 
		  /*
		   * 2 - 3 - 4
		   * |       |
		   * 1 - 0   5
		   *         |
		   * 8 - 7 - 6
		   */
		  INTERSECTION_OFFSETS = [
		      { x: 0, y: 0 },
		      { x: -1, y: -1 },
		      { x: 1, y: -1 },
		      { x: 1, y: 1 },
		      { x: -1, y: 1 }, // 8
		  ], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
		  /**
		   * Layer constructor.  Layers are tied to their own canvas element and are used
		   * to contain groups or shapes.
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Container
		   * @param {Object} config
		   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
		   * to clear the canvas before each layer draw.  The default value is true.
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * * @param {Object} [config.clip] set clip
		     * @param {Number} [config.clipX] set clip x
		     * @param {Number} [config.clipY] set clip y
		     * @param {Number} [config.clipWidth] set clip width
		     * @param {Number} [config.clipHeight] set clip height
		     * @param {Function} [config.clipFunc] set clip func

		   * @example
		   * var layer = new Konva.Layer();
		   * stage.add(layer);
		   * // now you can add shapes, groups into the layer
		   */
		  class Layer extends Container {
		      constructor(config) {
		          super(config);
		          this.canvas = new SceneCanvas();
		          this.hitCanvas = new HitCanvas({
		              pixelRatio: 1,
		          });
		          this._waitingForDraw = false;
		          this.on('visibleChange.konva', this._checkVisibility);
		          this._checkVisibility();
		          this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
		          this._setSmoothEnabled();
		      }
		      // for nodejs?
		      createPNGStream() {
		          const c = this.canvas._canvas;
		          return c.createPNGStream();
		      }
		      /**
		       * get layer canvas wrapper
		       * @method
		       * @name Konva.Layer#getCanvas
		       */
		      getCanvas() {
		          return this.canvas;
		      }
		      /**
		       * get native canvas element
		       * @method
		       * @name Konva.Layer#getNativeCanvasElement
		       */
		      getNativeCanvasElement() {
		          return this.canvas._canvas;
		      }
		      /**
		       * get layer hit canvas
		       * @method
		       * @name Konva.Layer#getHitCanvas
		       */
		      getHitCanvas() {
		          return this.hitCanvas;
		      }
		      /**
		       * get layer canvas context
		       * @method
		       * @name Konva.Layer#getContext
		       */
		      getContext() {
		          return this.getCanvas().getContext();
		      }
		      // TODO: deprecate this method
		      clear(bounds) {
		          this.getContext().clear(bounds);
		          this.getHitCanvas().getContext().clear(bounds);
		          return this;
		      }
		      // extend Node.prototype.setZIndex
		      setZIndex(index) {
		          super.setZIndex(index);
		          var stage = this.getStage();
		          if (stage && stage.content) {
		              stage.content.removeChild(this.getNativeCanvasElement());
		              if (index < stage.children.length - 1) {
		                  stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
		              }
		              else {
		                  stage.content.appendChild(this.getNativeCanvasElement());
		              }
		          }
		          return this;
		      }
		      moveToTop() {
		          Node.prototype.moveToTop.call(this);
		          var stage = this.getStage();
		          if (stage && stage.content) {
		              stage.content.removeChild(this.getNativeCanvasElement());
		              stage.content.appendChild(this.getNativeCanvasElement());
		          }
		          return true;
		      }
		      moveUp() {
		          var moved = Node.prototype.moveUp.call(this);
		          if (!moved) {
		              return false;
		          }
		          var stage = this.getStage();
		          if (!stage || !stage.content) {
		              return false;
		          }
		          stage.content.removeChild(this.getNativeCanvasElement());
		          if (this.index < stage.children.length - 1) {
		              stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
		          }
		          else {
		              stage.content.appendChild(this.getNativeCanvasElement());
		          }
		          return true;
		      }
		      // extend Node.prototype.moveDown
		      moveDown() {
		          if (Node.prototype.moveDown.call(this)) {
		              var stage = this.getStage();
		              if (stage) {
		                  var children = stage.children;
		                  if (stage.content) {
		                      stage.content.removeChild(this.getNativeCanvasElement());
		                      stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
		                  }
		              }
		              return true;
		          }
		          return false;
		      }
		      // extend Node.prototype.moveToBottom
		      moveToBottom() {
		          if (Node.prototype.moveToBottom.call(this)) {
		              var stage = this.getStage();
		              if (stage) {
		                  var children = stage.children;
		                  if (stage.content) {
		                      stage.content.removeChild(this.getNativeCanvasElement());
		                      stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
		                  }
		              }
		              return true;
		          }
		          return false;
		      }
		      getLayer() {
		          return this;
		      }
		      remove() {
		          var _canvas = this.getNativeCanvasElement();
		          Node.prototype.remove.call(this);
		          if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) {
		              _canvas.parentNode.removeChild(_canvas);
		          }
		          return this;
		      }
		      getStage() {
		          return this.parent;
		      }
		      setSize({ width, height }) {
		          this.canvas.setSize(width, height);
		          this.hitCanvas.setSize(width, height);
		          this._setSmoothEnabled();
		          return this;
		      }
		      _validateAdd(child) {
		          var type = child.getType();
		          if (type !== 'Group' && type !== 'Shape') {
		              Util.throw('You may only add groups and shapes to a layer.');
		          }
		      }
		      _toKonvaCanvas(config) {
		          config = config || {};
		          config.width = config.width || this.getWidth();
		          config.height = config.height || this.getHeight();
		          config.x = config.x !== undefined ? config.x : this.x();
		          config.y = config.y !== undefined ? config.y : this.y();
		          return Node.prototype._toKonvaCanvas.call(this, config);
		      }
		      _checkVisibility() {
		          const visible = this.visible();
		          if (visible) {
		              this.canvas._canvas.style.display = 'block';
		          }
		          else {
		              this.canvas._canvas.style.display = 'none';
		          }
		      }
		      _setSmoothEnabled() {
		          this.getContext()._context.imageSmoothingEnabled =
		              this.imageSmoothingEnabled();
		      }
		      /**
		       * get/set width of layer. getter return width of stage. setter doing nothing.
		       * if you want change width use `stage.width(value);`
		       * @name Konva.Layer#width
		       * @method
		       * @returns {Number}
		       * @example
		       * var width = layer.width();
		       */
		      getWidth() {
		          if (this.parent) {
		              return this.parent.width();
		          }
		      }
		      setWidth() {
		          Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
		      }
		      /**
		       * get/set height of layer.getter return height of stage. setter doing nothing.
		       * if you want change height use `stage.height(value);`
		       * @name Konva.Layer#height
		       * @method
		       * @returns {Number}
		       * @example
		       * var height = layer.height();
		       */
		      getHeight() {
		          if (this.parent) {
		              return this.parent.height();
		          }
		      }
		      setHeight() {
		          Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
		      }
		      /**
		       * batch draw. this function will not do immediate draw
		       * but it will schedule drawing to next tick (requestAnimFrame)
		       * @method
		       * @name Konva.Layer#batchDraw
		       * @return {Konva.Layer} this
		       */
		      batchDraw() {
		          if (!this._waitingForDraw) {
		              this._waitingForDraw = true;
		              Util.requestAnimFrame(() => {
		                  this.draw();
		                  this._waitingForDraw = false;
		              });
		          }
		          return this;
		      }
		      /**
		       * get visible intersection shape. This is the preferred
		       * method for determining if a point intersects a shape or not
		       * also you may pass optional selector parameter to return ancestor of intersected shape
		       * @method
		       * @name Konva.Layer#getIntersection
		       * @param {Object} pos
		       * @param {Number} pos.x
		       * @param {Number} pos.y
		       * @returns {Konva.Node}
		       * @example
		       * var shape = layer.getIntersection({x: 50, y: 50});
		       */
		      getIntersection(pos) {
		          if (!this.isListening() || !this.isVisible()) {
		              return null;
		          }
		          // in some cases antialiased area may be bigger than 1px
		          // it is possible if we will cache node, then scale it a lot
		          var spiralSearchDistance = 1;
		          var continueSearch = false;
		          while (true) {
		              for (let i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
		                  const intersectionOffset = INTERSECTION_OFFSETS[i];
		                  const obj = this._getIntersection({
		                      x: pos.x + intersectionOffset.x * spiralSearchDistance,
		                      y: pos.y + intersectionOffset.y * spiralSearchDistance,
		                  });
		                  const shape = obj.shape;
		                  if (shape) {
		                      return shape;
		                  }
		                  // we should continue search if we found antialiased pixel
		                  // that means our node somewhere very close
		                  continueSearch = !!obj.antialiased;
		                  // stop search if found empty pixel
		                  if (!obj.antialiased) {
		                      break;
		                  }
		              }
		              // if no shape, and no antialiased pixel, we should end searching
		              if (continueSearch) {
		                  spiralSearchDistance += 1;
		              }
		              else {
		                  return null;
		              }
		          }
		      }
		      _getIntersection(pos) {
		          const ratio = this.hitCanvas.pixelRatio;
		          const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
		          const p3 = p[3];
		          // fully opaque pixel
		          if (p3 === 255) {
		              const colorKey = Util._rgbToHex(p[0], p[1], p[2]);
		              const shape = shapes[HASH + colorKey];
		              if (shape) {
		                  return {
		                      shape: shape,
		                  };
		              }
		              return {
		                  antialiased: true,
		              };
		          }
		          else if (p3 > 0) {
		              // antialiased pixel
		              return {
		                  antialiased: true,
		              };
		          }
		          // empty pixel
		          return {};
		      }
		      drawScene(can, top) {
		          var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
		          this._fire(BEFORE_DRAW, {
		              node: this,
		          });
		          if (this.clearBeforeDraw()) {
		              canvas.getContext().clear();
		          }
		          Container.prototype.drawScene.call(this, canvas, top);
		          this._fire(DRAW, {
		              node: this,
		          });
		          return this;
		      }
		      drawHit(can, top) {
		          var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
		          if (layer && layer.clearBeforeDraw()) {
		              layer.getHitCanvas().getContext().clear();
		          }
		          Container.prototype.drawHit.call(this, canvas, top);
		          return this;
		      }
		      /**
		       * enable hit graph. **DEPRECATED!** Use `layer.listening(true)` instead.
		       * @name Konva.Layer#enableHitGraph
		       * @method
		       * @returns {Layer}
		       */
		      enableHitGraph() {
		          this.hitGraphEnabled(true);
		          return this;
		      }
		      /**
		       * disable hit graph. **DEPRECATED!** Use `layer.listening(false)` instead.
		       * @name Konva.Layer#disableHitGraph
		       * @method
		       * @returns {Layer}
		       */
		      disableHitGraph() {
		          this.hitGraphEnabled(false);
		          return this;
		      }
		      setHitGraphEnabled(val) {
		          Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
		          this.listening(val);
		      }
		      getHitGraphEnabled(val) {
		          Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
		          return this.listening();
		      }
		      /**
		       * Show or hide hit canvas over the stage. May be useful for debugging custom hitFunc
		       * @name Konva.Layer#toggleHitCanvas
		       * @method
		       */
		      toggleHitCanvas() {
		          if (!this.parent || !this.parent['content']) {
		              return;
		          }
		          var parent = this.parent;
		          var added = !!this.hitCanvas._canvas.parentNode;
		          if (added) {
		              parent.content.removeChild(this.hitCanvas._canvas);
		          }
		          else {
		              parent.content.appendChild(this.hitCanvas._canvas);
		          }
		      }
		      destroy() {
		          Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
		          return super.destroy();
		      }
		  }
		  Layer.prototype.nodeType = 'Layer';
		  _registerNode(Layer);
		  /**
		   * get/set imageSmoothingEnabled flag
		   * For more info see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/imageSmoothingEnabled
		   * @name Konva.Layer#imageSmoothingEnabled
		   * @method
		   * @param {Boolean} imageSmoothingEnabled
		   * @returns {Boolean}
		   * @example
		   * // get imageSmoothingEnabled flag
		   * var imageSmoothingEnabled = layer.imageSmoothingEnabled();
		   *
		   * layer.imageSmoothingEnabled(false);
		   *
		   * layer.imageSmoothingEnabled(true);
		   */
		  Factory.addGetterSetter(Layer, 'imageSmoothingEnabled', true);
		  /**
		   * get/set clearBeforeDraw flag which determines if the layer is cleared or not
		   *  before drawing
		   * @name Konva.Layer#clearBeforeDraw
		   * @method
		   * @param {Boolean} clearBeforeDraw
		   * @returns {Boolean}
		   * @example
		   * // get clearBeforeDraw flag
		   * var clearBeforeDraw = layer.clearBeforeDraw();
		   *
		   * // disable clear before draw
		   * layer.clearBeforeDraw(false);
		   *
		   * // enable clear before draw
		   * layer.clearBeforeDraw(true);
		   */
		  Factory.addGetterSetter(Layer, 'clearBeforeDraw', true);
		  Factory.addGetterSetter(Layer, 'hitGraphEnabled', true, getBooleanValidator());
		  /**
		   * get/set hitGraphEnabled flag.  **DEPRECATED!** Use `layer.listening(false)` instead.
		   *  Disabling the hit graph will greatly increase
		   *  draw performance because the hit graph will not be redrawn each time the layer is
		   *  drawn.  This, however, also disables mouse/touch event detection
		   * @name Konva.Layer#hitGraphEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get hitGraphEnabled flag
		   * var hitGraphEnabled = layer.hitGraphEnabled();
		   *
		   * // disable hit graph
		   * layer.hitGraphEnabled(false);
		   *
		   * // enable hit graph
		   * layer.hitGraphEnabled(true);
		   */

		  /**
		   * FastLayer constructor. **DEPRECATED!** Please use `Konva.Layer({ listening: false})` instead. Layers are tied to their own canvas element and are used
		   * to contain shapes only.  If you don't need node nesting, mouse and touch interactions,
		   * or event pub/sub, you should use FastLayer instead of Layer to create your layers.
		   * It renders about 2x faster than normal layers.
		   *
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Layer
		   * * @param {Object} [config.clip] set clip
		     * @param {Number} [config.clipX] set clip x
		     * @param {Number} [config.clipY] set clip y
		     * @param {Number} [config.clipWidth] set clip width
		     * @param {Number} [config.clipHeight] set clip height
		     * @param {Function} [config.clipFunc] set clip func

		   * @example
		   * var layer = new Konva.FastLayer();
		   */
		  class FastLayer extends Layer {
		      constructor(attrs) {
		          super(attrs);
		          this.listening(false);
		          Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
		      }
		  }
		  FastLayer.prototype.nodeType = 'FastLayer';
		  _registerNode(FastLayer);

		  /**
		   * Group constructor.  Groups are used to contain shapes or other groups.
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Container
		   * @param {Object} config
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * * @param {Object} [config.clip] set clip
		     * @param {Number} [config.clipX] set clip x
		     * @param {Number} [config.clipY] set clip y
		     * @param {Number} [config.clipWidth] set clip width
		     * @param {Number} [config.clipHeight] set clip height
		     * @param {Function} [config.clipFunc] set clip func

		   * @example
		   * var group = new Konva.Group();
		   */
		  class Group extends Container {
		      _validateAdd(child) {
		          var type = child.getType();
		          if (type !== 'Group' && type !== 'Shape') {
		              Util.throw('You may only add groups and shapes to groups.');
		          }
		      }
		  }
		  Group.prototype.nodeType = 'Group';
		  _registerNode(Group);

		  const now = (function () {
		      if (glob.performance && glob.performance.now) {
		          return function () {
		              return glob.performance.now();
		          };
		      }
		      return function () {
		          return new Date().getTime();
		      };
		  })();
		  /**
		   * Animation constructor.
		   * @constructor
		   * @memberof Konva
		   * @param {AnimationFn} func function executed on each animation frame.  The function is passed a frame object, which contains
		   *  timeDiff, lastTime, time, and frameRate properties.  The timeDiff property is the number of milliseconds that have passed
		   *  since the last animation frame. The time property is the time in milliseconds that elapsed from the moment the animation started
		   *  to the current animation frame. The lastTime property is a `time` value from the previous frame.  The frameRate property is the current frame rate in frames / second.
		   *  Return false from function, if you don't need to redraw layer/layers on some frames.
		   * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn on each animation frame. Can be a layer, an array of layers, or null.
		   *  Not specifying a node will result in no redraw.
		   * @example
		   * // move a node to the right at 50 pixels / second
		   * var velocity = 50;
		   *
		   * var anim = new Konva.Animation(function(frame) {
		   *   var dist = velocity * (frame.timeDiff / 1000);
		   *   node.move({x: dist, y: 0});
		   * }, layer);
		   *
		   * anim.start();
		   */
		  class Animation {
		      constructor(func, layers) {
		          this.id = Animation.animIdCounter++;
		          this.frame = {
		              time: 0,
		              timeDiff: 0,
		              lastTime: now(),
		              frameRate: 0,
		          };
		          this.func = func;
		          this.setLayers(layers);
		      }
		      /**
		       * set layers to be redrawn on each animation frame
		       * @method
		       * @name Konva.Animation#setLayers
		       * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn. Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
		       * @return {Konva.Animation} this
		       */
		      setLayers(layers) {
		          let lays = [];
		          // if passing in no layers
		          if (layers) {
		              lays = Array.isArray(layers) ? layers : [layers];
		          }
		          this.layers = lays;
		          return this;
		      }
		      /**
		       * get layers
		       * @method
		       * @name Konva.Animation#getLayers
		       * @return {Array} Array of Konva.Layer
		       */
		      getLayers() {
		          return this.layers;
		      }
		      /**
		       * add layer.  Returns true if the layer was added, and false if it was not
		       * @method
		       * @name Konva.Animation#addLayer
		       * @param {Konva.Layer} layer to add
		       * @return {Bool} true if layer is added to animation, otherwise false
		       */
		      addLayer(layer) {
		          const layers = this.layers;
		          const len = layers.length;
		          // don't add the layer if it already exists
		          for (let n = 0; n < len; n++) {
		              if (layers[n]._id === layer._id) {
		                  return false;
		              }
		          }
		          this.layers.push(layer);
		          return true;
		      }
		      /**
		       * determine if animation is running or not.  returns true or false
		       * @method
		       * @name Konva.Animation#isRunning
		       * @return {Bool} is animation running?
		       */
		      isRunning() {
		          const a = Animation;
		          const animations = a.animations;
		          const len = animations.length;
		          for (let n = 0; n < len; n++) {
		              if (animations[n].id === this.id) {
		                  return true;
		              }
		          }
		          return false;
		      }
		      /**
		       * start animation
		       * @method
		       * @name Konva.Animation#start
		       * @return {Konva.Animation} this
		       */
		      start() {
		          this.stop();
		          this.frame.timeDiff = 0;
		          this.frame.lastTime = now();
		          Animation._addAnimation(this);
		          return this;
		      }
		      /**
		       * stop animation
		       * @method
		       * @name Konva.Animation#stop
		       * @return {Konva.Animation} this
		       */
		      stop() {
		          Animation._removeAnimation(this);
		          return this;
		      }
		      _updateFrameObject(time) {
		          this.frame.timeDiff = time - this.frame.lastTime;
		          this.frame.lastTime = time;
		          this.frame.time += this.frame.timeDiff;
		          this.frame.frameRate = 1000 / this.frame.timeDiff;
		      }
		      static _addAnimation(anim) {
		          this.animations.push(anim);
		          this._handleAnimation();
		      }
		      static _removeAnimation(anim) {
		          const id = anim.id;
		          const animations = this.animations;
		          const len = animations.length;
		          for (let n = 0; n < len; n++) {
		              if (animations[n].id === id) {
		                  this.animations.splice(n, 1);
		                  break;
		              }
		          }
		      }
		      static _runFrames() {
		          const layerHash = {};
		          const animations = this.animations;
		          /*
		           * loop through all animations and execute animation
		           *  function.  if the animation object has specified node,
		           *  we can add the node to the nodes hash to eliminate
		           *  drawing the same node multiple times.  The node property
		           *  can be the stage itself or a layer
		           */
		          /*
		           * WARNING: don't cache animations.length because it could change while
		           * the for loop is running, causing a JS error
		           */
		          for (let n = 0; n < animations.length; n++) {
		              const anim = animations[n];
		              const layers = anim.layers;
		              const func = anim.func;
		              anim._updateFrameObject(now());
		              const layersLen = layers.length;
		              // if animation object has a function, execute it
		              let needRedraw;
		              if (func) {
		                  // allow anim bypassing drawing
		                  needRedraw = func.call(anim, anim.frame) !== false;
		              }
		              else {
		                  needRedraw = true;
		              }
		              if (!needRedraw) {
		                  continue;
		              }
		              for (let i = 0; i < layersLen; i++) {
		                  const layer = layers[i];
		                  if (layer._id !== undefined) {
		                      layerHash[layer._id] = layer;
		                  }
		              }
		          }
		          for (let key in layerHash) {
		              if (!layerHash.hasOwnProperty(key)) {
		                  continue;
		              }
		              layerHash[key].batchDraw();
		          }
		      }
		      static _animationLoop() {
		          const Anim = Animation;
		          if (Anim.animations.length) {
		              Anim._runFrames();
		              Util.requestAnimFrame(Anim._animationLoop);
		          }
		          else {
		              Anim.animRunning = false;
		          }
		      }
		      static _handleAnimation() {
		          if (!this.animRunning) {
		              this.animRunning = true;
		              Util.requestAnimFrame(this._animationLoop);
		          }
		      }
		  }
		  Animation.animations = [];
		  Animation.animIdCounter = 0;
		  Animation.animRunning = false;

		  var blacklist = {
		      node: 1,
		      duration: 1,
		      easing: 1,
		      onFinish: 1,
		      yoyo: 1,
		  }, PAUSED = 1, PLAYING = 2, REVERSING = 3, idCounter = 0, colorAttrs = ['fill', 'stroke', 'shadowColor'];
		  class TweenEngine {
		      constructor(prop, propFunc, func, begin, finish, duration, yoyo) {
		          this.prop = prop;
		          this.propFunc = propFunc;
		          this.begin = begin;
		          this._pos = begin;
		          this.duration = duration;
		          this._change = 0;
		          this.prevPos = 0;
		          this.yoyo = yoyo;
		          this._time = 0;
		          this._position = 0;
		          this._startTime = 0;
		          this._finish = 0;
		          this.func = func;
		          this._change = finish - this.begin;
		          this.pause();
		      }
		      fire(str) {
		          var handler = this[str];
		          if (handler) {
		              handler();
		          }
		      }
		      setTime(t) {
		          if (t > this.duration) {
		              if (this.yoyo) {
		                  this._time = this.duration;
		                  this.reverse();
		              }
		              else {
		                  this.finish();
		              }
		          }
		          else if (t < 0) {
		              if (this.yoyo) {
		                  this._time = 0;
		                  this.play();
		              }
		              else {
		                  this.reset();
		              }
		          }
		          else {
		              this._time = t;
		              this.update();
		          }
		      }
		      getTime() {
		          return this._time;
		      }
		      setPosition(p) {
		          this.prevPos = this._pos;
		          this.propFunc(p);
		          this._pos = p;
		      }
		      getPosition(t) {
		          if (t === undefined) {
		              t = this._time;
		          }
		          return this.func(t, this.begin, this._change, this.duration);
		      }
		      play() {
		          this.state = PLAYING;
		          this._startTime = this.getTimer() - this._time;
		          this.onEnterFrame();
		          this.fire('onPlay');
		      }
		      reverse() {
		          this.state = REVERSING;
		          this._time = this.duration - this._time;
		          this._startTime = this.getTimer() - this._time;
		          this.onEnterFrame();
		          this.fire('onReverse');
		      }
		      seek(t) {
		          this.pause();
		          this._time = t;
		          this.update();
		          this.fire('onSeek');
		      }
		      reset() {
		          this.pause();
		          this._time = 0;
		          this.update();
		          this.fire('onReset');
		      }
		      finish() {
		          this.pause();
		          this._time = this.duration;
		          this.update();
		          this.fire('onFinish');
		      }
		      update() {
		          this.setPosition(this.getPosition(this._time));
		          this.fire('onUpdate');
		      }
		      onEnterFrame() {
		          var t = this.getTimer() - this._startTime;
		          if (this.state === PLAYING) {
		              this.setTime(t);
		          }
		          else if (this.state === REVERSING) {
		              this.setTime(this.duration - t);
		          }
		      }
		      pause() {
		          this.state = PAUSED;
		          this.fire('onPause');
		      }
		      getTimer() {
		          return new Date().getTime();
		      }
		  }
		  /**
		   * Tween constructor.  Tweens enable you to animate a node between the current state and a new state.
		   *  You can play, pause, reverse, seek, reset, and finish tweens.  By default, tweens are animated using
		   *  a linear easing.  For more tweening options, check out {@link Konva.Easings}
		   * @constructor
		   * @memberof Konva
		   * @example
		   * // instantiate new tween which fully rotates a node in 1 second
		   * var tween = new Konva.Tween({
		   *   // list of tween specific properties
		   *   node: node,
		   *   duration: 1,
		   *   easing: Konva.Easings.EaseInOut,
		   *   onUpdate: () => console.log('node attrs updated')
		   *   onFinish: () => console.log('finished'),
		   *   // set new values for any attributes of a passed node
		   *   rotation: 360,
		   *   fill: 'red'
		   * });
		   *
		   * // play tween
		   * tween.play();
		   *
		   * // pause tween
		   * tween.pause();
		   */
		  class Tween {
		      constructor(config) {
		          var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || Easings.Linear, yoyo = !!config.yoyo, key;
		          if (typeof config.duration === 'undefined') {
		              duration = 0.3;
		          }
		          else if (config.duration === 0) {
		              // zero is bad value for duration
		              duration = 0.001;
		          }
		          else {
		              duration = config.duration;
		          }
		          this.node = node;
		          this._id = idCounter++;
		          var layers = node.getLayer() ||
		              (node instanceof Konva$2['Stage'] ? node.getLayers() : null);
		          if (!layers) {
		              Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
		          }
		          this.anim = new Animation(function () {
		              that.tween.onEnterFrame();
		          }, layers);
		          this.tween = new TweenEngine(key, function (i) {
		              that._tweenFunc(i);
		          }, easing, 0, 1, duration * 1000, yoyo);
		          this._addListeners();
		          // init attrs map
		          if (!Tween.attrs[nodeId]) {
		              Tween.attrs[nodeId] = {};
		          }
		          if (!Tween.attrs[nodeId][this._id]) {
		              Tween.attrs[nodeId][this._id] = {};
		          }
		          // init tweens map
		          if (!Tween.tweens[nodeId]) {
		              Tween.tweens[nodeId] = {};
		          }
		          for (key in config) {
		              if (blacklist[key] === undefined) {
		                  this._addAttr(key, config[key]);
		              }
		          }
		          this.reset();
		          // callbacks
		          this.onFinish = config.onFinish;
		          this.onReset = config.onReset;
		          this.onUpdate = config.onUpdate;
		      }
		      _addAttr(key, end) {
		          var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
		          // remove conflict from tween map if it exists
		          tweenId = Tween.tweens[nodeId][key];
		          if (tweenId) {
		              delete Tween.attrs[nodeId][tweenId][key];
		          }
		          // add to tween map
		          start = node.getAttr(key);
		          if (Util._isArray(end)) {
		              diff = [];
		              len = Math.max(end.length, start.length);
		              if (key === 'points' && end.length !== start.length) {
		                  // before tweening points we need to make sure that start.length === end.length
		                  // Util._prepareArrayForTween thinking that end.length > start.length
		                  if (end.length > start.length) {
		                      // so in this case we will increase number of starting points
		                      trueStart = start;
		                      start = Util._prepareArrayForTween(start, end, node.closed());
		                  }
		                  else {
		                      // in this case we will increase number of eding points
		                      trueEnd = end;
		                      end = Util._prepareArrayForTween(end, start, node.closed());
		                  }
		              }
		              if (key.indexOf('fill') === 0) {
		                  for (n = 0; n < len; n++) {
		                      if (n % 2 === 0) {
		                          diff.push(end[n] - start[n]);
		                      }
		                      else {
		                          var startRGBA = Util.colorToRGBA(start[n]);
		                          endRGBA = Util.colorToRGBA(end[n]);
		                          start[n] = startRGBA;
		                          diff.push({
		                              r: endRGBA.r - startRGBA.r,
		                              g: endRGBA.g - startRGBA.g,
		                              b: endRGBA.b - startRGBA.b,
		                              a: endRGBA.a - startRGBA.a,
		                          });
		                      }
		                  }
		              }
		              else {
		                  for (n = 0; n < len; n++) {
		                      diff.push(end[n] - start[n]);
		                  }
		              }
		          }
		          else if (colorAttrs.indexOf(key) !== -1) {
		              start = Util.colorToRGBA(start);
		              endRGBA = Util.colorToRGBA(end);
		              diff = {
		                  r: endRGBA.r - start.r,
		                  g: endRGBA.g - start.g,
		                  b: endRGBA.b - start.b,
		                  a: endRGBA.a - start.a,
		              };
		          }
		          else {
		              diff = end - start;
		          }
		          Tween.attrs[nodeId][this._id][key] = {
		              start: start,
		              diff: diff,
		              end: end,
		              trueEnd: trueEnd,
		              trueStart: trueStart,
		          };
		          Tween.tweens[nodeId][key] = this._id;
		      }
		      _tweenFunc(i) {
		          var node = this.node, attrs = Tween.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
		          for (key in attrs) {
		              attr = attrs[key];
		              start = attr.start;
		              diff = attr.diff;
		              end = attr.end;
		              if (Util._isArray(start)) {
		                  newVal = [];
		                  len = Math.max(start.length, end.length);
		                  if (key.indexOf('fill') === 0) {
		                      for (n = 0; n < len; n++) {
		                          if (n % 2 === 0) {
		                              newVal.push((start[n] || 0) + diff[n] * i);
		                          }
		                          else {
		                              newVal.push('rgba(' +
		                                  Math.round(start[n].r + diff[n].r * i) +
		                                  ',' +
		                                  Math.round(start[n].g + diff[n].g * i) +
		                                  ',' +
		                                  Math.round(start[n].b + diff[n].b * i) +
		                                  ',' +
		                                  (start[n].a + diff[n].a * i) +
		                                  ')');
		                          }
		                      }
		                  }
		                  else {
		                      for (n = 0; n < len; n++) {
		                          newVal.push((start[n] || 0) + diff[n] * i);
		                      }
		                  }
		              }
		              else if (colorAttrs.indexOf(key) !== -1) {
		                  newVal =
		                      'rgba(' +
		                          Math.round(start.r + diff.r * i) +
		                          ',' +
		                          Math.round(start.g + diff.g * i) +
		                          ',' +
		                          Math.round(start.b + diff.b * i) +
		                          ',' +
		                          (start.a + diff.a * i) +
		                          ')';
		              }
		              else {
		                  newVal = start + diff * i;
		              }
		              node.setAttr(key, newVal);
		          }
		      }
		      _addListeners() {
		          // start listeners
		          this.tween.onPlay = () => {
		              this.anim.start();
		          };
		          this.tween.onReverse = () => {
		              this.anim.start();
		          };
		          // stop listeners
		          this.tween.onPause = () => {
		              this.anim.stop();
		          };
		          this.tween.onFinish = () => {
		              var node = this.node;
		              // after tweening  points of line we need to set original end
		              var attrs = Tween.attrs[node._id][this._id];
		              if (attrs.points && attrs.points.trueEnd) {
		                  node.setAttr('points', attrs.points.trueEnd);
		              }
		              if (this.onFinish) {
		                  this.onFinish.call(this);
		              }
		          };
		          this.tween.onReset = () => {
		              var node = this.node;
		              // after tweening  points of line we need to set original start
		              var attrs = Tween.attrs[node._id][this._id];
		              if (attrs.points && attrs.points.trueStart) {
		                  node.points(attrs.points.trueStart);
		              }
		              if (this.onReset) {
		                  this.onReset();
		              }
		          };
		          this.tween.onUpdate = () => {
		              if (this.onUpdate) {
		                  this.onUpdate.call(this);
		              }
		          };
		      }
		      /**
		       * play
		       * @method
		       * @name Konva.Tween#play
		       * @returns {Tween}
		       */
		      play() {
		          this.tween.play();
		          return this;
		      }
		      /**
		       * reverse
		       * @method
		       * @name Konva.Tween#reverse
		       * @returns {Tween}
		       */
		      reverse() {
		          this.tween.reverse();
		          return this;
		      }
		      /**
		       * reset
		       * @method
		       * @name Konva.Tween#reset
		       * @returns {Tween}
		       */
		      reset() {
		          this.tween.reset();
		          return this;
		      }
		      /**
		       * seek
		       * @method
		       * @name Konva.Tween#seek(
		       * @param {Integer} t time in seconds between 0 and the duration
		       * @returns {Tween}
		       */
		      seek(t) {
		          this.tween.seek(t * 1000);
		          return this;
		      }
		      /**
		       * pause
		       * @method
		       * @name Konva.Tween#pause
		       * @returns {Tween}
		       */
		      pause() {
		          this.tween.pause();
		          return this;
		      }
		      /**
		       * finish
		       * @method
		       * @name Konva.Tween#finish
		       * @returns {Tween}
		       */
		      finish() {
		          this.tween.finish();
		          return this;
		      }
		      /**
		       * destroy
		       * @method
		       * @name Konva.Tween#destroy
		       */
		      destroy() {
		          var nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId], key;
		          this.pause();
		          for (key in attrs) {
		              delete Tween.tweens[nodeId][key];
		          }
		          delete Tween.attrs[nodeId][thisId];
		      }
		  }
		  Tween.attrs = {};
		  Tween.tweens = {};
		  /**
		   * Tween node properties. Shorter usage of {@link Konva.Tween} object.
		   *
		   * @method Konva.Node#to
		   * @param {Object} [params] tween params
		   * @example
		   *
		   * circle.to({
		   *   x : 50,
		   *   duration : 0.5,
		   *   onUpdate: () => console.log('props updated'),
		   *   onFinish: () => console.log('finished'),
		   * });
		   */
		  Node.prototype.to = function (params) {
		      var onFinish = params.onFinish;
		      params.node = this;
		      params.onFinish = function () {
		          this.destroy();
		          if (onFinish) {
		              onFinish();
		          }
		      };
		      var tween = new Tween(params);
		      tween.play();
		  };
		  /*
		   * These eases were ported from an Adobe Flash tweening library to JavaScript
		   * by Xaric
		   */
		  /**
		   * @namespace Easings
		   * @memberof Konva
		   */
		  const Easings = {
		      /**
		       * back ease in
		       * @function
		       * @memberof Konva.Easings
		       */
		      BackEaseIn(t, b, c, d) {
		          var s = 1.70158;
		          return c * (t /= d) * t * ((s + 1) * t - s) + b;
		      },
		      /**
		       * back ease out
		       * @function
		       * @memberof Konva.Easings
		       */
		      BackEaseOut(t, b, c, d) {
		          var s = 1.70158;
		          return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
		      },
		      /**
		       * back ease in out
		       * @function
		       * @memberof Konva.Easings
		       */
		      BackEaseInOut(t, b, c, d) {
		          var s = 1.70158;
		          if ((t /= d / 2) < 1) {
		              return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		          }
		          return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
		      },
		      /**
		       * elastic ease in
		       * @function
		       * @memberof Konva.Easings
		       */
		      ElasticEaseIn(t, b, c, d, a, p) {
		          // added s = 0
		          var s = 0;
		          if (t === 0) {
		              return b;
		          }
		          if ((t /= d) === 1) {
		              return b + c;
		          }
		          if (!p) {
		              p = d * 0.3;
		          }
		          if (!a || a < Math.abs(c)) {
		              a = c;
		              s = p / 4;
		          }
		          else {
		              s = (p / (2 * Math.PI)) * Math.asin(c / a);
		          }
		          return (-(a *
		              Math.pow(2, 10 * (t -= 1)) *
		              Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b);
		      },
		      /**
		       * elastic ease out
		       * @function
		       * @memberof Konva.Easings
		       */
		      ElasticEaseOut(t, b, c, d, a, p) {
		          // added s = 0
		          var s = 0;
		          if (t === 0) {
		              return b;
		          }
		          if ((t /= d) === 1) {
		              return b + c;
		          }
		          if (!p) {
		              p = d * 0.3;
		          }
		          if (!a || a < Math.abs(c)) {
		              a = c;
		              s = p / 4;
		          }
		          else {
		              s = (p / (2 * Math.PI)) * Math.asin(c / a);
		          }
		          return (a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
		              c +
		              b);
		      },
		      /**
		       * elastic ease in out
		       * @function
		       * @memberof Konva.Easings
		       */
		      ElasticEaseInOut(t, b, c, d, a, p) {
		          // added s = 0
		          var s = 0;
		          if (t === 0) {
		              return b;
		          }
		          if ((t /= d / 2) === 2) {
		              return b + c;
		          }
		          if (!p) {
		              p = d * (0.3 * 1.5);
		          }
		          if (!a || a < Math.abs(c)) {
		              a = c;
		              s = p / 4;
		          }
		          else {
		              s = (p / (2 * Math.PI)) * Math.asin(c / a);
		          }
		          if (t < 1) {
		              return (-0.5 *
		                  (a *
		                      Math.pow(2, 10 * (t -= 1)) *
		                      Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
		                  b);
		          }
		          return (a *
		              Math.pow(2, -10 * (t -= 1)) *
		              Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
		              0.5 +
		              c +
		              b);
		      },
		      /**
		       * bounce ease out
		       * @function
		       * @memberof Konva.Easings
		       */
		      BounceEaseOut(t, b, c, d) {
		          if ((t /= d) < 1 / 2.75) {
		              return c * (7.5625 * t * t) + b;
		          }
		          else if (t < 2 / 2.75) {
		              return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
		          }
		          else if (t < 2.5 / 2.75) {
		              return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
		          }
		          else {
		              return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
		          }
		      },
		      /**
		       * bounce ease in
		       * @function
		       * @memberof Konva.Easings
		       */
		      BounceEaseIn(t, b, c, d) {
		          return c - Easings.BounceEaseOut(d - t, 0, c, d) + b;
		      },
		      /**
		       * bounce ease in out
		       * @function
		       * @memberof Konva.Easings
		       */
		      BounceEaseInOut(t, b, c, d) {
		          if (t < d / 2) {
		              return Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
		          }
		          else {
		              return Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
		          }
		      },
		      /**
		       * ease in
		       * @function
		       * @memberof Konva.Easings
		       */
		      EaseIn(t, b, c, d) {
		          return c * (t /= d) * t + b;
		      },
		      /**
		       * ease out
		       * @function
		       * @memberof Konva.Easings
		       */
		      EaseOut(t, b, c, d) {
		          return -c * (t /= d) * (t - 2) + b;
		      },
		      /**
		       * ease in out
		       * @function
		       * @memberof Konva.Easings
		       */
		      EaseInOut(t, b, c, d) {
		          if ((t /= d / 2) < 1) {
		              return (c / 2) * t * t + b;
		          }
		          return (-c / 2) * (--t * (t - 2) - 1) + b;
		      },
		      /**
		       * strong ease in
		       * @function
		       * @memberof Konva.Easings
		       */
		      StrongEaseIn(t, b, c, d) {
		          return c * (t /= d) * t * t * t * t + b;
		      },
		      /**
		       * strong ease out
		       * @function
		       * @memberof Konva.Easings
		       */
		      StrongEaseOut(t, b, c, d) {
		          return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
		      },
		      /**
		       * strong ease in out
		       * @function
		       * @memberof Konva.Easings
		       */
		      StrongEaseInOut(t, b, c, d) {
		          if ((t /= d / 2) < 1) {
		              return (c / 2) * t * t * t * t * t + b;
		          }
		          return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
		      },
		      /**
		       * linear
		       * @function
		       * @memberof Konva.Easings
		       */
		      Linear(t, b, c, d) {
		          return (c * t) / d + b;
		      },
		  };

		  // what is core parts of Konva?
		  const Konva$1 = Util._assign(Konva$2, {
		      Util,
		      Transform,
		      Node,
		      Container,
		      Stage,
		      stages,
		      Layer,
		      FastLayer,
		      Group,
		      DD,
		      Shape,
		      shapes,
		      Animation,
		      Tween,
		      Easings,
		      Context,
		      Canvas,
		  });

		  /**
		   * Arc constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Number} config.angle in degrees
		   * @param {Number} config.innerRadius
		   * @param {Number} config.outerRadius
		   * @param {Boolean} [config.clockwise]
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * // draw a Arc that's pointing downwards
		   * var arc = new Konva.Arc({
		   *   innerRadius: 40,
		   *   outerRadius: 80,
		   *   fill: 'red',
		   *   stroke: 'black'
		   *   strokeWidth: 5,
		   *   angle: 60,
		   *   rotationDeg: -120
		   * });
		   */
		  class Arc extends Shape {
		      _sceneFunc(context) {
		          var angle = Konva$2.getAngle(this.angle()), clockwise = this.clockwise();
		          context.beginPath();
		          context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
		          context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.outerRadius() * 2;
		      }
		      getHeight() {
		          return this.outerRadius() * 2;
		      }
		      setWidth(width) {
		          this.outerRadius(width / 2);
		      }
		      setHeight(height) {
		          this.outerRadius(height / 2);
		      }
		      getSelfRect() {
		          const innerRadius = this.innerRadius();
		          const outerRadius = this.outerRadius();
		          const clockwise = this.clockwise();
		          const angle = Konva$2.getAngle(clockwise ? 360 - this.angle() : this.angle());
		          const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
		          const boundRightRatio = 1;
		          const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), (3 * Math.PI) / 2));
		          const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
		          const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
		          const boundRight = boundRightRatio * (outerRadius );
		          const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
		          const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
		          return {
		              x: boundLeft,
		              y: clockwise ? -1 * boundBottom : boundTop,
		              width: boundRight - boundLeft,
		              height: boundBottom - boundTop,
		          };
		      }
		  }
		  Arc.prototype._centroid = true;
		  Arc.prototype.className = 'Arc';
		  Arc.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
		  _registerNode(Arc);
		  // add getters setters
		  Factory.addGetterSetter(Arc, 'innerRadius', 0, getNumberValidator());
		  /**
		   * get/set innerRadius
		   * @name Konva.Arc#innerRadius
		   * @method
		   * @param {Number} innerRadius
		   * @returns {Number}
		   * @example
		   * // get inner radius
		   * var innerRadius = arc.innerRadius();
		   *
		   * // set inner radius
		   * arc.innerRadius(20);
		   */
		  Factory.addGetterSetter(Arc, 'outerRadius', 0, getNumberValidator());
		  /**
		   * get/set outerRadius
		   * @name Konva.Arc#outerRadius
		   * @method
		   * @param {Number} outerRadius
		   * @returns {Number}
		   * @example
		   * // get outer radius
		   * var outerRadius = arc.outerRadius();
		   *
		   * // set outer radius
		   * arc.outerRadius(20);
		   */
		  Factory.addGetterSetter(Arc, 'angle', 0, getNumberValidator());
		  /**
		   * get/set angle in degrees
		   * @name Konva.Arc#angle
		   * @method
		   * @param {Number} angle
		   * @returns {Number}
		   * @example
		   * // get angle
		   * var angle = arc.angle();
		   *
		   * // set angle
		   * arc.angle(20);
		   */
		  Factory.addGetterSetter(Arc, 'clockwise', false, getBooleanValidator());
		  /**
		   * get/set clockwise flag
		   * @name Konva.Arc#clockwise
		   * @method
		   * @param {Boolean} clockwise
		   * @returns {Boolean}
		   * @example
		   * // get clockwise flag
		   * var clockwise = arc.clockwise();
		   *
		   * // draw arc counter-clockwise
		   * arc.clockwise(false);
		   *
		   * // draw arc clockwise
		   * arc.clockwise(true);
		   */

		  function getControlPoints(x0, y0, x1, y1, x2, y2, t) {
		      var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = (t * d01) / (d01 + d12), fb = (t * d12) / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
		      return [p1x, p1y, p2x, p2y];
		  }
		  function expandPoints(p, tension) {
		      var len = p.length, allPoints = [], n, cp;
		      for (n = 2; n < len - 2; n += 2) {
		          cp = getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
		          if (isNaN(cp[0])) {
		              continue;
		          }
		          allPoints.push(cp[0]);
		          allPoints.push(cp[1]);
		          allPoints.push(p[n]);
		          allPoints.push(p[n + 1]);
		          allPoints.push(cp[2]);
		          allPoints.push(cp[3]);
		      }
		      return allPoints;
		  }
		  /**
		   * Line constructor.&nbsp; Lines are defined by an array of points and
		   *  a tension
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
		   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
		   *   The default is 0
		   * @param {Boolean} [config.closed] defines whether or not the line shape is closed, creating a polygon or blob
		   * @param {Boolean} [config.bezier] if no tension is provided but bezier=true, we draw the line as a bezier using the passed points
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var line = new Konva.Line({
		   *   x: 100,
		   *   y: 50,
		   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
		   *   stroke: 'red',
		   *   tension: 1
		   * });
		   */
		  class Line extends Shape {
		      constructor(config) {
		          super(config);
		          this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function () {
		              this._clearCache('tensionPoints');
		          });
		      }
		      _sceneFunc(context) {
		          var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
		          if (!length) {
		              return;
		          }
		          context.beginPath();
		          context.moveTo(points[0], points[1]);
		          // tension
		          if (tension !== 0 && length > 4) {
		              tp = this.getTensionPoints();
		              len = tp.length;
		              n = closed ? 0 : 4;
		              if (!closed) {
		                  context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
		              }
		              while (n < len - 2) {
		                  context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
		              }
		              if (!closed) {
		                  context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
		              }
		          }
		          else if (bezier) {
		              // no tension but bezier
		              n = 2;
		              while (n < length) {
		                  context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
		              }
		          }
		          else {
		              // no tension
		              for (n = 2; n < length; n += 2) {
		                  context.lineTo(points[n], points[n + 1]);
		              }
		          }
		          // closed e.g. polygons and blobs
		          if (closed) {
		              context.closePath();
		              context.fillStrokeShape(this);
		          }
		          else {
		              // open e.g. lines and splines
		              context.strokeShape(this);
		          }
		      }
		      getTensionPoints() {
		          return this._getCache('tensionPoints', this._getTensionPoints);
		      }
		      _getTensionPoints() {
		          if (this.closed()) {
		              return this._getTensionPointsClosed();
		          }
		          else {
		              return expandPoints(this.points(), this.tension());
		          }
		      }
		      _getTensionPointsClosed() {
		          var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = expandPoints(p, tension), tp = [firstControlPoints[2], firstControlPoints[3]]
		              .concat(middle)
		              .concat([
		              lastControlPoints[0],
		              lastControlPoints[1],
		              p[len - 2],
		              p[len - 1],
		              lastControlPoints[2],
		              lastControlPoints[3],
		              firstControlPoints[0],
		              firstControlPoints[1],
		              p[0],
		              p[1],
		          ]);
		          return tp;
		      }
		      getWidth() {
		          return this.getSelfRect().width;
		      }
		      getHeight() {
		          return this.getSelfRect().height;
		      }
		      // overload size detection
		      getSelfRect() {
		          var points = this.points();
		          if (points.length < 4) {
		              return {
		                  x: points[0] || 0,
		                  y: points[1] || 0,
		                  width: 0,
		                  height: 0,
		              };
		          }
		          if (this.tension() !== 0) {
		              points = [
		                  points[0],
		                  points[1],
		                  ...this._getTensionPoints(),
		                  points[points.length - 2],
		                  points[points.length - 1],
		              ];
		          }
		          else {
		              points = this.points();
		          }
		          var minX = points[0];
		          var maxX = points[0];
		          var minY = points[1];
		          var maxY = points[1];
		          var x, y;
		          for (var i = 0; i < points.length / 2; i++) {
		              x = points[i * 2];
		              y = points[i * 2 + 1];
		              minX = Math.min(minX, x);
		              maxX = Math.max(maxX, x);
		              minY = Math.min(minY, y);
		              maxY = Math.max(maxY, y);
		          }
		          return {
		              x: minX,
		              y: minY,
		              width: maxX - minX,
		              height: maxY - minY,
		          };
		      }
		  }
		  Line.prototype.className = 'Line';
		  Line.prototype._attrsAffectingSize = ['points', 'bezier', 'tension'];
		  _registerNode(Line);
		  // add getters setters
		  Factory.addGetterSetter(Line, 'closed', false);
		  /**
		   * get/set closed flag.  The default is false
		   * @name Konva.Line#closed
		   * @method
		   * @param {Boolean} closed
		   * @returns {Boolean}
		   * @example
		   * // get closed flag
		   * var closed = line.closed();
		   *
		   * // close the shape
		   * line.closed(true);
		   *
		   * // open the shape
		   * line.closed(false);
		   */
		  Factory.addGetterSetter(Line, 'bezier', false);
		  /**
		   * get/set bezier flag.  The default is false
		   * @name Konva.Line#bezier
		   * @method
		   * @param {Boolean} bezier
		   * @returns {Boolean}
		   * @example
		   * // get whether the line is a bezier
		   * var isBezier = line.bezier();
		   *
		   * // set whether the line is a bezier
		   * line.bezier(true);
		   */
		  Factory.addGetterSetter(Line, 'tension', 0, getNumberValidator());
		  /**
		   * get/set tension
		   * @name Konva.Line#tension
		   * @method
		   * @param {Number} tension Higher values will result in a more curvy line.  A value of 0 will result in no interpolation. The default is 0
		   * @returns {Number}
		   * @example
		   * // get tension
		   * var tension = line.tension();
		   *
		   * // set tension
		   * line.tension(3);
		   */
		  Factory.addGetterSetter(Line, 'points', [], getNumberArrayValidator());
		  /**
		   * get/set points array. Points is a flat array [x1, y1, x2, y2]. It is flat for performance reasons.
		   * @name Konva.Line#points
		   * @method
		   * @param {Array} points
		   * @returns {Array}
		   * @example
		   * // get points
		   * var points = line.points();
		   *
		   * // set points
		   * line.points([10, 20, 30, 40, 50, 60]);
		   *
		   * // push a new point
		   * line.points(line.points().concat([70, 80]));
		   */

		  // Credits: rveciana/svg-path-properties
		  // Legendre-Gauss abscissae (xi values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
		  const tValues = [
		      [],
		      [],
		      [
		          -0.5773502691896257645091487805019574556476,
		          0.5773502691896257645091487805019574556476,
		      ],
		      [
		          0, -0.7745966692414833770358530799564799221665,
		          0.7745966692414833770358530799564799221665,
		      ],
		      [
		          -0.3399810435848562648026657591032446872005,
		          0.3399810435848562648026657591032446872005,
		          -0.8611363115940525752239464888928095050957,
		          0.8611363115940525752239464888928095050957,
		      ],
		      [
		          0, -0.5384693101056830910363144207002088049672,
		          0.5384693101056830910363144207002088049672,
		          -0.9061798459386639927976268782993929651256,
		          0.9061798459386639927976268782993929651256,
		      ],
		      [
		          0.6612093864662645136613995950199053470064,
		          -0.6612093864662645136613995950199053470064,
		          -0.2386191860831969086305017216807119354186,
		          0.2386191860831969086305017216807119354186,
		          -0.9324695142031520278123015544939946091347,
		          0.9324695142031520278123015544939946091347,
		      ],
		      [
		          0, 0.4058451513773971669066064120769614633473,
		          -0.4058451513773971669066064120769614633473,
		          -0.7415311855993944398638647732807884070741,
		          0.7415311855993944398638647732807884070741,
		          -0.9491079123427585245261896840478512624007,
		          0.9491079123427585245261896840478512624007,
		      ],
		      [
		          -0.1834346424956498049394761423601839806667,
		          0.1834346424956498049394761423601839806667,
		          -0.5255324099163289858177390491892463490419,
		          0.5255324099163289858177390491892463490419,
		          -0.7966664774136267395915539364758304368371,
		          0.7966664774136267395915539364758304368371,
		          -0.9602898564975362316835608685694729904282,
		          0.9602898564975362316835608685694729904282,
		      ],
		      [
		          0, -0.8360311073266357942994297880697348765441,
		          0.8360311073266357942994297880697348765441,
		          -0.9681602395076260898355762029036728700494,
		          0.9681602395076260898355762029036728700494,
		          -0.3242534234038089290385380146433366085719,
		          0.3242534234038089290385380146433366085719,
		          -0.6133714327005903973087020393414741847857,
		          0.6133714327005903973087020393414741847857,
		      ],
		      [
		          -0.1488743389816312108848260011297199846175,
		          0.1488743389816312108848260011297199846175,
		          -0.4333953941292471907992659431657841622,
		          0.4333953941292471907992659431657841622,
		          -0.6794095682990244062343273651148735757692,
		          0.6794095682990244062343273651148735757692,
		          -0.8650633666889845107320966884234930485275,
		          0.8650633666889845107320966884234930485275,
		          -0.9739065285171717200779640120844520534282,
		          0.9739065285171717200779640120844520534282,
		      ],
		      [
		          0, -0.2695431559523449723315319854008615246796,
		          0.2695431559523449723315319854008615246796,
		          -0.5190961292068118159257256694586095544802,
		          0.5190961292068118159257256694586095544802,
		          -0.7301520055740493240934162520311534580496,
		          0.7301520055740493240934162520311534580496,
		          -0.8870625997680952990751577693039272666316,
		          0.8870625997680952990751577693039272666316,
		          -0.9782286581460569928039380011228573907714,
		          0.9782286581460569928039380011228573907714,
		      ],
		      [
		          -0.1252334085114689154724413694638531299833,
		          0.1252334085114689154724413694638531299833,
		          -0.3678314989981801937526915366437175612563,
		          0.3678314989981801937526915366437175612563,
		          -0.587317954286617447296702418940534280369,
		          0.587317954286617447296702418940534280369,
		          -0.7699026741943046870368938332128180759849,
		          0.7699026741943046870368938332128180759849,
		          -0.9041172563704748566784658661190961925375,
		          0.9041172563704748566784658661190961925375,
		          -0.9815606342467192506905490901492808229601,
		          0.9815606342467192506905490901492808229601,
		      ],
		      [
		          0, -0.2304583159551347940655281210979888352115,
		          0.2304583159551347940655281210979888352115,
		          -0.4484927510364468528779128521276398678019,
		          0.4484927510364468528779128521276398678019,
		          -0.6423493394403402206439846069955156500716,
		          0.6423493394403402206439846069955156500716,
		          -0.8015780907333099127942064895828598903056,
		          0.8015780907333099127942064895828598903056,
		          -0.9175983992229779652065478365007195123904,
		          0.9175983992229779652065478365007195123904,
		          -0.9841830547185881494728294488071096110649,
		          0.9841830547185881494728294488071096110649,
		      ],
		      [
		          -0.1080549487073436620662446502198347476119,
		          0.1080549487073436620662446502198347476119,
		          -0.3191123689278897604356718241684754668342,
		          0.3191123689278897604356718241684754668342,
		          -0.5152486363581540919652907185511886623088,
		          0.5152486363581540919652907185511886623088,
		          -0.6872929048116854701480198030193341375384,
		          0.6872929048116854701480198030193341375384,
		          -0.8272013150697649931897947426503949610397,
		          0.8272013150697649931897947426503949610397,
		          -0.928434883663573517336391139377874264477,
		          0.928434883663573517336391139377874264477,
		          -0.986283808696812338841597266704052801676,
		          0.986283808696812338841597266704052801676,
		      ],
		      [
		          0, -0.2011940939974345223006283033945962078128,
		          0.2011940939974345223006283033945962078128,
		          -0.3941513470775633698972073709810454683627,
		          0.3941513470775633698972073709810454683627,
		          -0.5709721726085388475372267372539106412383,
		          0.5709721726085388475372267372539106412383,
		          -0.7244177313601700474161860546139380096308,
		          0.7244177313601700474161860546139380096308,
		          -0.8482065834104272162006483207742168513662,
		          0.8482065834104272162006483207742168513662,
		          -0.9372733924007059043077589477102094712439,
		          0.9372733924007059043077589477102094712439,
		          -0.9879925180204854284895657185866125811469,
		          0.9879925180204854284895657185866125811469,
		      ],
		      [
		          -0.0950125098376374401853193354249580631303,
		          0.0950125098376374401853193354249580631303,
		          -0.281603550779258913230460501460496106486,
		          0.281603550779258913230460501460496106486,
		          -0.45801677765722738634241944298357757354,
		          0.45801677765722738634241944298357757354,
		          -0.6178762444026437484466717640487910189918,
		          0.6178762444026437484466717640487910189918,
		          -0.7554044083550030338951011948474422683538,
		          0.7554044083550030338951011948474422683538,
		          -0.8656312023878317438804678977123931323873,
		          0.8656312023878317438804678977123931323873,
		          -0.9445750230732325760779884155346083450911,
		          0.9445750230732325760779884155346083450911,
		          -0.9894009349916499325961541734503326274262,
		          0.9894009349916499325961541734503326274262,
		      ],
		      [
		          0, -0.1784841814958478558506774936540655574754,
		          0.1784841814958478558506774936540655574754,
		          -0.3512317634538763152971855170953460050405,
		          0.3512317634538763152971855170953460050405,
		          -0.5126905370864769678862465686295518745829,
		          0.5126905370864769678862465686295518745829,
		          -0.6576711592166907658503022166430023351478,
		          0.6576711592166907658503022166430023351478,
		          -0.7815140038968014069252300555204760502239,
		          0.7815140038968014069252300555204760502239,
		          -0.8802391537269859021229556944881556926234,
		          0.8802391537269859021229556944881556926234,
		          -0.9506755217687677612227169578958030214433,
		          0.9506755217687677612227169578958030214433,
		          -0.9905754753144173356754340199406652765077,
		          0.9905754753144173356754340199406652765077,
		      ],
		      [
		          -0.0847750130417353012422618529357838117333,
		          0.0847750130417353012422618529357838117333,
		          -0.2518862256915055095889728548779112301628,
		          0.2518862256915055095889728548779112301628,
		          -0.4117511614628426460359317938330516370789,
		          0.4117511614628426460359317938330516370789,
		          -0.5597708310739475346078715485253291369276,
		          0.5597708310739475346078715485253291369276,
		          -0.6916870430603532078748910812888483894522,
		          0.6916870430603532078748910812888483894522,
		          -0.8037049589725231156824174550145907971032,
		          0.8037049589725231156824174550145907971032,
		          -0.8926024664975557392060605911271455154078,
		          0.8926024664975557392060605911271455154078,
		          -0.9558239495713977551811958929297763099728,
		          0.9558239495713977551811958929297763099728,
		          -0.9915651684209309467300160047061507702525,
		          0.9915651684209309467300160047061507702525,
		      ],
		      [
		          0, -0.1603586456402253758680961157407435495048,
		          0.1603586456402253758680961157407435495048,
		          -0.3165640999636298319901173288498449178922,
		          0.3165640999636298319901173288498449178922,
		          -0.4645707413759609457172671481041023679762,
		          0.4645707413759609457172671481041023679762,
		          -0.6005453046616810234696381649462392798683,
		          0.6005453046616810234696381649462392798683,
		          -0.7209661773352293786170958608237816296571,
		          0.7209661773352293786170958608237816296571,
		          -0.8227146565371428249789224867127139017745,
		          0.8227146565371428249789224867127139017745,
		          -0.9031559036148179016426609285323124878093,
		          0.9031559036148179016426609285323124878093,
		          -0.960208152134830030852778840687651526615,
		          0.960208152134830030852778840687651526615,
		          -0.9924068438435844031890176702532604935893,
		          0.9924068438435844031890176702532604935893,
		      ],
		      [
		          -0.0765265211334973337546404093988382110047,
		          0.0765265211334973337546404093988382110047,
		          -0.227785851141645078080496195368574624743,
		          0.227785851141645078080496195368574624743,
		          -0.3737060887154195606725481770249272373957,
		          0.3737060887154195606725481770249272373957,
		          -0.5108670019508270980043640509552509984254,
		          0.5108670019508270980043640509552509984254,
		          -0.6360536807265150254528366962262859367433,
		          0.6360536807265150254528366962262859367433,
		          -0.7463319064601507926143050703556415903107,
		          0.7463319064601507926143050703556415903107,
		          -0.8391169718222188233945290617015206853296,
		          0.8391169718222188233945290617015206853296,
		          -0.9122344282513259058677524412032981130491,
		          0.9122344282513259058677524412032981130491,
		          -0.963971927277913791267666131197277221912,
		          0.963971927277913791267666131197277221912,
		          -0.9931285991850949247861223884713202782226,
		          0.9931285991850949247861223884713202782226,
		      ],
		      [
		          0, -0.1455618541608950909370309823386863301163,
		          0.1455618541608950909370309823386863301163,
		          -0.288021316802401096600792516064600319909,
		          0.288021316802401096600792516064600319909,
		          -0.4243421202074387835736688885437880520964,
		          0.4243421202074387835736688885437880520964,
		          -0.551618835887219807059018796724313286622,
		          0.551618835887219807059018796724313286622,
		          -0.667138804197412319305966669990339162597,
		          0.667138804197412319305966669990339162597,
		          -0.7684399634756779086158778513062280348209,
		          0.7684399634756779086158778513062280348209,
		          -0.8533633645833172836472506385875676702761,
		          0.8533633645833172836472506385875676702761,
		          -0.9200993341504008287901871337149688941591,
		          0.9200993341504008287901871337149688941591,
		          -0.9672268385663062943166222149076951614246,
		          0.9672268385663062943166222149076951614246,
		          -0.9937521706203895002602420359379409291933,
		          0.9937521706203895002602420359379409291933,
		      ],
		      [
		          -0.0697392733197222212138417961186280818222,
		          0.0697392733197222212138417961186280818222,
		          -0.2078604266882212854788465339195457342156,
		          0.2078604266882212854788465339195457342156,
		          -0.3419358208920842251581474204273796195591,
		          0.3419358208920842251581474204273796195591,
		          -0.4693558379867570264063307109664063460953,
		          0.4693558379867570264063307109664063460953,
		          -0.5876404035069115929588769276386473488776,
		          0.5876404035069115929588769276386473488776,
		          -0.6944872631866827800506898357622567712673,
		          0.6944872631866827800506898357622567712673,
		          -0.7878168059792081620042779554083515213881,
		          0.7878168059792081620042779554083515213881,
		          -0.8658125777203001365364256370193787290847,
		          0.8658125777203001365364256370193787290847,
		          -0.9269567721871740005206929392590531966353,
		          0.9269567721871740005206929392590531966353,
		          -0.9700604978354287271239509867652687108059,
		          0.9700604978354287271239509867652687108059,
		          -0.994294585482399292073031421161298980393,
		          0.994294585482399292073031421161298980393,
		      ],
		      [
		          0, -0.1332568242984661109317426822417661370104,
		          0.1332568242984661109317426822417661370104,
		          -0.264135680970344930533869538283309602979,
		          0.264135680970344930533869538283309602979,
		          -0.390301038030290831421488872880605458578,
		          0.390301038030290831421488872880605458578,
		          -0.5095014778460075496897930478668464305448,
		          0.5095014778460075496897930478668464305448,
		          -0.6196098757636461563850973116495956533871,
		          0.6196098757636461563850973116495956533871,
		          -0.7186613631319501944616244837486188483299,
		          0.7186613631319501944616244837486188483299,
		          -0.8048884016188398921511184069967785579414,
		          0.8048884016188398921511184069967785579414,
		          -0.8767523582704416673781568859341456716389,
		          0.8767523582704416673781568859341456716389,
		          -0.9329710868260161023491969890384229782357,
		          0.9329710868260161023491969890384229782357,
		          -0.9725424712181152319560240768207773751816,
		          0.9725424712181152319560240768207773751816,
		          -0.9947693349975521235239257154455743605736,
		          0.9947693349975521235239257154455743605736,
		      ],
		      [
		          -0.0640568928626056260850430826247450385909,
		          0.0640568928626056260850430826247450385909,
		          -0.1911188674736163091586398207570696318404,
		          0.1911188674736163091586398207570696318404,
		          -0.3150426796961633743867932913198102407864,
		          0.3150426796961633743867932913198102407864,
		          -0.4337935076260451384870842319133497124524,
		          0.4337935076260451384870842319133497124524,
		          -0.5454214713888395356583756172183723700107,
		          0.5454214713888395356583756172183723700107,
		          -0.6480936519369755692524957869107476266696,
		          0.6480936519369755692524957869107476266696,
		          -0.7401241915785543642438281030999784255232,
		          0.7401241915785543642438281030999784255232,
		          -0.8200019859739029219539498726697452080761,
		          0.8200019859739029219539498726697452080761,
		          -0.8864155270044010342131543419821967550873,
		          0.8864155270044010342131543419821967550873,
		          -0.9382745520027327585236490017087214496548,
		          0.9382745520027327585236490017087214496548,
		          -0.9747285559713094981983919930081690617411,
		          0.9747285559713094981983919930081690617411,
		          -0.9951872199970213601799974097007368118745,
		          0.9951872199970213601799974097007368118745,
		      ],
		  ];
		  // Legendre-Gauss weights (wi values, defined by a function linked to in the Bezier primer article)
		  const cValues = [
		      [],
		      [],
		      [1.0, 1.0],
		      [
		          0.8888888888888888888888888888888888888888,
		          0.5555555555555555555555555555555555555555,
		          0.5555555555555555555555555555555555555555,
		      ],
		      [
		          0.6521451548625461426269360507780005927646,
		          0.6521451548625461426269360507780005927646,
		          0.3478548451374538573730639492219994072353,
		          0.3478548451374538573730639492219994072353,
		      ],
		      [
		          0.5688888888888888888888888888888888888888,
		          0.4786286704993664680412915148356381929122,
		          0.4786286704993664680412915148356381929122,
		          0.2369268850561890875142640407199173626432,
		          0.2369268850561890875142640407199173626432,
		      ],
		      [
		          0.3607615730481386075698335138377161116615,
		          0.3607615730481386075698335138377161116615,
		          0.4679139345726910473898703439895509948116,
		          0.4679139345726910473898703439895509948116,
		          0.1713244923791703450402961421727328935268,
		          0.1713244923791703450402961421727328935268,
		      ],
		      [
		          0.4179591836734693877551020408163265306122,
		          0.3818300505051189449503697754889751338783,
		          0.3818300505051189449503697754889751338783,
		          0.2797053914892766679014677714237795824869,
		          0.2797053914892766679014677714237795824869,
		          0.1294849661688696932706114326790820183285,
		          0.1294849661688696932706114326790820183285,
		      ],
		      [
		          0.3626837833783619829651504492771956121941,
		          0.3626837833783619829651504492771956121941,
		          0.3137066458778872873379622019866013132603,
		          0.3137066458778872873379622019866013132603,
		          0.2223810344533744705443559944262408844301,
		          0.2223810344533744705443559944262408844301,
		          0.1012285362903762591525313543099621901153,
		          0.1012285362903762591525313543099621901153,
		      ],
		      [
		          0.3302393550012597631645250692869740488788,
		          0.1806481606948574040584720312429128095143,
		          0.1806481606948574040584720312429128095143,
		          0.0812743883615744119718921581105236506756,
		          0.0812743883615744119718921581105236506756,
		          0.3123470770400028400686304065844436655987,
		          0.3123470770400028400686304065844436655987,
		          0.2606106964029354623187428694186328497718,
		          0.2606106964029354623187428694186328497718,
		      ],
		      [
		          0.295524224714752870173892994651338329421,
		          0.295524224714752870173892994651338329421,
		          0.2692667193099963550912269215694693528597,
		          0.2692667193099963550912269215694693528597,
		          0.2190863625159820439955349342281631924587,
		          0.2190863625159820439955349342281631924587,
		          0.1494513491505805931457763396576973324025,
		          0.1494513491505805931457763396576973324025,
		          0.0666713443086881375935688098933317928578,
		          0.0666713443086881375935688098933317928578,
		      ],
		      [
		          0.272925086777900630714483528336342189156,
		          0.2628045445102466621806888698905091953727,
		          0.2628045445102466621806888698905091953727,
		          0.2331937645919904799185237048431751394317,
		          0.2331937645919904799185237048431751394317,
		          0.1862902109277342514260976414316558916912,
		          0.1862902109277342514260976414316558916912,
		          0.1255803694649046246346942992239401001976,
		          0.1255803694649046246346942992239401001976,
		          0.0556685671161736664827537204425485787285,
		          0.0556685671161736664827537204425485787285,
		      ],
		      [
		          0.2491470458134027850005624360429512108304,
		          0.2491470458134027850005624360429512108304,
		          0.2334925365383548087608498989248780562594,
		          0.2334925365383548087608498989248780562594,
		          0.2031674267230659217490644558097983765065,
		          0.2031674267230659217490644558097983765065,
		          0.160078328543346226334652529543359071872,
		          0.160078328543346226334652529543359071872,
		          0.1069393259953184309602547181939962242145,
		          0.1069393259953184309602547181939962242145,
		          0.047175336386511827194615961485017060317,
		          0.047175336386511827194615961485017060317,
		      ],
		      [
		          0.2325515532308739101945895152688359481566,
		          0.2262831802628972384120901860397766184347,
		          0.2262831802628972384120901860397766184347,
		          0.2078160475368885023125232193060527633865,
		          0.2078160475368885023125232193060527633865,
		          0.1781459807619457382800466919960979955128,
		          0.1781459807619457382800466919960979955128,
		          0.1388735102197872384636017768688714676218,
		          0.1388735102197872384636017768688714676218,
		          0.0921214998377284479144217759537971209236,
		          0.0921214998377284479144217759537971209236,
		          0.0404840047653158795200215922009860600419,
		          0.0404840047653158795200215922009860600419,
		      ],
		      [
		          0.2152638534631577901958764433162600352749,
		          0.2152638534631577901958764433162600352749,
		          0.2051984637212956039659240656612180557103,
		          0.2051984637212956039659240656612180557103,
		          0.1855383974779378137417165901251570362489,
		          0.1855383974779378137417165901251570362489,
		          0.1572031671581935345696019386238421566056,
		          0.1572031671581935345696019386238421566056,
		          0.1215185706879031846894148090724766259566,
		          0.1215185706879031846894148090724766259566,
		          0.0801580871597602098056332770628543095836,
		          0.0801580871597602098056332770628543095836,
		          0.0351194603317518630318328761381917806197,
		          0.0351194603317518630318328761381917806197,
		      ],
		      [
		          0.2025782419255612728806201999675193148386,
		          0.1984314853271115764561183264438393248186,
		          0.1984314853271115764561183264438393248186,
		          0.1861610000155622110268005618664228245062,
		          0.1861610000155622110268005618664228245062,
		          0.1662692058169939335532008604812088111309,
		          0.1662692058169939335532008604812088111309,
		          0.1395706779261543144478047945110283225208,
		          0.1395706779261543144478047945110283225208,
		          0.1071592204671719350118695466858693034155,
		          0.1071592204671719350118695466858693034155,
		          0.0703660474881081247092674164506673384667,
		          0.0703660474881081247092674164506673384667,
		          0.0307532419961172683546283935772044177217,
		          0.0307532419961172683546283935772044177217,
		      ],
		      [
		          0.1894506104550684962853967232082831051469,
		          0.1894506104550684962853967232082831051469,
		          0.1826034150449235888667636679692199393835,
		          0.1826034150449235888667636679692199393835,
		          0.1691565193950025381893120790303599622116,
		          0.1691565193950025381893120790303599622116,
		          0.1495959888165767320815017305474785489704,
		          0.1495959888165767320815017305474785489704,
		          0.1246289712555338720524762821920164201448,
		          0.1246289712555338720524762821920164201448,
		          0.0951585116824927848099251076022462263552,
		          0.0951585116824927848099251076022462263552,
		          0.0622535239386478928628438369943776942749,
		          0.0622535239386478928628438369943776942749,
		          0.0271524594117540948517805724560181035122,
		          0.0271524594117540948517805724560181035122,
		      ],
		      [
		          0.1794464703562065254582656442618856214487,
		          0.1765627053669926463252709901131972391509,
		          0.1765627053669926463252709901131972391509,
		          0.1680041021564500445099706637883231550211,
		          0.1680041021564500445099706637883231550211,
		          0.1540457610768102880814315948019586119404,
		          0.1540457610768102880814315948019586119404,
		          0.1351363684685254732863199817023501973721,
		          0.1351363684685254732863199817023501973721,
		          0.1118838471934039710947883856263559267358,
		          0.1118838471934039710947883856263559267358,
		          0.0850361483171791808835353701910620738504,
		          0.0850361483171791808835353701910620738504,
		          0.0554595293739872011294401653582446605128,
		          0.0554595293739872011294401653582446605128,
		          0.0241483028685479319601100262875653246916,
		          0.0241483028685479319601100262875653246916,
		      ],
		      [
		          0.1691423829631435918406564701349866103341,
		          0.1691423829631435918406564701349866103341,
		          0.1642764837458327229860537764659275904123,
		          0.1642764837458327229860537764659275904123,
		          0.1546846751262652449254180038363747721932,
		          0.1546846751262652449254180038363747721932,
		          0.1406429146706506512047313037519472280955,
		          0.1406429146706506512047313037519472280955,
		          0.1225552067114784601845191268002015552281,
		          0.1225552067114784601845191268002015552281,
		          0.1009420441062871655628139849248346070628,
		          0.1009420441062871655628139849248346070628,
		          0.0764257302548890565291296776166365256053,
		          0.0764257302548890565291296776166365256053,
		          0.0497145488949697964533349462026386416808,
		          0.0497145488949697964533349462026386416808,
		          0.0216160135264833103133427102664524693876,
		          0.0216160135264833103133427102664524693876,
		      ],
		      [
		          0.1610544498487836959791636253209167350399,
		          0.1589688433939543476499564394650472016787,
		          0.1589688433939543476499564394650472016787,
		          0.152766042065859666778855400897662998461,
		          0.152766042065859666778855400897662998461,
		          0.1426067021736066117757461094419029724756,
		          0.1426067021736066117757461094419029724756,
		          0.1287539625393362276755157848568771170558,
		          0.1287539625393362276755157848568771170558,
		          0.1115666455473339947160239016817659974813,
		          0.1115666455473339947160239016817659974813,
		          0.0914900216224499994644620941238396526609,
		          0.0914900216224499994644620941238396526609,
		          0.0690445427376412265807082580060130449618,
		          0.0690445427376412265807082580060130449618,
		          0.0448142267656996003328381574019942119517,
		          0.0448142267656996003328381574019942119517,
		          0.0194617882297264770363120414644384357529,
		          0.0194617882297264770363120414644384357529,
		      ],
		      [
		          0.1527533871307258506980843319550975934919,
		          0.1527533871307258506980843319550975934919,
		          0.1491729864726037467878287370019694366926,
		          0.1491729864726037467878287370019694366926,
		          0.1420961093183820513292983250671649330345,
		          0.1420961093183820513292983250671649330345,
		          0.1316886384491766268984944997481631349161,
		          0.1316886384491766268984944997481631349161,
		          0.118194531961518417312377377711382287005,
		          0.118194531961518417312377377711382287005,
		          0.1019301198172404350367501354803498761666,
		          0.1019301198172404350367501354803498761666,
		          0.0832767415767047487247581432220462061001,
		          0.0832767415767047487247581432220462061001,
		          0.0626720483341090635695065351870416063516,
		          0.0626720483341090635695065351870416063516,
		          0.040601429800386941331039952274932109879,
		          0.040601429800386941331039952274932109879,
		          0.0176140071391521183118619623518528163621,
		          0.0176140071391521183118619623518528163621,
		      ],
		      [
		          0.1460811336496904271919851476833711882448,
		          0.1445244039899700590638271665537525436099,
		          0.1445244039899700590638271665537525436099,
		          0.1398873947910731547221334238675831108927,
		          0.1398873947910731547221334238675831108927,
		          0.132268938633337461781052574496775604329,
		          0.132268938633337461781052574496775604329,
		          0.1218314160537285341953671771257335983563,
		          0.1218314160537285341953671771257335983563,
		          0.1087972991671483776634745780701056420336,
		          0.1087972991671483776634745780701056420336,
		          0.0934444234560338615532897411139320884835,
		          0.0934444234560338615532897411139320884835,
		          0.0761001136283793020170516533001831792261,
		          0.0761001136283793020170516533001831792261,
		          0.0571344254268572082836358264724479574912,
		          0.0571344254268572082836358264724479574912,
		          0.0369537897708524937999506682993296661889,
		          0.0369537897708524937999506682993296661889,
		          0.0160172282577743333242246168584710152658,
		          0.0160172282577743333242246168584710152658,
		      ],
		      [
		          0.1392518728556319933754102483418099578739,
		          0.1392518728556319933754102483418099578739,
		          0.1365414983460151713525738312315173965863,
		          0.1365414983460151713525738312315173965863,
		          0.1311735047870623707329649925303074458757,
		          0.1311735047870623707329649925303074458757,
		          0.1232523768105124242855609861548144719594,
		          0.1232523768105124242855609861548144719594,
		          0.1129322960805392183934006074217843191142,
		          0.1129322960805392183934006074217843191142,
		          0.1004141444428809649320788378305362823508,
		          0.1004141444428809649320788378305362823508,
		          0.0859416062170677274144436813727028661891,
		          0.0859416062170677274144436813727028661891,
		          0.0697964684245204880949614189302176573987,
		          0.0697964684245204880949614189302176573987,
		          0.0522933351526832859403120512732112561121,
		          0.0522933351526832859403120512732112561121,
		          0.0337749015848141547933022468659129013491,
		          0.0337749015848141547933022468659129013491,
		          0.0146279952982722006849910980471854451902,
		          0.0146279952982722006849910980471854451902,
		      ],
		      [
		          0.1336545721861061753514571105458443385831,
		          0.132462039404696617371642464703316925805,
		          0.132462039404696617371642464703316925805,
		          0.1289057221880821499785953393997936532597,
		          0.1289057221880821499785953393997936532597,
		          0.1230490843067295304675784006720096548158,
		          0.1230490843067295304675784006720096548158,
		          0.1149966402224113649416435129339613014914,
		          0.1149966402224113649416435129339613014914,
		          0.1048920914645414100740861850147438548584,
		          0.1048920914645414100740861850147438548584,
		          0.0929157660600351474770186173697646486034,
		          0.0929157660600351474770186173697646486034,
		          0.0792814117767189549228925247420432269137,
		          0.0792814117767189549228925247420432269137,
		          0.0642324214085258521271696151589109980391,
		          0.0642324214085258521271696151589109980391,
		          0.0480376717310846685716410716320339965612,
		          0.0480376717310846685716410716320339965612,
		          0.0309880058569794443106942196418845053837,
		          0.0309880058569794443106942196418845053837,
		          0.0134118594871417720813094934586150649766,
		          0.0134118594871417720813094934586150649766,
		      ],
		      [
		          0.1279381953467521569740561652246953718517,
		          0.1279381953467521569740561652246953718517,
		          0.1258374563468282961213753825111836887264,
		          0.1258374563468282961213753825111836887264,
		          0.121670472927803391204463153476262425607,
		          0.121670472927803391204463153476262425607,
		          0.1155056680537256013533444839067835598622,
		          0.1155056680537256013533444839067835598622,
		          0.1074442701159656347825773424466062227946,
		          0.1074442701159656347825773424466062227946,
		          0.0976186521041138882698806644642471544279,
		          0.0976186521041138882698806644642471544279,
		          0.086190161531953275917185202983742667185,
		          0.086190161531953275917185202983742667185,
		          0.0733464814110803057340336152531165181193,
		          0.0733464814110803057340336152531165181193,
		          0.0592985849154367807463677585001085845412,
		          0.0592985849154367807463677585001085845412,
		          0.0442774388174198061686027482113382288593,
		          0.0442774388174198061686027482113382288593,
		          0.0285313886289336631813078159518782864491,
		          0.0285313886289336631813078159518782864491,
		          0.0123412297999871995468056670700372915759,
		          0.0123412297999871995468056670700372915759,
		      ],
		  ];
		  // LUT for binomial coefficient arrays per curve order 'n'
		  const binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
		  const getCubicArcLength = (xs, ys, t) => {
		      let z;
		      let sum;
		      let correctedT;
		      /*if (xs.length >= tValues.length) {
		            throw new Error('too high n bezier');
		          }*/
		      const n = 20;
		      z = t / 2;
		      sum = 0;
		      for (let i = 0; i < n; i++) {
		          correctedT = z * tValues[n][i] + z;
		          sum += cValues[n][i] * BFunc(xs, ys, correctedT);
		      }
		      return z * sum;
		  };
		  const getQuadraticArcLength = (xs, ys, t) => {
		      if (t === undefined) {
		          t = 1;
		      }
		      const ax = xs[0] - 2 * xs[1] + xs[2];
		      const ay = ys[0] - 2 * ys[1] + ys[2];
		      const bx = 2 * xs[1] - 2 * xs[0];
		      const by = 2 * ys[1] - 2 * ys[0];
		      const A = 4 * (ax * ax + ay * ay);
		      const B = 4 * (ax * bx + ay * by);
		      const C = bx * bx + by * by;
		      if (A === 0) {
		          return (t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2)));
		      }
		      const b = B / (2 * A);
		      const c = C / A;
		      const u = t + b;
		      const k = c - b * b;
		      const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
		      const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
		      const term = b + Math.sqrt(b * b + k) !== 0
		          ? k * Math.log(Math.abs((u + uuk) / (b + bbk)))
		          : 0;
		      return (Math.sqrt(A) / 2) * (u * uuk - b * bbk + term);
		  };
		  function BFunc(xs, ys, t) {
		      const xbase = getDerivative(1, t, xs);
		      const ybase = getDerivative(1, t, ys);
		      const combined = xbase * xbase + ybase * ybase;
		      return Math.sqrt(combined);
		  }
		  /**
		   * Compute the curve derivative (hodograph) at t.
		   */
		  const getDerivative = (derivative, t, vs) => {
		      // the derivative of any 't'-less function is zero.
		      const n = vs.length - 1;
		      let _vs;
		      let value;
		      if (n === 0) {
		          return 0;
		      }
		      // direct values? compute!
		      if (derivative === 0) {
		          value = 0;
		          for (let k = 0; k <= n; k++) {
		              value +=
		                  binomialCoefficients[n][k] *
		                      Math.pow(1 - t, n - k) *
		                      Math.pow(t, k) *
		                      vs[k];
		          }
		          return value;
		      }
		      else {
		          // Still some derivative? go down one order, then try
		          // for the lower order curve's.
		          _vs = new Array(n);
		          for (let k = 0; k < n; k++) {
		              _vs[k] = n * (vs[k + 1] - vs[k]);
		          }
		          return getDerivative(derivative - 1, t, _vs);
		      }
		  };
		  const t2length = (length, totalLength, func) => {
		      let error = 1;
		      let t = length / totalLength;
		      let step = (length - func(t)) / totalLength;
		      let numIterations = 0;
		      while (error > 0.001) {
		          const increasedTLength = func(t + step);
		          const increasedTError = Math.abs(length - increasedTLength) / totalLength;
		          if (increasedTError < error) {
		              error = increasedTError;
		              t += step;
		          }
		          else {
		              const decreasedTLength = func(t - step);
		              const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
		              if (decreasedTError < error) {
		                  error = decreasedTError;
		                  t -= step;
		              }
		              else {
		                  step /= 2;
		              }
		          }
		          numIterations++;
		          if (numIterations > 500) {
		              break;
		          }
		      }
		      return t;
		  };

		  /**
		   * Path constructor.
		   * @author Jason Follas
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {String} config.data SVG data string
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var path = new Konva.Path({
		   *   x: 240,
		   *   y: 40,
		   *   data: 'M12.582,9.551C3.251,16.237,0.921,29.021,7.08,38.564l-2.36,1.689l4.893,2.262l4.893,2.262l-0.568-5.36l-0.567-5.359l-2.365,1.694c-4.657-7.375-2.83-17.185,4.352-22.33c7.451-5.338,17.817-3.625,23.156,3.824c5.337,7.449,3.625,17.813-3.821,23.152l2.857,3.988c9.617-6.893,11.827-20.277,4.935-29.896C35.591,4.87,22.204,2.658,12.582,9.551z',
		   *   fill: 'green',
		   *   scaleX: 2,
		   *   scaleY: 2
		   * });
		   */
		  class Path extends Shape {
		      constructor(config) {
		          super(config);
		          this.dataArray = [];
		          this.pathLength = 0;
		          this._readDataAttribute();
		          this.on('dataChange.konva', function () {
		              this._readDataAttribute();
		          });
		      }
		      _readDataAttribute() {
		          this.dataArray = Path.parsePathData(this.data());
		          this.pathLength = Path.getPathLength(this.dataArray);
		      }
		      _sceneFunc(context) {
		          var ca = this.dataArray;
		          // context position
		          context.beginPath();
		          var isClosed = false;
		          for (var n = 0; n < ca.length; n++) {
		              var c = ca[n].command;
		              var p = ca[n].points;
		              switch (c) {
		                  case 'L':
		                      context.lineTo(p[0], p[1]);
		                      break;
		                  case 'M':
		                      context.moveTo(p[0], p[1]);
		                      break;
		                  case 'C':
		                      context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
		                      break;
		                  case 'Q':
		                      context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
		                      break;
		                  case 'A':
		                      var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
		                      var r = rx > ry ? rx : ry;
		                      var scaleX = rx > ry ? 1 : rx / ry;
		                      var scaleY = rx > ry ? ry / rx : 1;
		                      context.translate(cx, cy);
		                      context.rotate(psi);
		                      context.scale(scaleX, scaleY);
		                      context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
		                      context.scale(1 / scaleX, 1 / scaleY);
		                      context.rotate(-psi);
		                      context.translate(-cx, -cy);
		                      break;
		                  case 'z':
		                      isClosed = true;
		                      context.closePath();
		                      break;
		              }
		          }
		          if (!isClosed && !this.hasFill()) {
		              context.strokeShape(this);
		          }
		          else {
		              context.fillStrokeShape(this);
		          }
		      }
		      getSelfRect() {
		          var points = [];
		          this.dataArray.forEach(function (data) {
		              if (data.command === 'A') {
		                  // Approximates by breaking curve into line segments
		                  var start = data.points[4];
		                  // 4 = theta
		                  var dTheta = data.points[5];
		                  // 5 = dTheta
		                  var end = data.points[4] + dTheta;
		                  var inc = Math.PI / 180.0;
		                  // 1 degree resolution
		                  if (Math.abs(start - end) < inc) {
		                      inc = Math.abs(start - end);
		                  }
		                  if (dTheta < 0) {
		                      // clockwise
		                      for (let t = start - inc; t > end; t -= inc) {
		                          const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
		                          points.push(point.x, point.y);
		                      }
		                  }
		                  else {
		                      // counter-clockwise
		                      for (let t = start + inc; t < end; t += inc) {
		                          const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
		                          points.push(point.x, point.y);
		                      }
		                  }
		              }
		              else if (data.command === 'C') {
		                  // Approximates by breaking curve into 100 line segments
		                  for (let t = 0.0; t <= 1; t += 0.01) {
		                      const point = Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
		                      points.push(point.x, point.y);
		                  }
		              }
		              else {
		                  // TODO: how can we calculate bezier curves better?
		                  points = points.concat(data.points);
		              }
		          });
		          var minX = points[0];
		          var maxX = points[0];
		          var minY = points[1];
		          var maxY = points[1];
		          var x, y;
		          for (var i = 0; i < points.length / 2; i++) {
		              x = points[i * 2];
		              y = points[i * 2 + 1];
		              // skip bad values
		              if (!isNaN(x)) {
		                  minX = Math.min(minX, x);
		                  maxX = Math.max(maxX, x);
		              }
		              if (!isNaN(y)) {
		                  minY = Math.min(minY, y);
		                  maxY = Math.max(maxY, y);
		              }
		          }
		          return {
		              x: minX,
		              y: minY,
		              width: maxX - minX,
		              height: maxY - minY,
		          };
		      }
		      /**
		       * Return length of the path.
		       * @method
		       * @name Konva.Path#getLength
		       * @returns {Number} length
		       * @example
		       * var length = path.getLength();
		       */
		      getLength() {
		          return this.pathLength;
		      }
		      /**
		       * Get point on path at specific length of the path
		       * @method
		       * @name Konva.Path#getPointAtLength
		       * @param {Number} length length
		       * @returns {Object} point {x,y} point
		       * @example
		       * var point = path.getPointAtLength(10);
		       */
		      getPointAtLength(length) {
		          return Path.getPointAtLengthOfDataArray(length, this.dataArray);
		      }
		      static getLineLength(x1, y1, x2, y2) {
		          return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
		      }
		      static getPathLength(dataArray) {
		          let pathLength = 0;
		          for (var i = 0; i < dataArray.length; ++i) {
		              pathLength += dataArray[i].pathLength;
		          }
		          return pathLength;
		      }
		      static getPointAtLengthOfDataArray(length, dataArray) {
		          var point, i = 0, ii = dataArray.length;
		          if (!ii) {
		              return null;
		          }
		          while (i < ii && length > dataArray[i].pathLength) {
		              length -= dataArray[i].pathLength;
		              ++i;
		          }
		          if (i === ii) {
		              point = dataArray[i - 1].points.slice(-2);
		              return {
		                  x: point[0],
		                  y: point[1],
		              };
		          }
		          if (length < 0.01) {
		              point = dataArray[i].points.slice(0, 2);
		              return {
		                  x: point[0],
		                  y: point[1],
		              };
		          }
		          var cp = dataArray[i];
		          var p = cp.points;
		          switch (cp.command) {
		              case 'L':
		                  return Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
		              case 'C':
		                  return Path.getPointOnCubicBezier(t2length(length, Path.getPathLength(dataArray), (i) => {
		                      return getCubicArcLength([cp.start.x, p[0], p[2], p[4]], [cp.start.y, p[1], p[3], p[5]], i);
		                  }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
		              case 'Q':
		                  return Path.getPointOnQuadraticBezier(t2length(length, Path.getPathLength(dataArray), (i) => {
		                      return getQuadraticArcLength([cp.start.x, p[0], p[2]], [cp.start.y, p[1], p[3]], i);
		                  }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
		              case 'A':
		                  var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
		                  theta += (dTheta * length) / cp.pathLength;
		                  return Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
		          }
		          return null;
		      }
		      static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
		          if (fromX === undefined) {
		              fromX = P1x;
		          }
		          if (fromY === undefined) {
		              fromY = P1y;
		          }
		          var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
		          var run = Math.sqrt((dist * dist) / (1 + m * m));
		          if (P2x < P1x) {
		              run *= -1;
		          }
		          var rise = m * run;
		          var pt;
		          if (P2x === P1x) {
		              // vertical line
		              pt = {
		                  x: fromX,
		                  y: fromY + rise,
		              };
		          }
		          else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) {
		              pt = {
		                  x: fromX + run,
		                  y: fromY + rise,
		              };
		          }
		          else {
		              var ix, iy;
		              var len = this.getLineLength(P1x, P1y, P2x, P2y);
		              // if (len < 0.00000001) {
		              //   return {
		              //     x: P1x,
		              //     y: P1y,
		              //   };
		              // }
		              var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
		              u = u / (len * len);
		              ix = P1x + u * (P2x - P1x);
		              iy = P1y + u * (P2y - P1y);
		              var pRise = this.getLineLength(fromX, fromY, ix, iy);
		              var pRun = Math.sqrt(dist * dist - pRise * pRise);
		              run = Math.sqrt((pRun * pRun) / (1 + m * m));
		              if (P2x < P1x) {
		                  run *= -1;
		              }
		              rise = m * run;
		              pt = {
		                  x: ix + run,
		                  y: iy + rise,
		              };
		          }
		          return pt;
		      }
		      static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
		          function CB1(t) {
		              return t * t * t;
		          }
		          function CB2(t) {
		              return 3 * t * t * (1 - t);
		          }
		          function CB3(t) {
		              return 3 * t * (1 - t) * (1 - t);
		          }
		          function CB4(t) {
		              return (1 - t) * (1 - t) * (1 - t);
		          }
		          var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
		          var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
		          return {
		              x: x,
		              y: y,
		          };
		      }
		      static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
		          function QB1(t) {
		              return t * t;
		          }
		          function QB2(t) {
		              return 2 * t * (1 - t);
		          }
		          function QB3(t) {
		              return (1 - t) * (1 - t);
		          }
		          var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
		          var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
		          return {
		              x: x,
		              y: y,
		          };
		      }
		      static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
		          var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
		          var pt = {
		              x: rx * Math.cos(theta),
		              y: ry * Math.sin(theta),
		          };
		          return {
		              x: cx + (pt.x * cosPsi - pt.y * sinPsi),
		              y: cy + (pt.x * sinPsi + pt.y * cosPsi),
		          };
		      }
		      /*
		       * get parsed data array from the data
		       *  string.  V, v, H, h, and l data are converted to
		       *  L data for the purpose of high performance Path
		       *  rendering
		       */
		      static parsePathData(data) {
		          // Path Data Segment must begin with a moveTo
		          //m (x y)+  Relative moveTo (subsequent points are treated as lineTo)
		          //M (x y)+  Absolute moveTo (subsequent points are treated as lineTo)
		          //l (x y)+  Relative lineTo
		          //L (x y)+  Absolute LineTo
		          //h (x)+    Relative horizontal lineTo
		          //H (x)+    Absolute horizontal lineTo
		          //v (y)+    Relative vertical lineTo
		          //V (y)+    Absolute vertical lineTo
		          //z (closepath)
		          //Z (closepath)
		          //c (x1 y1 x2 y2 x y)+ Relative Bezier curve
		          //C (x1 y1 x2 y2 x y)+ Absolute Bezier curve
		          //q (x1 y1 x y)+       Relative Quadratic Bezier
		          //Q (x1 y1 x y)+       Absolute Quadratic Bezier
		          //t (x y)+    Shorthand/Smooth Relative Quadratic Bezier
		          //T (x y)+    Shorthand/Smooth Absolute Quadratic Bezier
		          //s (x2 y2 x y)+       Shorthand/Smooth Relative Bezier curve
		          //S (x2 y2 x y)+       Shorthand/Smooth Absolute Bezier curve
		          //a (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+     Relative Elliptical Arc
		          //A (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+  Absolute Elliptical Arc
		          // return early if data is not defined
		          if (!data) {
		              return [];
		          }
		          // command string
		          var cs = data;
		          // command chars
		          var cc = [
		              'm',
		              'M',
		              'l',
		              'L',
		              'v',
		              'V',
		              'h',
		              'H',
		              'z',
		              'Z',
		              'c',
		              'C',
		              'q',
		              'Q',
		              't',
		              'T',
		              's',
		              'S',
		              'a',
		              'A',
		          ];
		          // convert white spaces to commas
		          cs = cs.replace(new RegExp(' ', 'g'), ',');
		          // create pipes so that we can split the data
		          for (var n = 0; n < cc.length; n++) {
		              cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
		          }
		          // create array
		          var arr = cs.split('|');
		          var ca = [];
		          var coords = [];
		          // init context point
		          var cpx = 0;
		          var cpy = 0;
		          var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
		          var match;
		          for (n = 1; n < arr.length; n++) {
		              var str = arr[n];
		              var c = str.charAt(0);
		              str = str.slice(1);
		              coords.length = 0;
		              while ((match = re.exec(str))) {
		                  coords.push(match[0]);
		              }
		              // while ((match = re.exec(str))) {
		              //   coords.push(match[0]);
		              // }
		              var p = [];
		              for (var j = 0, jlen = coords.length; j < jlen; j++) {
		                  // extra case for merged flags
		                  if (coords[j] === '00') {
		                      p.push(0, 0);
		                      continue;
		                  }
		                  var parsed = parseFloat(coords[j]);
		                  if (!isNaN(parsed)) {
		                      p.push(parsed);
		                  }
		                  else {
		                      p.push(0);
		                  }
		              }
		              while (p.length > 0) {
		                  if (isNaN(p[0])) {
		                      // case for a trailing comma before next command
		                      break;
		                  }
		                  var cmd = '';
		                  var points = [];
		                  var startX = cpx, startY = cpy;
		                  // Move var from within the switch to up here (jshint)
		                  var prevCmd, ctlPtx, ctlPty; // Ss, Tt
		                  var rx, ry, psi, fa, fs, x1, y1; // Aa
		                  // convert l, H, h, V, and v to L
		                  switch (c) {
		                      // Note: Keep the lineTo's above the moveTo's in this switch
		                      case 'l':
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'L';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'L':
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          points.push(cpx, cpy);
		                          break;
		                      // Note: lineTo handlers need to be above this point
		                      case 'm':
		                          var dx = p.shift();
		                          var dy = p.shift();
		                          cpx += dx;
		                          cpy += dy;
		                          cmd = 'M';
		                          // After closing the path move the current position
		                          // to the the first point of the path (if any).
		                          if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
		                              for (var idx = ca.length - 2; idx >= 0; idx--) {
		                                  if (ca[idx].command === 'M') {
		                                      cpx = ca[idx].points[0] + dx;
		                                      cpy = ca[idx].points[1] + dy;
		                                      break;
		                                  }
		                              }
		                          }
		                          points.push(cpx, cpy);
		                          c = 'l';
		                          // subsequent points are treated as relative lineTo
		                          break;
		                      case 'M':
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          cmd = 'M';
		                          points.push(cpx, cpy);
		                          c = 'L';
		                          // subsequent points are treated as absolute lineTo
		                          break;
		                      case 'h':
		                          cpx += p.shift();
		                          cmd = 'L';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'H':
		                          cpx = p.shift();
		                          cmd = 'L';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'v':
		                          cpy += p.shift();
		                          cmd = 'L';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'V':
		                          cpy = p.shift();
		                          cmd = 'L';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'C':
		                          points.push(p.shift(), p.shift(), p.shift(), p.shift());
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          points.push(cpx, cpy);
		                          break;
		                      case 'c':
		                          points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'C';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'S':
		                          ctlPtx = cpx;
		                          ctlPty = cpy;
		                          prevCmd = ca[ca.length - 1];
		                          if (prevCmd.command === 'C') {
		                              ctlPtx = cpx + (cpx - prevCmd.points[2]);
		                              ctlPty = cpy + (cpy - prevCmd.points[3]);
		                          }
		                          points.push(ctlPtx, ctlPty, p.shift(), p.shift());
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          cmd = 'C';
		                          points.push(cpx, cpy);
		                          break;
		                      case 's':
		                          ctlPtx = cpx;
		                          ctlPty = cpy;
		                          prevCmd = ca[ca.length - 1];
		                          if (prevCmd.command === 'C') {
		                              ctlPtx = cpx + (cpx - prevCmd.points[2]);
		                              ctlPty = cpy + (cpy - prevCmd.points[3]);
		                          }
		                          points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'C';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'Q':
		                          points.push(p.shift(), p.shift());
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          points.push(cpx, cpy);
		                          break;
		                      case 'q':
		                          points.push(cpx + p.shift(), cpy + p.shift());
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'Q';
		                          points.push(cpx, cpy);
		                          break;
		                      case 'T':
		                          ctlPtx = cpx;
		                          ctlPty = cpy;
		                          prevCmd = ca[ca.length - 1];
		                          if (prevCmd.command === 'Q') {
		                              ctlPtx = cpx + (cpx - prevCmd.points[0]);
		                              ctlPty = cpy + (cpy - prevCmd.points[1]);
		                          }
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          cmd = 'Q';
		                          points.push(ctlPtx, ctlPty, cpx, cpy);
		                          break;
		                      case 't':
		                          ctlPtx = cpx;
		                          ctlPty = cpy;
		                          prevCmd = ca[ca.length - 1];
		                          if (prevCmd.command === 'Q') {
		                              ctlPtx = cpx + (cpx - prevCmd.points[0]);
		                              ctlPty = cpy + (cpy - prevCmd.points[1]);
		                          }
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'Q';
		                          points.push(ctlPtx, ctlPty, cpx, cpy);
		                          break;
		                      case 'A':
		                          rx = p.shift();
		                          ry = p.shift();
		                          psi = p.shift();
		                          fa = p.shift();
		                          fs = p.shift();
		                          x1 = cpx;
		                          y1 = cpy;
		                          cpx = p.shift();
		                          cpy = p.shift();
		                          cmd = 'A';
		                          points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
		                          break;
		                      case 'a':
		                          rx = p.shift();
		                          ry = p.shift();
		                          psi = p.shift();
		                          fa = p.shift();
		                          fs = p.shift();
		                          x1 = cpx;
		                          y1 = cpy;
		                          cpx += p.shift();
		                          cpy += p.shift();
		                          cmd = 'A';
		                          points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
		                          break;
		                  }
		                  ca.push({
		                      command: cmd || c,
		                      points: points,
		                      start: {
		                          x: startX,
		                          y: startY,
		                      },
		                      pathLength: this.calcLength(startX, startY, cmd || c, points),
		                  });
		              }
		              if (c === 'z' || c === 'Z') {
		                  ca.push({
		                      command: 'z',
		                      points: [],
		                      start: undefined,
		                      pathLength: 0,
		                  });
		              }
		          }
		          return ca;
		      }
		      static calcLength(x, y, cmd, points) {
		          var len, p1, p2, t;
		          var path = Path;
		          switch (cmd) {
		              case 'L':
		                  return path.getLineLength(x, y, points[0], points[1]);
		              case 'C':
		                  return getCubicArcLength([x, points[0], points[2], points[4]], [y, points[1], points[3], points[5]], 1);
		              case 'Q':
		                  return getQuadraticArcLength([x, points[0], points[2]], [y, points[1], points[3]], 1);
		              case 'A':
		                  // Approximates by breaking curve into line segments
		                  len = 0.0;
		                  var start = points[4];
		                  // 4 = theta
		                  var dTheta = points[5];
		                  // 5 = dTheta
		                  var end = points[4] + dTheta;
		                  var inc = Math.PI / 180.0;
		                  // 1 degree resolution
		                  if (Math.abs(start - end) < inc) {
		                      inc = Math.abs(start - end);
		                  }
		                  // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
		                  p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
		                  if (dTheta < 0) {
		                      // clockwise
		                      for (t = start - inc; t > end; t -= inc) {
		                          p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
		                          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
		                          p1 = p2;
		                      }
		                  }
		                  else {
		                      // counter-clockwise
		                      for (t = start + inc; t < end; t += inc) {
		                          p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
		                          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
		                          p1 = p2;
		                      }
		                  }
		                  p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
		                  len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
		                  return len;
		          }
		          return 0;
		      }
		      static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
		          // Derived from: http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
		          var psi = psiDeg * (Math.PI / 180.0);
		          var xp = (Math.cos(psi) * (x1 - x2)) / 2.0 + (Math.sin(psi) * (y1 - y2)) / 2.0;
		          var yp = (-1 * Math.sin(psi) * (x1 - x2)) / 2.0 +
		              (Math.cos(psi) * (y1 - y2)) / 2.0;
		          var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
		          if (lambda > 1) {
		              rx *= Math.sqrt(lambda);
		              ry *= Math.sqrt(lambda);
		          }
		          var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
		              (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
		          if (fa === fs) {
		              f *= -1;
		          }
		          if (isNaN(f)) {
		              f = 0;
		          }
		          var cxp = (f * rx * yp) / ry;
		          var cyp = (f * -ry * xp) / rx;
		          var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
		          var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
		          var vMag = function (v) {
		              return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
		          };
		          var vRatio = function (u, v) {
		              return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
		          };
		          var vAngle = function (u, v) {
		              return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
		          };
		          var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
		          var u = [(xp - cxp) / rx, (yp - cyp) / ry];
		          var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
		          var dTheta = vAngle(u, v);
		          if (vRatio(u, v) <= -1) {
		              dTheta = Math.PI;
		          }
		          if (vRatio(u, v) >= 1) {
		              dTheta = 0;
		          }
		          if (fs === 0 && dTheta > 0) {
		              dTheta = dTheta - 2 * Math.PI;
		          }
		          if (fs === 1 && dTheta < 0) {
		              dTheta = dTheta + 2 * Math.PI;
		          }
		          return [cx, cy, rx, ry, theta, dTheta, psi, fs];
		      }
		  }
		  Path.prototype.className = 'Path';
		  Path.prototype._attrsAffectingSize = ['data'];
		  _registerNode(Path);
		  /**
		   * get/set SVG path data string.  This method
		   *  also automatically parses the data string
		   *  into a data array.  Currently supported SVG data:
		   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
		   * @name Konva.Path#data
		   * @method
		   * @param {String} data svg path string
		   * @returns {String}
		   * @example
		   * // get data
		   * var data = path.data();
		   *
		   * // set data
		   * path.data('M200,100h100v50z');
		   */
		  Factory.addGetterSetter(Path, 'data');

		  /**
		   * Arrow constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Line
		   * @param {Object} config
		   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
		   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
		   *   The default is 0
		   * @param {Number} config.pointerLength Arrow pointer length. Default value is 10.
		   * @param {Number} config.pointerWidth Arrow pointer width. Default value is 10.
		   * @param {Boolean} config.pointerAtBeginning Do we need to draw pointer on beginning position?. Default false.
		   * @param {Boolean} config.pointerAtEnding Do we need to draw pointer on ending position?. Default true.
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var line = new Konva.Line({
		   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
		   *   stroke: 'red',
		   *   tension: 1,
		   *   pointerLength : 10,
		   *   pointerWidth : 12
		   * });
		   */
		  class Arrow extends Line {
		      _sceneFunc(ctx) {
		          super._sceneFunc(ctx);
		          var PI2 = Math.PI * 2;
		          var points = this.points();
		          var tp = points;
		          var fromTension = this.tension() !== 0 && points.length > 4;
		          if (fromTension) {
		              tp = this.getTensionPoints();
		          }
		          var length = this.pointerLength();
		          var n = points.length;
		          var dx, dy;
		          if (fromTension) {
		              const lp = [
		                  tp[tp.length - 4],
		                  tp[tp.length - 3],
		                  tp[tp.length - 2],
		                  tp[tp.length - 1],
		                  points[n - 2],
		                  points[n - 1],
		              ];
		              const lastLength = Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
		              const previous = Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
		              dx = points[n - 2] - previous.x;
		              dy = points[n - 1] - previous.y;
		          }
		          else {
		              dx = points[n - 2] - points[n - 4];
		              dy = points[n - 1] - points[n - 3];
		          }
		          var radians = (Math.atan2(dy, dx) + PI2) % PI2;
		          var width = this.pointerWidth();
		          if (this.pointerAtEnding()) {
		              ctx.save();
		              ctx.beginPath();
		              ctx.translate(points[n - 2], points[n - 1]);
		              ctx.rotate(radians);
		              ctx.moveTo(0, 0);
		              ctx.lineTo(-length, width / 2);
		              ctx.lineTo(-length, -width / 2);
		              ctx.closePath();
		              ctx.restore();
		              this.__fillStroke(ctx);
		          }
		          if (this.pointerAtBeginning()) {
		              ctx.save();
		              ctx.beginPath();
		              ctx.translate(points[0], points[1]);
		              if (fromTension) {
		                  dx = (tp[0] + tp[2]) / 2 - points[0];
		                  dy = (tp[1] + tp[3]) / 2 - points[1];
		              }
		              else {
		                  dx = points[2] - points[0];
		                  dy = points[3] - points[1];
		              }
		              ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
		              ctx.moveTo(0, 0);
		              ctx.lineTo(-length, width / 2);
		              ctx.lineTo(-length, -width / 2);
		              ctx.closePath();
		              ctx.restore();
		              this.__fillStroke(ctx);
		          }
		      }
		      __fillStroke(ctx) {
		          // here is a tricky part
		          // we need to disable dash for arrow pointers
		          var isDashEnabled = this.dashEnabled();
		          if (isDashEnabled) {
		              // manually disable dash for head
		              // it is better not to use setter here,
		              // because it will trigger attr change event
		              this.attrs.dashEnabled = false;
		              ctx.setLineDash([]);
		          }
		          ctx.fillStrokeShape(this);
		          // restore old value
		          if (isDashEnabled) {
		              this.attrs.dashEnabled = true;
		          }
		      }
		      getSelfRect() {
		          const lineRect = super.getSelfRect();
		          const offset = this.pointerWidth() / 2;
		          return {
		              x: lineRect.x - offset,
		              y: lineRect.y - offset,
		              width: lineRect.width + offset * 2,
		              height: lineRect.height + offset * 2,
		          };
		      }
		  }
		  Arrow.prototype.className = 'Arrow';
		  _registerNode(Arrow);
		  /**
		   * get/set pointerLength
		   * @name Konva.Arrow#pointerLength
		   * @method
		   * @param {Number} Length of pointer of arrow. The default is 10.
		   * @returns {Number}
		   * @example
		   * // get length
		   * var pointerLength = line.pointerLength();
		   *
		   * // set length
		   * line.pointerLength(15);
		   */
		  Factory.addGetterSetter(Arrow, 'pointerLength', 10, getNumberValidator());
		  /**
		   * get/set pointerWidth
		   * @name Konva.Arrow#pointerWidth
		   * @method
		   * @param {Number} Width of pointer of arrow.
		   *   The default is 10.
		   * @returns {Number}
		   * @example
		   * // get width
		   * var pointerWidth = line.pointerWidth();
		   *
		   * // set width
		   * line.pointerWidth(15);
		   */
		  Factory.addGetterSetter(Arrow, 'pointerWidth', 10, getNumberValidator());
		  /**
		   * get/set pointerAtBeginning
		   * @name Konva.Arrow#pointerAtBeginning
		   * @method
		   * @param {Number} Should pointer displayed at beginning of arrow. The default is false.
		   * @returns {Boolean}
		   * @example
		   * // get value
		   * var pointerAtBeginning = line.pointerAtBeginning();
		   *
		   * // set value
		   * line.pointerAtBeginning(true);
		   */
		  Factory.addGetterSetter(Arrow, 'pointerAtBeginning', false);
		  /**
		   * get/set pointerAtEnding
		   * @name Konva.Arrow#pointerAtEnding
		   * @method
		   * @param {Number} Should pointer displayed at ending of arrow. The default is true.
		   * @returns {Boolean}
		   * @example
		   * // get value
		   * var pointerAtEnding = line.pointerAtEnding();
		   *
		   * // set value
		   * line.pointerAtEnding(false);
		   */
		  Factory.addGetterSetter(Arrow, 'pointerAtEnding', true);

		  /**
		   * Circle constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Number} config.radius
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * // create circle
		   * var circle = new Konva.Circle({
		   *   radius: 40,
		   *   fill: 'red',
		   *   stroke: 'black',
		   *   strokeWidth: 5
		   * });
		   */
		  class Circle extends Shape {
		      _sceneFunc(context) {
		          context.beginPath();
		          context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.radius() * 2;
		      }
		      getHeight() {
		          return this.radius() * 2;
		      }
		      setWidth(width) {
		          if (this.radius() !== width / 2) {
		              this.radius(width / 2);
		          }
		      }
		      setHeight(height) {
		          if (this.radius() !== height / 2) {
		              this.radius(height / 2);
		          }
		      }
		  }
		  Circle.prototype._centroid = true;
		  Circle.prototype.className = 'Circle';
		  Circle.prototype._attrsAffectingSize = ['radius'];
		  _registerNode(Circle);
		  /**
		   * get/set radius
		   * @name Konva.Circle#radius
		   * @method
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get radius
		   * var radius = circle.radius();
		   *
		   * // set radius
		   * circle.radius(10);
		   */
		  Factory.addGetterSetter(Circle, 'radius', 0, getNumberValidator());

		  /**
		   * Ellipse constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Object} config.radius defines x and y radius
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var ellipse = new Konva.Ellipse({
		   *   radius : {
		   *     x : 50,
		   *     y : 50
		   *   },
		   *   fill: 'red'
		   * });
		   */
		  class Ellipse extends Shape {
		      _sceneFunc(context) {
		          var rx = this.radiusX(), ry = this.radiusY();
		          context.beginPath();
		          context.save();
		          if (rx !== ry) {
		              context.scale(1, ry / rx);
		          }
		          context.arc(0, 0, rx, 0, Math.PI * 2, false);
		          context.restore();
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.radiusX() * 2;
		      }
		      getHeight() {
		          return this.radiusY() * 2;
		      }
		      setWidth(width) {
		          this.radiusX(width / 2);
		      }
		      setHeight(height) {
		          this.radiusY(height / 2);
		      }
		  }
		  Ellipse.prototype.className = 'Ellipse';
		  Ellipse.prototype._centroid = true;
		  Ellipse.prototype._attrsAffectingSize = ['radiusX', 'radiusY'];
		  _registerNode(Ellipse);
		  // add getters setters
		  Factory.addComponentsGetterSetter(Ellipse, 'radius', ['x', 'y']);
		  /**
		   * get/set radius
		   * @name Konva.Ellipse#radius
		   * @method
		   * @param {Object} radius
		   * @param {Number} radius.x
		   * @param {Number} radius.y
		   * @returns {Object}
		   * @example
		   * // get radius
		   * var radius = ellipse.radius();
		   *
		   * // set radius
		   * ellipse.radius({
		   *   x: 200,
		   *   y: 100
		   * });
		   */
		  Factory.addGetterSetter(Ellipse, 'radiusX', 0, getNumberValidator());
		  /**
		   * get/set radius x
		   * @name Konva.Ellipse#radiusX
		   * @method
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get radius x
		   * var radiusX = ellipse.radiusX();
		   *
		   * // set radius x
		   * ellipse.radiusX(200);
		   */
		  Factory.addGetterSetter(Ellipse, 'radiusY', 0, getNumberValidator());
		  /**
		   * get/set radius y
		   * @name Konva.Ellipse#radiusY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get radius y
		   * var radiusY = ellipse.radiusY();
		   *
		   * // set radius y
		   * ellipse.radiusY(200);
		   */

		  /**
		   * Image constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Image} config.image
		   * @param {Object} [config.crop]
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var imageObj = new Image();
		   * imageObj.onload = function() {
		   *   var image = new Konva.Image({
		   *     x: 200,
		   *     y: 50,
		   *     image: imageObj,
		   *     width: 100,
		   *     height: 100
		   *   });
		   * };
		   * imageObj.src = '/path/to/image.jpg'
		   */
		  class Image extends Shape {
		      constructor(attrs) {
		          super(attrs);
		          this.on('imageChange.konva', () => {
		              this._setImageLoad();
		          });
		          this._setImageLoad();
		      }
		      _setImageLoad() {
		          const image = this.image();
		          // check is image is already loaded
		          if (image && image.complete) {
		              return;
		          }
		          // check is video is already loaded
		          if (image && image.readyState === 4) {
		              return;
		          }
		          if (image && image['addEventListener']) {
		              image['addEventListener']('load', () => {
		                  this._requestDraw();
		              });
		          }
		      }
		      _useBufferCanvas() {
		          return super._useBufferCanvas(true);
		      }
		      _sceneFunc(context) {
		          const width = this.getWidth();
		          const height = this.getHeight();
		          const cornerRadius = this.cornerRadius();
		          const image = this.attrs.image;
		          let params;
		          if (image) {
		              const cropWidth = this.attrs.cropWidth;
		              const cropHeight = this.attrs.cropHeight;
		              if (cropWidth && cropHeight) {
		                  params = [
		                      image,
		                      this.cropX(),
		                      this.cropY(),
		                      cropWidth,
		                      cropHeight,
		                      0,
		                      0,
		                      width,
		                      height,
		                  ];
		              }
		              else {
		                  params = [image, 0, 0, width, height];
		              }
		          }
		          if (this.hasFill() || this.hasStroke() || cornerRadius) {
		              context.beginPath();
		              cornerRadius
		                  ? Util.drawRoundedRectPath(context, width, height, cornerRadius)
		                  : context.rect(0, 0, width, height);
		              context.closePath();
		              context.fillStrokeShape(this);
		          }
		          if (image) {
		              if (cornerRadius) {
		                  context.clip();
		              }
		              context.drawImage.apply(context, params);
		          }
		          // If you need to draw later, you need to execute save/restore
		      }
		      _hitFunc(context) {
		          var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
		          context.beginPath();
		          if (!cornerRadius) {
		              context.rect(0, 0, width, height);
		          }
		          else {
		              Util.drawRoundedRectPath(context, width, height, cornerRadius);
		          }
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          var _a, _b;
		          return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
		      }
		      getHeight() {
		          var _a, _b;
		          return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
		      }
		      /**
		       * load image from given url and create `Konva.Image` instance
		       * @method
		       * @memberof Konva.Image
		       * @param {String} url image source
		       * @param {Function} callback with Konva.Image instance as first argument
		       * @param {Function} onError optional error handler
		       * @example
		       *  Konva.Image.fromURL(imageURL, function(image){
		       *    // image is Konva.Image instance
		       *    layer.add(image);
		       *    layer.draw();
		       *  });
		       */
		      static fromURL(url, callback, onError = null) {
		          var img = Util.createImageElement();
		          img.onload = function () {
		              var image = new Image({
		                  image: img,
		              });
		              callback(image);
		          };
		          img.onerror = onError;
		          img.crossOrigin = 'Anonymous';
		          img.src = url;
		      }
		  }
		  Image.prototype.className = 'Image';
		  _registerNode(Image);
		  /**
		   * get/set corner radius
		   * @method
		   * @name Konva.Image#cornerRadius
		   * @param {Number} cornerRadius
		   * @returns {Number}
		   * @example
		   * // get corner radius
		   * var cornerRadius = image.cornerRadius();
		   *
		   * // set corner radius
		   * image.cornerRadius(10);
		   *
		   * // set different corner radius values
		   * // top-left, top-right, bottom-right, bottom-left
		   * image.cornerRadius([0, 10, 20, 30]);
		   */
		  Factory.addGetterSetter(Image, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));
		  /**
		   * get/set image source. It can be image, canvas or video element
		   * @name Konva.Image#image
		   * @method
		   * @param {Object} image source
		   * @returns {Object}
		   * @example
		   * // get value
		   * var image = shape.image();
		   *
		   * // set value
		   * shape.image(img);
		   */
		  Factory.addGetterSetter(Image, 'image');
		  Factory.addComponentsGetterSetter(Image, 'crop', ['x', 'y', 'width', 'height']);
		  /**
		   * get/set crop
		   * @method
		   * @name Konva.Image#crop
		   * @param {Object} crop
		   * @param {Number} crop.x
		   * @param {Number} crop.y
		   * @param {Number} crop.width
		   * @param {Number} crop.height
		   * @returns {Object}
		   * @example
		   * // get crop
		   * var crop = image.crop();
		   *
		   * // set crop
		   * image.crop({
		   *   x: 20,
		   *   y: 20,
		   *   width: 20,
		   *   height: 20
		   * });
		   */
		  Factory.addGetterSetter(Image, 'cropX', 0, getNumberValidator());
		  /**
		   * get/set crop x
		   * @method
		   * @name Konva.Image#cropX
		   * @param {Number} x
		   * @returns {Number}
		   * @example
		   * // get crop x
		   * var cropX = image.cropX();
		   *
		   * // set crop x
		   * image.cropX(20);
		   */
		  Factory.addGetterSetter(Image, 'cropY', 0, getNumberValidator());
		  /**
		   * get/set crop y
		   * @name Konva.Image#cropY
		   * @method
		   * @param {Number} y
		   * @returns {Number}
		   * @example
		   * // get crop y
		   * var cropY = image.cropY();
		   *
		   * // set crop y
		   * image.cropY(20);
		   */
		  Factory.addGetterSetter(Image, 'cropWidth', 0, getNumberValidator());
		  /**
		   * get/set crop width
		   * @name Konva.Image#cropWidth
		   * @method
		   * @param {Number} width
		   * @returns {Number}
		   * @example
		   * // get crop width
		   * var cropWidth = image.cropWidth();
		   *
		   * // set crop width
		   * image.cropWidth(20);
		   */
		  Factory.addGetterSetter(Image, 'cropHeight', 0, getNumberValidator());
		  /**
		   * get/set crop height
		   * @name Konva.Image#cropHeight
		   * @method
		   * @param {Number} height
		   * @returns {Number}
		   * @example
		   * // get crop height
		   * var cropHeight = image.cropHeight();
		   *
		   * // set crop height
		   * image.cropHeight(20);
		   */

		  // constants
		  var ATTR_CHANGE_LIST$2 = [
		      'fontFamily',
		      'fontSize',
		      'fontStyle',
		      'padding',
		      'lineHeight',
		      'text',
		      'width',
		      'height',
		      'pointerDirection',
		      'pointerWidth',
		      'pointerHeight',
		  ], CHANGE_KONVA$1 = 'Change.konva', NONE$1 = 'none', UP = 'up', RIGHT$1 = 'right', DOWN = 'down', LEFT$1 = 'left', 
		  // cached variables
		  attrChangeListLen$1 = ATTR_CHANGE_LIST$2.length;
		  /**
		   * Label constructor.&nbsp; Labels are groups that contain a Text and Tag shape
		   * @constructor
		   * @memberof Konva
		   * @param {Object} config
		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * // create label
		   * var label = new Konva.Label({
		   *   x: 100,
		   *   y: 100,
		   *   draggable: true
		   * });
		   *
		   * // add a tag to the label
		   * label.add(new Konva.Tag({
		   *   fill: '#bbb',
		   *   stroke: '#333',
		   *   shadowColor: 'black',
		   *   shadowBlur: 10,
		   *   shadowOffset: [10, 10],
		   *   shadowOpacity: 0.2,
		   *   lineJoin: 'round',
		   *   pointerDirection: 'up',
		   *   pointerWidth: 20,
		   *   pointerHeight: 20,
		   *   cornerRadius: 5
		   * }));
		   *
		   * // add text to the label
		   * label.add(new Konva.Text({
		   *   text: 'Hello World!',
		   *   fontSize: 50,
		   *   lineHeight: 1.2,
		   *   padding: 10,
		   *   fill: 'green'
		   *  }));
		   */
		  class Label extends Group {
		      constructor(config) {
		          super(config);
		          this.on('add.konva', function (evt) {
		              this._addListeners(evt.child);
		              this._sync();
		          });
		      }
		      /**
		       * get Text shape for the label.  You need to access the Text shape in order to update
		       * the text properties
		       * @name Konva.Label#getText
		       * @method
		       * @example
		       * label.getText().fill('red')
		       */
		      getText() {
		          return this.find('Text')[0];
		      }
		      /**
		       * get Tag shape for the label.  You need to access the Tag shape in order to update
		       * the pointer properties and the corner radius
		       * @name Konva.Label#getTag
		       * @method
		       */
		      getTag() {
		          return this.find('Tag')[0];
		      }
		      _addListeners(text) {
		          var that = this, n;
		          var func = function () {
		              that._sync();
		          };
		          // update text data for certain attr changes
		          for (n = 0; n < attrChangeListLen$1; n++) {
		              text.on(ATTR_CHANGE_LIST$2[n] + CHANGE_KONVA$1, func);
		          }
		      }
		      getWidth() {
		          return this.getText().width();
		      }
		      getHeight() {
		          return this.getText().height();
		      }
		      _sync() {
		          var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
		          if (text && tag) {
		              width = text.width();
		              height = text.height();
		              pointerDirection = tag.pointerDirection();
		              pointerWidth = tag.pointerWidth();
		              pointerHeight = tag.pointerHeight();
		              x = 0;
		              y = 0;
		              switch (pointerDirection) {
		                  case UP:
		                      x = width / 2;
		                      y = -1 * pointerHeight;
		                      break;
		                  case RIGHT$1:
		                      x = width + pointerWidth;
		                      y = height / 2;
		                      break;
		                  case DOWN:
		                      x = width / 2;
		                      y = height + pointerHeight;
		                      break;
		                  case LEFT$1:
		                      x = -1 * pointerWidth;
		                      y = height / 2;
		                      break;
		              }
		              tag.setAttrs({
		                  x: -1 * x,
		                  y: -1 * y,
		                  width: width,
		                  height: height,
		              });
		              text.setAttrs({
		                  x: -1 * x,
		                  y: -1 * y,
		              });
		          }
		      }
		  }
		  Label.prototype.className = 'Label';
		  _registerNode(Label);
		  /**
		   * Tag constructor.&nbsp; A Tag can be configured
		   *  to have a pointer element that points up, right, down, or left
		   * @constructor
		   * @memberof Konva
		   * @param {Object} config
		   * @param {String} [config.pointerDirection] can be up, right, down, left, or none; the default
		   *  is none.  When a pointer is present, the positioning of the label is relative to the tip of the pointer.
		   * @param {Number} [config.pointerWidth]
		   * @param {Number} [config.pointerHeight]
		   * @param {Number} [config.cornerRadius]
		   */
		  class Tag extends Shape {
		      _sceneFunc(context) {
		          var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
		          let topLeft = 0;
		          let topRight = 0;
		          let bottomLeft = 0;
		          let bottomRight = 0;
		          if (typeof cornerRadius === 'number') {
		              topLeft =
		                  topRight =
		                      bottomLeft =
		                          bottomRight =
		                              Math.min(cornerRadius, width / 2, height / 2);
		          }
		          else {
		              topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
		              topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
		              bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
		              bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
		          }
		          context.beginPath();
		          context.moveTo(topLeft, 0);
		          if (pointerDirection === UP) {
		              context.lineTo((width - pointerWidth) / 2, 0);
		              context.lineTo(width / 2, -1 * pointerHeight);
		              context.lineTo((width + pointerWidth) / 2, 0);
		          }
		          context.lineTo(width - topRight, 0);
		          context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
		          if (pointerDirection === RIGHT$1) {
		              context.lineTo(width, (height - pointerHeight) / 2);
		              context.lineTo(width + pointerWidth, height / 2);
		              context.lineTo(width, (height + pointerHeight) / 2);
		          }
		          context.lineTo(width, height - bottomRight);
		          context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
		          if (pointerDirection === DOWN) {
		              context.lineTo((width + pointerWidth) / 2, height);
		              context.lineTo(width / 2, height + pointerHeight);
		              context.lineTo((width - pointerWidth) / 2, height);
		          }
		          context.lineTo(bottomLeft, height);
		          context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
		          if (pointerDirection === LEFT$1) {
		              context.lineTo(0, (height + pointerHeight) / 2);
		              context.lineTo(-1 * pointerWidth, height / 2);
		              context.lineTo(0, (height - pointerHeight) / 2);
		          }
		          context.lineTo(0, topLeft);
		          context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getSelfRect() {
		          var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
		          if (direction === UP) {
		              y -= pointerHeight;
		              height += pointerHeight;
		          }
		          else if (direction === DOWN) {
		              height += pointerHeight;
		          }
		          else if (direction === LEFT$1) {
		              // ARGH!!! I have no idea why should I used magic 1.5!!!!!!!!!
		              x -= pointerWidth * 1.5;
		              width += pointerWidth;
		          }
		          else if (direction === RIGHT$1) {
		              width += pointerWidth * 1.5;
		          }
		          return {
		              x: x,
		              y: y,
		              width: width,
		              height: height,
		          };
		      }
		  }
		  Tag.prototype.className = 'Tag';
		  _registerNode(Tag);
		  /**
		   * get/set pointer direction
		   * @name Konva.Tag#pointerDirection
		   * @method
		   * @param {String} pointerDirection can be up, right, down, left, or none.  The default is none.
		   * @returns {String}
		   * @example
		   * tag.pointerDirection('right');
		   */
		  Factory.addGetterSetter(Tag, 'pointerDirection', NONE$1);
		  /**
		   * get/set pointer width
		   * @name Konva.Tag#pointerWidth
		   * @method
		   * @param {Number} pointerWidth
		   * @returns {Number}
		   * @example
		   * tag.pointerWidth(20);
		   */
		  Factory.addGetterSetter(Tag, 'pointerWidth', 0, getNumberValidator());
		  /**
		   * get/set pointer height
		   * @method
		   * @name Konva.Tag#pointerHeight
		   * @param {Number} pointerHeight
		   * @returns {Number}
		   * @example
		   * tag.pointerHeight(20);
		   */
		  Factory.addGetterSetter(Tag, 'pointerHeight', 0, getNumberValidator());
		  /**
		   * get/set cornerRadius
		   * @name Konva.Tag#cornerRadius
		   * @method
		   * @param {Number} cornerRadius
		   * @returns {Number}
		   * @example
		   * tag.cornerRadius(20);
		   *
		   * // set different corner radius values
		   * // top-left, top-right, bottom-right, bottom-left
		   * tag.cornerRadius([0, 10, 20, 30]);
		   */
		  Factory.addGetterSetter(Tag, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));

		  /**
		   * Rect constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Number} [config.cornerRadius]
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var rect = new Konva.Rect({
		   *   width: 100,
		   *   height: 50,
		   *   fill: 'red',
		   *   stroke: 'black',
		   *   strokeWidth: 5
		   * });
		   */
		  class Rect extends Shape {
		      _sceneFunc(context) {
		          var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
		          context.beginPath();
		          if (!cornerRadius) {
		              // simple rect - don't bother doing all that complicated maths stuff.
		              context.rect(0, 0, width, height);
		          }
		          else {
		              Util.drawRoundedRectPath(context, width, height, cornerRadius);
		          }
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		  }
		  Rect.prototype.className = 'Rect';
		  _registerNode(Rect);
		  /**
		   * get/set corner radius
		   * @method
		   * @name Konva.Rect#cornerRadius
		   * @param {Number} cornerRadius
		   * @returns {Number}
		   * @example
		   * // get corner radius
		   * var cornerRadius = rect.cornerRadius();
		   *
		   * // set corner radius
		   * rect.cornerRadius(10);
		   *
		   * // set different corner radius values
		   * // top-left, top-right, bottom-right, bottom-left
		   * rect.cornerRadius([0, 10, 20, 30]);
		   */
		  Factory.addGetterSetter(Rect, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));

		  /**
		   * RegularPolygon constructor. Examples include triangles, squares, pentagons, hexagons, etc.
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Number} config.sides
		   * @param {Number} config.radius
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var hexagon = new Konva.RegularPolygon({
		   *   x: 100,
		   *   y: 200,
		   *   sides: 6,
		   *   radius: 70,
		   *   fill: 'red',
		   *   stroke: 'black',
		   *   strokeWidth: 4
		   * });
		   */
		  class RegularPolygon extends Shape {
		      _sceneFunc(context) {
		          const points = this._getPoints();
		          context.beginPath();
		          context.moveTo(points[0].x, points[0].y);
		          for (var n = 1; n < points.length; n++) {
		              context.lineTo(points[n].x, points[n].y);
		          }
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      _getPoints() {
		          const sides = this.attrs.sides;
		          const radius = this.attrs.radius || 0;
		          const points = [];
		          for (var n = 0; n < sides; n++) {
		              points.push({
		                  x: radius * Math.sin((n * 2 * Math.PI) / sides),
		                  y: -1 * radius * Math.cos((n * 2 * Math.PI) / sides),
		              });
		          }
		          return points;
		      }
		      getSelfRect() {
		          const points = this._getPoints();
		          var minX = points[0].x;
		          var maxX = points[0].y;
		          var minY = points[0].x;
		          var maxY = points[0].y;
		          points.forEach((point) => {
		              minX = Math.min(minX, point.x);
		              maxX = Math.max(maxX, point.x);
		              minY = Math.min(minY, point.y);
		              maxY = Math.max(maxY, point.y);
		          });
		          return {
		              x: minX,
		              y: minY,
		              width: maxX - minX,
		              height: maxY - minY,
		          };
		      }
		      getWidth() {
		          return this.radius() * 2;
		      }
		      getHeight() {
		          return this.radius() * 2;
		      }
		      setWidth(width) {
		          this.radius(width / 2);
		      }
		      setHeight(height) {
		          this.radius(height / 2);
		      }
		  }
		  RegularPolygon.prototype.className = 'RegularPolygon';
		  RegularPolygon.prototype._centroid = true;
		  RegularPolygon.prototype._attrsAffectingSize = ['radius'];
		  _registerNode(RegularPolygon);
		  /**
		   * get/set radius
		   * @method
		   * @name Konva.RegularPolygon#radius
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get radius
		   * var radius = shape.radius();
		   *
		   * // set radius
		   * shape.radius(10);
		   */
		  Factory.addGetterSetter(RegularPolygon, 'radius', 0, getNumberValidator());
		  /**
		   * get/set sides
		   * @method
		   * @name Konva.RegularPolygon#sides
		   * @param {Number} sides
		   * @returns {Number}
		   * @example
		   * // get sides
		   * var sides = shape.sides();
		   *
		   * // set sides
		   * shape.sides(10);
		   */
		  Factory.addGetterSetter(RegularPolygon, 'sides', 0, getNumberValidator());

		  var PIx2 = Math.PI * 2;
		  /**
		   * Ring constructor
		   * @constructor
		   * @augments Konva.Shape
		   * @memberof Konva
		   * @param {Object} config
		   * @param {Number} config.innerRadius
		   * @param {Number} config.outerRadius
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var ring = new Konva.Ring({
		   *   innerRadius: 40,
		   *   outerRadius: 80,
		   *   fill: 'red',
		   *   stroke: 'black',
		   *   strokeWidth: 5
		   * });
		   */
		  class Ring extends Shape {
		      _sceneFunc(context) {
		          context.beginPath();
		          context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
		          context.moveTo(this.outerRadius(), 0);
		          context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.outerRadius() * 2;
		      }
		      getHeight() {
		          return this.outerRadius() * 2;
		      }
		      setWidth(width) {
		          this.outerRadius(width / 2);
		      }
		      setHeight(height) {
		          this.outerRadius(height / 2);
		      }
		  }
		  Ring.prototype.className = 'Ring';
		  Ring.prototype._centroid = true;
		  Ring.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
		  _registerNode(Ring);
		  /**
		   * get/set innerRadius
		   * @method
		   * @name Konva.Ring#innerRadius
		   * @param {Number} innerRadius
		   * @returns {Number}
		   * @example
		   * // get inner radius
		   * var innerRadius = ring.innerRadius();
		   *
		   * // set inner radius
		   * ring.innerRadius(20);
		   */
		  Factory.addGetterSetter(Ring, 'innerRadius', 0, getNumberValidator());
		  /**
		   * get/set outerRadius
		   * @name Konva.Ring#outerRadius
		   * @method
		   * @param {Number} outerRadius
		   * @returns {Number}
		   * @example
		   * // get outer radius
		   * var outerRadius = ring.outerRadius();
		   *
		   * // set outer radius
		   * ring.outerRadius(20);
		   */
		  Factory.addGetterSetter(Ring, 'outerRadius', 0, getNumberValidator());

		  /**
		   * Sprite constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {String} config.animation animation key
		   * @param {Object} config.animations animation map
		   * @param {Integer} [config.frameIndex] animation frame index
		   * @param {Image} config.image image object
		   * @param {Integer} [config.frameRate] animation frame rate
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var imageObj = new Image();
		   * imageObj.onload = function() {
		   *   var sprite = new Konva.Sprite({
		   *     x: 200,
		   *     y: 100,
		   *     image: imageObj,
		   *     animation: 'standing',
		   *     animations: {
		   *       standing: [
		   *         // x, y, width, height (6 frames)
		   *         0, 0, 49, 109,
		   *         52, 0, 49, 109,
		   *         105, 0, 49, 109,
		   *         158, 0, 49, 109,
		   *         210, 0, 49, 109,
		   *         262, 0, 49, 109
		   *       ],
		   *       kicking: [
		   *         // x, y, width, height (6 frames)
		   *         0, 109, 45, 98,
		   *         45, 109, 45, 98,
		   *         95, 109, 63, 98,
		   *         156, 109, 70, 98,
		   *         229, 109, 60, 98,
		   *         287, 109, 41, 98
		   *       ]
		   *     },
		   *     frameRate: 7,
		   *     frameIndex: 0
		   *   });
		   * };
		   * imageObj.src = '/path/to/image.jpg'
		   */
		  class Sprite extends Shape {
		      constructor(config) {
		          super(config);
		          this._updated = true;
		          this.anim = new Animation(() => {
		              // if we don't need to redraw layer we should return false
		              var updated = this._updated;
		              this._updated = false;
		              return updated;
		          });
		          this.on('animationChange.konva', function () {
		              // reset index when animation changes
		              this.frameIndex(0);
		          });
		          this.on('frameIndexChange.konva', function () {
		              this._updated = true;
		          });
		          // smooth change for frameRate
		          this.on('frameRateChange.konva', function () {
		              if (!this.anim.isRunning()) {
		                  return;
		              }
		              clearInterval(this.interval);
		              this._setInterval();
		          });
		      }
		      _sceneFunc(context) {
		          var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
		          if (this.hasFill() || this.hasStroke()) {
		              context.beginPath();
		              context.rect(0, 0, width, height);
		              context.closePath();
		              context.fillStrokeShape(this);
		          }
		          if (image) {
		              if (offsets) {
		                  var offset = offsets[anim], ix2 = index * 2;
		                  context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
		              }
		              else {
		                  context.drawImage(image, x, y, width, height, 0, 0, width, height);
		              }
		          }
		      }
		      _hitFunc(context) {
		          var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
		          context.beginPath();
		          if (offsets) {
		              var offset = offsets[anim];
		              var ix2 = index * 2;
		              context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
		          }
		          else {
		              context.rect(0, 0, width, height);
		          }
		          context.closePath();
		          context.fillShape(this);
		      }
		      _useBufferCanvas() {
		          return super._useBufferCanvas(true);
		      }
		      _setInterval() {
		          var that = this;
		          this.interval = setInterval(function () {
		              that._updateIndex();
		          }, 1000 / this.frameRate());
		      }
		      /**
		       * start sprite animation
		       * @method
		       * @name Konva.Sprite#start
		       */
		      start() {
		          if (this.isRunning()) {
		              return;
		          }
		          var layer = this.getLayer();
		          /*
		           * animation object has no executable function because
		           *  the updates are done with a fixed FPS with the setInterval
		           *  below.  The anim object only needs the layer reference for
		           *  redraw
		           */
		          this.anim.setLayers(layer);
		          this._setInterval();
		          this.anim.start();
		      }
		      /**
		       * stop sprite animation
		       * @method
		       * @name Konva.Sprite#stop
		       */
		      stop() {
		          this.anim.stop();
		          clearInterval(this.interval);
		      }
		      /**
		       * determine if animation of sprite is running or not.  returns true or false
		       * @method
		       * @name Konva.Sprite#isRunning
		       * @returns {Boolean}
		       */
		      isRunning() {
		          return this.anim.isRunning();
		      }
		      _updateIndex() {
		          var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
		          if (index < len - 1) {
		              this.frameIndex(index + 1);
		          }
		          else {
		              this.frameIndex(0);
		          }
		      }
		  }
		  Sprite.prototype.className = 'Sprite';
		  _registerNode(Sprite);
		  // add getters setters
		  Factory.addGetterSetter(Sprite, 'animation');
		  /**
		   * get/set animation key
		   * @name Konva.Sprite#animation
		   * @method
		   * @param {String} anim animation key
		   * @returns {String}
		   * @example
		   * // get animation key
		   * var animation = sprite.animation();
		   *
		   * // set animation key
		   * sprite.animation('kicking');
		   */
		  Factory.addGetterSetter(Sprite, 'animations');
		  /**
		   * get/set animations map
		   * @name Konva.Sprite#animations
		   * @method
		   * @param {Object} animations
		   * @returns {Object}
		   * @example
		   * // get animations map
		   * var animations = sprite.animations();
		   *
		   * // set animations map
		   * sprite.animations({
		   *   standing: [
		   *     // x, y, width, height (6 frames)
		   *     0, 0, 49, 109,
		   *     52, 0, 49, 109,
		   *     105, 0, 49, 109,
		   *     158, 0, 49, 109,
		   *     210, 0, 49, 109,
		   *     262, 0, 49, 109
		   *   ],
		   *   kicking: [
		   *     // x, y, width, height (6 frames)
		   *     0, 109, 45, 98,
		   *     45, 109, 45, 98,
		   *     95, 109, 63, 98,
		   *     156, 109, 70, 98,
		   *     229, 109, 60, 98,
		   *     287, 109, 41, 98
		   *   ]
		   * });
		   */
		  Factory.addGetterSetter(Sprite, 'frameOffsets');
		  /**
		   * get/set offsets map
		   * @name Konva.Sprite#offsets
		   * @method
		   * @param {Object} offsets
		   * @returns {Object}
		   * @example
		   * // get offsets map
		   * var offsets = sprite.offsets();
		   *
		   * // set offsets map
		   * sprite.offsets({
		   *   standing: [
		   *     // x, y (6 frames)
		   *     0, 0,
		   *     0, 0,
		   *     5, 0,
		   *     0, 0,
		   *     0, 3,
		   *     2, 0
		   *   ],
		   *   kicking: [
		   *     // x, y (6 frames)
		   *     0, 5,
		   *     5, 0,
		   *     10, 0,
		   *     0, 0,
		   *     2, 1,
		   *     0, 0
		   *   ]
		   * });
		   */
		  Factory.addGetterSetter(Sprite, 'image');
		  /**
		   * get/set image
		   * @name Konva.Sprite#image
		   * @method
		   * @param {Image} image
		   * @returns {Image}
		   * @example
		   * // get image
		   * var image = sprite.image();
		   *
		   * // set image
		   * sprite.image(imageObj);
		   */
		  Factory.addGetterSetter(Sprite, 'frameIndex', 0, getNumberValidator());
		  /**
		   * set/set animation frame index
		   * @name Konva.Sprite#frameIndex
		   * @method
		   * @param {Integer} frameIndex
		   * @returns {Integer}
		   * @example
		   * // get animation frame index
		   * var frameIndex = sprite.frameIndex();
		   *
		   * // set animation frame index
		   * sprite.frameIndex(3);
		   */
		  Factory.addGetterSetter(Sprite, 'frameRate', 17, getNumberValidator());
		  /**
		   * get/set frame rate in frames per second.  Increase this number to make the sprite
		   *  animation run faster, and decrease the number to make the sprite animation run slower
		   *  The default is 17 frames per second
		   * @name Konva.Sprite#frameRate
		   * @method
		   * @param {Integer} frameRate
		   * @returns {Integer}
		   * @example
		   * // get frame rate
		   * var frameRate = sprite.frameRate();
		   *
		   * // set frame rate to 2 frames per second
		   * sprite.frameRate(2);
		   */
		  Factory.backCompat(Sprite, {
		      index: 'frameIndex',
		      getIndex: 'getFrameIndex',
		      setIndex: 'setFrameIndex',
		  });

		  /**
		   * Star constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Integer} config.numPoints
		   * @param {Number} config.innerRadius
		   * @param {Number} config.outerRadius
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var star = new Konva.Star({
		   *   x: 100,
		   *   y: 200,
		   *   numPoints: 5,
		   *   innerRadius: 70,
		   *   outerRadius: 70,
		   *   fill: 'red',
		   *   stroke: 'black',
		   *   strokeWidth: 4
		   * });
		   */
		  class Star extends Shape {
		      _sceneFunc(context) {
		          var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
		          context.beginPath();
		          context.moveTo(0, 0 - outerRadius);
		          for (var n = 1; n < numPoints * 2; n++) {
		              var radius = n % 2 === 0 ? outerRadius : innerRadius;
		              var x = radius * Math.sin((n * Math.PI) / numPoints);
		              var y = -1 * radius * Math.cos((n * Math.PI) / numPoints);
		              context.lineTo(x, y);
		          }
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.outerRadius() * 2;
		      }
		      getHeight() {
		          return this.outerRadius() * 2;
		      }
		      setWidth(width) {
		          this.outerRadius(width / 2);
		      }
		      setHeight(height) {
		          this.outerRadius(height / 2);
		      }
		  }
		  Star.prototype.className = 'Star';
		  Star.prototype._centroid = true;
		  Star.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
		  _registerNode(Star);
		  /**
		   * get/set number of points
		   * @name Konva.Star#numPoints
		   * @method
		   * @param {Number} numPoints
		   * @returns {Number}
		   * @example
		   * // get inner radius
		   * var numPoints = star.numPoints();
		   *
		   * // set inner radius
		   * star.numPoints(20);
		   */
		  Factory.addGetterSetter(Star, 'numPoints', 5, getNumberValidator());
		  /**
		   * get/set innerRadius
		   * @name Konva.Star#innerRadius
		   * @method
		   * @param {Number} innerRadius
		   * @returns {Number}
		   * @example
		   * // get inner radius
		   * var innerRadius = star.innerRadius();
		   *
		   * // set inner radius
		   * star.innerRadius(20);
		   */
		  Factory.addGetterSetter(Star, 'innerRadius', 0, getNumberValidator());
		  /**
		   * get/set outerRadius
		   * @name Konva.Star#outerRadius
		   * @method
		   * @param {Number} outerRadius
		   * @returns {Number}
		   * @example
		   * // get inner radius
		   * var outerRadius = star.outerRadius();
		   *
		   * // set inner radius
		   * star.outerRadius(20);
		   */
		  Factory.addGetterSetter(Star, 'outerRadius', 0, getNumberValidator());

		  function stringToArray(string) {
		      // we need to use `Array.from` because it can split unicode string correctly
		      // we also can use some regexp magic from lodash:
		      // https://github.com/lodash/lodash/blob/fb1f99d9d90ad177560d771bc5953a435b2dc119/lodash.toarray/index.js#L256
		      // but I decided it is too much code for that small fix
		      return Array.from(string);
		  }
		  // constants
		  var AUTO = 'auto', 
		  //CANVAS = 'canvas',
		  CENTER = 'center', INHERIT = 'inherit', JUSTIFY = 'justify', CHANGE_KONVA = 'Change.konva', CONTEXT_2D = '2d', DASH = '-', LEFT = 'left', TEXT = 'text', TEXT_UPPER = 'Text', TOP = 'top', BOTTOM = 'bottom', MIDDLE = 'middle', NORMAL$1 = 'normal', PX_SPACE = 'px ', SPACE = ' ', RIGHT = 'right', RTL = 'rtl', WORD = 'word', CHAR = 'char', NONE = 'none', ELLIPSIS = '…', ATTR_CHANGE_LIST$1 = [
		      'direction',
		      'fontFamily',
		      'fontSize',
		      'fontStyle',
		      'fontVariant',
		      'padding',
		      'align',
		      'verticalAlign',
		      'lineHeight',
		      'text',
		      'width',
		      'height',
		      'wrap',
		      'ellipsis',
		      'letterSpacing',
		  ], 
		  // cached variables
		  attrChangeListLen = ATTR_CHANGE_LIST$1.length;
		  function normalizeFontFamily(fontFamily) {
		      return fontFamily
		          .split(',')
		          .map((family) => {
		          family = family.trim();
		          const hasSpace = family.indexOf(' ') >= 0;
		          const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
		          if (hasSpace && !hasQuotes) {
		              family = `"${family}"`;
		          }
		          return family;
		      })
		          .join(', ');
		  }
		  var dummyContext;
		  function getDummyContext() {
		      if (dummyContext) {
		          return dummyContext;
		      }
		      dummyContext = Util.createCanvasElement().getContext(CONTEXT_2D);
		      return dummyContext;
		  }
		  function _fillFunc$1(context) {
		      context.fillText(this._partialText, this._partialTextX, this._partialTextY);
		  }
		  function _strokeFunc$1(context) {
		      context.setAttr('miterLimit', 2);
		      context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
		  }
		  function checkDefaultFill(config) {
		      config = config || {};
		      // set default color to black
		      if (!config.fillLinearGradientColorStops &&
		          !config.fillRadialGradientColorStops &&
		          !config.fillPatternImage) {
		          config.fill = config.fill || 'black';
		      }
		      return config;
		  }
		  /**
		   * Text constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {String} [config.direction] default is inherit
		   * @param {String} [config.fontFamily] default is Arial
		   * @param {Number} [config.fontSize] in pixels.  Default is 12
		   * @param {String} [config.fontStyle] can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
		   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
		   * @param {String} [config.textDecoration] can be line-through, underline or empty string. Default is empty string.
		   * @param {String} config.text
		   * @param {String} [config.align] can be left, center, or right
		   * @param {String} [config.verticalAlign] can be top, middle or bottom
		   * @param {Number} [config.padding]
		   * @param {Number} [config.lineHeight] default is 1
		   * @param {String} [config.wrap] can be "word", "char", or "none". Default is word
		   * @param {Boolean} [config.ellipsis] can be true or false. Default is false. if Konva.Text config is set to wrap="none" and ellipsis=true, then it will add "..." to the end
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var text = new Konva.Text({
		   *   x: 10,
		   *   y: 15,
		   *   text: 'Simple Text',
		   *   fontSize: 30,
		   *   fontFamily: 'Calibri',
		   *   fill: 'green'
		   * });
		   */
		  class Text extends Shape {
		      constructor(config) {
		          super(checkDefaultFill(config));
		          this._partialTextX = 0;
		          this._partialTextY = 0;
		          // update text data for certain attr changes
		          for (var n = 0; n < attrChangeListLen; n++) {
		              this.on(ATTR_CHANGE_LIST$1[n] + CHANGE_KONVA, this._setTextData);
		          }
		          this._setTextData();
		      }
		      _sceneFunc(context) {
		          var textArr = this.textArr, textArrLen = textArr.length;
		          if (!this.text()) {
		              return;
		          }
		          var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
		          direction = direction === INHERIT ? context.direction : direction;
		          var translateY = 0;
		          var translateY = lineHeightPx / 2;
		          var lineTranslateX = 0;
		          var lineTranslateY = 0;
		          if (direction === RTL) {
		              context.setAttr('direction', direction);
		          }
		          context.setAttr('font', this._getContextFont());
		          context.setAttr('textBaseline', MIDDLE);
		          context.setAttr('textAlign', LEFT);
		          // handle vertical alignment
		          if (verticalAlign === MIDDLE) {
		              alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
		          }
		          else if (verticalAlign === BOTTOM) {
		              alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
		          }
		          context.translate(padding, alignY + padding);
		          // draw text lines
		          for (n = 0; n < textArrLen; n++) {
		              var lineTranslateX = 0;
		              var lineTranslateY = 0;
		              var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
		              // horizontal alignment
		              context.save();
		              if (align === RIGHT) {
		                  lineTranslateX += totalWidth - width - padding * 2;
		              }
		              else if (align === CENTER) {
		                  lineTranslateX += (totalWidth - width - padding * 2) / 2;
		              }
		              if (shouldUnderline) {
		                  context.save();
		                  context.beginPath();
		                  context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
		                  spacesNumber = text.split(' ').length - 1;
		                  oneWord = spacesNumber === 0;
		                  lineWidth =
		                      align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
		                  context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
		                  // I have no idea what is real ratio
		                  // just /15 looks good enough
		                  context.lineWidth = fontSize / 15;
		                  const gradient = this._getLinearGradient();
		                  context.strokeStyle = gradient || fill;
		                  context.stroke();
		                  context.restore();
		              }
		              if (shouldLineThrough) {
		                  context.save();
		                  context.beginPath();
		                  context.moveTo(lineTranslateX, translateY + lineTranslateY);
		                  spacesNumber = text.split(' ').length - 1;
		                  oneWord = spacesNumber === 0;
		                  lineWidth =
		                      align === JUSTIFY && lastLine && !oneWord
		                          ? totalWidth - padding * 2
		                          : width;
		                  context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
		                  context.lineWidth = fontSize / 15;
		                  const gradient = this._getLinearGradient();
		                  context.strokeStyle = gradient || fill;
		                  context.stroke();
		                  context.restore();
		              }
		              // As `letterSpacing` isn't supported on Safari, we use this polyfill.
		              // The exception is for RTL text, which we rely on native as it cannot
		              // be supported otherwise.
		              if (direction !== RTL && (letterSpacing !== 0 || align === JUSTIFY)) {
		                  //   var words = text.split(' ');
		                  spacesNumber = text.split(' ').length - 1;
		                  var array = stringToArray(text);
		                  for (var li = 0; li < array.length; li++) {
		                      var letter = array[li];
		                      // skip justify for the last line
		                      if (letter === ' ' && !lastLine && align === JUSTIFY) {
		                          lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
		                          // context.translate(
		                          //   Math.floor((totalWidth - padding * 2 - width) / spacesNumber),
		                          //   0
		                          // );
		                      }
		                      this._partialTextX = lineTranslateX;
		                      this._partialTextY = translateY + lineTranslateY;
		                      this._partialText = letter;
		                      context.fillStrokeShape(this);
		                      lineTranslateX += this.measureSize(letter).width + letterSpacing;
		                  }
		              }
		              else {
		                  if (letterSpacing !== 0) {
		                      context.setAttr('letterSpacing', `${letterSpacing}px`);
		                  }
		                  this._partialTextX = lineTranslateX;
		                  this._partialTextY = translateY + lineTranslateY;
		                  this._partialText = text;
		                  context.fillStrokeShape(this);
		              }
		              context.restore();
		              if (textArrLen > 1) {
		                  translateY += lineHeightPx;
		              }
		          }
		      }
		      _hitFunc(context) {
		          var width = this.getWidth(), height = this.getHeight();
		          context.beginPath();
		          context.rect(0, 0, width, height);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      setText(text) {
		          var str = Util._isString(text)
		              ? text
		              : text === null || text === undefined
		                  ? ''
		                  : text + '';
		          this._setAttr(TEXT, str);
		          return this;
		      }
		      getWidth() {
		          var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
		          return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
		      }
		      getHeight() {
		          var isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;
		          return isAuto
		              ? this.fontSize() * this.textArr.length * this.lineHeight() +
		                  this.padding() * 2
		              : this.attrs.height;
		      }
		      /**
		       * get pure text width without padding
		       * @method
		       * @name Konva.Text#getTextWidth
		       * @returns {Number}
		       */
		      getTextWidth() {
		          return this.textWidth;
		      }
		      getTextHeight() {
		          Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
		          return this.textHeight;
		      }
		      /**
		       * measure string with the font of current text shape.
		       * That method can't handle multiline text.
		       * @method
		       * @name Konva.Text#measureSize
		       * @param {String} [text] text to measure
		       * @returns {Object} { width , height} of measured text
		       */
		      measureSize(text) {
		          var _context = getDummyContext(), fontSize = this.fontSize(), metrics;
		          _context.save();
		          _context.font = this._getContextFont();
		          metrics = _context.measureText(text);
		          _context.restore();
		          return {
		              width: metrics.width,
		              height: fontSize,
		          };
		      }
		      _getContextFont() {
		          return (this.fontStyle() +
		              SPACE +
		              this.fontVariant() +
		              SPACE +
		              (this.fontSize() + PX_SPACE) +
		              // wrap font family into " so font families with spaces works ok
		              normalizeFontFamily(this.fontFamily()));
		      }
		      _addTextLine(line) {
		          const align = this.align();
		          if (align === JUSTIFY) {
		              line = line.trim();
		          }
		          var width = this._getTextWidth(line);
		          return this.textArr.push({
		              text: line,
		              width: width,
		              lastInParagraph: false,
		          });
		      }
		      _getTextWidth(text) {
		          var letterSpacing = this.letterSpacing();
		          var length = text.length;
		          return (getDummyContext().measureText(text).width +
		              (length ? letterSpacing * (length - 1) : 0));
		      }
		      _setTextData() {
		          var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== undefined, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), 
		          // align = this.align(),
		          shouldWrap = wrap !== NONE, wrapAtWord = wrap !== CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
		          this.textArr = [];
		          getDummyContext().font = this._getContextFont();
		          var additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;
		          for (var i = 0, max = lines.length; i < max; ++i) {
		              var line = lines[i];
		              var lineWidth = this._getTextWidth(line);
		              if (fixedWidth && lineWidth > maxWidth) {
		                  /*
		                   * if width is fixed and line does not fit entirely
		                   * break the line into multiple fitting lines
		                   */
		                  while (line.length > 0) {
		                      /*
		                       * use binary search to find the longest substring that
		                       * that would fit in the specified width
		                       */
		                      var low = 0, high = line.length, match = '', matchWidth = 0;
		                      while (low < high) {
		                          var mid = (low + high) >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
		                          if (substrWidth <= maxWidth) {
		                              low = mid + 1;
		                              match = substr;
		                              matchWidth = substrWidth;
		                          }
		                          else {
		                              high = mid;
		                          }
		                      }
		                      /*
		                       * 'low' is now the index of the substring end
		                       * 'match' is the substring
		                       * 'matchWidth' is the substring width in px
		                       */
		                      if (match) {
		                          // a fitting substring was found
		                          if (wrapAtWord) {
		                              // try to find a space or dash where wrapping could be done
		                              var wrapIndex;
		                              var nextChar = line[match.length];
		                              var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
		                              if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
		                                  wrapIndex = match.length;
		                              }
		                              else {
		                                  wrapIndex =
		                                      Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
		                                          1;
		                              }
		                              if (wrapIndex > 0) {
		                                  // re-cut the substring found at the space/dash position
		                                  low = wrapIndex;
		                                  match = match.slice(0, low);
		                                  matchWidth = this._getTextWidth(match);
		                              }
		                          }
		                          // if (align === 'right') {
		                          match = match.trimRight();
		                          // }
		                          this._addTextLine(match);
		                          textWidth = Math.max(textWidth, matchWidth);
		                          currentHeightPx += lineHeightPx;
		                          var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
		                          if (shouldHandleEllipsis) {
		                              this._tryToAddEllipsisToLastLine();
		                              /*
		                               * stop wrapping if wrapping is disabled or if adding
		                               * one more line would overflow the fixed height
		                               */
		                              break;
		                          }
		                          line = line.slice(low);
		                          line = line.trimLeft();
		                          if (line.length > 0) {
		                              // Check if the remaining text would fit on one line
		                              lineWidth = this._getTextWidth(line);
		                              if (lineWidth <= maxWidth) {
		                                  // if it does, add the line and break out of the loop
		                                  this._addTextLine(line);
		                                  currentHeightPx += lineHeightPx;
		                                  textWidth = Math.max(textWidth, lineWidth);
		                                  break;
		                              }
		                          }
		                      }
		                      else {
		                          // not even one character could fit in the element, abort
		                          break;
		                      }
		                  }
		              }
		              else {
		                  // element width is automatically adjusted to max line width
		                  this._addTextLine(line);
		                  currentHeightPx += lineHeightPx;
		                  textWidth = Math.max(textWidth, lineWidth);
		                  if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) {
		                      this._tryToAddEllipsisToLastLine();
		                  }
		              }
		              // if element height is fixed, abort if adding one more line would overflow
		              if (this.textArr[this.textArr.length - 1]) {
		                  this.textArr[this.textArr.length - 1].lastInParagraph = true;
		              }
		              if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
		                  break;
		              }
		          }
		          this.textHeight = fontSize;
		          // var maxTextWidth = 0;
		          // for(var j = 0; j < this.textArr.length; j++) {
		          //     maxTextWidth = Math.max(maxTextWidth, this.textArr[j].width);
		          // }
		          this.textWidth = textWidth;
		      }
		      /**
		       * whether to handle ellipsis, there are two cases:
		       * 1. the current line is the last line
		       * 2. wrap is NONE
		       * @param {Number} currentHeightPx
		       * @returns
		       */
		      _shouldHandleEllipsis(currentHeightPx) {
		          var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== NONE;
		          return (!shouldWrap ||
		              (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx));
		      }
		      _tryToAddEllipsisToLastLine() {
		          var width = this.attrs.width, fixedWidth = width !== AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
		          var lastLine = this.textArr[this.textArr.length - 1];
		          if (!lastLine || !shouldAddEllipsis) {
		              return;
		          }
		          if (fixedWidth) {
		              var haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;
		              if (!haveSpace) {
		                  lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
		              }
		          }
		          this.textArr.splice(this.textArr.length - 1, 1);
		          this._addTextLine(lastLine.text + ELLIPSIS);
		      }
		      // for text we can't disable stroke scaling
		      // if we do, the result will be unexpected
		      getStrokeScaleEnabled() {
		          return true;
		      }
		      _useBufferCanvas() {
		          const hasLine = this.textDecoration().indexOf('underline') !== -1 ||
		              this.textDecoration().indexOf('line-through') !== -1;
		          const hasShadow = this.hasShadow();
		          if (hasLine && hasShadow) {
		              return true;
		          }
		          return super._useBufferCanvas();
		      }
		  }
		  Text.prototype._fillFunc = _fillFunc$1;
		  Text.prototype._strokeFunc = _strokeFunc$1;
		  Text.prototype.className = TEXT_UPPER;
		  Text.prototype._attrsAffectingSize = [
		      'text',
		      'fontSize',
		      'padding',
		      'wrap',
		      'lineHeight',
		      'letterSpacing',
		  ];
		  _registerNode(Text);
		  /**
		   * get/set width of text area, which includes padding.
		   * @name Konva.Text#width
		   * @method
		   * @param {Number} width
		   * @returns {Number}
		   * @example
		   * // get width
		   * var width = text.width();
		   *
		   * // set width
		   * text.width(20);
		   *
		   * // set to auto
		   * text.width('auto');
		   * text.width() // will return calculated width, and not "auto"
		   */
		  Factory.overWriteSetter(Text, 'width', getNumberOrAutoValidator());
		  /**
		   * get/set the height of the text area, which takes into account multi-line text, line heights, and padding.
		   * @name Konva.Text#height
		   * @method
		   * @param {Number} height
		   * @returns {Number}
		   * @example
		   * // get height
		   * var height = text.height();
		   *
		   * // set height
		   * text.height(20);
		   *
		   * // set to auto
		   * text.height('auto');
		   * text.height() // will return calculated height, and not "auto"
		   */
		  Factory.overWriteSetter(Text, 'height', getNumberOrAutoValidator());
		  /**
		   * get/set direction
		   * @name Konva.Text#direction
		   * @method
		   * @param {String} direction
		   * @returns {String}
		   * @example
		   * // get direction
		   * var direction = text.direction();
		   *
		   * // set direction
		   * text.direction('rtl');
		   */
		  Factory.addGetterSetter(Text, 'direction', INHERIT);
		  /**
		   * get/set font family
		   * @name Konva.Text#fontFamily
		   * @method
		   * @param {String} fontFamily
		   * @returns {String}
		   * @example
		   * // get font family
		   * var fontFamily = text.fontFamily();
		   *
		   * // set font family
		   * text.fontFamily('Arial');
		   */
		  Factory.addGetterSetter(Text, 'fontFamily', 'Arial');
		  /**
		   * get/set font size in pixels
		   * @name Konva.Text#fontSize
		   * @method
		   * @param {Number} fontSize
		   * @returns {Number}
		   * @example
		   * // get font size
		   * var fontSize = text.fontSize();
		   *
		   * // set font size to 22px
		   * text.fontSize(22);
		   */
		  Factory.addGetterSetter(Text, 'fontSize', 12, getNumberValidator());
		  /**
		   * get/set font style.  Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
		   * @name Konva.Text#fontStyle
		   * @method
		   * @param {String} fontStyle
		   * @returns {String}
		   * @example
		   * // get font style
		   * var fontStyle = text.fontStyle();
		   *
		   * // set font style
		   * text.fontStyle('bold');
		   */
		  Factory.addGetterSetter(Text, 'fontStyle', NORMAL$1);
		  /**
		   * get/set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
		   * @name Konva.Text#fontVariant
		   * @method
		   * @param {String} fontVariant
		   * @returns {String}
		   * @example
		   * // get font variant
		   * var fontVariant = text.fontVariant();
		   *
		   * // set font variant
		   * text.fontVariant('small-caps');
		   */
		  Factory.addGetterSetter(Text, 'fontVariant', NORMAL$1);
		  /**
		   * get/set padding
		   * @name Konva.Text#padding
		   * @method
		   * @param {Number} padding
		   * @returns {Number}
		   * @example
		   * // get padding
		   * var padding = text.padding();
		   *
		   * // set padding to 10 pixels
		   * text.padding(10);
		   */
		  Factory.addGetterSetter(Text, 'padding', 0, getNumberValidator());
		  /**
		   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
		   * @name Konva.Text#align
		   * @method
		   * @param {String} align
		   * @returns {String}
		   * @example
		   * // get text align
		   * var align = text.align();
		   *
		   * // center text
		   * text.align('center');
		   *
		   * // align text to right
		   * text.align('right');
		   */
		  Factory.addGetterSetter(Text, 'align', LEFT);
		  /**
		   * get/set vertical align of text.  Can be 'top', 'middle', 'bottom'.
		   * @name Konva.Text#verticalAlign
		   * @method
		   * @param {String} verticalAlign
		   * @returns {String}
		   * @example
		   * // get text vertical align
		   * var verticalAlign = text.verticalAlign();
		   *
		   * // center text
		   * text.verticalAlign('middle');
		   */
		  Factory.addGetterSetter(Text, 'verticalAlign', TOP);
		  /**
		   * get/set line height.  The default is 1.
		   * @name Konva.Text#lineHeight
		   * @method
		   * @param {Number} lineHeight
		   * @returns {Number}
		   * @example
		   * // get line height
		   * var lineHeight = text.lineHeight();
		   *
		   * // set the line height
		   * text.lineHeight(2);
		   */
		  Factory.addGetterSetter(Text, 'lineHeight', 1, getNumberValidator());
		  /**
		   * get/set wrap.  Can be "word", "char", or "none". Default is "word".
		   * In "word" wrapping any word still can be wrapped if it can't be placed in the required width
		   * without breaks.
		   * @name Konva.Text#wrap
		   * @method
		   * @param {String} wrap
		   * @returns {String}
		   * @example
		   * // get wrap
		   * var wrap = text.wrap();
		   *
		   * // set wrap
		   * text.wrap('word');
		   */
		  Factory.addGetterSetter(Text, 'wrap', WORD);
		  /**
		   * get/set ellipsis. Can be true or false. Default is false. If ellipses is true,
		   * Konva will add "..." at the end of the text if it doesn't have enough space to write characters.
		   * That is possible only when you limit both width and height of the text
		   * @name Konva.Text#ellipsis
		   * @method
		   * @param {Boolean} ellipsis
		   * @returns {Boolean}
		   * @example
		   * // get ellipsis param, returns true or false
		   * var ellipsis = text.ellipsis();
		   *
		   * // set ellipsis
		   * text.ellipsis(true);
		   */
		  Factory.addGetterSetter(Text, 'ellipsis', false, getBooleanValidator());
		  /**
		   * set letter spacing property. Default value is 0.
		   * @name Konva.Text#letterSpacing
		   * @method
		   * @param {Number} letterSpacing
		   */
		  Factory.addGetterSetter(Text, 'letterSpacing', 0, getNumberValidator());
		  /**
		   * get/set text
		   * @name Konva.Text#text
		   * @method
		   * @param {String} text
		   * @returns {String}
		   * @example
		   * // get text
		   * var text = text.text();
		   *
		   * // set text
		   * text.text('Hello world!');
		   */
		  Factory.addGetterSetter(Text, 'text', '', getStringValidator());
		  /**
		   * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
		   * @name Konva.Text#textDecoration
		   * @method
		   * @param {String} textDecoration
		   * @returns {String}
		   * @example
		   * // get text decoration
		   * var textDecoration = text.textDecoration();
		   *
		   * // underline text
		   * text.textDecoration('underline');
		   *
		   * // strike text
		   * text.textDecoration('line-through');
		   *
		   * // underline and strike text
		   * text.textDecoration('underline line-through');
		   */
		  Factory.addGetterSetter(Text, 'textDecoration', '');

		  var EMPTY_STRING = '', NORMAL = 'normal';
		  function _fillFunc(context) {
		      context.fillText(this.partialText, 0, 0);
		  }
		  function _strokeFunc(context) {
		      context.strokeText(this.partialText, 0, 0);
		  }
		  /**
		   * Path constructor.
		   * @author Jason Follas
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {String} [config.fontFamily] default is Arial
		   * @param {Number} [config.fontSize] default is 12
		   * @param {String} [config.fontStyle] Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
		   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
		   * @param {String} [config.textBaseline] Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'. Default is middle
		   * @param {String} config.text
		   * @param {String} config.data SVG data string
		   * @param {Function} config.kerningFunc a getter for kerning values for the specified characters
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * var kerningPairs = {
		   *   'A': {
		   *     ' ': -0.05517578125,
		   *     'T': -0.07421875,
		   *     'V': -0.07421875
		   *   }
		   *   'V': {
		   *     ',': -0.091796875,
		   *     ":": -0.037109375,
		   *     ";": -0.037109375,
		   *     "A": -0.07421875
		   *   }
		   * }
		   * var textpath = new Konva.TextPath({
		   *   x: 100,
		   *   y: 50,
		   *   fill: '#333',
		   *   fontSize: '24',
		   *   fontFamily: 'Arial',
		   *   text: 'All the world\'s a stage, and all the men and women merely players.',
		   *   data: 'M10,10 C0,0 10,150 100,100 S300,150 400,50',
		   *   kerningFunc(leftChar, rightChar) {
		   *     return kerningPairs.hasOwnProperty(leftChar) ? pairs[leftChar][rightChar] || 0 : 0
		   *   }
		   * });
		   */
		  class TextPath extends Shape {
		      constructor(config) {
		          // call super constructor
		          super(config);
		          this.dummyCanvas = Util.createCanvasElement();
		          this.dataArray = [];
		          this._readDataAttribute();
		          this.on('dataChange.konva', function () {
		              this._readDataAttribute();
		              this._setTextData();
		          });
		          // update text data for certain attr changes
		          this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
		          this._setTextData();
		      }
		      _getTextPathLength() {
		          return Path.getPathLength(this.dataArray);
		      }
		      _getPointAtLength(length) {
		          // if path is not defined yet, do nothing
		          if (!this.attrs.data) {
		              return null;
		          }
		          const totalLength = this.pathLength;
		          // -1px for rounding of the last symbol
		          if (length - 1 > totalLength) {
		              return null;
		          }
		          return Path.getPointAtLengthOfDataArray(length, this.dataArray);
		      }
		      _readDataAttribute() {
		          this.dataArray = Path.parsePathData(this.attrs.data);
		          this.pathLength = this._getTextPathLength();
		      }
		      _sceneFunc(context) {
		          context.setAttr('font', this._getContextFont());
		          context.setAttr('textBaseline', this.textBaseline());
		          context.setAttr('textAlign', 'left');
		          context.save();
		          var textDecoration = this.textDecoration();
		          var fill = this.fill();
		          var fontSize = this.fontSize();
		          var glyphInfo = this.glyphInfo;
		          if (textDecoration === 'underline') {
		              context.beginPath();
		          }
		          for (var i = 0; i < glyphInfo.length; i++) {
		              context.save();
		              var p0 = glyphInfo[i].p0;
		              context.translate(p0.x, p0.y);
		              context.rotate(glyphInfo[i].rotation);
		              this.partialText = glyphInfo[i].text;
		              context.fillStrokeShape(this);
		              if (textDecoration === 'underline') {
		                  if (i === 0) {
		                      context.moveTo(0, fontSize / 2 + 1);
		                  }
		                  context.lineTo(fontSize, fontSize / 2 + 1);
		              }
		              context.restore();
		              //// To assist with debugging visually, uncomment following
		              //
		              // if (i % 2) context.strokeStyle = 'cyan';
		              // else context.strokeStyle = 'green';
		              // var p1 = glyphInfo[i].p1;
		              // context.moveTo(p0.x, p0.y);
		              // context.lineTo(p1.x, p1.y);
		              // context.stroke();
		          }
		          if (textDecoration === 'underline') {
		              context.strokeStyle = fill;
		              context.lineWidth = fontSize / 20;
		              context.stroke();
		          }
		          context.restore();
		      }
		      _hitFunc(context) {
		          context.beginPath();
		          var glyphInfo = this.glyphInfo;
		          if (glyphInfo.length >= 1) {
		              var p0 = glyphInfo[0].p0;
		              context.moveTo(p0.x, p0.y);
		          }
		          for (var i = 0; i < glyphInfo.length; i++) {
		              var p1 = glyphInfo[i].p1;
		              context.lineTo(p1.x, p1.y);
		          }
		          context.setAttr('lineWidth', this.fontSize());
		          context.setAttr('strokeStyle', this.colorKey);
		          context.stroke();
		      }
		      /**
		       * get text width in pixels
		       * @method
		       * @name Konva.TextPath#getTextWidth
		       */
		      getTextWidth() {
		          return this.textWidth;
		      }
		      getTextHeight() {
		          Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
		          return this.textHeight;
		      }
		      setText(text) {
		          return Text.prototype.setText.call(this, text);
		      }
		      _getContextFont() {
		          return Text.prototype._getContextFont.call(this);
		      }
		      _getTextSize(text) {
		          var dummyCanvas = this.dummyCanvas;
		          var _context = dummyCanvas.getContext('2d');
		          _context.save();
		          _context.font = this._getContextFont();
		          var metrics = _context.measureText(text);
		          _context.restore();
		          return {
		              width: metrics.width,
		              height: parseInt(`${this.fontSize()}`, 10),
		          };
		      }
		      _setTextData() {
		          const { width, height } = this._getTextSize(this.attrs.text);
		          this.textWidth = width;
		          this.textHeight = height;
		          this.glyphInfo = [];
		          if (!this.attrs.data) {
		              return null;
		          }
		          const letterSpacing = this.letterSpacing();
		          const align = this.align();
		          const kerningFunc = this.kerningFunc();
		          // defines the width of the text on a straight line
		          const textWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
		          let offset = 0;
		          if (align === 'center') {
		              offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
		          }
		          if (align === 'right') {
		              offset = Math.max(0, this.pathLength - textWidth);
		          }
		          const charArr = stringToArray(this.text());
		          // Algorithm for calculating glyph positions:
		          // 1. Get the begging point of the glyph on the path using the offsetToGlyph,
		          // 2. Get the ending point of the glyph on the path using the offsetToGlyph plus glyph width,
		          // 3. Calculate the rotation, width, and midpoint of the glyph using the start and end points,
		          // 4. Add glyph width to the offsetToGlyph and repeat
		          let offsetToGlyph = offset;
		          for (var i = 0; i < charArr.length; i++) {
		              const charStartPoint = this._getPointAtLength(offsetToGlyph);
		              if (!charStartPoint)
		                  return;
		              let glyphWidth = this._getTextSize(charArr[i]).width + letterSpacing;
		              if (charArr[i] === ' ' && align === 'justify') {
		                  const numberOfSpaces = this.text().split(' ').length - 1;
		                  glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
		              }
		              const charEndPoint = this._getPointAtLength(offsetToGlyph + glyphWidth);
		              if (!charEndPoint)
		                  return;
		              const width = Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
		              let kern = 0;
		              if (kerningFunc) {
		                  try {
		                      // getKerning is a user provided getter. Make sure it never breaks our logic
		                      kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
		                  }
		                  catch (e) {
		                      kern = 0;
		                  }
		              }
		              charStartPoint.x += kern;
		              charEndPoint.x += kern;
		              this.textWidth += kern;
		              const midpoint = Path.getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
		              const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
		              this.glyphInfo.push({
		                  transposeX: midpoint.x,
		                  transposeY: midpoint.y,
		                  text: charArr[i],
		                  rotation: rotation,
		                  p0: charStartPoint,
		                  p1: charEndPoint,
		              });
		              offsetToGlyph += glyphWidth;
		          }
		      }
		      getSelfRect() {
		          if (!this.glyphInfo.length) {
		              return {
		                  x: 0,
		                  y: 0,
		                  width: 0,
		                  height: 0,
		              };
		          }
		          var points = [];
		          this.glyphInfo.forEach(function (info) {
		              points.push(info.p0.x);
		              points.push(info.p0.y);
		              points.push(info.p1.x);
		              points.push(info.p1.y);
		          });
		          var minX = points[0] || 0;
		          var maxX = points[0] || 0;
		          var minY = points[1] || 0;
		          var maxY = points[1] || 0;
		          var x, y;
		          for (var i = 0; i < points.length / 2; i++) {
		              x = points[i * 2];
		              y = points[i * 2 + 1];
		              minX = Math.min(minX, x);
		              maxX = Math.max(maxX, x);
		              minY = Math.min(minY, y);
		              maxY = Math.max(maxY, y);
		          }
		          var fontSize = this.fontSize();
		          return {
		              x: minX - fontSize / 2,
		              y: minY - fontSize / 2,
		              width: maxX - minX + fontSize,
		              height: maxY - minY + fontSize,
		          };
		      }
		      destroy() {
		          Util.releaseCanvas(this.dummyCanvas);
		          return super.destroy();
		      }
		  }
		  TextPath.prototype._fillFunc = _fillFunc;
		  TextPath.prototype._strokeFunc = _strokeFunc;
		  TextPath.prototype._fillFuncHit = _fillFunc;
		  TextPath.prototype._strokeFuncHit = _strokeFunc;
		  TextPath.prototype.className = 'TextPath';
		  TextPath.prototype._attrsAffectingSize = ['text', 'fontSize', 'data'];
		  _registerNode(TextPath);
		  /**
		   * get/set SVG path data string.  This method
		   *  also automatically parses the data string
		   *  into a data array.  Currently supported SVG data:
		   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
		   * @name Konva.TextPath#data
		   * @method
		   * @param {String} data svg path string
		   * @returns {String}
		   * @example
		   * // get data
		   * var data = shape.data();
		   *
		   * // set data
		   * shape.data('M200,100h100v50z');
		   */
		  Factory.addGetterSetter(TextPath, 'data');
		  /**
		   * get/set font family
		   * @name Konva.TextPath#fontFamily
		   * @method
		   * @param {String} fontFamily
		   * @returns {String}
		   * @example
		   * // get font family
		   * var fontFamily = shape.fontFamily();
		   *
		   * // set font family
		   * shape.fontFamily('Arial');
		   */
		  Factory.addGetterSetter(TextPath, 'fontFamily', 'Arial');
		  /**
		   * get/set font size in pixels
		   * @name Konva.TextPath#fontSize
		   * @method
		   * @param {Number} fontSize
		   * @returns {Number}
		   * @example
		   * // get font size
		   * var fontSize = shape.fontSize();
		   *
		   * // set font size to 22px
		   * shape.fontSize(22);
		   */
		  Factory.addGetterSetter(TextPath, 'fontSize', 12, getNumberValidator());
		  /**
		   * get/set font style.  Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
		   * @name Konva.TextPath#fontStyle
		   * @method
		   * @param {String} fontStyle
		   * @returns {String}
		   * @example
		   * // get font style
		   * var fontStyle = shape.fontStyle();
		   *
		   * // set font style
		   * shape.fontStyle('bold');
		   */
		  Factory.addGetterSetter(TextPath, 'fontStyle', NORMAL);
		  /**
		   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
		   * @name Konva.TextPath#align
		   * @method
		   * @param {String} align
		   * @returns {String}
		   * @example
		   * // get text align
		   * var align = text.align();
		   *
		   * // center text
		   * text.align('center');
		   *
		   * // align text to right
		   * text.align('right');
		   */
		  Factory.addGetterSetter(TextPath, 'align', 'left');
		  /**
		   * get/set letter spacing.  The default is 0.
		   * @name Konva.TextPath#letterSpacing
		   * @method
		   * @param {Number} letterSpacing
		   * @returns {Number}
		   * @example
		   * // get letter spacing value
		   * var letterSpacing = shape.letterSpacing();
		   *
		   * // set the letter spacing value
		   * shape.letterSpacing(2);
		   */
		  Factory.addGetterSetter(TextPath, 'letterSpacing', 0, getNumberValidator());
		  /**
		   * get/set text baseline.  The default is 'middle'. Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'
		   * @name Konva.TextPath#textBaseline
		   * @method
		   * @param {String} textBaseline
		   * @returns {String}
		   * @example
		   * // get current text baseline
		   * var textBaseline = shape.textBaseline();
		   *
		   * // set new text baseline
		   * shape.textBaseline('top');
		   */
		  Factory.addGetterSetter(TextPath, 'textBaseline', 'middle');
		  /**
		   * get/set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
		   * @name Konva.TextPath#fontVariant
		   * @method
		   * @param {String} fontVariant
		   * @returns {String}
		   * @example
		   * // get font variant
		   * var fontVariant = shape.fontVariant();
		   *
		   * // set font variant
		   * shape.fontVariant('small-caps');
		   */
		  Factory.addGetterSetter(TextPath, 'fontVariant', NORMAL);
		  /**
		   * get/set text
		   * @name Konva.TextPath#getText
		   * @method
		   * @param {String} text
		   * @returns {String}
		   * @example
		   * // get text
		   * var text = text.text();
		   *
		   * // set text
		   * text.text('Hello world!');
		   */
		  Factory.addGetterSetter(TextPath, 'text', EMPTY_STRING);
		  /**
		   * get/set text decoration of a text.  Can be '' or 'underline'.
		   * @name Konva.TextPath#textDecoration
		   * @method
		   * @param {String} textDecoration
		   * @returns {String}
		   * @example
		   * // get text decoration
		   * var textDecoration = shape.textDecoration();
		   *
		   * // underline text
		   * shape.textDecoration('underline');
		   */
		  Factory.addGetterSetter(TextPath, 'textDecoration', null);
		  /**
		   * get/set kerning function.
		   * @name Konva.TextPath#kerningFunc
		   * @method
		   * @param {String} kerningFunc
		   * @returns {String}
		   * @example
		   * // get text decoration
		   * var kerningFunc = text.kerningFunc();
		   *
		   * // center text
		   * text.kerningFunc(function(leftChar, rightChar) {
		   *   return 1;
		   * });
		   */
		  Factory.addGetterSetter(TextPath, 'kerningFunc', null);

		  var EVENTS_NAME = 'tr-konva';
		  var ATTR_CHANGE_LIST = [
		      'resizeEnabledChange',
		      'rotateAnchorOffsetChange',
		      'rotateEnabledChange',
		      'enabledAnchorsChange',
		      'anchorSizeChange',
		      'borderEnabledChange',
		      'borderStrokeChange',
		      'borderStrokeWidthChange',
		      'borderDashChange',
		      'anchorStrokeChange',
		      'anchorStrokeWidthChange',
		      'anchorFillChange',
		      'anchorCornerRadiusChange',
		      'ignoreStrokeChange',
		      'anchorStyleFuncChange',
		  ]
		      .map((e) => e + `.${EVENTS_NAME}`)
		      .join(' ');
		  var NODES_RECT = 'nodesRect';
		  var TRANSFORM_CHANGE_STR = [
		      'widthChange',
		      'heightChange',
		      'scaleXChange',
		      'scaleYChange',
		      'skewXChange',
		      'skewYChange',
		      'rotationChange',
		      'offsetXChange',
		      'offsetYChange',
		      'transformsEnabledChange',
		      'strokeWidthChange',
		  ];
		  var ANGLES = {
		      'top-left': -45,
		      'top-center': 0,
		      'top-right': 45,
		      'middle-right': -90,
		      'middle-left': 90,
		      'bottom-left': -135,
		      'bottom-center': 180,
		      'bottom-right': 135,
		  };
		  const TOUCH_DEVICE = 'ontouchstart' in Konva$2._global;
		  function getCursor(anchorName, rad, rotateCursor) {
		      if (anchorName === 'rotater') {
		          return rotateCursor;
		      }
		      rad += Util.degToRad(ANGLES[anchorName] || 0);
		      var angle = ((Util.radToDeg(rad) % 360) + 360) % 360;
		      if (Util._inRange(angle, 315 + 22.5, 360) || Util._inRange(angle, 0, 22.5)) {
		          // TOP
		          return 'ns-resize';
		      }
		      else if (Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
		          // TOP - RIGHT
		          return 'nesw-resize';
		      }
		      else if (Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
		          // RIGHT
		          return 'ew-resize';
		      }
		      else if (Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
		          // BOTTOM - RIGHT
		          return 'nwse-resize';
		      }
		      else if (Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
		          // BOTTOM
		          return 'ns-resize';
		      }
		      else if (Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
		          // BOTTOM - LEFT
		          return 'nesw-resize';
		      }
		      else if (Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
		          // RIGHT
		          return 'ew-resize';
		      }
		      else if (Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
		          // BOTTOM - RIGHT
		          return 'nwse-resize';
		      }
		      else {
		          // how can we can there?
		          Util.error('Transformer has unknown angle for cursor detection: ' + angle);
		          return 'pointer';
		      }
		  }
		  var ANCHORS_NAMES = [
		      'top-left',
		      'top-center',
		      'top-right',
		      'middle-right',
		      'middle-left',
		      'bottom-left',
		      'bottom-center',
		      'bottom-right',
		  ];
		  var MAX_SAFE_INTEGER = 100000000;
		  function getCenter(shape) {
		      return {
		          x: shape.x +
		              (shape.width / 2) * Math.cos(shape.rotation) +
		              (shape.height / 2) * Math.sin(-shape.rotation),
		          y: shape.y +
		              (shape.height / 2) * Math.cos(shape.rotation) +
		              (shape.width / 2) * Math.sin(shape.rotation),
		      };
		  }
		  function rotateAroundPoint(shape, angleRad, point) {
		      const x = point.x +
		          (shape.x - point.x) * Math.cos(angleRad) -
		          (shape.y - point.y) * Math.sin(angleRad);
		      const y = point.y +
		          (shape.x - point.x) * Math.sin(angleRad) +
		          (shape.y - point.y) * Math.cos(angleRad);
		      return {
		          ...shape,
		          rotation: shape.rotation + angleRad,
		          x,
		          y,
		      };
		  }
		  function rotateAroundCenter(shape, deltaRad) {
		      const center = getCenter(shape);
		      return rotateAroundPoint(shape, deltaRad, center);
		  }
		  function getSnap(snaps, newRotationRad, tol) {
		      let snapped = newRotationRad;
		      for (let i = 0; i < snaps.length; i++) {
		          const angle = Konva$2.getAngle(snaps[i]);
		          const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
		          const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
		          if (dif < tol) {
		              snapped = angle;
		          }
		      }
		      return snapped;
		  }
		  /**
		   * Transformer constructor.  Transformer is a special type of group that allow you transform Konva
		   * primitives and shapes. Transforming tool is not changing `width` and `height` properties of nodes
		   * when you resize them. Instead it changes `scaleX` and `scaleY` properties.
		   * @constructor
		   * @memberof Konva
		   * @param {Object} config
		   * @param {Boolean} [config.resizeEnabled] Default is true
		   * @param {Boolean} [config.rotateEnabled] Default is true
		   * @param {Array} [config.rotationSnaps] Array of angles for rotation snaps. Default is []
		   * @param {Number} [config.rotationSnapTolerance] Snapping tolerance. If closer than this it will snap. Default is 5
		   * @param {Number} [config.rotateAnchorOffset] Default is 50
		   * @param {String} [config.rotateAnchorCursor] Default is crosshair
		   * @param {Number} [config.padding] Default is 0
		   * @param {Boolean} [config.borderEnabled] Should we draw border? Default is true
		   * @param {String} [config.borderStroke] Border stroke color
		   * @param {Number} [config.borderStrokeWidth] Border stroke size
		   * @param {Array} [config.borderDash] Array for border dash.
		   * @param {String} [config.anchorFill] Anchor fill color
		   * @param {String} [config.anchorStroke] Anchor stroke color
		   * @param {String} [config.anchorCornerRadius] Anchor corner radius
		   * @param {Number} [config.anchorStrokeWidth] Anchor stroke size
		   * @param {Number} [config.anchorSize] Default is 10
		   * @param {Boolean} [config.keepRatio] Should we keep ratio when we are moving edges? Default is true
		   * @param {String} [config.shiftBehavior] How does transformer react on shift key press when we are moving edges? Default is 'default'
		   * @param {Boolean} [config.centeredScaling] Should we resize relative to node's center? Default is false
		   * @param {Array} [config.enabledAnchors] Array of names of enabled handles
		   * @param {Boolean} [config.flipEnabled] Can we flip/mirror shape on transform?. True by default
		   * @param {Function} [config.boundBoxFunc] Bounding box function
		   * @param {Function} [config.ignoreStroke] Should we ignore stroke size? Default is false
		   * @param {Boolean} [config.useSingleNodeRotation] When just one node attached, should we use its rotation for transformer?
		   * @param {Boolean} [config.shouldOverdrawWholeArea] Should we fill whole transformer area with fake transparent shape to enable dragging from empty spaces?
		   * @example
		   * var transformer = new Konva.Transformer({
		   *   nodes: [rectangle],
		   *   rotateAnchorOffset: 60,
		   *   enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
		   * });
		   * layer.add(transformer);
		   */
		  class Transformer extends Group {
		      constructor(config) {
		          // call super constructor
		          super(config);
		          this._movingAnchorName = null;
		          this._transforming = false;
		          this._createElements();
		          // bindings
		          this._handleMouseMove = this._handleMouseMove.bind(this);
		          this._handleMouseUp = this._handleMouseUp.bind(this);
		          this.update = this.update.bind(this);
		          // update transformer data for certain attr changes
		          this.on(ATTR_CHANGE_LIST, this.update);
		          if (this.getNode()) {
		              this.update();
		          }
		      }
		      /**
		       * alias to `tr.nodes([shape])`/ This method is deprecated and will be removed soon.
		       * @method
		       * @name Konva.Transformer#attachTo
		       * @returns {Konva.Transformer}
		       * @example
		       * transformer.attachTo(shape);
		       */
		      attachTo(node) {
		          this.setNode(node);
		          return this;
		      }
		      setNode(node) {
		          Util.warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
		          return this.setNodes([node]);
		      }
		      getNode() {
		          return this._nodes && this._nodes[0];
		      }
		      _getEventNamespace() {
		          return EVENTS_NAME + this._id;
		      }
		      setNodes(nodes = []) {
		          if (this._nodes && this._nodes.length) {
		              this.detach();
		          }
		          const filteredNodes = nodes.filter((node) => {
		              // check if ancestor of the transformer
		              if (node.isAncestorOf(this)) {
		                  Util.error('Konva.Transformer cannot be an a child of the node you are trying to attach');
		                  return false;
		              }
		              return true;
		          });
		          this._nodes = nodes = filteredNodes;
		          if (nodes.length === 1 && this.useSingleNodeRotation()) {
		              this.rotation(nodes[0].getAbsoluteRotation());
		          }
		          else {
		              this.rotation(0);
		          }
		          this._nodes.forEach((node) => {
		              const onChange = () => {
		                  if (this.nodes().length === 1 && this.useSingleNodeRotation()) {
		                      this.rotation(this.nodes()[0].getAbsoluteRotation());
		                  }
		                  this._resetTransformCache();
		                  if (!this._transforming && !this.isDragging()) {
		                      this.update();
		                  }
		              };
		              const additionalEvents = node._attrsAffectingSize
		                  .map((prop) => prop + 'Change.' + this._getEventNamespace())
		                  .join(' ');
		              node.on(additionalEvents, onChange);
		              node.on(TRANSFORM_CHANGE_STR.map((e) => e + `.${this._getEventNamespace()}`).join(' '), onChange);
		              node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
		              this._proxyDrag(node);
		          });
		          this._resetTransformCache();
		          // we may need it if we set node in initial props
		          // so elements are not defined yet
		          var elementsCreated = !!this.findOne('.top-left');
		          if (elementsCreated) {
		              this.update();
		          }
		          return this;
		      }
		      _proxyDrag(node) {
		          let lastPos;
		          node.on(`dragstart.${this._getEventNamespace()}`, (e) => {
		              lastPos = node.getAbsolutePosition();
		              // actual dragging of Transformer doesn't make sense
		              // but we need to make sure it also has all drag events
		              if (!this.isDragging() && node !== this.findOne('.back')) {
		                  this.startDrag(e, false);
		              }
		          });
		          node.on(`dragmove.${this._getEventNamespace()}`, (e) => {
		              if (!lastPos) {
		                  return;
		              }
		              const abs = node.getAbsolutePosition();
		              const dx = abs.x - lastPos.x;
		              const dy = abs.y - lastPos.y;
		              this.nodes().forEach((otherNode) => {
		                  if (otherNode === node) {
		                      return;
		                  }
		                  if (otherNode.isDragging()) {
		                      return;
		                  }
		                  const otherAbs = otherNode.getAbsolutePosition();
		                  otherNode.setAbsolutePosition({
		                      x: otherAbs.x + dx,
		                      y: otherAbs.y + dy,
		                  });
		                  otherNode.startDrag(e);
		              });
		              lastPos = null;
		          });
		      }
		      getNodes() {
		          return this._nodes || [];
		      }
		      /**
		       * return the name of current active anchor
		       * @method
		       * @name Konva.Transformer#getActiveAnchor
		       * @returns {String | Null}
		       * @example
		       * transformer.getActiveAnchor();
		       */
		      getActiveAnchor() {
		          return this._movingAnchorName;
		      }
		      /**
		       * detach transformer from an attached node
		       * @method
		       * @name Konva.Transformer#detach
		       * @returns {Konva.Transformer}
		       * @example
		       * transformer.detach();
		       */
		      detach() {
		          // remove events
		          if (this._nodes) {
		              this._nodes.forEach((node) => {
		                  node.off('.' + this._getEventNamespace());
		              });
		          }
		          this._nodes = [];
		          this._resetTransformCache();
		      }
		      /**
		       * bind events to the Transformer. You can use events: `transform`, `transformstart`, `transformend`, `dragstart`, `dragmove`, `dragend`
		       * @method
		       * @name Konva.Transformer#on
		       * @param {String} evtStr e.g. 'transform'
		       * @param {Function} handler The handler function. The first argument of that function is event object. Event object has `target` as main target of the event, `currentTarget` as current node listener and `evt` as native browser event.
		       * @returns {Konva.Transformer}
		       * @example
		       * // add click listener
		       * tr.on('transformstart', function() {
		       *   console.log('transform started');
		       * });
		       */
		      _resetTransformCache() {
		          this._clearCache(NODES_RECT);
		          this._clearCache('transform');
		          this._clearSelfAndDescendantCache('absoluteTransform');
		      }
		      _getNodeRect() {
		          return this._getCache(NODES_RECT, this.__getNodeRect);
		      }
		      // return absolute rotated bounding rectangle
		      __getNodeShape(node, rot = this.rotation(), relative) {
		          var rect = node.getClientRect({
		              skipTransform: true,
		              skipShadow: true,
		              skipStroke: this.ignoreStroke(),
		          });
		          var absScale = node.getAbsoluteScale(relative);
		          var absPos = node.getAbsolutePosition(relative);
		          var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
		          var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
		          const rotation = (Konva$2.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) %
		              (Math.PI * 2);
		          const box = {
		              x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
		              y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
		              width: rect.width * absScale.x,
		              height: rect.height * absScale.y,
		              rotation: rotation,
		          };
		          return rotateAroundPoint(box, -Konva$2.getAngle(rot), {
		              x: 0,
		              y: 0,
		          });
		      }
		      // returns box + rotation of all shapes
		      __getNodeRect() {
		          var node = this.getNode();
		          if (!node) {
		              return {
		                  x: -MAX_SAFE_INTEGER,
		                  y: -MAX_SAFE_INTEGER,
		                  width: 0,
		                  height: 0,
		                  rotation: 0,
		              };
		          }
		          const totalPoints = [];
		          this.nodes().map((node) => {
		              const box = node.getClientRect({
		                  skipTransform: true,
		                  skipShadow: true,
		                  skipStroke: this.ignoreStroke(),
		              });
		              var points = [
		                  { x: box.x, y: box.y },
		                  { x: box.x + box.width, y: box.y },
		                  { x: box.x + box.width, y: box.y + box.height },
		                  { x: box.x, y: box.y + box.height },
		              ];
		              var trans = node.getAbsoluteTransform();
		              points.forEach(function (point) {
		                  var transformed = trans.point(point);
		                  totalPoints.push(transformed);
		              });
		          });
		          const tr = new Transform();
		          tr.rotate(-Konva$2.getAngle(this.rotation()));
		          var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
		          totalPoints.forEach(function (point) {
		              var transformed = tr.point(point);
		              if (minX === undefined) {
		                  minX = maxX = transformed.x;
		                  minY = maxY = transformed.y;
		              }
		              minX = Math.min(minX, transformed.x);
		              minY = Math.min(minY, transformed.y);
		              maxX = Math.max(maxX, transformed.x);
		              maxY = Math.max(maxY, transformed.y);
		          });
		          tr.invert();
		          const p = tr.point({ x: minX, y: minY });
		          return {
		              x: p.x,
		              y: p.y,
		              width: maxX - minX,
		              height: maxY - minY,
		              rotation: Konva$2.getAngle(this.rotation()),
		          };
		          // const shapes = this.nodes().map(node => {
		          //   return this.__getNodeShape(node);
		          // });
		          // const box = getShapesRect(shapes);
		          // return rotateAroundPoint(box, Konva.getAngle(this.rotation()), {
		          //   x: 0,
		          //   y: 0
		          // });
		      }
		      getX() {
		          return this._getNodeRect().x;
		      }
		      getY() {
		          return this._getNodeRect().y;
		      }
		      getWidth() {
		          return this._getNodeRect().width;
		      }
		      getHeight() {
		          return this._getNodeRect().height;
		      }
		      _createElements() {
		          this._createBack();
		          ANCHORS_NAMES.forEach((name) => {
		              this._createAnchor(name);
		          });
		          this._createAnchor('rotater');
		      }
		      _createAnchor(name) {
		          var anchor = new Rect({
		              stroke: 'rgb(0, 161, 255)',
		              fill: 'white',
		              strokeWidth: 1,
		              name: name + ' _anchor',
		              dragDistance: 0,
		              // make it draggable,
		              // so activating the anchor will not start drag&drop of any parent
		              draggable: true,
		              hitStrokeWidth: TOUCH_DEVICE ? 10 : 'auto',
		          });
		          var self = this;
		          anchor.on('mousedown touchstart', function (e) {
		              self._handleMouseDown(e);
		          });
		          anchor.on('dragstart', (e) => {
		              anchor.stopDrag();
		              e.cancelBubble = true;
		          });
		          anchor.on('dragend', (e) => {
		              e.cancelBubble = true;
		          });
		          // add hover styling
		          anchor.on('mouseenter', () => {
		              var rad = Konva$2.getAngle(this.rotation());
		              var rotateCursor = this.rotateAnchorCursor();
		              var cursor = getCursor(name, rad, rotateCursor);
		              anchor.getStage().content &&
		                  (anchor.getStage().content.style.cursor = cursor);
		              this._cursorChange = true;
		          });
		          anchor.on('mouseout', () => {
		              anchor.getStage().content &&
		                  (anchor.getStage().content.style.cursor = '');
		              this._cursorChange = false;
		          });
		          this.add(anchor);
		      }
		      _createBack() {
		          var back = new Shape({
		              name: 'back',
		              width: 0,
		              height: 0,
		              draggable: true,
		              sceneFunc(ctx, shape) {
		                  var tr = shape.getParent();
		                  var padding = tr.padding();
		                  ctx.beginPath();
		                  ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
		                  ctx.moveTo(shape.width() / 2, -padding);
		                  if (tr.rotateEnabled()) {
		                      ctx.lineTo(shape.width() / 2, -tr.rotateAnchorOffset() * Util._sign(shape.height()) - padding);
		                  }
		                  ctx.fillStrokeShape(shape);
		              },
		              hitFunc: (ctx, shape) => {
		                  if (!this.shouldOverdrawWholeArea()) {
		                      return;
		                  }
		                  var padding = this.padding();
		                  ctx.beginPath();
		                  ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
		                  ctx.fillStrokeShape(shape);
		              },
		          });
		          this.add(back);
		          this._proxyDrag(back);
		          // do not bubble drag from the back shape
		          // because we already "drag" whole transformer
		          // so we don't want to trigger drag twice on transformer
		          back.on('dragstart', (e) => {
		              e.cancelBubble = true;
		          });
		          back.on('dragmove', (e) => {
		              e.cancelBubble = true;
		          });
		          back.on('dragend', (e) => {
		              e.cancelBubble = true;
		          });
		          // force self update when we drag with shouldOverDrawWholeArea setting
		          this.on('dragmove', (e) => {
		              this.update();
		          });
		      }
		      _handleMouseDown(e) {
		          this._movingAnchorName = e.target.name().split(' ')[0];
		          var attrs = this._getNodeRect();
		          var width = attrs.width;
		          var height = attrs.height;
		          var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
		          this.sin = Math.abs(height / hypotenuse);
		          this.cos = Math.abs(width / hypotenuse);
		          if (typeof window !== 'undefined') {
		              window.addEventListener('mousemove', this._handleMouseMove);
		              window.addEventListener('touchmove', this._handleMouseMove);
		              window.addEventListener('mouseup', this._handleMouseUp, true);
		              window.addEventListener('touchend', this._handleMouseUp, true);
		          }
		          this._transforming = true;
		          var ap = e.target.getAbsolutePosition();
		          var pos = e.target.getStage().getPointerPosition();
		          this._anchorDragOffset = {
		              x: pos.x - ap.x,
		              y: pos.y - ap.y,
		          };
		          this._fire('transformstart', { evt: e.evt, target: this.getNode() });
		          this._nodes.forEach((target) => {
		              target._fire('transformstart', { evt: e.evt, target });
		          });
		      }
		      _handleMouseMove(e) {
		          var x, y, newHypotenuse;
		          var anchorNode = this.findOne('.' + this._movingAnchorName);
		          var stage = anchorNode.getStage();
		          stage.setPointersPositions(e);
		          const pp = stage.getPointerPosition();
		          let newNodePos = {
		              x: pp.x - this._anchorDragOffset.x,
		              y: pp.y - this._anchorDragOffset.y,
		          };
		          const oldAbs = anchorNode.getAbsolutePosition();
		          if (this.anchorDragBoundFunc()) {
		              newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
		          }
		          anchorNode.setAbsolutePosition(newNodePos);
		          const newAbs = anchorNode.getAbsolutePosition();
		          // console.log(oldAbs, newNodePos, newAbs);
		          if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) {
		              return;
		          }
		          // rotater is working very differently, so do it first
		          if (this._movingAnchorName === 'rotater') {
		              var attrs = this._getNodeRect();
		              x = anchorNode.x() - attrs.width / 2;
		              y = -anchorNode.y() + attrs.height / 2;
		              // hor angle is changed?
		              let delta = Math.atan2(-y, x) + Math.PI / 2;
		              if (attrs.height < 0) {
		                  delta -= Math.PI;
		              }
		              var oldRotation = Konva$2.getAngle(this.rotation());
		              const newRotation = oldRotation + delta;
		              const tol = Konva$2.getAngle(this.rotationSnapTolerance());
		              const snappedRot = getSnap(this.rotationSnaps(), newRotation, tol);
		              const diff = snappedRot - attrs.rotation;
		              const shape = rotateAroundCenter(attrs, diff);
		              this._fitNodesInto(shape, e);
		              return;
		          }
		          var shiftBehavior = this.shiftBehavior();
		          var keepProportion;
		          if (shiftBehavior === 'inverted') {
		              keepProportion = this.keepRatio() && !e.shiftKey;
		          }
		          else if (shiftBehavior === 'none') {
		              keepProportion = this.keepRatio();
		          }
		          else {
		              keepProportion = this.keepRatio() || e.shiftKey;
		          }
		          var centeredScaling = this.centeredScaling() || e.altKey;
		          if (this._movingAnchorName === 'top-left') {
		              if (keepProportion) {
		                  var comparePoint = centeredScaling
		                      ? {
		                          x: this.width() / 2,
		                          y: this.height() / 2,
		                      }
		                      : {
		                          x: this.findOne('.bottom-right').x(),
		                          y: this.findOne('.bottom-right').y(),
		                      };
		                  newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
		                      Math.pow(comparePoint.y - anchorNode.y(), 2));
		                  var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
		                  var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
		                  x = newHypotenuse * this.cos * reverseX;
		                  y = newHypotenuse * this.sin * reverseY;
		                  this.findOne('.top-left').x(comparePoint.x - x);
		                  this.findOne('.top-left').y(comparePoint.y - y);
		              }
		          }
		          else if (this._movingAnchorName === 'top-center') {
		              this.findOne('.top-left').y(anchorNode.y());
		          }
		          else if (this._movingAnchorName === 'top-right') {
		              if (keepProportion) {
		                  var comparePoint = centeredScaling
		                      ? {
		                          x: this.width() / 2,
		                          y: this.height() / 2,
		                      }
		                      : {
		                          x: this.findOne('.bottom-left').x(),
		                          y: this.findOne('.bottom-left').y(),
		                      };
		                  newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
		                      Math.pow(comparePoint.y - anchorNode.y(), 2));
		                  var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
		                  var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
		                  x = newHypotenuse * this.cos * reverseX;
		                  y = newHypotenuse * this.sin * reverseY;
		                  this.findOne('.top-right').x(comparePoint.x + x);
		                  this.findOne('.top-right').y(comparePoint.y - y);
		              }
		              var pos = anchorNode.position();
		              this.findOne('.top-left').y(pos.y);
		              this.findOne('.bottom-right').x(pos.x);
		          }
		          else if (this._movingAnchorName === 'middle-left') {
		              this.findOne('.top-left').x(anchorNode.x());
		          }
		          else if (this._movingAnchorName === 'middle-right') {
		              this.findOne('.bottom-right').x(anchorNode.x());
		          }
		          else if (this._movingAnchorName === 'bottom-left') {
		              if (keepProportion) {
		                  var comparePoint = centeredScaling
		                      ? {
		                          x: this.width() / 2,
		                          y: this.height() / 2,
		                      }
		                      : {
		                          x: this.findOne('.top-right').x(),
		                          y: this.findOne('.top-right').y(),
		                      };
		                  newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
		                      Math.pow(anchorNode.y() - comparePoint.y, 2));
		                  var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
		                  var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
		                  x = newHypotenuse * this.cos * reverseX;
		                  y = newHypotenuse * this.sin * reverseY;
		                  anchorNode.x(comparePoint.x - x);
		                  anchorNode.y(comparePoint.y + y);
		              }
		              pos = anchorNode.position();
		              this.findOne('.top-left').x(pos.x);
		              this.findOne('.bottom-right').y(pos.y);
		          }
		          else if (this._movingAnchorName === 'bottom-center') {
		              this.findOne('.bottom-right').y(anchorNode.y());
		          }
		          else if (this._movingAnchorName === 'bottom-right') {
		              if (keepProportion) {
		                  var comparePoint = centeredScaling
		                      ? {
		                          x: this.width() / 2,
		                          y: this.height() / 2,
		                      }
		                      : {
		                          x: this.findOne('.top-left').x(),
		                          y: this.findOne('.top-left').y(),
		                      };
		                  newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
		                      Math.pow(anchorNode.y() - comparePoint.y, 2));
		                  var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
		                  var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
		                  x = newHypotenuse * this.cos * reverseX;
		                  y = newHypotenuse * this.sin * reverseY;
		                  this.findOne('.bottom-right').x(comparePoint.x + x);
		                  this.findOne('.bottom-right').y(comparePoint.y + y);
		              }
		          }
		          else {
		              console.error(new Error('Wrong position argument of selection resizer: ' +
		                  this._movingAnchorName));
		          }
		          var centeredScaling = this.centeredScaling() || e.altKey;
		          if (centeredScaling) {
		              var topLeft = this.findOne('.top-left');
		              var bottomRight = this.findOne('.bottom-right');
		              var topOffsetX = topLeft.x();
		              var topOffsetY = topLeft.y();
		              var bottomOffsetX = this.getWidth() - bottomRight.x();
		              var bottomOffsetY = this.getHeight() - bottomRight.y();
		              bottomRight.move({
		                  x: -topOffsetX,
		                  y: -topOffsetY,
		              });
		              topLeft.move({
		                  x: bottomOffsetX,
		                  y: bottomOffsetY,
		              });
		          }
		          var absPos = this.findOne('.top-left').getAbsolutePosition();
		          x = absPos.x;
		          y = absPos.y;
		          var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
		          var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
		          this._fitNodesInto({
		              x: x,
		              y: y,
		              width: width,
		              height: height,
		              rotation: Konva$2.getAngle(this.rotation()),
		          }, e);
		      }
		      _handleMouseUp(e) {
		          this._removeEvents(e);
		      }
		      getAbsoluteTransform() {
		          return this.getTransform();
		      }
		      _removeEvents(e) {
		          if (this._transforming) {
		              this._transforming = false;
		              if (typeof window !== 'undefined') {
		                  window.removeEventListener('mousemove', this._handleMouseMove);
		                  window.removeEventListener('touchmove', this._handleMouseMove);
		                  window.removeEventListener('mouseup', this._handleMouseUp, true);
		                  window.removeEventListener('touchend', this._handleMouseUp, true);
		              }
		              var node = this.getNode();
		              this._fire('transformend', { evt: e, target: node });
		              if (node) {
		                  this._nodes.forEach((target) => {
		                      target._fire('transformend', { evt: e, target });
		                  });
		              }
		              this._movingAnchorName = null;
		          }
		      }
		      _fitNodesInto(newAttrs, evt) {
		          var oldAttrs = this._getNodeRect();
		          const minSize = 1;
		          if (Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
		              this.update();
		              return;
		          }
		          if (Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
		              this.update();
		              return;
		          }
		          const allowNegativeScale = this.flipEnabled();
		          var t = new Transform();
		          t.rotate(Konva$2.getAngle(this.rotation()));
		          if (this._movingAnchorName &&
		              newAttrs.width < 0 &&
		              this._movingAnchorName.indexOf('left') >= 0) {
		              const offset = t.point({
		                  x: -this.padding() * 2,
		                  y: 0,
		              });
		              newAttrs.x += offset.x;
		              newAttrs.y += offset.y;
		              newAttrs.width += this.padding() * 2;
		              this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
		              this._anchorDragOffset.x -= offset.x;
		              this._anchorDragOffset.y -= offset.y;
		              if (!allowNegativeScale) {
		                  this.update();
		                  return;
		              }
		          }
		          else if (this._movingAnchorName &&
		              newAttrs.width < 0 &&
		              this._movingAnchorName.indexOf('right') >= 0) {
		              const offset = t.point({
		                  x: this.padding() * 2,
		                  y: 0,
		              });
		              this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
		              this._anchorDragOffset.x -= offset.x;
		              this._anchorDragOffset.y -= offset.y;
		              newAttrs.width += this.padding() * 2;
		              if (!allowNegativeScale) {
		                  this.update();
		                  return;
		              }
		          }
		          if (this._movingAnchorName &&
		              newAttrs.height < 0 &&
		              this._movingAnchorName.indexOf('top') >= 0) {
		              const offset = t.point({
		                  x: 0,
		                  y: -this.padding() * 2,
		              });
		              newAttrs.x += offset.x;
		              newAttrs.y += offset.y;
		              this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
		              this._anchorDragOffset.x -= offset.x;
		              this._anchorDragOffset.y -= offset.y;
		              newAttrs.height += this.padding() * 2;
		              if (!allowNegativeScale) {
		                  this.update();
		                  return;
		              }
		          }
		          else if (this._movingAnchorName &&
		              newAttrs.height < 0 &&
		              this._movingAnchorName.indexOf('bottom') >= 0) {
		              const offset = t.point({
		                  x: 0,
		                  y: this.padding() * 2,
		              });
		              this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
		              this._anchorDragOffset.x -= offset.x;
		              this._anchorDragOffset.y -= offset.y;
		              newAttrs.height += this.padding() * 2;
		              if (!allowNegativeScale) {
		                  this.update();
		                  return;
		              }
		          }
		          if (this.boundBoxFunc()) {
		              const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
		              if (bounded) {
		                  newAttrs = bounded;
		              }
		              else {
		                  Util.warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
		              }
		          }
		          // base size value doesn't really matter
		          // we just need to think about bounding boxes as transforms
		          // but how?
		          // the idea is that we have a transformed rectangle with the size of "baseSize"
		          const baseSize = 10000000;
		          const oldTr = new Transform();
		          oldTr.translate(oldAttrs.x, oldAttrs.y);
		          oldTr.rotate(oldAttrs.rotation);
		          oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
		          const newTr = new Transform();
		          newTr.translate(newAttrs.x, newAttrs.y);
		          newTr.rotate(newAttrs.rotation);
		          newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
		          // now lets think we had [old transform] and n ow we have [new transform]
		          // Now, the questions is: how can we transform "parent" to go from [old transform] into [new transform]
		          // in equation it will be:
		          // [delta transform] * [old transform] = [new transform]
		          // that means that
		          // [delta transform] = [new transform] * [old transform inverted]
		          const delta = newTr.multiply(oldTr.invert());
		          this._nodes.forEach((node) => {
		              var _a;
		              // for each node we have the same [delta transform]
		              // the equations is
		              // [delta transform] * [parent transform] * [old local transform] = [parent transform] * [new local transform]
		              // and we need to find [new local transform]
		              // [new local] = [parent inverted] * [delta] * [parent] * [old local]
		              const parentTransform = node.getParent().getAbsoluteTransform();
		              const localTransform = node.getTransform().copy();
		              // skip offset:
		              localTransform.translate(node.offsetX(), node.offsetY());
		              const newLocalTransform = new Transform();
		              newLocalTransform
		                  .multiply(parentTransform.copy().invert())
		                  .multiply(delta)
		                  .multiply(parentTransform)
		                  .multiply(localTransform);
		              const attrs = newLocalTransform.decompose();
		              node.setAttrs(attrs);
		              this._fire('transform', { evt: evt, target: node });
		              node._fire('transform', { evt: evt, target: node });
		              (_a = node.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
		          });
		          this.rotation(Util._getRotation(newAttrs.rotation));
		          this._resetTransformCache();
		          this.update();
		          this.getLayer().batchDraw();
		      }
		      /**
		       * force update of Konva.Transformer.
		       * Use it when you updated attached Konva.Group and now you need to reset transformer size
		       * @method
		       * @name Konva.Transformer#forceUpdate
		       */
		      forceUpdate() {
		          this._resetTransformCache();
		          this.update();
		      }
		      _batchChangeChild(selector, attrs) {
		          const anchor = this.findOne(selector);
		          anchor.setAttrs(attrs);
		      }
		      update() {
		          var _a;
		          var attrs = this._getNodeRect();
		          this.rotation(Util._getRotation(attrs.rotation));
		          var width = attrs.width;
		          var height = attrs.height;
		          var enabledAnchors = this.enabledAnchors();
		          var resizeEnabled = this.resizeEnabled();
		          var padding = this.padding();
		          var anchorSize = this.anchorSize();
		          const anchors = this.find('._anchor');
		          anchors.forEach((node) => {
		              node.setAttrs({
		                  width: anchorSize,
		                  height: anchorSize,
		                  offsetX: anchorSize / 2,
		                  offsetY: anchorSize / 2,
		                  stroke: this.anchorStroke(),
		                  strokeWidth: this.anchorStrokeWidth(),
		                  fill: this.anchorFill(),
		                  cornerRadius: this.anchorCornerRadius(),
		              });
		          });
		          this._batchChangeChild('.top-left', {
		              x: 0,
		              y: 0,
		              offsetX: anchorSize / 2 + padding,
		              offsetY: anchorSize / 2 + padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0,
		          });
		          this._batchChangeChild('.top-center', {
		              x: width / 2,
		              y: 0,
		              offsetY: anchorSize / 2 + padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0,
		          });
		          this._batchChangeChild('.top-right', {
		              x: width,
		              y: 0,
		              offsetX: anchorSize / 2 - padding,
		              offsetY: anchorSize / 2 + padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0,
		          });
		          this._batchChangeChild('.middle-left', {
		              x: 0,
		              y: height / 2,
		              offsetX: anchorSize / 2 + padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0,
		          });
		          this._batchChangeChild('.middle-right', {
		              x: width,
		              y: height / 2,
		              offsetX: anchorSize / 2 - padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0,
		          });
		          this._batchChangeChild('.bottom-left', {
		              x: 0,
		              y: height,
		              offsetX: anchorSize / 2 + padding,
		              offsetY: anchorSize / 2 - padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0,
		          });
		          this._batchChangeChild('.bottom-center', {
		              x: width / 2,
		              y: height,
		              offsetY: anchorSize / 2 - padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0,
		          });
		          this._batchChangeChild('.bottom-right', {
		              x: width,
		              y: height,
		              offsetX: anchorSize / 2 - padding,
		              offsetY: anchorSize / 2 - padding,
		              visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0,
		          });
		          this._batchChangeChild('.rotater', {
		              x: width / 2,
		              y: -this.rotateAnchorOffset() * Util._sign(height) - padding,
		              visible: this.rotateEnabled(),
		          });
		          this._batchChangeChild('.back', {
		              width: width,
		              height: height,
		              visible: this.borderEnabled(),
		              stroke: this.borderStroke(),
		              strokeWidth: this.borderStrokeWidth(),
		              dash: this.borderDash(),
		              x: 0,
		              y: 0,
		          });
		          const styleFunc = this.anchorStyleFunc();
		          if (styleFunc) {
		              anchors.forEach((node) => {
		                  styleFunc(node);
		              });
		          }
		          (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
		      }
		      /**
		       * determine if transformer is in active transform
		       * @method
		       * @name Konva.Transformer#isTransforming
		       * @returns {Boolean}
		       */
		      isTransforming() {
		          return this._transforming;
		      }
		      /**
		       * Stop active transform action
		       * @method
		       * @name Konva.Transformer#stopTransform
		       * @returns {Boolean}
		       */
		      stopTransform() {
		          if (this._transforming) {
		              this._removeEvents();
		              var anchorNode = this.findOne('.' + this._movingAnchorName);
		              if (anchorNode) {
		                  anchorNode.stopDrag();
		              }
		          }
		      }
		      destroy() {
		          if (this.getStage() && this._cursorChange) {
		              this.getStage().content && (this.getStage().content.style.cursor = '');
		          }
		          Group.prototype.destroy.call(this);
		          this.detach();
		          this._removeEvents();
		          return this;
		      }
		      // do not work as a container
		      // we will recreate inner nodes manually
		      toObject() {
		          return Node.prototype.toObject.call(this);
		      }
		      // overwrite clone to NOT use method from Container
		      clone(obj) {
		          var node = Node.prototype.clone.call(this, obj);
		          return node;
		      }
		      getClientRect() {
		          if (this.nodes().length > 0) {
		              return super.getClientRect();
		          }
		          else {
		              // if we are detached return zero size
		              // so it will be skipped in calculations
		              return { x: 0, y: 0, width: 0, height: 0 };
		          }
		      }
		  }
		  function validateAnchors(val) {
		      if (!(val instanceof Array)) {
		          Util.warn('enabledAnchors value should be an array');
		      }
		      if (val instanceof Array) {
		          val.forEach(function (name) {
		              if (ANCHORS_NAMES.indexOf(name) === -1) {
		                  Util.warn('Unknown anchor name: ' +
		                      name +
		                      '. Available names are: ' +
		                      ANCHORS_NAMES.join(', '));
		              }
		          });
		      }
		      return val || [];
		  }
		  Transformer.prototype.className = 'Transformer';
		  _registerNode(Transformer);
		  /**
		   * get/set enabled handlers
		   * @name Konva.Transformer#enabledAnchors
		   * @method
		   * @param {Array} array
		   * @returns {Array}
		   * @example
		   * // get list of handlers
		   * var enabledAnchors = transformer.enabledAnchors();
		   *
		   * // set handlers
		   * transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
		   */
		  Factory.addGetterSetter(Transformer, 'enabledAnchors', ANCHORS_NAMES, validateAnchors);
		  /**
		   * get/set flip enabled
		   * @name Konva.Transformer#flipEnabled
		   * @method
		   * @param {Boolean} flag
		   * @returns {Boolean}
		   * @example
		   * // get flip enabled property
		   * var flipEnabled = transformer.flipEnabled();
		   *
		   * // set flip enabled property
		   * transformer.flipEnabled(false);
		   */
		  Factory.addGetterSetter(Transformer, 'flipEnabled', true, getBooleanValidator());
		  /**
		   * get/set resize ability. If false it will automatically hide resizing handlers
		   * @name Konva.Transformer#resizeEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var resizeEnabled = transformer.resizeEnabled();
		   *
		   * // set
		   * transformer.resizeEnabled(false);
		   */
		  Factory.addGetterSetter(Transformer, 'resizeEnabled', true);
		  /**
		   * get/set anchor size. Default is 10
		   * @name Konva.Transformer#anchorSize
		   * @method
		   * @param {Number} size
		   * @returns {Number}
		   * @example
		   * // get
		   * var anchorSize = transformer.anchorSize();
		   *
		   * // set
		   * transformer.anchorSize(20)
		   */
		  Factory.addGetterSetter(Transformer, 'anchorSize', 10, getNumberValidator());
		  /**
		   * get/set ability to rotate.
		   * @name Konva.Transformer#rotateEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var rotateEnabled = transformer.rotateEnabled();
		   *
		   * // set
		   * transformer.rotateEnabled(false);
		   */
		  Factory.addGetterSetter(Transformer, 'rotateEnabled', true);
		  /**
		   * get/set rotation snaps angles.
		   * @name Konva.Transformer#rotationSnaps
		   * @method
		   * @param {Array} array
		   * @returns {Array}
		   * @example
		   * // get
		   * var rotationSnaps = transformer.rotationSnaps();
		   *
		   * // set
		   * transformer.rotationSnaps([0, 90, 180, 270]);
		   */
		  Factory.addGetterSetter(Transformer, 'rotationSnaps', []);
		  /**
		   * get/set distance for rotation handler
		   * @name Konva.Transformer#rotateAnchorOffset
		   * @method
		   * @param {Number} offset
		   * @returns {Number}
		   * @example
		   * // get
		   * var rotateAnchorOffset = transformer.rotateAnchorOffset();
		   *
		   * // set
		   * transformer.rotateAnchorOffset(100);
		   */
		  Factory.addGetterSetter(Transformer, 'rotateAnchorOffset', 50, getNumberValidator());
		  /**
		   * get/set rotation anchor cursor
		   * @name Konva.Transformer#rotateAnchorCursor
		   * @method
		   * @param {String} cursorName
		   * @returns {String}
		   * @example
		   * // get
		   * var currentRotationAnchorCursor = transformer.rotateAnchorCursor();
		   *
		   * // set
		   * transformer.rotateAnchorCursor('grab');
		   */
		  Factory.addGetterSetter(Transformer, 'rotateAnchorCursor', 'crosshair');
		  /**
		   * get/set distance for rotation tolerance
		   * @name Konva.Transformer#rotationSnapTolerance
		   * @method
		   * @param {Number} tolerance
		   * @returns {Number}
		   * @example
		   * // get
		   * var rotationSnapTolerance = transformer.rotationSnapTolerance();
		   *
		   * // set
		   * transformer.rotationSnapTolerance(100);
		   */
		  Factory.addGetterSetter(Transformer, 'rotationSnapTolerance', 5, getNumberValidator());
		  /**
		   * get/set visibility of border
		   * @name Konva.Transformer#borderEnabled
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var borderEnabled = transformer.borderEnabled();
		   *
		   * // set
		   * transformer.borderEnabled(false);
		   */
		  Factory.addGetterSetter(Transformer, 'borderEnabled', true);
		  /**
		   * get/set anchor stroke color
		   * @name Konva.Transformer#anchorStroke
		   * @method
		   * @param {String} strokeColor
		   * @returns {String}
		   * @example
		   * // get
		   * var anchorStroke = transformer.anchorStroke();
		   *
		   * // set
		   * transformer.anchorStroke('red');
		   */
		  Factory.addGetterSetter(Transformer, 'anchorStroke', 'rgb(0, 161, 255)');
		  /**
		   * get/set anchor stroke width
		   * @name Konva.Transformer#anchorStrokeWidth
		   * @method
		   * @param {Number} anchorStrokeWidth
		   * @returns {Number}
		   * @example
		   * // get
		   * var anchorStrokeWidth = transformer.anchorStrokeWidth();
		   *
		   * // set
		   * transformer.anchorStrokeWidth(3);
		   */
		  Factory.addGetterSetter(Transformer, 'anchorStrokeWidth', 1, getNumberValidator());
		  /**
		   * get/set anchor fill color
		   * @name Konva.Transformer#anchorFill
		   * @method
		   * @param {String} anchorFill
		   * @returns {String}
		   * @example
		   * // get
		   * var anchorFill = transformer.anchorFill();
		   *
		   * // set
		   * transformer.anchorFill('red');
		   */
		  Factory.addGetterSetter(Transformer, 'anchorFill', 'white');
		  /**
		   * get/set anchor corner radius
		   * @name Konva.Transformer#anchorCornerRadius
		   * @method
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get
		   * var anchorCornerRadius = transformer.anchorCornerRadius();
		   *
		   * // set
		   * transformer.anchorCornerRadius(3);
		   */
		  Factory.addGetterSetter(Transformer, 'anchorCornerRadius', 0, getNumberValidator());
		  /**
		   * get/set border stroke color
		   * @name Konva.Transformer#borderStroke
		   * @method
		   * @param {Boolean} enabled
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var borderStroke = transformer.borderStroke();
		   *
		   * // set
		   * transformer.borderStroke('red');
		   */
		  Factory.addGetterSetter(Transformer, 'borderStroke', 'rgb(0, 161, 255)');
		  /**
		   * get/set border stroke width
		   * @name Konva.Transformer#borderStrokeWidth
		   * @method
		   * @param {Number} strokeWidth
		   * @returns {Number}
		   * @example
		   * // get
		   * var borderStrokeWidth = transformer.borderStrokeWidth();
		   *
		   * // set
		   * transformer.borderStrokeWidth(3);
		   */
		  Factory.addGetterSetter(Transformer, 'borderStrokeWidth', 1, getNumberValidator());
		  /**
		   * get/set border dash array
		   * @name Konva.Transformer#borderDash
		   * @method
		   * @param {Array} dash array
		   * @returns {Array}
		   * @example
		   * // get
		   * var borderDash = transformer.borderDash();
		   *
		   * // set
		   * transformer.borderDash([2, 2]);
		   */
		  Factory.addGetterSetter(Transformer, 'borderDash');
		  /**
		   * get/set should we keep ratio while resize anchors at corners
		   * @name Konva.Transformer#keepRatio
		   * @method
		   * @param {Boolean} keepRatio
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var keepRatio = transformer.keepRatio();
		   *
		   * // set
		   * transformer.keepRatio(false);
		   */
		  Factory.addGetterSetter(Transformer, 'keepRatio', true);
		  /**
		   * get/set how to react on skift key while resizing anchors at corners
		   * @name Konva.Transformer#shiftBehavior
		   * @method
		   * @param {String} shiftBehavior
		   * @returns {String}
		   * @example
		   * // get
		   * var shiftBehavior = transformer.shiftBehavior();
		   *
		   * // set
		   * transformer.shiftBehavior('none');
		   */
		  Factory.addGetterSetter(Transformer, 'shiftBehavior', 'default');
		  /**
		   * get/set should we resize relative to node's center?
		   * @name Konva.Transformer#centeredScaling
		   * @method
		   * @param {Boolean} centeredScaling
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var centeredScaling = transformer.centeredScaling();
		   *
		   * // set
		   * transformer.centeredScaling(true);
		   */
		  Factory.addGetterSetter(Transformer, 'centeredScaling', false);
		  /**
		   * get/set should we think about stroke while resize? Good to use when a shape has strokeScaleEnabled = false
		   * default is false
		   * @name Konva.Transformer#ignoreStroke
		   * @method
		   * @param {Boolean} ignoreStroke
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var ignoreStroke = transformer.ignoreStroke();
		   *
		   * // set
		   * transformer.ignoreStroke(true);
		   */
		  Factory.addGetterSetter(Transformer, 'ignoreStroke', false);
		  /**
		   * get/set padding
		   * @name Konva.Transformer#padding
		   * @method
		   * @param {Number} padding
		   * @returns {Number}
		   * @example
		   * // get
		   * var padding = transformer.padding();
		   *
		   * // set
		   * transformer.padding(10);
		   */
		  Factory.addGetterSetter(Transformer, 'padding', 0, getNumberValidator());
		  Factory.addGetterSetter(Transformer, 'node');
		  /**
		   * get/set attached nodes of the Transformer. Transformer will adapt to their size and listen to their events
		   * @method
		   * @name Konva.Transformer#nodes
		   * @returns {Konva.Node}
		   * @example
		   * // get
		   * const nodes = transformer.nodes();
		   *
		   * // set
		   * transformer.nodes([rect, circle]);
		   *
		   * // push new item:
		   * const oldNodes = transformer.nodes();
		   * const newNodes = oldNodes.concat([newShape]);
		   * // it is important to set new array instance (and concat method above will create it)
		   * transformer.nodes(newNodes);
		   */
		  Factory.addGetterSetter(Transformer, 'nodes');
		  /**
		   * get/set bounding box function. **IMPORTANT!** boundBondFunc operates in absolute coordinates.
		   * @name Konva.Transformer#boundBoxFunc
		   * @method
		   * @param {Function} func
		   * @returns {Function}
		   * @example
		   * // get
		   * var boundBoxFunc = transformer.boundBoxFunc();
		   *
		   * // set
		   * transformer.boundBoxFunc(function(oldBox, newBox) {
		   *   // width and height of the boxes are corresponding to total absolute width and height of all nodes combined
		   *   // so it includes scale of the node.
		   *   if (newBox.width > 200) {
		   *     return oldBox;
		   *   }
		   *   return newBox;
		   * });
		   */
		  Factory.addGetterSetter(Transformer, 'boundBoxFunc');
		  /**
		   * get/set dragging func for transformer anchors
		   * @name Konva.Transformer#anchorDragBoundFunc
		   * @method
		   * @param {Function} func
		   * @returns {Function}
		   * @example
		   * // get
		   * var anchorDragBoundFunc = transformer.anchorDragBoundFunc();
		   *
		   * // set
		   * transformer.anchorDragBoundFunc(function(oldAbsPos, newAbsPos, event) {
		   *  return {
		   *   x: 0,
		   *   y: newAbsolutePosition.y
		   *  }
		   * });
		   */
		  Factory.addGetterSetter(Transformer, 'anchorDragBoundFunc');
		  /**
		   * get/set styling function for transformer anchors to overwrite default styles
		   * @name Konva.Transformer#anchorStyleFunc
		   * @method
		   * @param {Function} func
		   * @returns {Function}
		   * @example
		   * // get
		   * var anchorStyleFunc = transformer.anchorStyleFunc();
		   *
		   * // set
		   * transformer.anchorStyleFunc(function(anchor) {
		   *  // anchor is a simple Konva.Rect instance
		   *  // it will be executed AFTER all attributes are set, like 'anchorStrokeWidth' or 'anchorFill'
		   *  if (anchor.hasName('.rotater')) {
		   *    // make rotater anchor filled black and looks like a circle
		   *    anchor.fill('black');
		   *    anchor.cornerRadius(anchor.width() / 2);
		   *  }
		   * });
		   */
		  Factory.addGetterSetter(Transformer, 'anchorStyleFunc');
		  /**
		   * using this setting you can drag transformer group by dragging empty space between attached nodes
		   * shouldOverdrawWholeArea = true may temporary disable all events on attached nodes
		   * @name Konva.Transformer#shouldOverdrawWholeArea
		   * @method
		   * @param {Boolean} shouldOverdrawWholeArea
		   * @returns {Boolean}
		   * @example
		   * // get
		   * var shouldOverdrawWholeArea = transformer.shouldOverdrawWholeArea();
		   *
		   * // set
		   * transformer.shouldOverdrawWholeArea(true);
		   */
		  Factory.addGetterSetter(Transformer, 'shouldOverdrawWholeArea', false);
		  /**
		   * If you have just one attached node to Transformer it will set its initial rotation to the rotation of that node.
		   * In some cases you may need to set a different rotation.
		   * @name Konva.Transformer#useSingleNodeRotation
		   * @method
		   * @param {Boolean} useSingleNodeRotation
		   * @returns {Boolean}
		   * @example
		   * // set flag to false
		   * transformer.useSingleNodeRotation(false);
		   * // attach a shape
		   * transformer.nodes([shape]);
		   * transformer.rotation(45);
		   * transformer.update();
		   */
		  Factory.addGetterSetter(Transformer, 'useSingleNodeRotation', true);
		  Factory.backCompat(Transformer, {
		      lineEnabled: 'borderEnabled',
		      rotateHandlerOffset: 'rotateAnchorOffset',
		      enabledHandlers: 'enabledAnchors',
		  });

		  /**
		   * Wedge constructor
		   * @constructor
		   * @memberof Konva
		   * @augments Konva.Shape
		   * @param {Object} config
		   * @param {Number} config.angle in degrees
		   * @param {Number} config.radius
		   * @param {Boolean} [config.clockwise]
		   * @param {String} [config.fill] fill color
		     * @param {Image} [config.fillPatternImage] fill pattern image
		     * @param {Number} [config.fillPatternX]
		     * @param {Number} [config.fillPatternY]
		     * @param {Object} [config.fillPatternOffset] object with x and y component
		     * @param {Number} [config.fillPatternOffsetX] 
		     * @param {Number} [config.fillPatternOffsetY] 
		     * @param {Object} [config.fillPatternScale] object with x and y component
		     * @param {Number} [config.fillPatternScaleX]
		     * @param {Number} [config.fillPatternScaleY]
		     * @param {Number} [config.fillPatternRotation]
		     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
		     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientStartPointX]
		     * @param {Number} [config.fillLinearGradientStartPointY]
		     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillLinearGradientEndPointX]
		     * @param {Number} [config.fillLinearGradientEndPointY]
		     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
		     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientStartPointX]
		     * @param {Number} [config.fillRadialGradientStartPointY]
		     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
		     * @param {Number} [config.fillRadialGradientEndPointX] 
		     * @param {Number} [config.fillRadialGradientEndPointY] 
		     * @param {Number} [config.fillRadialGradientStartRadius]
		     * @param {Number} [config.fillRadialGradientEndRadius]
		     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
		     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
		     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
		     * @param {String} [config.stroke] stroke color
		     * @param {Number} [config.strokeWidth] stroke width
		     * @param {Boolean} [config.fillAfterStrokeEnabled]. Should we draw fill AFTER stroke? Default is false.
		     * @param {Number} [config.hitStrokeWidth] size of the stroke on hit canvas.  The default is "auto" - equals to strokeWidth
		     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
		     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
		     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shadow for stroke.  The default is true
		     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
		     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
		     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
		     *  is miter
		     * @param {String} [config.lineCap] can be butt, round, or square.  The default
		     *  is butt
		     * @param {String} [config.shadowColor]
		     * @param {Number} [config.shadowBlur]
		     * @param {Object} [config.shadowOffset] object with x and y component
		     * @param {Number} [config.shadowOffsetX]
		     * @param {Number} [config.shadowOffsetY]
		     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
		     *  between 0 and 1
		     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
		     * @param {Array} [config.dash]
		     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true

		   * @param {Number} [config.x]
		     * @param {Number} [config.y]
		     * @param {Number} [config.width]
		     * @param {Number} [config.height]
		     * @param {Boolean} [config.visible]
		     * @param {Boolean} [config.listening] whether or not the node is listening for events
		     * @param {String} [config.id] unique id
		     * @param {String} [config.name] non-unique name
		     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
		     * @param {Object} [config.scale] set scale
		     * @param {Number} [config.scaleX] set scale x
		     * @param {Number} [config.scaleY] set scale y
		     * @param {Number} [config.rotation] rotation in degrees
		     * @param {Object} [config.offset] offset from center point and rotation point
		     * @param {Number} [config.offsetX] set offset x
		     * @param {Number} [config.offsetY] set offset y
		     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
		     *  the entire stage by dragging any portion of the stage
		     * @param {Number} [config.dragDistance]
		     * @param {Function} [config.dragBoundFunc]
		   * @example
		   * // draw a wedge that's pointing downwards
		   * var wedge = new Konva.Wedge({
		   *   radius: 40,
		   *   fill: 'red',
		   *   stroke: 'black'
		   *   strokeWidth: 5,
		   *   angleDeg: 60,
		   *   rotationDeg: -120
		   * });
		   */
		  class Wedge extends Shape {
		      _sceneFunc(context) {
		          context.beginPath();
		          context.arc(0, 0, this.radius(), 0, Konva$2.getAngle(this.angle()), this.clockwise());
		          context.lineTo(0, 0);
		          context.closePath();
		          context.fillStrokeShape(this);
		      }
		      getWidth() {
		          return this.radius() * 2;
		      }
		      getHeight() {
		          return this.radius() * 2;
		      }
		      setWidth(width) {
		          this.radius(width / 2);
		      }
		      setHeight(height) {
		          this.radius(height / 2);
		      }
		  }
		  Wedge.prototype.className = 'Wedge';
		  Wedge.prototype._centroid = true;
		  Wedge.prototype._attrsAffectingSize = ['radius'];
		  _registerNode(Wedge);
		  /**
		   * get/set radius
		   * @name Konva.Wedge#radius
		   * @method
		   * @param {Number} radius
		   * @returns {Number}
		   * @example
		   * // get radius
		   * var radius = wedge.radius();
		   *
		   * // set radius
		   * wedge.radius(10);
		   */
		  Factory.addGetterSetter(Wedge, 'radius', 0, getNumberValidator());
		  /**
		   * get/set angle in degrees
		   * @name Konva.Wedge#angle
		   * @method
		   * @param {Number} angle
		   * @returns {Number}
		   * @example
		   * // get angle
		   * var angle = wedge.angle();
		   *
		   * // set angle
		   * wedge.angle(20);
		   */
		  Factory.addGetterSetter(Wedge, 'angle', 0, getNumberValidator());
		  /**
		   * get/set clockwise flag
		   * @name Konva.Wedge#clockwise
		   * @method
		   * @param {Number} clockwise
		   * @returns {Number}
		   * @example
		   * // get clockwise flag
		   * var clockwise = wedge.clockwise();
		   *
		   * // draw wedge counter-clockwise
		   * wedge.clockwise(false);
		   *
		   * // draw wedge clockwise
		   * wedge.clockwise(true);
		   */
		  Factory.addGetterSetter(Wedge, 'clockwise', false);
		  Factory.backCompat(Wedge, {
		      angleDeg: 'angle',
		      getAngleDeg: 'getAngle',
		      setAngleDeg: 'setAngle',
		  });

		  /*
		   the Gauss filter
		   master repo: https://github.com/pavelpower/kineticjsGaussFilter
		  */
		  /*

		       StackBlur - a fast almost Gaussian Blur For Canvas

		       Version:   0.5
		       Author:    Mario Klingemann
		       Contact:   mario@quasimondo.com
		       Website:   http://www.quasimondo.com/StackBlurForCanvas
		       Twitter:   @quasimondo

		       In case you find this class useful - especially in commercial projects -
		       I am not totally unhappy for a small donation to my PayPal account
		       mario@quasimondo.de

		       Or support me on flattr:
		       https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

		       Copyright (c) 2010 Mario Klingemann

		       Permission is hereby granted, free of charge, to any person
		       obtaining a copy of this software and associated documentation
		       files (the "Software"), to deal in the Software without
		       restriction, including without limitation the rights to use,
		       copy, modify, merge, publish, distribute, sublicense, and/or sell
		       copies of the Software, and to permit persons to whom the
		       Software is furnished to do so, subject to the following
		       conditions:

		       The above copyright notice and this permission notice shall be
		       included in all copies or substantial portions of the Software.

		       THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
		       EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
		       OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
		       NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
		       HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
		       WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
		       FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
		       OTHER DEALINGS IN THE SOFTWARE.
		       */
		  function BlurStack() {
		      this.r = 0;
		      this.g = 0;
		      this.b = 0;
		      this.a = 0;
		      this.next = null;
		  }
		  var mul_table = [
		      512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292,
		      512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292,
		      273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259,
		      496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292,
		      282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373,
		      364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259,
		      507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381,
		      374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292,
		      287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461,
		      454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373,
		      368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309,
		      305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259,
		      257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442,
		      437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381,
		      377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332,
		      329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292,
		      289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259,
		  ];
		  var shg_table = [
		      9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17,
		      17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19,
		      19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
		      20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
		      21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22,
		      22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
		      22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23,
		      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
		      23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
		      23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
		      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
		      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
		      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
		      24, 24, 24, 24, 24, 24, 24,
		  ];
		  function filterGaussBlurRGBA(imageData, radius) {
		      var pixels = imageData.data, width = imageData.width, height = imageData.height;
		      var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
		      var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = (radiusPlus1 * (radiusPlus1 + 1)) / 2, stackStart = new BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = mul_table[radius], shg_sum = shg_table[radius];
		      for (i = 1; i < div; i++) {
		          stack = stack.next = new BlurStack();
		          if (i === radiusPlus1) {
		              stackEnd = stack;
		          }
		      }
		      stack.next = stackStart;
		      yw = yi = 0;
		      for (y = 0; y < height; y++) {
		          r_in_sum =
		              g_in_sum =
		                  b_in_sum =
		                      a_in_sum =
		                          r_sum =
		                              g_sum =
		                                  b_sum =
		                                      a_sum =
		                                          0;
		          r_out_sum = radiusPlus1 * (pr = pixels[yi]);
		          g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
		          b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
		          a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
		          r_sum += sumFactor * pr;
		          g_sum += sumFactor * pg;
		          b_sum += sumFactor * pb;
		          a_sum += sumFactor * pa;
		          stack = stackStart;
		          for (i = 0; i < radiusPlus1; i++) {
		              stack.r = pr;
		              stack.g = pg;
		              stack.b = pb;
		              stack.a = pa;
		              stack = stack.next;
		          }
		          for (i = 1; i < radiusPlus1; i++) {
		              p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
		              r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
		              g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
		              b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
		              a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
		              r_in_sum += pr;
		              g_in_sum += pg;
		              b_in_sum += pb;
		              a_in_sum += pa;
		              stack = stack.next;
		          }
		          stackIn = stackStart;
		          stackOut = stackEnd;
		          for (x = 0; x < width; x++) {
		              pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
		              if (pa !== 0) {
		                  pa = 255 / pa;
		                  pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
		                  pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
		                  pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
		              }
		              else {
		                  pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
		              }
		              r_sum -= r_out_sum;
		              g_sum -= g_out_sum;
		              b_sum -= b_out_sum;
		              a_sum -= a_out_sum;
		              r_out_sum -= stackIn.r;
		              g_out_sum -= stackIn.g;
		              b_out_sum -= stackIn.b;
		              a_out_sum -= stackIn.a;
		              p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;
		              r_in_sum += stackIn.r = pixels[p];
		              g_in_sum += stackIn.g = pixels[p + 1];
		              b_in_sum += stackIn.b = pixels[p + 2];
		              a_in_sum += stackIn.a = pixels[p + 3];
		              r_sum += r_in_sum;
		              g_sum += g_in_sum;
		              b_sum += b_in_sum;
		              a_sum += a_in_sum;
		              stackIn = stackIn.next;
		              r_out_sum += pr = stackOut.r;
		              g_out_sum += pg = stackOut.g;
		              b_out_sum += pb = stackOut.b;
		              a_out_sum += pa = stackOut.a;
		              r_in_sum -= pr;
		              g_in_sum -= pg;
		              b_in_sum -= pb;
		              a_in_sum -= pa;
		              stackOut = stackOut.next;
		              yi += 4;
		          }
		          yw += width;
		      }
		      for (x = 0; x < width; x++) {
		          g_in_sum =
		              b_in_sum =
		                  a_in_sum =
		                      r_in_sum =
		                          g_sum =
		                              b_sum =
		                                  a_sum =
		                                      r_sum =
		                                          0;
		          yi = x << 2;
		          r_out_sum = radiusPlus1 * (pr = pixels[yi]);
		          g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
		          b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
		          a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
		          r_sum += sumFactor * pr;
		          g_sum += sumFactor * pg;
		          b_sum += sumFactor * pb;
		          a_sum += sumFactor * pa;
		          stack = stackStart;
		          for (i = 0; i < radiusPlus1; i++) {
		              stack.r = pr;
		              stack.g = pg;
		              stack.b = pb;
		              stack.a = pa;
		              stack = stack.next;
		          }
		          yp = width;
		          for (i = 1; i <= radius; i++) {
		              yi = (yp + x) << 2;
		              r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
		              g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
		              b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
		              a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
		              r_in_sum += pr;
		              g_in_sum += pg;
		              b_in_sum += pb;
		              a_in_sum += pa;
		              stack = stack.next;
		              if (i < heightMinus1) {
		                  yp += width;
		              }
		          }
		          yi = x;
		          stackIn = stackStart;
		          stackOut = stackEnd;
		          for (y = 0; y < height; y++) {
		              p = yi << 2;
		              pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
		              if (pa > 0) {
		                  pa = 255 / pa;
		                  pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
		                  pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
		                  pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
		              }
		              else {
		                  pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
		              }
		              r_sum -= r_out_sum;
		              g_sum -= g_out_sum;
		              b_sum -= b_out_sum;
		              a_sum -= a_out_sum;
		              r_out_sum -= stackIn.r;
		              g_out_sum -= stackIn.g;
		              b_out_sum -= stackIn.b;
		              a_out_sum -= stackIn.a;
		              p =
		                  (x +
		                      ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width) <<
		                      2;
		              r_sum += r_in_sum += stackIn.r = pixels[p];
		              g_sum += g_in_sum += stackIn.g = pixels[p + 1];
		              b_sum += b_in_sum += stackIn.b = pixels[p + 2];
		              a_sum += a_in_sum += stackIn.a = pixels[p + 3];
		              stackIn = stackIn.next;
		              r_out_sum += pr = stackOut.r;
		              g_out_sum += pg = stackOut.g;
		              b_out_sum += pb = stackOut.b;
		              a_out_sum += pa = stackOut.a;
		              r_in_sum -= pr;
		              g_in_sum -= pg;
		              b_in_sum -= pb;
		              a_in_sum -= pa;
		              stackOut = stackOut.next;
		              yi += width;
		          }
		      }
		  }
		  /**
		   * Blur Filter
		   * @function
		   * @name Blur
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Blur]);
		   * node.blurRadius(10);
		   */
		  const Blur = function Blur(imageData) {
		      var radius = Math.round(this.blurRadius());
		      if (radius > 0) {
		          filterGaussBlurRGBA(imageData, radius);
		      }
		  };
		  Factory.addGetterSetter(Node, 'blurRadius', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set blur radius. Use with {@link Konva.Filters.Blur} filter
		   * @name Konva.Node#blurRadius
		   * @method
		   * @param {Integer} radius
		   * @returns {Integer}
		   */

		  /**
		   * Brighten Filter.
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Brighten]);
		   * node.brightness(0.8);
		   */
		  const Brighten = function (imageData) {
		      var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
		      for (i = 0; i < len; i += 4) {
		          // red
		          data[i] += brightness;
		          // green
		          data[i + 1] += brightness;
		          // blue
		          data[i + 2] += brightness;
		      }
		  };
		  Factory.addGetterSetter(Node, 'brightness', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set filter brightness.  The brightness is a number between -1 and 1.&nbsp; Positive values
		   *  brighten the pixels and negative values darken them. Use with {@link Konva.Filters.Brighten} filter.
		   * @name Konva.Node#brightness
		   * @method

		   * @param {Number} brightness value between -1 and 1
		   * @returns {Number}
		   */

		  /**
		   * Contrast Filter.
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Contrast]);
		   * node.contrast(10);
		   */
		  const Contrast = function (imageData) {
		      var adjust = Math.pow((this.contrast() + 100) / 100, 2);
		      var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
		      for (i = 0; i < nPixels; i += 4) {
		          red = data[i];
		          green = data[i + 1];
		          blue = data[i + 2];
		          //Red channel
		          red /= 255;
		          red -= 0.5;
		          red *= adjust;
		          red += 0.5;
		          red *= 255;
		          //Green channel
		          green /= 255;
		          green -= 0.5;
		          green *= adjust;
		          green += 0.5;
		          green *= 255;
		          //Blue channel
		          blue /= 255;
		          blue -= 0.5;
		          blue *= adjust;
		          blue += 0.5;
		          blue *= 255;
		          red = red < 0 ? 0 : red > 255 ? 255 : red;
		          green = green < 0 ? 0 : green > 255 ? 255 : green;
		          blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
		          data[i] = red;
		          data[i + 1] = green;
		          data[i + 2] = blue;
		      }
		  };
		  /**
		   * get/set filter contrast.  The contrast is a number between -100 and 100.
		   * Use with {@link Konva.Filters.Contrast} filter.
		   * @name Konva.Node#contrast
		   * @method
		   * @param {Number} contrast value between -100 and 100
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'contrast', 0, getNumberValidator(), Factory.afterSetFilter);

		  /**
		   * Emboss Filter.
		   * Pixastic Lib - Emboss filter - v0.1.0
		   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
		   * License: [http://www.pixastic.com/lib/license.txt]
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Emboss]);
		   * node.embossStrength(0.8);
		   * node.embossWhiteLevel(0.3);
		   * node.embossDirection('right');
		   * node.embossBlend(true);
		   */
		  const Emboss = function (imageData) {
		      // pixastic strength is between 0 and 10.  I want it between 0 and 1
		      // pixastic greyLevel is between 0 and 255.  I want it between 0 and 1.  Also,
		      // a max value of greyLevel yields a white emboss, and the min value yields a black
		      // emboss.  Therefore, I changed greyLevel to whiteLevel
		      var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
		      switch (direction) {
		          case 'top-left':
		              dirY = -1;
		              dirX = -1;
		              break;
		          case 'top':
		              dirY = -1;
		              dirX = 0;
		              break;
		          case 'top-right':
		              dirY = -1;
		              dirX = 1;
		              break;
		          case 'right':
		              dirY = 0;
		              dirX = 1;
		              break;
		          case 'bottom-right':
		              dirY = 1;
		              dirX = 1;
		              break;
		          case 'bottom':
		              dirY = 1;
		              dirX = 0;
		              break;
		          case 'bottom-left':
		              dirY = 1;
		              dirX = -1;
		              break;
		          case 'left':
		              dirY = 0;
		              dirX = -1;
		              break;
		          default:
		              Util.error('Unknown emboss direction: ' + direction);
		      }
		      do {
		          var offsetY = (y - 1) * w4;
		          var otherY = dirY;
		          if (y + otherY < 1) {
		              otherY = 0;
		          }
		          if (y + otherY > h) {
		              otherY = 0;
		          }
		          var offsetYOther = (y - 1 + otherY) * w * 4;
		          var x = w;
		          do {
		              var offset = offsetY + (x - 1) * 4;
		              var otherX = dirX;
		              if (x + otherX < 1) {
		                  otherX = 0;
		              }
		              if (x + otherX > w) {
		                  otherX = 0;
		              }
		              var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
		              var dR = data[offset] - data[offsetOther];
		              var dG = data[offset + 1] - data[offsetOther + 1];
		              var dB = data[offset + 2] - data[offsetOther + 2];
		              var dif = dR;
		              var absDif = dif > 0 ? dif : -dif;
		              var absG = dG > 0 ? dG : -dG;
		              var absB = dB > 0 ? dB : -dB;
		              if (absG > absDif) {
		                  dif = dG;
		              }
		              if (absB > absDif) {
		                  dif = dB;
		              }
		              dif *= strength;
		              if (blend) {
		                  var r = data[offset] + dif;
		                  var g = data[offset + 1] + dif;
		                  var b = data[offset + 2] + dif;
		                  data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
		                  data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
		                  data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
		              }
		              else {
		                  var grey = greyLevel - dif;
		                  if (grey < 0) {
		                      grey = 0;
		                  }
		                  else if (grey > 255) {
		                      grey = 255;
		                  }
		                  data[offset] = data[offset + 1] = data[offset + 2] = grey;
		              }
		          } while (--x);
		      } while (--y);
		  };
		  Factory.addGetterSetter(Node, 'embossStrength', 0.5, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set emboss strength. Use with {@link Konva.Filters.Emboss} filter.
		   * @name Konva.Node#embossStrength
		   * @method
		   * @param {Number} level between 0 and 1.  Default is 0.5
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'embossWhiteLevel', 0.5, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set emboss white level. Use with {@link Konva.Filters.Emboss} filter.
		   * @name Konva.Node#embossWhiteLevel
		   * @method
		   * @param {Number} embossWhiteLevel between 0 and 1.  Default is 0.5
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'embossDirection', 'top-left', null, Factory.afterSetFilter);
		  /**
		   * get/set emboss direction. Use with {@link Konva.Filters.Emboss} filter.
		   * @name Konva.Node#embossDirection
		   * @method
		   * @param {String} embossDirection can be top-left, top, top-right, right, bottom-right, bottom, bottom-left or left
		   *   The default is top-left
		   * @returns {String}
		   */
		  Factory.addGetterSetter(Node, 'embossBlend', false, null, Factory.afterSetFilter);
		  /**
		   * get/set emboss blend. Use with {@link Konva.Filters.Emboss} filter.
		   * @name Konva.Node#embossBlend
		   * @method
		   * @param {Boolean} embossBlend
		   * @returns {Boolean}
		   */

		  function remap(fromValue, fromMin, fromMax, toMin, toMax) {
		      // Compute the range of the data
		      var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
		      // If either range is 0, then the value can only be mapped to 1 value
		      if (fromRange === 0) {
		          return toMin + toRange / 2;
		      }
		      if (toRange === 0) {
		          return toMin;
		      }
		      // (1) untranslate, (2) unscale, (3) rescale, (4) retranslate
		      toValue = (fromValue - fromMin) / fromRange;
		      toValue = toRange * toValue + toMin;
		      return toValue;
		  }
		  /**
		   * Enhance Filter. Adjusts the colors so that they span the widest
		   *  possible range (ie 0-255). Performs w*h pixel reads and w*h pixel
		   *  writes.
		   * @function
		   * @name Enhance
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Enhance]);
		   * node.enhance(0.4);
		   */
		  const Enhance = function (imageData) {
		      var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
		      // If we are not enhancing anything - don't do any computation
		      var enhanceAmount = this.enhance();
		      if (enhanceAmount === 0) {
		          return;
		      }
		      // 1st Pass - find the min and max for each channel:
		      for (i = 0; i < nSubPixels; i += 4) {
		          r = data[i + 0];
		          if (r < rMin) {
		              rMin = r;
		          }
		          else if (r > rMax) {
		              rMax = r;
		          }
		          g = data[i + 1];
		          if (g < gMin) {
		              gMin = g;
		          }
		          else if (g > gMax) {
		              gMax = g;
		          }
		          b = data[i + 2];
		          if (b < bMin) {
		              bMin = b;
		          }
		          else if (b > bMax) {
		              bMax = b;
		          }
		          //a = data[i + 3];
		          //if (a < aMin) { aMin = a; } else
		          //if (a > aMax) { aMax = a; }
		      }
		      // If there is only 1 level - don't remap
		      if (rMax === rMin) {
		          rMax = 255;
		          rMin = 0;
		      }
		      if (gMax === gMin) {
		          gMax = 255;
		          gMin = 0;
		      }
		      if (bMax === bMin) {
		          bMax = 255;
		          bMin = 0;
		      }
		      var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
		      // If the enhancement is positive - stretch the histogram
		      if (enhanceAmount > 0) {
		          rGoalMax = rMax + enhanceAmount * (255 - rMax);
		          rGoalMin = rMin - enhanceAmount * (rMin - 0);
		          gGoalMax = gMax + enhanceAmount * (255 - gMax);
		          gGoalMin = gMin - enhanceAmount * (gMin - 0);
		          bGoalMax = bMax + enhanceAmount * (255 - bMax);
		          bGoalMin = bMin - enhanceAmount * (bMin - 0);
		          // If the enhancement is negative -   compress the histogram
		      }
		      else {
		          rMid = (rMax + rMin) * 0.5;
		          rGoalMax = rMax + enhanceAmount * (rMax - rMid);
		          rGoalMin = rMin + enhanceAmount * (rMin - rMid);
		          gMid = (gMax + gMin) * 0.5;
		          gGoalMax = gMax + enhanceAmount * (gMax - gMid);
		          gGoalMin = gMin + enhanceAmount * (gMin - gMid);
		          bMid = (bMax + bMin) * 0.5;
		          bGoalMax = bMax + enhanceAmount * (bMax - bMid);
		          bGoalMin = bMin + enhanceAmount * (bMin - bMid);
		      }
		      // Pass 2 - remap everything, except the alpha
		      for (i = 0; i < nSubPixels; i += 4) {
		          data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
		          data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
		          data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
		          //data[i + 3] = remap(data[i + 3], aMin, aMax, aGoalMin, aGoalMax);
		      }
		  };
		  /**
		   * get/set enhance. Use with {@link Konva.Filters.Enhance} filter. -1 to 1 values
		   * @name Konva.Node#enhance
		   * @method
		   * @param {Float} amount
		   * @returns {Float}
		   */
		  Factory.addGetterSetter(Node, 'enhance', 0, getNumberValidator(), Factory.afterSetFilter);

		  /**
		   * Grayscale Filter
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Grayscale]);
		   */
		  const Grayscale = function (imageData) {
		      var data = imageData.data, len = data.length, i, brightness;
		      for (i = 0; i < len; i += 4) {
		          brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
		          // red
		          data[i] = brightness;
		          // green
		          data[i + 1] = brightness;
		          // blue
		          data[i + 2] = brightness;
		      }
		  };

		  Factory.addGetterSetter(Node, 'hue', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
		   * @name Konva.Node#hue
		   * @method
		   * @param {Number} hue value between 0 and 359
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'saturation', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
		   * @name Konva.Node#saturation
		   * @method
		   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'luminance', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsl luminance. Use with {@link Konva.Filters.HSL} filter.
		   * @name Konva.Node#luminance
		   * @method
		   * @param {Number} value from -1 to 1
		   * @returns {Number}
		   */
		  /**
		   * HSL Filter. Adjusts the hue, saturation and luminance (or lightness)
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * image.filters([Konva.Filters.HSL]);
		   * image.luminance(0.2);
		   */
		  const HSL = function (imageData) {
		      var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
		      // Basis for the technique used:
		      // http://beesbuzz.biz/code/hsv_color_transforms.php
		      // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
		      // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
		      // H is the hue shift in degrees (0 to 360)
		      // vsu = V*S*cos(H*PI/180);
		      // vsw = V*S*sin(H*PI/180);
		      //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
		      //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
		      //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
		      // Precompute the values in the matrix:
		      var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
		      // (result spot)(source spot)
		      var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
		      var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
		      var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
		      var r, g, b, a;
		      for (i = 0; i < nPixels; i += 4) {
		          r = data[i + 0];
		          g = data[i + 1];
		          b = data[i + 2];
		          a = data[i + 3];
		          data[i + 0] = rr * r + rg * g + rb * b + l;
		          data[i + 1] = gr * r + gg * g + gb * b + l;
		          data[i + 2] = br * r + bg * g + bb * b + l;
		          data[i + 3] = a; // alpha
		      }
		  };

		  /**
		   * HSV Filter. Adjusts the hue, saturation and value
		   * @function
		   * @name HSV
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * image.filters([Konva.Filters.HSV]);
		   * image.value(200);
		   */
		  const HSV = function (imageData) {
		      var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
		      // Basis for the technique used:
		      // http://beesbuzz.biz/code/hsv_color_transforms.php
		      // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
		      // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
		      // H is the hue shift in degrees (0 to 360)
		      // vsu = V*S*cos(H*PI/180);
		      // vsw = V*S*sin(H*PI/180);
		      //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
		      //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
		      //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
		      // Precompute the values in the matrix:
		      var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
		      // (result spot)(source spot)
		      var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
		      var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
		      var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
		      var r, g, b, a;
		      for (i = 0; i < nPixels; i += 4) {
		          r = data[i + 0];
		          g = data[i + 1];
		          b = data[i + 2];
		          a = data[i + 3];
		          data[i + 0] = rr * r + rg * g + rb * b;
		          data[i + 1] = gr * r + gg * g + gb * b;
		          data[i + 2] = br * r + bg * g + bb * b;
		          data[i + 3] = a; // alpha
		      }
		  };
		  Factory.addGetterSetter(Node, 'hue', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
		   * @name Konva.Node#hue
		   * @method
		   * @param {Number} hue value between 0 and 359
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'saturation', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
		   * @name Konva.Node#saturation
		   * @method
		   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
		   * @returns {Number}
		   */
		  Factory.addGetterSetter(Node, 'value', 0, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set hsv value. Use with {@link Konva.Filters.HSV} filter.
		   * @name Konva.Node#value
		   * @method
		   * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
		   * @returns {Number}
		   */

		  /**
		   * Invert Filter
		   * @function
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Invert]);
		   */
		  const Invert = function (imageData) {
		      var data = imageData.data, len = data.length, i;
		      for (i = 0; i < len; i += 4) {
		          // red
		          data[i] = 255 - data[i];
		          // green
		          data[i + 1] = 255 - data[i + 1];
		          // blue
		          data[i + 2] = 255 - data[i + 2];
		      }
		  };

		  /*
		   * ToPolar Filter. Converts image data to polar coordinates. Performs
		   *  w*h*4 pixel reads and w*h pixel writes. The r axis is placed along
		   *  what would be the y axis and the theta axis along the x axis.
		   * @function
		   * @author ippo615
		   * @memberof Konva.Filters
		   * @param {ImageData} src, the source image data (what will be transformed)
		   * @param {ImageData} dst, the destination image data (where it will be saved)
		   * @param {Object} opt
		   * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
		   *  default is in the middle
		   * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
		   *  default is in the middle
		   */
		  var ToPolar = function (src, dst, opt) {
		      var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
		      // Find the largest radius
		      var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
		      x = xSize - xMid;
		      y = ySize - yMid;
		      rad = Math.sqrt(x * x + y * y);
		      rMax = rad > rMax ? rad : rMax;
		      // We'll be uisng y as the radius, and x as the angle (theta=t)
		      var rSize = ySize, tSize = xSize, radius, theta;
		      // We want to cover all angles (0-360) and we need to convert to
		      // radians (*PI/180)
		      var conversion = ((360 / tSize) * Math.PI) / 180, sin, cos;
		      // var x1, x2, x1i, x2i, y1, y2, y1i, y2i, scale;
		      for (theta = 0; theta < tSize; theta += 1) {
		          sin = Math.sin(theta * conversion);
		          cos = Math.cos(theta * conversion);
		          for (radius = 0; radius < rSize; radius += 1) {
		              x = Math.floor(xMid + ((rMax * radius) / rSize) * cos);
		              y = Math.floor(yMid + ((rMax * radius) / rSize) * sin);
		              i = (y * xSize + x) * 4;
		              r = srcPixels[i + 0];
		              g = srcPixels[i + 1];
		              b = srcPixels[i + 2];
		              a = srcPixels[i + 3];
		              // Store it
		              //i = (theta * xSize  +  radius) * 4;
		              i = (theta + radius * xSize) * 4;
		              dstPixels[i + 0] = r;
		              dstPixels[i + 1] = g;
		              dstPixels[i + 2] = b;
		              dstPixels[i + 3] = a;
		          }
		      }
		  };
		  /*
		   * FromPolar Filter. Converts image data from polar coordinates back to rectangular.
		   *  Performs w*h*4 pixel reads and w*h pixel writes.
		   * @function
		   * @author ippo615
		   * @memberof Konva.Filters
		   * @param {ImageData} src, the source image data (what will be transformed)
		   * @param {ImageData} dst, the destination image data (where it will be saved)
		   * @param {Object} opt
		   * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
		   *  default is in the middle
		   * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
		   *  default is in the middle
		   * @param {Number} [opt.polarRotation] amount to rotate the image counterclockwis,
		   *  0 is no rotation, 360 degrees is a full rotation
		   */
		  var FromPolar = function (src, dst, opt) {
		      var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
		      // Find the largest radius
		      var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
		      x = xSize - xMid;
		      y = ySize - yMid;
		      rad = Math.sqrt(x * x + y * y);
		      rMax = rad > rMax ? rad : rMax;
		      // We'll be uisng x as the radius, and y as the angle (theta=t)
		      var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
		      // We need to convert to degrees and we need to make sure
		      // it's between (0-360)
		      // var conversion = tSize/360*180/Math.PI;
		      //var conversion = tSize/360*180/Math.PI;
		      var x1, y1;
		      for (x = 0; x < xSize; x += 1) {
		          for (y = 0; y < ySize; y += 1) {
		              dx = x - xMid;
		              dy = y - yMid;
		              radius = (Math.sqrt(dx * dx + dy * dy) * rSize) / rMax;
		              theta = ((Math.atan2(dy, dx) * 180) / Math.PI + 360 + phaseShift) % 360;
		              theta = (theta * tSize) / 360;
		              x1 = Math.floor(theta);
		              y1 = Math.floor(radius);
		              i = (y1 * xSize + x1) * 4;
		              r = srcPixels[i + 0];
		              g = srcPixels[i + 1];
		              b = srcPixels[i + 2];
		              a = srcPixels[i + 3];
		              // Store it
		              i = (y * xSize + x) * 4;
		              dstPixels[i + 0] = r;
		              dstPixels[i + 1] = g;
		              dstPixels[i + 2] = b;
		              dstPixels[i + 3] = a;
		          }
		      }
		  };
		  //Konva.Filters.ToPolar = Util._FilterWrapDoubleBuffer(ToPolar);
		  //Konva.Filters.FromPolar = Util._FilterWrapDoubleBuffer(FromPolar);
		  // create a temporary canvas for working - shared between multiple calls
		  /*
		   * Kaleidoscope Filter.
		   * @function
		   * @name Kaleidoscope
		   * @author ippo615
		   * @memberof Konva.Filters
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Kaleidoscope]);
		   * node.kaleidoscopePower(3);
		   * node.kaleidoscopeAngle(45);
		   */
		  const Kaleidoscope = function (imageData) {
		      var xSize = imageData.width, ySize = imageData.height;
		      var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
		      var power = Math.round(this.kaleidoscopePower());
		      var angle = Math.round(this.kaleidoscopeAngle());
		      var offset = Math.floor((xSize * (angle % 360)) / 360);
		      if (power < 1) {
		          return;
		      }
		      // Work with our shared buffer canvas
		      var tempCanvas = Util.createCanvasElement();
		      tempCanvas.width = xSize;
		      tempCanvas.height = ySize;
		      var scratchData = tempCanvas
		          .getContext('2d')
		          .getImageData(0, 0, xSize, ySize);
		      Util.releaseCanvas(tempCanvas);
		      // Convert thhe original to polar coordinates
		      ToPolar(imageData, scratchData, {
		          polarCenterX: xSize / 2,
		          polarCenterY: ySize / 2,
		      });
		      // Determine how big each section will be, if it's too small
		      // make it bigger
		      var minSectionSize = xSize / Math.pow(2, power);
		      while (minSectionSize <= 8) {
		          minSectionSize = minSectionSize * 2;
		          power -= 1;
		      }
		      minSectionSize = Math.ceil(minSectionSize);
		      var sectionSize = minSectionSize;
		      // Copy the offset region to 0
		      // Depending on the size of filter and location of the offset we may need
		      // to copy the section backwards to prevent it from rewriting itself
		      var xStart = 0, xEnd = sectionSize, xDelta = 1;
		      if (offset + minSectionSize > xSize) {
		          xStart = sectionSize;
		          xEnd = 0;
		          xDelta = -1;
		      }
		      for (y = 0; y < ySize; y += 1) {
		          for (x = xStart; x !== xEnd; x += xDelta) {
		              xoff = Math.round(x + offset) % xSize;
		              srcPos = (xSize * y + xoff) * 4;
		              r = scratchData.data[srcPos + 0];
		              g = scratchData.data[srcPos + 1];
		              b = scratchData.data[srcPos + 2];
		              a = scratchData.data[srcPos + 3];
		              dstPos = (xSize * y + x) * 4;
		              scratchData.data[dstPos + 0] = r;
		              scratchData.data[dstPos + 1] = g;
		              scratchData.data[dstPos + 2] = b;
		              scratchData.data[dstPos + 3] = a;
		          }
		      }
		      // Perform the actual effect
		      for (y = 0; y < ySize; y += 1) {
		          sectionSize = Math.floor(minSectionSize);
		          for (i = 0; i < power; i += 1) {
		              for (x = 0; x < sectionSize + 1; x += 1) {
		                  srcPos = (xSize * y + x) * 4;
		                  r = scratchData.data[srcPos + 0];
		                  g = scratchData.data[srcPos + 1];
		                  b = scratchData.data[srcPos + 2];
		                  a = scratchData.data[srcPos + 3];
		                  dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
		                  scratchData.data[dstPos + 0] = r;
		                  scratchData.data[dstPos + 1] = g;
		                  scratchData.data[dstPos + 2] = b;
		                  scratchData.data[dstPos + 3] = a;
		              }
		              sectionSize *= 2;
		          }
		      }
		      // Convert back from polar coordinates
		      FromPolar(scratchData, imageData, { polarRotation: 0 });
		  };
		  /**
		   * get/set kaleidoscope power. Use with {@link Konva.Filters.Kaleidoscope} filter.
		   * @name Konva.Node#kaleidoscopePower
		   * @method
		   * @param {Integer} power of kaleidoscope
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'kaleidoscopePower', 2, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set kaleidoscope angle. Use with {@link Konva.Filters.Kaleidoscope} filter.
		   * @name Konva.Node#kaleidoscopeAngle
		   * @method
		   * @param {Integer} degrees
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'kaleidoscopeAngle', 0, getNumberValidator(), Factory.afterSetFilter);

		  function pixelAt(idata, x, y) {
		      var idx = (y * idata.width + x) * 4;
		      var d = [];
		      d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
		      return d;
		  }
		  function rgbDistance(p1, p2) {
		      return Math.sqrt(Math.pow(p1[0] - p2[0], 2) +
		          Math.pow(p1[1] - p2[1], 2) +
		          Math.pow(p1[2] - p2[2], 2));
		  }
		  function rgbMean(pTab) {
		      var m = [0, 0, 0];
		      for (var i = 0; i < pTab.length; i++) {
		          m[0] += pTab[i][0];
		          m[1] += pTab[i][1];
		          m[2] += pTab[i][2];
		      }
		      m[0] /= pTab.length;
		      m[1] /= pTab.length;
		      m[2] /= pTab.length;
		      return m;
		  }
		  function backgroundMask(idata, threshold) {
		      var rgbv_no = pixelAt(idata, 0, 0);
		      var rgbv_ne = pixelAt(idata, idata.width - 1, 0);
		      var rgbv_so = pixelAt(idata, 0, idata.height - 1);
		      var rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
		      var thres = threshold || 10;
		      if (rgbDistance(rgbv_no, rgbv_ne) < thres &&
		          rgbDistance(rgbv_ne, rgbv_se) < thres &&
		          rgbDistance(rgbv_se, rgbv_so) < thres &&
		          rgbDistance(rgbv_so, rgbv_no) < thres) {
		          // Mean color
		          var mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
		          // Mask based on color distance
		          var mask = [];
		          for (var i = 0; i < idata.width * idata.height; i++) {
		              var d = rgbDistance(mean, [
		                  idata.data[i * 4],
		                  idata.data[i * 4 + 1],
		                  idata.data[i * 4 + 2],
		              ]);
		              mask[i] = d < thres ? 0 : 255;
		          }
		          return mask;
		      }
		  }
		  function applyMask(idata, mask) {
		      for (var i = 0; i < idata.width * idata.height; i++) {
		          idata.data[4 * i + 3] = mask[i];
		      }
		  }
		  function erodeMask(mask, sw, sh) {
		      var weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
		      var side = Math.round(Math.sqrt(weights.length));
		      var halfSide = Math.floor(side / 2);
		      var maskResult = [];
		      for (var y = 0; y < sh; y++) {
		          for (var x = 0; x < sw; x++) {
		              var so = y * sw + x;
		              var a = 0;
		              for (var cy = 0; cy < side; cy++) {
		                  for (var cx = 0; cx < side; cx++) {
		                      var scy = y + cy - halfSide;
		                      var scx = x + cx - halfSide;
		                      if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
		                          var srcOff = scy * sw + scx;
		                          var wt = weights[cy * side + cx];
		                          a += mask[srcOff] * wt;
		                      }
		                  }
		              }
		              maskResult[so] = a === 255 * 8 ? 255 : 0;
		          }
		      }
		      return maskResult;
		  }
		  function dilateMask(mask, sw, sh) {
		      var weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
		      var side = Math.round(Math.sqrt(weights.length));
		      var halfSide = Math.floor(side / 2);
		      var maskResult = [];
		      for (var y = 0; y < sh; y++) {
		          for (var x = 0; x < sw; x++) {
		              var so = y * sw + x;
		              var a = 0;
		              for (var cy = 0; cy < side; cy++) {
		                  for (var cx = 0; cx < side; cx++) {
		                      var scy = y + cy - halfSide;
		                      var scx = x + cx - halfSide;
		                      if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
		                          var srcOff = scy * sw + scx;
		                          var wt = weights[cy * side + cx];
		                          a += mask[srcOff] * wt;
		                      }
		                  }
		              }
		              maskResult[so] = a >= 255 * 4 ? 255 : 0;
		          }
		      }
		      return maskResult;
		  }
		  function smoothEdgeMask(mask, sw, sh) {
		      var weights = [1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9];
		      var side = Math.round(Math.sqrt(weights.length));
		      var halfSide = Math.floor(side / 2);
		      var maskResult = [];
		      for (var y = 0; y < sh; y++) {
		          for (var x = 0; x < sw; x++) {
		              var so = y * sw + x;
		              var a = 0;
		              for (var cy = 0; cy < side; cy++) {
		                  for (var cx = 0; cx < side; cx++) {
		                      var scy = y + cy - halfSide;
		                      var scx = x + cx - halfSide;
		                      if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
		                          var srcOff = scy * sw + scx;
		                          var wt = weights[cy * side + cx];
		                          a += mask[srcOff] * wt;
		                      }
		                  }
		              }
		              maskResult[so] = a;
		          }
		      }
		      return maskResult;
		  }
		  /**
		   * Mask Filter
		   * @function
		   * @name Mask
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Mask]);
		   * node.threshold(200);
		   */
		  const Mask = function (imageData) {
		      // Detect pixels close to the background color
		      var threshold = this.threshold(), mask = backgroundMask(imageData, threshold);
		      if (mask) {
		          // Erode
		          mask = erodeMask(mask, imageData.width, imageData.height);
		          // Dilate
		          mask = dilateMask(mask, imageData.width, imageData.height);
		          // Gradient
		          mask = smoothEdgeMask(mask, imageData.width, imageData.height);
		          // Apply mask
		          applyMask(imageData, mask);
		      }
		      return imageData;
		  };
		  Factory.addGetterSetter(Node, 'threshold', 0, getNumberValidator(), Factory.afterSetFilter);

		  /**
		   * Noise Filter. Randomly adds or substracts to the color channels
		   * @function
		   * @name Noise
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Noise]);
		   * node.noise(0.8);
		   */
		  const Noise = function (imageData) {
		      var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
		      for (i = 0; i < nPixels; i += 4) {
		          data[i + 0] += half - 2 * half * Math.random();
		          data[i + 1] += half - 2 * half * Math.random();
		          data[i + 2] += half - 2 * half * Math.random();
		      }
		  };
		  Factory.addGetterSetter(Node, 'noise', 0.2, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set noise amount.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Noise} filter.
		   * @name Konva.Node#noise
		   * @method
		   * @param {Number} noise
		   * @returns {Number}
		   */

		  /*eslint-disable max-depth */
		  /**
		   * Pixelate Filter. Averages groups of pixels and redraws
		   *  them as larger pixels
		   * @function
		   * @name Pixelate
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Pixelate]);
		   * node.pixelSize(10);
		   */
		  const Pixelate = function (imageData) {
		      var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, 
		      //pixelsPerBin = pixelSize * pixelSize,
		      red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
		      if (pixelSize <= 0) {
		          Util.error('pixelSize value can not be <= 0');
		          return;
		      }
		      for (xBin = 0; xBin < nBinsX; xBin += 1) {
		          for (yBin = 0; yBin < nBinsY; yBin += 1) {
		              // Initialize the color accumlators to 0
		              red = 0;
		              green = 0;
		              blue = 0;
		              alpha = 0;
		              // Determine which pixels are included in this bin
		              xBinStart = xBin * pixelSize;
		              xBinEnd = xBinStart + pixelSize;
		              yBinStart = yBin * pixelSize;
		              yBinEnd = yBinStart + pixelSize;
		              // Add all of the pixels to this bin!
		              pixelsInBin = 0;
		              for (x = xBinStart; x < xBinEnd; x += 1) {
		                  if (x >= width) {
		                      continue;
		                  }
		                  for (y = yBinStart; y < yBinEnd; y += 1) {
		                      if (y >= height) {
		                          continue;
		                      }
		                      i = (width * y + x) * 4;
		                      red += data[i + 0];
		                      green += data[i + 1];
		                      blue += data[i + 2];
		                      alpha += data[i + 3];
		                      pixelsInBin += 1;
		                  }
		              }
		              // Make sure the channels are between 0-255
		              red = red / pixelsInBin;
		              green = green / pixelsInBin;
		              blue = blue / pixelsInBin;
		              alpha = alpha / pixelsInBin;
		              // Draw this bin
		              for (x = xBinStart; x < xBinEnd; x += 1) {
		                  if (x >= width) {
		                      continue;
		                  }
		                  for (y = yBinStart; y < yBinEnd; y += 1) {
		                      if (y >= height) {
		                          continue;
		                      }
		                      i = (width * y + x) * 4;
		                      data[i + 0] = red;
		                      data[i + 1] = green;
		                      data[i + 2] = blue;
		                      data[i + 3] = alpha;
		                  }
		              }
		          }
		      }
		  };
		  Factory.addGetterSetter(Node, 'pixelSize', 8, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set pixel size. Use with {@link Konva.Filters.Pixelate} filter.
		   * @name Konva.Node#pixelSize
		   * @method
		   * @param {Integer} pixelSize
		   * @returns {Integer}
		   */

		  /**
		   * Posterize Filter. Adjusts the channels so that there are no more
		   *  than n different values for that channel. This is also applied
		   *  to the alpha channel.
		   * @function
		   * @name Posterize
		   * @author ippo615
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Posterize]);
		   * node.levels(0.8); // between 0 and 1
		   */
		  const Posterize = function (imageData) {
		      // level must be between 1 and 255
		      var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
		      for (i = 0; i < len; i += 1) {
		          data[i] = Math.floor(data[i] / scale) * scale;
		      }
		  };
		  Factory.addGetterSetter(Node, 'levels', 0.5, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set levels.  Must be a number between 0 and 1.  Use with {@link Konva.Filters.Posterize} filter.
		   * @name Konva.Node#levels
		   * @method
		   * @param {Number} level between 0 and 1
		   * @returns {Number}
		   */

		  /**
		   * RGB Filter
		   * @function
		   * @name RGB
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.RGB]);
		   * node.blue(120);
		   * node.green(200);
		   */
		  const RGB = function (imageData) {
		      var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
		      for (i = 0; i < nPixels; i += 4) {
		          brightness =
		              (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
		          data[i] = brightness * red; // r
		          data[i + 1] = brightness * green; // g
		          data[i + 2] = brightness * blue; // b
		          data[i + 3] = data[i + 3]; // alpha
		      }
		  };
		  Factory.addGetterSetter(Node, 'red', 0, function (val) {
		      this._filterUpToDate = false;
		      if (val > 255) {
		          return 255;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      else {
		          return Math.round(val);
		      }
		  });
		  /**
		   * get/set filter red value. Use with {@link Konva.Filters.RGB} filter.
		   * @name red
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} red value between 0 and 255
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'green', 0, function (val) {
		      this._filterUpToDate = false;
		      if (val > 255) {
		          return 255;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      else {
		          return Math.round(val);
		      }
		  });
		  /**
		   * get/set filter green value. Use with {@link Konva.Filters.RGB} filter.
		   * @name green
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} green value between 0 and 255
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'blue', 0, RGBComponent, Factory.afterSetFilter);
		  /**
		   * get/set filter blue value. Use with {@link Konva.Filters.RGB} filter.
		   * @name blue
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} blue value between 0 and 255
		   * @returns {Integer}
		   */

		  /**
		   * RGBA Filter
		   * @function
		   * @name RGBA
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author codefo
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.RGBA]);
		   * node.blue(120);
		   * node.green(200);
		   * node.alpha(0.3);
		   */
		  const RGBA = function (imageData) {
		      var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
		      for (i = 0; i < nPixels; i += 4) {
		          ia = 1 - alpha;
		          data[i] = red * alpha + data[i] * ia; // r
		          data[i + 1] = green * alpha + data[i + 1] * ia; // g
		          data[i + 2] = blue * alpha + data[i + 2] * ia; // b
		      }
		  };
		  Factory.addGetterSetter(Node, 'red', 0, function (val) {
		      this._filterUpToDate = false;
		      if (val > 255) {
		          return 255;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      else {
		          return Math.round(val);
		      }
		  });
		  /**
		   * get/set filter red value. Use with {@link Konva.Filters.RGBA} filter.
		   * @name red
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} red value between 0 and 255
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'green', 0, function (val) {
		      this._filterUpToDate = false;
		      if (val > 255) {
		          return 255;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      else {
		          return Math.round(val);
		      }
		  });
		  /**
		   * get/set filter green value. Use with {@link Konva.Filters.RGBA} filter.
		   * @name green
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} green value between 0 and 255
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'blue', 0, RGBComponent, Factory.afterSetFilter);
		  /**
		   * get/set filter blue value. Use with {@link Konva.Filters.RGBA} filter.
		   * @name blue
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Integer} blue value between 0 and 255
		   * @returns {Integer}
		   */
		  Factory.addGetterSetter(Node, 'alpha', 1, function (val) {
		      this._filterUpToDate = false;
		      if (val > 1) {
		          return 1;
		      }
		      else if (val < 0) {
		          return 0;
		      }
		      else {
		          return val;
		      }
		  });
		  /**
		   * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
		   * @name alpha
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Float} alpha value between 0 and 1
		   * @returns {Float}
		   */

		  // based on https://stackoverflow.com/questions/1061093/how-is-a-sepia-tone-created
		  /**
		   * @function
		   * @name Sepia
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Sepia]);
		   */
		  const Sepia = function (imageData) {
		      var data = imageData.data, nPixels = data.length, i, r, g, b;
		      for (i = 0; i < nPixels; i += 4) {
		          r = data[i + 0];
		          g = data[i + 1];
		          b = data[i + 2];
		          data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
		          data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
		          data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
		      }
		  };

		  /**
		   * Solarize Filter
		   * Pixastic Lib - Solarize filter - v0.1.0
		   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
		   * License: [http://www.pixastic.com/lib/license.txt]
		   * @function
		   * @name Solarize
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Solarize]);
		   */
		  const Solarize = function (imageData) {
		      var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
		      do {
		          var offsetY = (y - 1) * w4;
		          var x = w;
		          do {
		              var offset = offsetY + (x - 1) * 4;
		              var r = data[offset];
		              var g = data[offset + 1];
		              var b = data[offset + 2];
		              if (r > 127) {
		                  r = 255 - r;
		              }
		              if (g > 127) {
		                  g = 255 - g;
		              }
		              if (b > 127) {
		                  b = 255 - b;
		              }
		              data[offset] = r;
		              data[offset + 1] = g;
		              data[offset + 2] = b;
		          } while (--x);
		      } while (--y);
		  };

		  /**
		   * Threshold Filter. Pushes any value above the mid point to
		   *  the max and any value below the mid point to the min.
		   *  This affects the alpha channel.
		   * @function
		   * @name Threshold
		   * @memberof Konva.Filters
		   * @param {Object} imageData
		   * @author ippo615
		   * @example
		   * node.cache();
		   * node.filters([Konva.Filters.Threshold]);
		   * node.threshold(0.1);
		   */
		  const Threshold = function (imageData) {
		      var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
		      for (i = 0; i < len; i += 1) {
		          data[i] = data[i] < level ? 0 : 255;
		      }
		  };
		  Factory.addGetterSetter(Node, 'threshold', 0.5, getNumberValidator(), Factory.afterSetFilter);
		  /**
		   * get/set threshold.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Threshold} or {@link Konva.Filters.Mask} filter.
		   * @name threshold
		   * @method
		   * @memberof Konva.Node.prototype
		   * @param {Number} threshold
		   * @returns {Number}
		   */

		  // we need to import core of the Konva and then extend it with all additional objects
		  const Konva = Konva$1.Util._assign(Konva$1, {
		      Arc,
		      Arrow,
		      Circle,
		      Ellipse,
		      Image,
		      Label,
		      Tag,
		      Line,
		      Path,
		      Rect,
		      RegularPolygon,
		      Ring,
		      Sprite,
		      Star,
		      Text,
		      TextPath,
		      Transformer,
		      Wedge,
		      /**
		       * @namespace Filters
		       * @memberof Konva
		       */
		      Filters: {
		          Blur,
		          Brighten,
		          Contrast,
		          Emboss,
		          Enhance,
		          Grayscale,
		          HSL,
		          HSV,
		          Invert,
		          Kaleidoscope,
		          Mask,
		          Noise,
		          Pixelate,
		          Posterize,
		          RGB,
		          RGBA,
		          Sepia,
		          Solarize,
		          Threshold,
		      },
		  });

		  return Konva;

		})); 
	} (konva));
	return konva.exports;
}

var name = "@yopbox/picasso";
var version = "2.1.13";
var description = "Clip cut render in canvas library";
var scripts = {
	patch: "npm version patch && ./deploy.sh",
	"front-test": "rollup -c --watch & pid=$(lsof -i:8000 | awk 'NR==2 {print $2}' | head -1) && kill $pid ; python3 ./tests/front/server.py & echo 'FRONT TEST : Go to http://localhost:8000/tests/front'",
	"render-test": "rollup -c & node ./tests/render/index.js",
	build: "rollup -c",
	watch: "rollup -c --watch"
};
var author = "Yopbox Inc";
var license = "ISC";
var repository = {
	type: "git",
	url: "git+ssh://git@gitlab.com/yopbox/picasso"
};
var main = "dist/library.js";
var module = "dist/library.mjs";
var files = [
	"dist/library.js",
	"dist/library.mjs",
	"dist/library.min.js"
];
var publishConfig = {
	"@yopbox:registry": "https://gitlab.com/api/v4/projects/48025210/packages/npm/"
};
var devDependencies = {
	"@rollup/plugin-commonjs": "^25.0.7",
	"@rollup/plugin-json": "^6.0.1",
	"@rollup/plugin-node-resolve": "^15.2.3",
	"app-root-dir": "^1.0.2",
	axios: "^1.5.1",
	canvas: "^2.11.2",
	events: "^3.3.0",
	"ffmpeg-static": "^5.2.0",
	gifler: "^0.1.0",
	gsap: "^3.12.5",
	konva: "^9.2.2",
	"lottie-web": "^5.12.2",
	"promise-concurrency": "^1.1.1",
	rollup: "^3.29.4",
	vue: "^3.3.5"
};
var engines = {
	npm: ">=9.0.0",
	node: ">=16.0.0"
};
var dependencies = {
	fontfaceobserver: "^2.3.0",
	npm: "^10.5.1"
};
var require$$1 = {
	name: name,
	version: version,
	description: description,
	scripts: scripts,
	author: author,
	license: license,
	repository: repository,
	main: main,
	module: module,
	files: files,
	publishConfig: publishConfig,
	devDependencies: devDependencies,
	engines: engines,
	dependencies: dependencies
};

var events = {exports: {}};

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  };

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
events.exports = EventEmitter$1;
events.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter$1.EventEmitter = EventEmitter$1;

EventEmitter$1.prototype._events = undefined;
EventEmitter$1.prototype._eventsCount = 0;
EventEmitter$1.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter$1, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter$1.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter$1.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter$1.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter$1.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter$1.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter$1.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;

EventEmitter$1.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter$1.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter$1.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter$1.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter$1.prototype.off = EventEmitter$1.prototype.removeListener;

EventEmitter$1.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners$1(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter$1.prototype.listeners = function listeners(type) {
  return _listeners$1(this, type, true);
};

EventEmitter$1.prototype.rawListeners = function rawListeners(type) {
  return _listeners$1(this, type, false);
};

EventEmitter$1.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter$1.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter$1.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

var eventsExports = events.exports;

async function renderFrame$1(frameIndex, frameData){
  //console.log("frameData", frameData);

  if (this.videoBackground != undefined){
    this.videoBackground.destroy();
  }

  try {
    let mainVideoFile = frameData.mainVideoFile;
    this.videoBackground = await this.loadKonvaImage(mainVideoFile);
    this.videoLayer.add(this.videoBackground);
    
    this.setSize(false);
    
    if (frameData.asset != undefined){
      //find asset overlay
      this._overlays_assets.forEach((asset) => {
        //console.log('asset', asset.asset_id)
        if (asset.asset_id == frameData.asset.asset_id){
          asset.frameFile = frameData.asset.frameFile;
          //console.log(frameIndex, asset.frameFile)
        };
      });
    }
    
    await this.seek(frameIndex*40);

  } catch (e){
    console.error(e);
    throw e
  }
}

var render = {
  renderFrame: renderFrame$1
};

var fontfaceobserver_standalone = {exports: {}};

/* Font Face Observer v2.3.0 - © Bram Stein. License: BSD-3-Clause */

(function (module) {
	(function(){function p(a,c){document.addEventListener?a.addEventListener("scroll",c,!1):a.attachEvent("scroll",c);}function u(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function b(){document.removeEventListener("DOMContentLoaded",b);a();}):document.attachEvent("onreadystatechange",function g(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",g),a();});}function w(a){this.g=document.createElement("div");this.g.setAttribute("aria-hidden","true");this.g.appendChild(document.createTextNode(a));this.h=document.createElement("span");this.i=document.createElement("span");this.m=document.createElement("span");this.j=document.createElement("span");this.l=-1;this.h.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.i.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
	this.j.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.m.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.h.appendChild(this.m);this.i.appendChild(this.j);this.g.appendChild(this.h);this.g.appendChild(this.i);}
	function x(a,c){a.g.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+c+";";}function B(a){var c=a.g.offsetWidth,b=c+100;a.j.style.width=b+"px";a.i.scrollLeft=b;a.h.scrollLeft=a.h.scrollWidth+100;return a.l!==c?(a.l=c,!0):!1}function C(a,c){function b(){var e=g;B(e)&&null!==e.g.parentNode&&c(e.l);}var g=a;p(a.h,b);p(a.i,b);B(a);}function D(a,c,b){c=c||{};b=b||window;this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal";this.context=b;}var E=null,F=null,G=null,H=null;function I(a){null===F&&(M(a)&&/Apple/.test(window.navigator.vendor)?(a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent),F=!!a&&603>parseInt(a[1],10)):F=!1);return F}function M(a){null===H&&(H=!!a.document.fonts);return H}
	function N(a,c){var b=a.style,g=a.weight;if(null===G){var e=document.createElement("div");try{e.style.font="condensed 100px sans-serif";}catch(q){}G=""!==e.style.font;}return [b,g,G?a.stretch:"","100px",c].join(" ")}
	D.prototype.load=function(a,c){var b=this,g=a||"BESbswy",e=0,q=c||3E3,J=(new Date).getTime();return new Promise(function(K,L){if(M(b.context)&&!I(b.context)){var O=new Promise(function(r,t){function h(){(new Date).getTime()-J>=q?t(Error(""+q+"ms timeout exceeded")):b.context.document.fonts.load(N(b,'"'+b.family+'"'),g).then(function(n){1<=n.length?r():setTimeout(h,25);},t);}h();}),P=new Promise(function(r,t){e=setTimeout(function(){t(Error(""+q+"ms timeout exceeded"));},q);});Promise.race([P,O]).then(function(){clearTimeout(e);
	K(b);},L);}else u(function(){function r(){var d;if(d=-1!=k&&-1!=l||-1!=k&&-1!=m||-1!=l&&-1!=m)(d=k!=l&&k!=m&&l!=m)||(null===E&&(d=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),E=!!d&&(536>parseInt(d[1],10)||536===parseInt(d[1],10)&&11>=parseInt(d[2],10))),d=E&&(k==y&&l==y&&m==y||k==z&&l==z&&m==z||k==A&&l==A&&m==A)),d=!d;d&&(null!==f.parentNode&&f.parentNode.removeChild(f),clearTimeout(e),K(b));}function t(){if((new Date).getTime()-J>=q)null!==f.parentNode&&f.parentNode.removeChild(f),
	L(Error(""+q+"ms timeout exceeded"));else {var d=b.context.document.hidden;if(!0===d||void 0===d)k=h.g.offsetWidth,l=n.g.offsetWidth,m=v.g.offsetWidth,r();e=setTimeout(t,50);}}var h=new w(g),n=new w(g),v=new w(g),k=-1,l=-1,m=-1,y=-1,z=-1,A=-1,f=document.createElement("div");f.dir="ltr";x(h,N(b,"sans-serif"));x(n,N(b,"serif"));x(v,N(b,"monospace"));f.appendChild(h.g);f.appendChild(n.g);f.appendChild(v.g);b.context.document.body.appendChild(f);y=h.g.offsetWidth;z=n.g.offsetWidth;A=v.g.offsetWidth;t();
	C(h,function(d){k=d;r();});x(h,N(b,'"'+b.family+'",sans-serif'));C(n,function(d){l=d;r();});x(n,N(b,'"'+b.family+'",serif'));C(v,function(d){m=d;r();});x(v,N(b,'"'+b.family+'",monospace'));});})};module.exports=D;}()); 
} (fontfaceobserver_standalone));

var fontfaceobserver_standaloneExports = fontfaceobserver_standalone.exports;

function loadKonvaImage$1(url) {
    return new Promise((res, reject) => {
      //console.debug('Loading url as Konva image node :', url)
      Konva.Image.fromURL(url, res, reject);
    });
}

function parseFontName$3(fontName){
  let fontStyle = "normal";
  let italic = false;
  let bold = false;
  if (fontName.includes('italic bold')){
    fontStyle = "italic bold";
    italic = true;
    bold = true;
  } else if (fontName.includes('italic')){
    fontStyle = "italic";
    italic = true;
  } else if (fontName.includes('bold')){
    fontStyle = "bold";
    bold = true;
  }

  const fontFamily = `${fontName}`.replace(/\sbold|\sitalic/g, "");
  
  return {
    fontFamily,
    fontStyle,
    italic,
    bold
  }

}


const sleep$4 = (ms) => new Promise((r) => setTimeout(r, ms));



var FontFaceObserver = fontfaceobserver_standaloneExports;

async function waitForFontLoading$2(...params){
  try {
    var font = new FontFaceObserver(...params);
    await font.load();
    return true
  } catch (e){
    console.warn(e);
    return false
  }
  
}

var utils = {
  loadKonvaImage: loadKonvaImage$1,
  parseFontName: parseFontName$3,
  sleep: sleep$4,
  waitForFontLoading: waitForFontLoading$2
};

const wordAnimations$1 = {
  default: {
    initial: {
      opacity: 1,
    },
    end: {},
  },
  slideFromBottom: {
    initial: {
      opacity: 0,
      offsetY: -10,
    },
    tween: {
      opacity: 1,
      offsetY: 0,
    },
    end: {
      opacity: 1,
      offsetY: 0,
    },
  },
  wordByWord: {
    initial: {
      opacity: 0,
    },
    end: {
      opacity: 1,
    },
  },
};

function initCaptions$1() {
  if (this.captionsLayer != undefined || this.captionsLayer != null) {
    this.captionsLayer.destroy();
  }

  //CONSTRUCTOR
  this.currentSubtitlePageIdx = -1;

  var wordPageCount = 1;
  const minWordGapPage = 180;

  //Make group of captions : Each subtitle group will be display in a same page
  this.captions = [
    {
      start: null,
      end: null,
      words: [],
    },
  ];

  var currentSubtitleIndex = 0;

  let transcriptionFiltered = this.transcription.filter((w) => w.hidden != true && w.type != "silence");
  transcriptionFiltered.forEach((word, wordIdx) => {
    //Define starting time of subtitle page
    if (this.captions[currentSubtitleIndex].start == null) {
      this.captions[currentSubtitleIndex].start = word.start;
    }

    this.captions[currentSubtitleIndex].words.push(word);
    this.captions[currentSubtitleIndex].end = word.end;

    //Define the end of the subtitle page
    let maxWordCountReached =
      Number(wordPageCount) + 1 > this.captionsSettings.wordByPage;
    //If the gap with the next word is too longer, define here the end of the page
    let minGapLengthReached =
      transcriptionFiltered[wordIdx + 1] != undefined &&
      transcriptionFiltered[wordIdx + 1].start - word.end > minWordGapPage;
    //minGapLengthReached = false
    let endOfPage = maxWordCountReached || minGapLengthReached;

    if (endOfPage == true) {
      this.captions.push({
        start: null,
        words: [],
      });
      currentSubtitleIndex++;
      wordPageCount = 1;
    } else {
      wordPageCount++;
    }
  });

  //Stick word in caption pages
  this.captions.forEach((caption) => {
    caption.words.forEach((word, wordIdx) => {
      if (caption.words[wordIdx - 1] != undefined) {
        word.start = caption.words[wordIdx - 1].end;
      }
    });
  });

  this.captionsLayer = new Konva.Layer({
    name: "CaptionsLayer",
    listening : false
  });
  this.stage.add(this.captionsLayer);

  this.checkCaptions();
}

function createCaptionPage$1(subtitlePage, idx) {
  //LINE WIDTH MAX
  const widthMax = this.captionsLayer.width() * 0.6;

  var subtitlePageGroupe = new Konva.Group({
    name: "subtitlePage",
    id: "subtitlePage_" + idx,
    opacity: 1,
    listening : false
  });

  let lastWord = null;
  let newWord = null;
  let lineIndex = 0;

  let width = this.width;
  if (this.ratio == 16 / 9) {
    width = this.width / (16 / 9);
  } else if (this.ratio == 9 / 16) {
    width = this.width * (16 / 9);
  }

  let fontSize = (width * this.captionsSettings.fontSize) / 400;

  var wordMargin = 0.3 * fontSize;
  var lineMargin = 0.3 * fontSize;
  let currentLine = new Konva.Group({
    name: "subtitle_line",
    id: idx + "_subtitle_line_" + lineIndex,
  });

  subtitlePage.words.forEach((word, wordIdx) => {
    let lastWordWidth = lastWord != null ? lastWord.width() : -wordMargin;
    let lastWordPosX = lastWord != null ? lastWord.position().x : 0;

    newWord = new Konva.Text({
      name: "word",
      id: "word_" + wordIdx,
      x: lastWordPosX + lastWordWidth + wordMargin,
      y: 0,
      text: word.word,
      fontSize: fontSize, //Make fontSize same no matter how high is the canvas
      fontFamily: "Lato",
      fontFamily: this.captionsSettings.fontFamily || "Poppins",
      fontStyle: this.captionsSettings.fontStyle,
      fill: this.captionsSettings.fontColor,
      shadowOpacity: 0,
      fillAfterStrokeEnabled: true,
      stroke: this.captionsSettings.borderColor,
      strokeWidth: this.captionsSettings.borderSize,

      ...this.wordAnimation.initial,
    });

    let createNewLine =
      wordIdx != 0 && newWord.position().x + newWord.width() > widthMax; //If the current width of current line is higher than canvas width
    let isTheLastWord = wordIdx == subtitlePage.words.length - 1;

    //Center the line
    let currentLineHeight = 0;
    if (
      currentLine.children.length > 0 &&
      currentLine.children[0] != undefined
    ) {
      currentLineHeight = currentLine.children[0].height();
    }

    currentLine.position({
      x:
        this.captionsLayer.width() / 2 -
        (newWord.position().x - wordMargin) / 2,
      y: lineIndex * currentLineHeight + lineIndex * lineMargin,
    });

    //Storing line width value for futur usage
    currentLine.width(newWord.position().x - wordMargin);
    if (subtitlePageGroupe.width() < currentLine.width()) {
      subtitlePageGroupe.width(currentLine.width());
    }

    if (createNewLine) {
      subtitlePageGroupe.add(currentLine);

      lineIndex++;
      currentLine = new Konva.Group({
        name: "subtitle_line",
        id: idx + "_subtitle_line_" + lineIndex,
      });

      newWord.position({
        x: 0,
      });

      //Adding word to a new line
      currentLine.add(newWord);
    } else {
      //Adding word to the current line
      currentLine.add(newWord);
    }

    //If it's the last word, add line
    if (isTheLastWord) {
      let lineY = 0;
      if (currentLine.children[0] != undefined) {
        lineY = lineIndex * currentLine.children[0].height();
      }
      //Center the line
      currentLine.position({
        x:
          this.captionsLayer.width() / 2 -
          (newWord.position().x + newWord.width()) / 2,
        y: lineY + lineIndex * lineMargin,
      });
      currentLine.width(newWord.position().x + newWord.width());

      if (subtitlePageGroupe.width() < currentLine.width()) {
        subtitlePageGroupe.width(currentLine.width());
      }

      subtitlePageGroupe.add(currentLine);
    }

    lastWord = newWord;
    newWord = null;
  });

  this.captionsLayer.add(subtitlePageGroupe);

  //CREATE BACKGROUND
  const bg_padding = 0.5 * fontSize;
  let lines = subtitlePageGroupe.find(".subtitle_line");
  if (lines.length > 0 && lines[0].children[0] != undefined) {
    var lineHeight = lines[0].children[0].height();
  } else {
    console.log("Can't retrive heigth", lines);
    var lineHeight = 0;
  }
  let totalHeight = lines.length * lineHeight + (lines.length - 1) * lineMargin;
  let background = new Konva.Rect({
    width: subtitlePageGroupe.width() + 2 * bg_padding,
    x:
      this.captionsLayer.width() / 2 -
      (subtitlePageGroupe.width() + 2 * bg_padding) / 2,
    height: totalHeight + 2 * bg_padding,
    fill: this.captionsSettings.backgroundColor,
    y: -bg_padding,
  });

  subtitlePageGroupe.add(background);
  background.zIndex(0);

  //Center verticaly subtitle page
  subtitlePageGroupe.height(totalHeight);

  subtitlePageGroupe.position({
    y:
      this.captionsLayer.height() *
        ((100 - this.captionsSettings.position) / 100) -
      subtitlePageGroupe.height() / 2,
  });
}

function checkCaptions$1(mediaTime = null, force = true) {
  if (this.captions == undefined || this.captionsLayer == undefined) {
    return;
  }

  if (
    this.captionsSettings == undefined ||
    this.captionsSettings.enable == undefined ||
    this.captionsSettings.enable != true
  ) {
    this.captionsLayer.destroyChildren();
    return;
  }

  //if (mediaTime == null){
  //    mediaTime = this.videoList[this.index_currentVideo].currentTime * 1000;
  //mediaTime = this.cure
  //}

  mediaTime = this.currentMediaTime;

  if (mediaTime == null || isNaN(mediaTime)) {
    return;
  }

  //Anticipate a little bit the subtitle appearence
  if (!this.renderMode) ;
  let wordIndex = null;
  let word = null;

  //Retrieve subTitle page index from mediaTime
  let subPageIdx = this.captions.findIndex((subPage) => {
    if (subPage.start <= mediaTime && mediaTime <= subPage.end) {
      wordIndex = subPage.words.findIndex(
        (word) => word.start <= mediaTime && mediaTime < word.end
      );
      word = subPage.words[wordIndex];
      return true;
    }
  });

  //Changing subtitle page
  if (
    subPageIdx != -1 &&
    (subPageIdx != this.currentSubtitlePageIdx || force)
  ) {
    this.currentSubtitlePageIdx = subPageIdx;

    //Clear subtitleLayer
    this.captionsLayer.destroyChildren();

    this.createCaptionPage(this.captions[subPageIdx], subPageIdx);
  } else if (subPageIdx == -1) {
    //Clear subtitleLayer
    this.captionsLayer.destroyChildren();
  }

  //Focus word
  let currentSubtitlePage = this.captionsLayer.findOne(
    `#subtitlePage_${subPageIdx}`
  );
  if (currentSubtitlePage == undefined) {
    return;
  }

  currentSubtitlePage.find(".word").fill(this.captionsSettings.fontColor);

  let wordNode = currentSubtitlePage.findOne("#word_" + wordIndex);
  if (wordNode != undefined) {
    wordNode.fill(this.captionsSettings.focusColor);
  } else {
    return;
  }
  //If word animation require tween
  if (this.wordAnimation.tween != undefined) {
    if (this.currentWordTween != null) {
      this.currentWordTween.destroy();
    }
    this.currentWordTween = new Konva.Tween({
      node: wordNode,
      duration: 0.2,
      easing: Konva.Easings.EaseOut,
      ...this.wordAnimation.tween,
    });

    let tweenTimeDecay = (mediaTime - word.start) / 1000;
    if (tweenTimeDecay > 0.2) {
      tweenTimeDecay = 0.2;
    }
    this.currentWordTween.seek(tweenTimeDecay);

    //Else if animation require to setting up parameters
  } else if (this.wordAnimation.end != undefined) {
    Object.keys(this.wordAnimation.end).forEach((parameter) => {
      wordNode[parameter](this.wordAnimation.end[parameter]);
    });
  }

  //Hide other captions
  let otherWordsBefore = currentSubtitlePage.find(
    (node) =>
      node.getName() == "word" &&
      Number(node.id().replace("word_", "")) < wordIndex
  );
  otherWordsBefore.forEach((w) => {
    w.fill(this.captionsSettings.fontColor);
    w.shadowColor(this.captionsSettings.stroke);
    Object.keys(this.wordAnimation.end).forEach((parameter) => {
      w[parameter](this.wordAnimation.end[parameter]);
    });
  });

  //var otherWordsAfter = currentSubtitlePage.find(node => (node.getName() == 'word' && node.id() != `word_${wordIndex}`));
  let otherWordsAfter = currentSubtitlePage.find(
    (node) =>
      node.getName() == "word" &&
      Number(node.id().replace("word_", "")) > wordIndex
  );
  otherWordsAfter.forEach((w) => {
    w.fill(this.captionsSettings.fontColor);
    w.shadowColor(this.captionsSettings.stroke);

    Object.keys(this.wordAnimation.initial).forEach((parameter) => {
      w[parameter](this.wordAnimation.initial[parameter]);
    });
  });
}

var captions = {
  initCaptions: initCaptions$1,
  createCaptionPage: createCaptionPage$1,
  checkCaptions: checkCaptions$1,
  wordAnimations: wordAnimations$1,
};

function removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

Array.prototype.forEachAsync = async function (fn) {
    var i = 0;
    for (let t of this) {
      i++;
      await fn(t, (i-1));
    }
};

const sleep$3 = (ms) => new Promise((r) => setTimeout(r, ms));

function onDrawFrame(ctx, frame, canvas, layer) {

    //console.log(frame)
    canvas.width = frame.width;
    canvas.height = frame.height;
    ctx.drawImage(frame.buffer, 0, 0);
    layer.draw();
}

function resizeImageForCanvas(canvasWidth, canvasHeight, assetWidth, assetHeight) {

    const videoScale = 0.8;
    
    const assetRatio = assetWidth / assetHeight;
    const canvasRatio = canvasWidth / canvasHeight;

    let newAssetWidth, newAssetHeight;
    
    if (assetRatio >= canvasRatio){ // Asset plus horizontal que le canvas => On adapte la width
        newAssetWidth = canvasWidth;
        newAssetHeight = canvasWidth / assetRatio;
    } else if (assetRatio < canvasRatio){ // Asset plus vertical que le canvas => On adapte la height
        newAssetHeight = canvasHeight;
        newAssetWidth = canvasHeight * assetRatio;
    }

    return {
        width: newAssetWidth * videoScale,
        height: newAssetHeight * videoScale
    };
}

function resizeImageToFillCanvas(canvasWidth, canvasHeight, videoWidth, videoHeight) {
    const videoRatio = videoWidth / videoHeight;
    const canvasRatio = canvasWidth / canvasHeight;

    let newVideoWidth, newVideoHeight;

    if (canvasRatio > videoRatio) {
        newVideoWidth = canvasWidth;
        newVideoHeight = canvasWidth / videoRatio;
    } else {
        newVideoHeight = canvasHeight;
        newVideoWidth = canvasHeight * videoRatio;
    }

    return {
        width: newVideoWidth,
        height: newVideoHeight
    };
}

function initOverlays(params){
    if (params != undefined && params.assets != undefined){
        this._overlays_assets = JSON.parse(JSON.stringify(params.assets));
    }
    if (params != undefined && params.texts != undefined){

        this._overlays_texts.forEach(ot =>{
            if (ot.object != undefined && ot.object.destroy != undefined){
                ot.object.destroy();
            }
        });

        this._overlays_texts = JSON.parse(JSON.stringify(params.texts));
    }

    //Init Layer
    if (this.overlaysLayer != undefined){
        this.overlaysLayer.destroy();
    }    this.overlaysLayer = new Konva.Layer({
        name : "overlays",
        listening : true
    });

    if (this.stage == undefined){
        return;
    }

    this.stage.add(this.overlaysLayer);
    this.overlaysLayer.zIndex(1);


    var anim = new Konva.Animation(() => {}, this.overlaysLayer);
    anim.start();

    this.overlayGroupA = new Konva.Group({
        id: "groupA",
        opacity : 0,
        listening : false
    });
    this.overlaysLayer.add(this.overlayGroupA);
    this.overlayGroupB = new Konva.Group({
        id: "groupB",
        opacity : 0,
        listening : false
    });
    this.overlaysLayer.add(this.overlayGroupB);

    //BACKGROUND
    let overlayBackgroundParams = {
        x: 0,
        y: 0,
        width: this.width,
        height: this.height,
        fill: this.background_color, //"#4fbecc",
        opacity : 1,
        name : "assetOverlayBackground"
    };
    let colorBackground = new Konva.Rect(overlayBackgroundParams);
    this.overlayGroupA.add(colorBackground);

    colorBackground = new Konva.Rect(overlayBackgroundParams);
    this.overlayGroupB.add(colorBackground);

    this.currentOverlayGroup = "A";

    this.appear_idx = -1;
    this.next_appear_idx = -1;

    this._overlays_assets.forEach(asset =>{
        delete asset.groupNodeRef;
        delete asset.videoDomRef;
    });

    //Init overlays appearances list
    this.overlays_appearances = [];
    this.overlays_appearances_current_idx = -1;

    this._overlays_assets.forEach((asset, assetIndex) =>{
        const appareancesStartTimeFound = this.overlays_appearances.findIndex(app => app.time == asset.start);
        if (appareancesStartTimeFound != -1){
            this.overlays_appearances[appareancesStartTimeFound].show.push(asset.asset_id);
        } else {
            this.overlays_appearances.push({
                time : asset.start,
                show : [asset.asset_id],
                hide : []
            });
        }

        const appareancesEndTimeFound = this.overlays_appearances.findIndex(app => app.time == asset.end);
        if (appareancesEndTimeFound != -1){
            this.overlays_appearances[appareancesEndTimeFound].hide.push(asset.asset_id);
        } else {
            this.overlays_appearances.push({
                time : asset.end,
                show : [],
                hide : [asset.asset_id]
            });
        }
    });

    this.initTextOverlays();
}

function adapteOverlayBackground(){
    if (this.overlaysLayer != undefined){
        this.overlaysLayer.find('.assetOverlayBackground').forEach(node =>{
            node.width(this.width);
            node.height(this.height);
        });
    }
}



async function initAsset(asset_id){
    try {
        
    
        var asset = this._overlays_assets.find(a => a.asset_id == asset_id);

        if (this.renderMode == false && asset.groupNodeRef != undefined && asset.groupNodeRef.find && asset.groupNodeRef.find("Image").length != 0){
            //console.log('Asset ' + asset_id + " already loaded");
            return asset;
        } else {
            //console.log('Asset '+ asset_id + " loaded")
        }

        //Define/alterne groupNode A and B
        if (this.currentOverlayGroup == "A"){
            var goupeNode = this.overlayGroupA;
        } else {
            var goupeNode = this.overlayGroupB;
        };

        if (asset.type == "video"){
            if (this.renderMode == false){
                var videoDOM = document.createElement("video");
                videoDOM.muted = true;
                videoDOM.src = asset.media_url;
                if (asset.media_url == undefined || asset.media_url == null){
                    console.warn(`Video asset ${asset_id} has no media_url`);
                }
                asset.videoDomRef = videoDOM;
                videoDOM.currentTime = asset.trim_in/1000;
                videoDOM.loop = true;
                videoDOM.preload = "auto";
                var imageNode = new Konva.Image({
                    draggable: false,
                    image : videoDOM
                });
            } else {
                var imageNode = await this.loadKonvaImage(asset.frameFile);
            }

        } else if (asset.type == "gif"){
            var gifCanvas = document.createElement('canvas');
            
            gifler(asset.media_url).frames(gifCanvas, (ctx, frame, frameIdx, _animator) =>{
                if (asset.gifAnimator == undefined){
                    asset.gifAnimator = _animator;
                }
                this.onDrawFrame(ctx, frame, gifCanvas, this.overlaysLayer);
            });

            await new Promise(async (resolve) =>{
                while (asset.gifAnimator == undefined){
                    await sleep$3(200);
                }
                resolve();
            });

            if (this.paused == true){
                asset.gifAnimator.stop(10);
            }

            var imageNode = new Konva.Image({
                draggable: false,
                image : gifCanvas
            });
            asset.videoDomRef = null;
        } else if (asset.type == "image"){
            if (this.renderMode == false){
                var imageNode = await this.loadKonvaImage(asset.media_url);
            } else {
                var imageNode = await this.loadKonvaImage(asset.frameFile);
            }
            asset.videoDomRef = null;
        };

        
        imageNode.cornerRadius(this.overlayCornerRadius);

        goupeNode.add(imageNode);
        asset.groupNodeRef = goupeNode;

        if (asset.position == "fit"){
            var imageDimensions = resizeImageForCanvas(this.width, this.height, asset.width, asset.height);
        } else {
            var imageDimensions = resizeImageToFillCanvas(this.width, this.height, asset.width, asset.height);
        }

        imageNode.absolutePosition({x : this.width/2 - imageDimensions.width/2, y : this.height/2 - imageDimensions.height/2});
        imageNode.width(imageDimensions.width);
        imageNode.height(imageDimensions.height);
        imageNode.setAttr('asset_id', asset.asset_id);
        

        if (this.currentOverlayGroup == "A"){
            this.currentOverlayGroup = "B";
        } else if (this.currentOverlayGroup == "B"){
            this.currentOverlayGroup = "A";
        };
        //console.debug("Asset "+ assetIdx + " loaded")

        if (asset.hasToDisplayWhenLoaded == true){
            this.checkOverlays(true);
        }
        return asset;
    } catch (e){
        console.warn("Can't init asset", e);
        return null
    }
}

/**
 * @param {Boolean} seek Is function launched by a seek ?
 */
async function checkOverlays(seek = false){

    //Find current appearance if exist
    if (this.overlays_appearances == undefined){
        return;
    }

    if (this.overlaysLayer == undefined){
        console.log('ATTENTION this.overlaysLayer undefined');
        return
    }
    
    let appear_idx = this.overlays_appearances.findIndex((appearance, appear_idx) => {
        return (appearance.time <= this.currentMediaTime && this.currentMediaTime < (this.overlays_appearances[appear_idx + 1] ? this.overlays_appearances[appear_idx + 1].time : Infinity))
    });


    //Find next appearance
    let next_appear_idx = this.overlays_appearances.findIndex(appearance => {
        return (this.currentMediaTime < appearance.time)
    });

    //LOAD NEXT ASSETS
    var current_and_next_assets = [];

    //If next_appear_idx change since last loop
    if (next_appear_idx != this.next_appear_idx){
        this.next_appear_idx = next_appear_idx;
    }
    if (this.overlays_appearances[next_appear_idx] != undefined){
        current_and_next_assets.push(...this.overlays_appearances[next_appear_idx].show);
    }

    //LOADING CURRENT AND NEXT ASSETS
    if (appear_idx != -1){
        current_and_next_assets.push(...this.overlays_appearances[appear_idx].show);
    }    current_and_next_assets = removeDuplicates(current_and_next_assets);
    if (this.renderMode == false){
        current_and_next_assets.forEach((asset_id)=>{
            this.initAsset(asset_id);
        });
    }


    if (seek == true){
        //Destroy all execpt futur node Image
        
        this.overlaysLayer.find("Image").forEach((node) => {
            if (this.renderMode){
                node.destroy();
            }
            
            if (!current_and_next_assets.includes(node.getAttr("asset_id"))){
                node.destroy();
            }
        });
        this.overlayGroupA.opacity(0);
        this.overlayGroupB.opacity(0);
        this.appear_idx = -1;
    }

    
    
    if (appear_idx != -1 && (this.appear_idx != appear_idx || seek)){
        this.appear_idx = appear_idx;


        
        this.overlays_appearances_current_idx = appear_idx;
        let appear = this.overlays_appearances[appear_idx];
        //console.log('ici', appear);
        
        await appear.show.forEachAsync(async (asset_id) => {
            var asset = this._overlays_assets.find(a => a.asset_id == asset_id);

            if (this.renderMode){
                await this.initAsset(asset_id);
            }

            if (asset == undefined || asset.groupNodeRef == undefined || asset.groupNodeRef == null){
                asset.hasToDisplayWhenLoaded = true;
                return;
            }
            asset.groupNodeRef.opacity(1);
            //console.log('Showing ', asset);
            
            //Seek video
            if (asset.videoDomRef != undefined && asset.type == "video"){
                if (seek){
                    const trim_in = asset.trim_in != null ? asset.trim_in : 0;
                    const relativeTimeAtStart = this._retrieveCut(null, asset.start, false).relativeTime;
                    const decaySinceStart = this.relativeTime - relativeTimeAtStart;
                    const time = trim_in + decaySinceStart;

                    await new Promise(resolve =>{
                        asset.videoDomRef.addEventListener("timeupdate", () => {
                            resolve();
                        }, { once : true });
                        asset.videoDomRef.currentTime = time/1000;
                    });
                    
                    //asset.videoDomRef.currentTime = (this.currentMediaTime - appear.time  + asset.trim_in)/1000;
                }
                
                if (this.paused == false){
                    asset.videoDomRef.play();
                }
            }
        });
        
        appear.hide.forEach(asset_id => {
            //let asset = this._overlays_assets[asset_id];
            let asset = this._overlays_assets.find(a => a.asset_id == asset_id);

            if (asset == undefined){
                return;
            }

            if (asset.groupNodeRef != undefined){
                try {
                    asset.groupNodeRef.opacity(0);
                } catch (e){
                    console.log("Can't set opacity 0", e);
                }
                //Destroy childen image
                //console.log("Hide : " + asset_id, 'Destroy image node from ')
                asset.groupNodeRef.find("Image").forEach(node => { node.destroy();});
                asset.groupNodeRef = undefined;
            }

            if (asset.videoDomRef != undefined && asset.videoDomRef != null){
                asset.videoDomRef.pause();

                //Destroy
                asset.videoDomRef.removeAttribute('src'); // empty source
                asset.videoDomRef.load();
                asset.videoDomRef = undefined;
            }
            
        });
    }
}
function pauseCurrentOverlay(){
    if (this.overlays_appearances[this.appear_idx] == undefined){
        return;
    }

    this.overlays_appearances[this.appear_idx].show.forEach(asset_id =>{
        //let asset = this._overlays_assets[asset_id];
        let asset = this._overlays_assets.find(a => a.asset_id == asset_id);
        if (asset.videoDomRef != null){
            asset.videoDomRef.pause();
        } else if (asset.gifAnimator){
            asset.gifAnimator.stop();
        }
    });
}
function playCurrentOverlay(){

    if (this.overlays_appearances[this.appear_idx] == undefined){
        return;
    }

    this.overlays_appearances[this.appear_idx].show.forEach(asset_id =>{
        //let asset = this._overlays_assets[asset_id]
        let asset = this._overlays_assets.find(a => a.asset_id == asset_id);
        if (asset.videoDomRef != undefined){
            asset.videoDomRef.play();
        } else if (asset.gifAnimator){
            asset.gifAnimator.start();
        }
    });
}
var overlays_assets = {
    initOverlays,
    adapteOverlayBackground,
    checkOverlays,
    initAsset,
    pauseCurrentOverlay,
    playCurrentOverlay,
    onDrawFrame
};

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _reverting$1,
    _context,
    _bigNum$1 = 1e8,
    _tinyNum = 1 / _bigNum$1,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists$1 = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    _globalTimeline,
    _win$1,
    _coreInitted,
    _doc$1,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap$2;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _startAtRevertConfig = {
  suppressEvents: true,
  isStart: true,
  kill: false
},
    _revertConfigNoKill = {
  suppressEvents: true,
  kill: false
},
    _revertConfig = {
  suppressEvents: true
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
  var operator = value.charAt(0),
      end = parseFloat(value.substr(2));
  start = parseFloat(start);
  return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
},
    _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && !_reverting$1 && _lazyRender();
  animation.render(time, suppressEvents, force || _reverting$1 && time < 0 && (animation._initted || animation._startAt));
  _lazyTweens.length && !_reverting$1 && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
  return function (obj, defaults) {
    for (var p in defaults) {
      p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    }
  };
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
  return tween._startAt && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
    // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)

  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
  _initTween(tween, time, tTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && !_reverting$1 && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [tTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      // if iteration changed
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || _reverting$1 || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents && !_reverting$1) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
  animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum$1 ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value, v) {
  return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win$1;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc$1).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc$1.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum$1])[1];

      if (!wrapAt) {
        max = -_bigNum$1;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt < l && wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = wrapAt === _bigNum$1 ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum$1;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum$1;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum$1,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum$1,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      prevContext = _context,
      context = animation._ctx,
      params,
      scope,
      result;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  context && (_context = context);
  result = params ? callback.apply(scope, params) : callback.call(scope);
  _context = prevContext;
  return result;
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting$1);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _registerPluginQueue = [],
    _createPlugin = function _createPlugin(config) {
  if (!config) return;
  config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  if (_windowExists$1() || config.headless) {
    // edge case: some build tools may pass in a null/undefined value
    var name = config.name,
        isFunc = _isFunction(config),
        Plugin = name && !isFunc && config.init ? function () {
      this._props = [];
    } : config,
        //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
      init: _emptyFunc,
      render: _renderPropTweens,
      add: _addPropTween,
      kill: _killPropTweensOf,
      modifier: _addPluginModifier,
      rawVars: 0
    },
        statics = {
      targetTest: 0,
      get: 0,
      getSetter: _getSetter,
      aliases: {},
      register: 0
    };

    _wake();

    if (config !== Plugin) {
      if (_plugins[name]) {
        return;
      }

      _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


      _plugins[Plugin.prop = name] = Plugin;

      if (config.targetTest) {
        _harnessPlugins.push(Plugin);

        _reservedProps[name] = 1;
      }

      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }

    _addGlobal(name, Plugin);

    config.register && config.register(gsap$2, Plugin, PropTween);
  } else {
    _registerPluginQueue.push(config);
  }
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
  h += h < 0 ? 1 : h > 1 ? -1 : 0;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists$1()) {
          _win$1 = _coreInitted = window;
          _doc$1 = _win$1.document || {};
          _globals.gsap = gsap$2;
          (_win$1.gsapVersions || (_win$1.gsapVersions = [])).push(gsap$2.version);

          _install(_installScope || _win$1.GreenSockGlobals || !_win$1.gsap && _win$1 || {});

          _registerPluginQueue.forEach(_createPlugin);
        }

        _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback, once, prioritize) {
      var func = once ? function (t, d, f, v) {
        callback(t, d, f, v);

        _self.remove(func);
      } : callback;

      _self.remove(callback);

      _listeners[prioritize ? "unshift" : "push"](func);

      _wake();

      return func;
    },
    remove: function remove(callback, i) {
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;

    if (_context) {
      this._ctx = _context;

      _context.data.push(this);
    }

    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value, suppressEvents) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return _recacheAncestors(this);
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.revert = function revert(config) {
    if (config === void 0) {
      config = _revertConfig;
    }

    var prevIsReverting = _reverting$1;
    _reverting$1 = config;

    if (this._initted || this._startAt) {
      this.timeline && this.timeline.revert(config);
      this.totalTime(-0.01, config.suppressEvents);
    }

    this.data !== "nested" && config.kill !== false && this.kill();
    _reverting$1 = prevIsReverting;
    return this;
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (Math.abs(animation._ts) || 1);
      animation = animation._dp;
    }

    return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.

          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting$1 && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum$1;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate(soft) {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate(soft);
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this, soft);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum$1,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (!optional || parsedStart !== end || _forceAllPropTweens) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens,
    _initTween = function _initTween(tween, time, tTime) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl || keyframes && !vars.stagger) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);

    if (prevStartAt) {
      prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.

      time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
      // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.

      prevStartAt._lazy = 0;
    }

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: !prevStartAt && _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate && function () {
          return _callback(tween, "onUpdate");
        },
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.

      tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween

      time < 0 && (_reverting$1 || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        if (dur && time <= 0 && tTime <= 0) {
          // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        }
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (!prevStartAt) {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        tween._startAt._dp = 0; // don't allow it to get put back into root timeline!

        tween._startAt._sat = tween; // used in globalTime()

        time < 0 && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
        tween._zTime = time;

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = tween._ptCache = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.

  keyframes && time <= 0 && tl.render(_bigNum$1, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
},
    _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
  var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
      pt,
      rootPT,
      lookup,
      i;

  if (!ptCache) {
    ptCache = tween._ptCache[property] = [];
    lookup = tween._ptLookup;
    i = tween._targets.length;

    while (i--) {
      pt = lookup[i][property];

      if (pt && pt.d && pt.d._pt) {
        // it's a plugin, so find the nested PropTween
        pt = pt.d._pt;

        while (pt && pt.p !== property && pt.fp !== property) {
          // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
          pt = pt._next;
        }
      }

      if (!pt) {
        // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
        // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
        _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.

        tween.vars[property] = "+=0";

        _initTween(tween, time);

        _forceAllPropTweens = 0;
        return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
      }

      ptCache.push(pt);
    }
  }

  i = ptCache.length;

  while (i--) {
    rootPT = ptCache[i];
    pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.

    pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
    pt.c = value - pt.s;
    rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)

    rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
  }
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut",
      p,
      a;

  if (_isArray(obj)) {
    a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease

    obj.forEach(function (value, i) {
      return a.push({
        t: i / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p in obj) {
      a = allProps[p] || (allProps[p] = []);
      p === "ease" || a.push({
        t: parseFloat(prop),
        v: obj[p],
        e: ease
      });
    }
  }
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
    _staggerPropsToSkip = {};

_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
  return _staggerPropsToSkip[name] = 1;
});
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {},
        targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
      }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.

      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        l = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0,
            a,
            kf,
            v;

        if (_isArray(keyframes)) {
          keyframes.forEach(function (frame) {
            return tl.to(parsedTargets, frame, ">");
          });
          tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
        } else {
          copy = {};

          for (p in keyframes) {
            p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
          }

          for (p in copy) {
            a = copy[p].sort(function (a, b) {
              return a.t - b.t;
            });
            time = 0;

            for (i = 0; i < a.length; i++) {
              kf = a[i];
              v = {
                ease: kf.e,
                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
              };
              v[p] = kf.v;
              tl.to(parsedTargets, v, time);
              time += v.duration;
            }
          }

          tl.duration() < duration && tl.to({}, {
            duration: duration - tl.duration()
          }); // in case keyframes didn't go to 100%
        }
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay) || 0); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        isNegative = totalTime < 0,
        tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted && iteration === prevIteration) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          this._tTime = tTime;
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
            // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
          // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate(soft) {
    // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
    (!soft || !this.vars.runBackwards) && (this._startAt = 0);
    this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate(soft);
    return _Animation2.prototype.invalidate.call(this, soft);
  };

  _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
    _tickerActive || _ticker.wake();
    this._ts || this.play();
    var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        ratio;
    this._initted || _initTween(this, time);
    ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
    // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
    // if (_isObject(property)) { // performance optimization
    // 	for (p in property) {
    // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
    // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    // 		}
    // 	}
    // } else {

    if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
      return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    } //}


    _alignPlayhead(this, 0);

    this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
    return this.render(0);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;

var _media = [],
    _listeners = {},
    _emptyArray = [],
    _lastMediaTime = 0,
    _contextID = 0,
    _dispatch = function _dispatch(type) {
  return (_listeners[type] || _emptyArray).map(function (f) {
    return f();
  });
},
    _onMediaChange = function _onMediaChange() {
  var time = Date.now(),
      matches = [];

  if (time - _lastMediaTime > 2) {
    _dispatch("matchMediaInit");

    _media.forEach(function (c) {
      var queries = c.queries,
          conditions = c.conditions,
          match,
          p,
          anyMatch,
          toggled;

      for (p in queries) {
        match = _win$1.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.

        match && (anyMatch = 1);

        if (match !== conditions[p]) {
          conditions[p] = match;
          toggled = 1;
        }
      }

      if (toggled) {
        c.revert();
        anyMatch && matches.push(c);
      }
    });

    _dispatch("matchMediaRevert");

    matches.forEach(function (c) {
      return c.onMatch(c, function (func) {
        return c.add(null, func);
      });
    });
    _lastMediaTime = time;

    _dispatch("matchMedia");
  }
};

var Context = /*#__PURE__*/function () {
  function Context(func, scope) {
    this.selector = scope && selector(scope);
    this.data = [];
    this._r = []; // returned/cleanup functions

    this.isReverted = false;
    this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely

    func && this.add(func);
  }

  var _proto5 = Context.prototype;

  _proto5.add = function add(name, func, scope) {
    // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
    // if (name && _isFunction(name.revert)) {
    // 	this.data.push(name);
    // 	return (name._ctx = this);
    // }
    if (_isFunction(name)) {
      scope = func;
      func = name;
      name = _isFunction;
    }

    var self = this,
        f = function f() {
      var prev = _context,
          prevSelector = self.selector,
          result;
      prev && prev !== self && prev.data.push(self);
      scope && (self.selector = selector(scope));
      _context = self;
      result = func.apply(self, arguments);
      _isFunction(result) && self._r.push(result);
      _context = prev;
      self.selector = prevSelector;
      self.isReverted = false;
      return result;
    };

    self.last = f;
    return name === _isFunction ? f(self, function (func) {
      return self.add(null, func);
    }) : name ? self[name] = f : f;
  };

  _proto5.ignore = function ignore(func) {
    var prev = _context;
    _context = null;
    func(this);
    _context = prev;
  };

  _proto5.getTweens = function getTweens() {
    var a = [];
    this.data.forEach(function (e) {
      return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
    });
    return a;
  };

  _proto5.clear = function clear() {
    this._r.length = this.data.length = 0;
  };

  _proto5.kill = function kill(revert, matchMedia) {
    var _this4 = this;

    if (revert) {
      (function () {
        var tweens = _this4.getTweens(),
            i = _this4.data.length,
            t;

        while (i--) {
          // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
          t = _this4.data[i];

          if (t.data === "isFlip") {
            t.revert();
            t.getChildren(true, true, false).forEach(function (tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort


        tweens.map(function (t) {
          return {
            g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
            t: t
          };
        }).sort(function (a, b) {
          return b.g - a.g || -Infinity;
        }).forEach(function (o) {
          return o.t.revert(revert);
        }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.

        i = _this4.data.length;

        while (i--) {
          // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
          t = _this4.data[i];

          if (t instanceof Timeline) {
            if (t.data !== "nested") {
              t.scrollTrigger && t.scrollTrigger.revert();
              t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
            }
          } else {
            !(t instanceof Tween) && t.revert && t.revert(revert);
          }
        }

        _this4._r.forEach(function (f) {
          return f(revert, _this4);
        });

        _this4.isReverted = true;
      })();
    } else {
      this.data.forEach(function (e) {
        return e.kill && e.kill();
      });
    }

    this.clear();

    if (matchMedia) {
      var i = _media.length;

      while (i--) {
        // previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
        _media[i].id === this.id && _media.splice(i, 1);
      }
    }
  };

  _proto5.revert = function revert(config) {
    this.kill(config || {});
  };

  return Context;
}();

var MatchMedia = /*#__PURE__*/function () {
  function MatchMedia(scope) {
    this.contexts = [];
    this.scope = scope;
    _context && _context.data.push(this);
  }

  var _proto6 = MatchMedia.prototype;

  _proto6.add = function add(conditions, func, scope) {
    _isObject(conditions) || (conditions = {
      matches: conditions
    });
    var context = new Context(0, scope || this.scope),
        cond = context.conditions = {},
        mq,
        p,
        active;
    _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()

    this.contexts.push(context);
    func = context.add("onMatch", func);
    context.queries = conditions;

    for (p in conditions) {
      if (p === "all") {
        active = 1;
      } else {
        mq = _win$1.matchMedia(conditions[p]);

        if (mq) {
          _media.indexOf(context) < 0 && _media.push(context);
          (cond[p] = mq.matches) && (active = 1);
          mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
        }
      }
    }

    active && func(context, function (f) {
      return context.add(null, f);
    });
    return this;
  } // refresh() {
  // 	let time = _lastMediaTime,
  // 		media = _media;
  // 	_lastMediaTime = -1;
  // 	_media = this.contexts;
  // 	_onMediaChange();
  // 	_lastMediaTime = time;
  // 	_media = media;
  // }
  ;

  _proto6.revert = function revert(config) {
    this.kill(config || {});
  };

  _proto6.kill = function kill(revert) {
    this.contexts.forEach(function (c) {
      return c.kill(revert, true);
    });
  };

  return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */


var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap$2.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  quickTo: function quickTo(target, property, vars) {
    var _merge2;

    var tween = gsap$2.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
        func = function func(value, start, startIsRelative) {
      return tween.resetTo(property, value, start, startIsRelative);
    };

    func.tween = tween;
    return func;
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  context: function context(func, scope) {
    return func ? new Context(func, scope) : _context;
  },
  matchMedia: function matchMedia(scope) {
    return new MatchMedia(scope);
  },
  matchMediaRefresh: function matchMediaRefresh() {
    return _media.forEach(function (c) {
      var cond = c.conditions,
          found,
          p;

      for (p in cond) {
        if (cond[p]) {
          cond[p] = false;
          found = 1;
        }
      }

      found && c.revert();
    }) || _onMediaChange();
  },
  addEventListener: function addEventListener(type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
  },
  removeEventListener: function removeEventListener(type, callback) {
    var a = _listeners[type],
        i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    reverting: function reverting() {
      return _reverting$1;
    },
    context: function context(toAdd) {
      if (toAdd && _context) {
        _context.data.push(toAdd);

        toAdd._ctx = _context;
      }

      return _context;
    },
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap$2 = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt, v;
    this.tween = tween;

    for (p in vars) {
      v = target.getAttribute(p) || "";
      pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
      pt.op = p;
      pt.b = v; // record the beginning value so we can revert()

      this._props.push(p);
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt;

    while (pt) {
      _reverting$1 ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)

      pt = pt._next;
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap$2.version = "3.12.5";
_coreReady = 1;
_windowExists$1() && _wake();
var Power0 = _easeMap.Power0,
    Power1 = _easeMap.Power1,
    Power2 = _easeMap.Power2,
    Power3 = _easeMap.Power3,
    Power4 = _easeMap.Power4,
    Linear = _easeMap.Linear,
    Quad = _easeMap.Quad,
    Cubic = _easeMap.Cubic,
    Quart = _easeMap.Quart,
    Quint = _easeMap.Quint,
    Strong = _easeMap.Strong,
    Elastic = _easeMap.Elastic,
    Back = _easeMap.Back,
    SteppedEase = _easeMap.SteppedEase,
    Bounce = _easeMap.Bounce,
    Sine = _easeMap.Sine,
    Expo = _easeMap.Expo,
    Circ = _easeMap.Circ;

/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/


var _win,
    _doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _recentSetterPlugin,
    _reverting,
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    _bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _saveStyle = function _saveStyle(property, isNotCSS) {
  var _this = this;

  var target = this.target,
      style = target.style,
      cache = target._gsap;

  if (property in _transformProps && style) {
    this.tfm = this.tfm || {};

    if (property !== "transform") {
      property = _propertyAliases[property] || property;
      ~property.indexOf(",") ? property.split(",").forEach(function (a) {
        return _this.tfm[a] = _get(target, a);
      }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.

      property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
    } else {
      return _propertyAliases.transform.split(",").forEach(function (p) {
        return _saveStyle.call(_this, p, isNotCSS);
      });
    }

    if (this.props.indexOf(_transformProp) >= 0) {
      return;
    }

    if (cache.svg) {
      this.svgo = target.getAttribute("data-svg-origin");
      this.props.push(_transformOriginProp, isNotCSS, "");
    }

    property = _transformProp;
  }

  (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
},
    _removeIndependentTransforms = function _removeIndependentTransforms(style) {
  if (style.translate) {
    style.removeProperty("translate");
    style.removeProperty("scale");
    style.removeProperty("rotate");
  }
},
    _revertStyle = function _revertStyle() {
  var props = this.props,
      target = this.target,
      style = target.style,
      cache = target._gsap,
      i,
      p;

  for (i = 0; i < props.length; i += 3) {
    // stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
  }

  if (this.tfm) {
    for (p in this.tfm) {
      cache[p] = this.tfm[p];
    }

    if (cache.svg) {
      cache.renderTransform();
      target.setAttribute("data-svg-origin", this.svgo || "");
    }

    i = _reverting();

    if ((!i || !i.isStart) && !style[_transformProp]) {
      _removeIndependentTransforms(style);

      if (cache.zOrigin && style[_transformOriginProp]) {
        style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.

        cache.zOrigin = 0;
        cache.renderTransform();
      }

      cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
    }
  }
},
    _getStyleSaver = function _getStyleSaver(target, properties) {
  var saver = {
    target: target,
    props: [],
    revert: _revertStyle,
    save: _saveStyle
  };
  target._gsap || gsap$2.core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.

  properties && properties.split(",").forEach(function (p) {
    return saver.save(p);
  });
  return saver;
},
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e && e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (_windowExists() && window.document) {
    _win = window;
    _doc = _win.document;
    _docElement = _doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _reverting = gsap$2.core.reverting;
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style,
        first2Chars;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      first2Chars = property.substr(0, 2);

      if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    _nonStandardLayouts = {
  grid: 1,
  flex: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === _doc || !parent.appendChild) {
    parent = _doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
    return _round(curValue / cache.width * amount);
  } else {
    if (toPercent && (property === "height" || property === "width")) {
      // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
      var v = target.style[property];
      target.style[property] = amount + unit;
      px = target[measureProperty];
      v ? target.style[property] = v : _removeProperty(target, property);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

      parent.appendChild(_tempDiv);
      px = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";
    }

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; // ensure values are strings

  end += "";

  if (end === "auto") {
    startValue = target.style[prop];
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
  }

  a = [start, end];

  _colorStringFilter(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;

        _removeIndependentTransforms(style);
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextElementSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      cs = getComputedStyle(target),
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));

  if (cs.translate) {
    // accommodate independent transforms by combining them into normal ones.
    if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
      style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
    }

    style.scale = style.rotate = style.translate = "none";
  }

  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    if (cache.uncache) {
      // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
      t2 = target.getBBox();
      origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
      t1 = "";
    } else {
      t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
    }

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  uncache = uncache || cache.uncache;
  cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority,
        inlineProps;
    _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps

    this.styles = this.styles || _getStyleSaver(target);
    inlineProps = this.styles.props;
    this.tween = tween;

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
        inlineProps.push(p, 0, style[p]);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p] || getUnit(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            inlineProps.push("visibility", 0, style.visibility);

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          this.styles.save(p);

          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
            this._pt.u = 0;
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
          } else if (p !== "parseTransform") {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
        }

        isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  render: function render(ratio, data) {
    if (data.tween._time || !_reverting()) {
      var pt = data._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    } else {
      data.styles.revert();
    }
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap$2.utils.checkPrefix = _checkPropPrefix;
gsap$2.core.getStyleSaver = _getStyleSaver;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap$2.registerPlugin(CSSPlugin);

var gsapWithCSS = gsap$2.registerPlugin(CSSPlugin) || gsap$2,
    // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;

var gsap$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Back: Back,
	Bounce: Bounce,
	CSSPlugin: CSSPlugin,
	Circ: Circ,
	Cubic: Cubic,
	Elastic: Elastic,
	Expo: Expo,
	Linear: Linear,
	Power0: Power0,
	Power1: Power1,
	Power2: Power2,
	Power3: Power3,
	Power4: Power4,
	Quad: Quad,
	Quart: Quart,
	Quint: Quint,
	Sine: Sine,
	SteppedEase: SteppedEase,
	Strong: Strong,
	TimelineLite: Timeline,
	TimelineMax: Timeline,
	TweenLite: Tween,
	TweenMax: TweenMaxWithCSS,
	default: gsapWithCSS,
	gsap: gsapWithCSS
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(gsap$1);

const gsap = require$$0;


const {parseFontName: parseFontName$2, sleep: sleep$2, waitForFontLoading: waitForFontLoading$1} = utils;


let simpleText$1 = class simpleText {
    constructor(data, vm){
        this._vm = vm;

        this._id = data.id;
        this._name = "simpleText";

        this._x = data.x;
        this._y = data.y;
        this._scale = data.scale;

        //INIT PARAMS
        const labels = ["text", "fontName", "alignText" ,"textColor", "backgroundColor", "animation"];
        labels.forEach(label =>{
            const index = data.params.findIndex(p => p.label == label);
            if (index == -1){
                data.params.push({
                    "label" : label
                });
            }
        });
        data.params.forEach(param =>{
            switch (param.label){
                case "text":
                    param.value = (param.value != undefined ? param.value : "Simple text");
                    //this._text = param.value
                    param.type = "text";
                    break;

                case "fontName":
                    param.value = (param.value != undefined ? param.value : "Poppins");
                    param.type = "font";
                    break;

                case "alignText":
                    param.value = (param.value != undefined ? param.value : "center");
                    param.type = "alignText";
                    break;
                    
                case "textColor":
                    param.value = (param.value != undefined ? param.value : "#3d545c");
                    //this._color
                    param.type = "color";
                    break;

                case "backgroundColor":
                    param.value = (param.value != undefined ? param.value : "#FFFFFF");
                    //this._background
                    param.type = "color";
                    break;

                case "animation":
                    param.value = (param.value != undefined ? param.value : "default");
                    //this._animation
                    param.type = "animation";
                    param.choices = ["default", "slideUp", "slideDown", "slideLeft", "slideRight", "zoomIn", "zoomOut"];
                    break;
            }
        });
        
        this.params = data.params;

        //TMIINGS
        this._appearanceDuration = data.appearanceDuration;
        this._startAt = data.start;

        this._padding = 5;

        this.playing = false;

        this.create();
    };

    get _text(){
        return this.params.find(p => p.label == "text").value
    }
    get _fontName(){
        return this.params.find(p => p.label == "fontName").value
    }
    get _alignText(){
        return this.params.find(p => p.label == "alignText" ).value
    }

    get _color(){
        return this.params.find(p => p.label == "textColor").value
    }
    get _backgroundColor(){
        return this.params.find(p => p.label == "backgroundColor").value
    }
    get _animation(){
        return this.params.find(p => p.label == "animation").value
    }


    get animationKeys(){
        const endOffset = this._renderOffset(this.width, this.height);
        switch (this._animation){
            case "default":
                return {
                    from : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }

            case "slideUp":
                
                return {
                    from : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY - this._vm.height*0.08,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }

            case "slideDown":
                
                return {
                    from : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY + this._vm.height*0.08,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }

            case "slideRight":
                
                return {
                    from : {
                        offsetX : endOffset.offsetX - this._vm.width*0.08,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }

            case "slideLeft":
                
                return {
                    from : {
                        offsetX : endOffset.offsetX + this._vm.width*0.08,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }
            

            case "zoomIn":
                const scaleStart_1 = this.absoluteScale - 1;
                return {
                    from : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : scaleStart_1,
                        scaleY : scaleStart_1
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }

            case "zoomOut":
                const scaleStart_2 = this.absoluteScale + 1;
                return {
                    from : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : scaleStart_2,
                        scaleY : scaleStart_2
                    },
                    to : {
                        offsetX : endOffset.offsetX,
                        offsetY : endOffset.offsetY,
                        scaleX : this.absoluteScale,
                        scaleY : this.absoluteScale
                    }
                }
        }
    }

    create(){
        //Create main node
        this._mainNode = new Konva.Group({
            draggable: true,
            listening: true,
            name : "textOverlay - simpleText"
        });

        this._mainNode.setAttr("textOverlayId", `${this._id}`);

        //CREATE TEXT
        this._textNode = new Konva.Text({
            text: this._text,
            fontFamily: parseFontName$2(this._fontName).fontFamily || "Poppins",
            fontStyle: parseFontName$2(this._fontName).fontStyle,
            fill: this._color,
            align : this._alignText
        });

        //ADD PADDING TO TEXT NODE
        this._textNode.absolutePosition({
            x: this._padding,
            y: this._padding
        });
        this._mainNode.add(this._textNode);

        //BACKGROUND
        this._backgroundNode = new Konva.Rect({
            fill: this._backgroundColor
        });

        this._backgroundNodeAutoResize();

        //waitForFontLoading(this._fontName).then(()=>{
        //    this._backgroundNodeAutoResize();
        //})


        this._mainNode.add(this._backgroundNode);
        this._backgroundNode.zIndex(0);

        //SET MAIN NODE POSITION FROM POSITION PARAMS (GIVED IN PERCENT by user)
        this._mainNode.absolutePosition(this.absolutePosition);
        this._mainNode.offsetX(this.animationKeys.from.offsetX);
        this._mainNode.offsetY(this.animationKeys.from.offsetY);
        this._mainNode.scaleX(this.animationKeys.from.scaleX);
        this._mainNode.scaleY(this.animationKeys.from.scaleY);
        this._mainNode.opacity((this._animation == "default" ? 1 : 0));

        this._vm.overlaysLayer.add(this._mainNode);



        //ANIMATION
        this._initAnimation();
          
          
        //EVENTS
        this._mainNode.on('mouseover', () => {
            //document.body.style.cursor = 'pointer !important';
            this._vm.container.style.cursor = "pointer";
        });

        this._mainNode.on('mouseout', () => {
            this._vm.container.style.cursor = "default";
        });

        this._mainNode.on('dragstart', () => {
            this._vm.draggingTextOverlay = true;
        });


        this._mainNode.on('dragend', (e) => {
            e.evt.preventDefault(); //Prevent mouseUp event

            this._x =  this.percentPositionFromCenter.x;
            this._y =  this.percentPositionFromCenter.y;
            this._mainNode.absolutePosition(this.absolutePosition);

            
            this.updateOverlayTextInPicassoList({
                x : this.percentPositionFromCenter.x,
                y : this.percentPositionFromCenter.y
            });

            this.emitChanges();
            this._vm.selectTextOverlay(this);
            
        });

        this._mainNode.on('transformend', () => {

            this._scale = this.relativeScale;

            //this._mainNode.offsetX(this.animationKeys.from.offsetX)
            //this._mainNode.offsetY(this.animationKeys.from.offsetY)
            this._mainNode.scaleX(this.animationKeys.from.scaleX);
            this._mainNode.scaleY(this.animationKeys.from.scaleY);

            
            this.updateOverlayTextInPicassoList({
                scale :this.relativeScale
            });

            

            this.emitChanges();
            this._vm.selectTextOverlay(this);
        });
    

    }

    _backgroundNodeAutoResize(){
        this._backgroundNode.width(this.width);
        this._backgroundNode.height(this.height);
        this._backgroundNode.cornerRadius(this._borderRadius);
        
    }
        
    get textOverlayId(){
        return `${this._id}`
    }

    get width(){
        const lines = this._text.split("\n");
        const linesWidth = lines.map(line => Number(this._textNode.measureSize(line).width));
        return Math.max(...linesWidth) + this._padding * 2
        //return this._textNode.width() + this._padding * 2
    }
    
    get height(){
        return this._textNode.height() + this._padding * 2
    }

    get _borderRadius(){
        return 2
    }

    get absoluteScale(){
        return (this._vm.width * this._scale) / 30000;
    }

    get relativeScale(){
        return parseFloat((this._mainNode.getAbsoluteScale().x * 30000 / this._vm.width).toFixed())
    }

    get offset(){
        return this._renderOffset(this.width, this.height)
    }

    _renderOffset(nodeWidth, nodeHeight){
        return {
            offsetX : nodeWidth/2,
            offsetY : nodeHeight/2
        }
    }


    get absolutePosition(){
        let set = {
            x: this._x * this._vm.width/100,
            y: this._y * this._vm.height/100
        };
        return set
    }


    get percentPositionFromCenter(){
        return {
            x : parseFloat((this._mainNode.absolutePosition().x * 100 / this._vm.width).toFixed()),
            y : parseFloat((this._mainNode.absolutePosition().y * 100 / this._vm.height).toFixed())
        }
    };

    get node(){
        return this._mainNode;
    }

    get completeDisplayDuration(){
        let set = this._appearanceDuration/1000 - (0.6*2);
        return (set < 0 ? 0 : set)
    }

    emitChanges(){
        let set = {
            textOverlayId : this._id,
            ...this.percentPositionFromCenter,
            scale : this.relativeScale
        };
        this._vm.emit("textOverlayTransformed", set);
    }

    play(){
        this.playing = true;
        this._tl.play();
    }

    pause(){
        this.playing = false;
        this._tl.pause();
    }

    get paused(){
        return this._tl.paused()
    }

    seek(time){
        this.playing = false;
        this._tl.pause();
        this._tl.seek(time/1000);
    }

    get currentTime(){
        return this._tl.time();
    }

    _initAnimation(){

        this._tl = gsap.gsap.timeline({
            paused : true
        });

        if (this._animation != "default"){
            this._tl.to(this._mainNode, {
                duration : 0.6,
                ...this.animationKeys.to,
                ease: gsap.Power4.easeOut
            }, "moveStarting") //Animation in => Move
            .to(this._mainNode, {
                duration : 0.2,
                opacity : 1,
                ease: gsap.Power4.easeOut
            }, "<") //Animation in => Opacity
            .to(this._mainNode, {
                duration : 0.6,
                ...this.animationKeys.from,
                ease: gsap.Power4.easeIn
            }, `moveStarting+=${0.6 + this.completeDisplayDuration}`) //Animation out => Move
            .to(this._mainNode, {
                duration : 0.2,
                opacity : 0,
                ease: gsap.Power4.easeIn
            }, "<0.4"); //Animation out => Opacity
        }
        

    }

    resize(){
        this._mainNode.absolutePosition(this.absolutePosition);
        this._backgroundNodeAutoResize();
    }

    destroy(){
        this._mainNode.destroy();
        this._tl.kill();
    };

    async update(param){
        this.params[this.params.findIndex(p => p.label == param.label)].value = param.value;
        
        switch (param.label){
            case 'text':
                //this._text = param.value;
                await this._textNode.text(param.value);

                this._backgroundNodeAutoResize();
                this._mainNode.absolutePosition(this.absolutePosition);
                break;

            case 'fontName':
                //this._font = param.value;
                let parseFontNameParsed = parseFontName$2(param.value);
                const fontFamily = parseFontNameParsed.fontFamily;
                const fontStyle = parseFontNameParsed.fontStyle;

                this._textNode.fontFamily(fontFamily);
                this._textNode.fontStyle(fontStyle);

                this._backgroundNodeAutoResize();

                if (!this._vm.renderMode){
                    waitForFontLoading$1(fontFamily, {
                        weight : parseFontNameParsed.bold == true ? "bold" : undefined,
                        style : parseFontNameParsed.italic == true ? "italic" : undefined
                    }).then(()=>{
                        this._textNode.fontFamily(fontFamily);
                        this._textNode.fontStyle(fontStyle);
                        this._backgroundNodeAutoResize();
                        this._vm._tr.forceUpdate();
                    });
                }
                
                this._mainNode.absolutePosition(this.absolutePosition);

                break;

            case 'textColor':
                //this._color = param.value
                this._textNode.fill(param.value);
                break;

            case 'backgroundColor':
                //this._background = param.value
                this._backgroundNode.fill(param.value);
                break;

            case "alignText" :
                this._textNode.align(param.value);
                break
        }

        if (['text', 'fontName', 'animation'].includes(param.label)){
            const currentTime = this._tl.time();
    
            this._tl.kill();
    
            this._initAnimation();
            this._tl.seek(currentTime);
            this._vm._tr.forceUpdate();
        }

        this.updateOverlayTextInPicassoList({"params" : [param]});
    }

    updateOverlayTextInPicassoList(data){
        //let el = this._vm.overlays_texts_map.get(this._id);
        var el = this._vm._overlays_texts.find(e => e.id == this._id);
        
        //console.log('avant', el)
        Object.keys(data).forEach(key =>{
            if (key == "params"){
                data.params.forEach(param =>{
                    
                    const paramIndex = el.params.findIndex(p => p.label == param.label);
                    el.params[paramIndex].value = param.value;
                });

            } else {
                el[key] = data[key];
            }
        });

        this._vm._overlays_texts[this._vm._overlays_texts.findIndex(e => e.id == this._id)] = el;
    }
    
};
var simpleText_1 = simpleText$1;

const simpleText = simpleText_1;

const { parseFontName: parseFontName$1, waitForFontLoading } = utils;

async function initTextOverlays(){
    if (!this.renderMode){
        this.availableFonts.forEach(font =>{
            const fontPrased = parseFontName$1(font);
            waitForFontLoading(fontPrased.fontFamily, {
                weight : fontPrased.bold == true ? "bold" : undefined,
                style : fontPrased.italic == true ? "italic" : undefined 
            });
        });
    }



    this._overlays_texts.forEach(textOverlay =>{
        //textOverlay.appearanceDuration = textOverlay.end - textOverlay.start;
        const relativeTimeAtEnd = this._retrieveCut(null, textOverlay.end, false).relativeTime;
        const relativeTimeAtStart = this._retrieveCut(null, textOverlay.start, false).relativeTime;
        
        textOverlay.appearanceDuration = relativeTimeAtEnd - relativeTimeAtStart;
    });

    

    //TRANSFORMER
    this._tr = new Konva.Transformer({
        rotateEnabled : false,
        keepRatio : true,
        centeredScaling : true,
        enabledAnchors: [
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
        ],
    });

    this.overlaysLayer.add(this._tr);

    this.stage.on('mouseup touchend', (evt) => {
        let textOverlayId = null;

        if (evt.target.parent != undefined && evt.target.parent.getAttr("textOverlayId") != undefined) {
            textOverlayId = evt.target.parent.getAttr("textOverlayId");
        } else if (evt.target.parent != undefined && evt.target.parent.parent != undefined && evt.target.parent.parent.getAttr("textOverlayId") != undefined) {
            textOverlayId = evt.target.parent.parent.getAttr("textOverlayId");
        }

        if ( textOverlayId == null){
            this.clearTextOverlaySelection();
            return;
        }

        const textObject = this._overlays_texts.find(element => element.object != undefined && element.object != null && element.object.textOverlayId == textOverlayId);
        //const textObject = this._overlays_texts_map.get(Number(textOverlayId))

        if (textObject != undefined){
            this.selectTextOverlay(textObject.object);
        } else {
            this.clearTextOverlaySelection();
        }

    });

    this.seekTextOverlays(true);
}

function selectTextOverlayById(elementId){
    const element = this._overlays_texts.find(el => el.id == elementId);
    if (element != undefined && element.object != undefined){
        this.selectTextOverlay(element.object);
    }
}

function selectTextOverlay(element){
    this._tr.nodes([element.node]);
    this.emit('textOverlaySelected', element);
}

function clearTextOverlaySelection(){
    this._tr.nodes([]);
    this.emit('textOverlaySelected', null);
}

async function initDisplayedTextOverlay(){
    if (this.overlaysLayer == null || this.overlaysLayer == undefined){
        return []
    }

    return this._overlays_texts.map((textOverlay) => {
        let currentlyDisplayed = (textOverlay.start <= this.currentMediaTime && this.currentMediaTime < textOverlay.end);
        if (currentlyDisplayed == true){
            //CREATE OBJECT IF NECESSARY
            if (textOverlay.object == undefined || textOverlay.object == null){
                switch (textOverlay.name){
                    case "simpleText":
                        textOverlay.object = new simpleText(textOverlay, this);
                        break;
                }
            }

            return textOverlay;
        } else {
            if (textOverlay.object != undefined && textOverlay.object.destroy != undefined){
                textOverlay.object.destroy();
                delete textOverlay.object;
                return null
            }
        }
    }).filter(e => e != null)
}

async function seekTextOverlays(seek = false){

    const currentlyVisibleTextOverlay = await this.initDisplayedTextOverlay();

    currentlyVisibleTextOverlay.forEach((textOverlay) => {
        //SEEK ANIMATION
        if (seek == true){
            
            const relativeTimeAtStart = this._retrieveCut(null, textOverlay.start, false).relativeTime;
            const decaySinceStart = this.relativeTime - relativeTimeAtStart;
            textOverlay.object.seek(decaySinceStart);
        }
        
        //PLAY
        if (this.paused == false && textOverlay.object != undefined && textOverlay.object.paused){
            textOverlay.object.play();
        }
        
    });
}

async function resizeTextOverlays(){
    const currentlyVisibleTextOverlay = await this.initDisplayedTextOverlay();

    currentlyVisibleTextOverlay.forEach((textOverlay) => {
        textOverlay.object.destroy();
        textOverlay.object.create();
        const relativeTimeAtStart = this._retrieveCut(null, textOverlay.start, false).relativeTime;
        const decaySinceStart = this.relativeTime - relativeTimeAtStart;
        textOverlay.object.seek(decaySinceStart);
    });
}

async function resumeTextOverlays(){
    const currentlyVisibleTextOverlay = await this.initDisplayedTextOverlay();

    currentlyVisibleTextOverlay.forEach((textOverlay) => {
        try {
            if (textOverlay.object != undefined){
                if (this.paused == false){
                    //PLAY
                    textOverlay.object.play();
                } else {
                    //PAUSE
                    textOverlay.object.pause();
                }
            }
        } catch (e){
            console.warn(e);
            console.log(textOverlay.object);
        }
        
    });

}

var overlays_texts = {
    seekTextOverlays,
    resumeTextOverlays,
    initDisplayedTextOverlay,
    initTextOverlays,
    resizeTextOverlays,
    selectTextOverlayById,
    selectTextOverlay,
    clearTextOverlaySelection
};

const sleep$1 = (ms) => new Promise((r) => setTimeout(r, ms));

function handle_videoWaiting() {
    if (this.zoomTween != null) {
      this.zoomTween.pause();
    }
  }
function handle_videoPlaying() {
    //console.log('this.zoomTween', this.zoomTween, this)
    if (this.zoomTween != null) {
      this.zoomTween.play();
    }
}
  
function handle_playerTimeUpdate(evt){
    evt.target.removeAttribute('seeking');
    const playerIndex = Number(evt.target.getAttribute('playerIndex'));
    const seekTarget = Number(evt.target.getAttribute("seekTarget"));
    this.playersState[playerIndex] = seekTarget;
}

function seekPlayer(playerIndex, time){
    return new Promise(async (resolve) =>{
        if (this.playersState[playerIndex] != time ){
            this.videoList[playerIndex].currentTime = time;
            this.videoList[playerIndex].setAttribute('seekTarget', time);
            this.videoList[playerIndex].setAttribute('seeking', true);
        }
        resolve();
    })
}

async function waitForPlayerSeeking(playerIndex){
    const seekTarget = Number(this.videoList[playerIndex].getAttribute("seekTarget"));
    while (this.playersState[playerIndex] != seekTarget){
        await sleep$1(40);
    }}

var mainVideo = {
    handle_videoWaiting,
    handle_videoPlaying,
    handle_playerTimeUpdate,
    seekPlayer,
    waitForPlayerSeeking
};

//If Konva not already loaded
if (typeof(Konva) === 'undefined'){
  requireKonva();
}
const pjson = require$$1;

const EventEmitter = eventsExports.EventEmitter;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const fontsList = ['Bangers', 'Arial', 'Arial italic', 'Arial bold', 'Arial italic bold', 'Comic Neue', 'Comic Neue italic', 'Comic Neue bold', 'Comic Neue italic bold', 'Inter', 'Inter bold', 'Lato', 'Lato italic', 'Lato bold', 'Lato italic bold', 'Merriweather', 'Merriweather italic', 'Merriweather bold', 'Merriweather italic bold', 'Montserrat', 'Montserrat bold', 'Mulish', 'Mulish italic', 'Mulish bold', 'Mulish italic bold', 'Open Sans', 'Open Sans italic', 'Open Sans bold', 'Open Sans italic bold', 'Oswald', 'Poppins', 'Poppins italic', 'Poppins bold', 'Poppins italic bold', 'Roboto', 'Roboto italic', 'Roboto bold', 'Roboto italic bold', 'Varela Round', 'Verdana', 'Verdana bold', 'Verdana italic', 'Verdana italic bold'];


const CROP_SCALE = 1.43;


class Picasso extends EventEmitter{
  //constructor(container, videoSrc, maker_data, format, originalSize, media_type, background_color = "#ffffff", renderMode = false
  constructor( container, format, clip_data, background_color = "#ffffff", captionsSettings, media, renderMode = false, overlays) {
    super();

    this.timing_retrieve_cut = [];
    this.timing_background_image = [];
    this.timing_checkcaption = [];
    this.timing_check_overlays = [];
    this.waitForPlayerTime = [];

    this.puppeteerMode = false;
    
    this.renderMode = renderMode;

    //Div container Id
    this.containerId = container;
    if (!this.renderMode && document != undefined){
      this.container = document.getElementById(container);
    } else {
      this.container = null;
    }


    this.setFormat(format);

    //Video
    this.nbVideoBalise = 4;
    this.videoSrc = media.videoSrc || null;
    this.videoList = [];
    this.playersState = [];
    this.handle_playerTimeUpdate = this.handle_playerTimeUpdate.bind(this);
    this.lastTimeRefresh = 0;

    this.currentMediaTime = 0;
    this.relativeTime = 0;
    this.subClips = clip_data.subClips;
    this.totalRelativeDuration = clip_data.relative_duration;
    this.index_current_subClip = 0;
    this.index_current_cut = 0;
    this.currentBaliseVideo = 0;

    this.zoomTween = null;
    this.paused = true;
    this.muted = false;
    this.fullscreen = false;
    this.originalSize = media.originalSize;
    this.media_type = media.media_type;
    this.background_color = background_color;

    //this.animationData = animationData;

    //CAPTIONS
    this.setCaptionsSettings(captionsSettings);
    this._last_wordbyPage_value = null;
    this.transcription = media.transcription;
    this.currentWordTween = null;


    //OVERLAYS
    this._overlays_assets = (overlays != undefined && overlays.assets != undefined ? JSON.parse(JSON.stringify(overlays.assets)) : []);
    this._overlays_texts = (overlays != undefined && overlays.texts != undefined ? JSON.parse(JSON.stringify(overlays.texts)) : []);

    this.init();
    

  }


  static getVersion(){
    return pjson.version
  }

  setTranscription(value){
    this.transcription = value;
    this.initCaptions();
  }

  async setCaptionsSettings(value){
    //If the nomber of word by page change from previous settings, change it to recalculate pages lines
    let captionNeedBeInit = value.wordByPage != this._last_wordbyPage_value;
    this._last_wordbyPage_value = value.wordByPage;

    this.captionsSettings = value;

    let parseFontNameParsed = parseFontName(this.captionsSettings.fontName);
    this.captionsSettings.fontStyle = parseFontNameParsed.fontStyle;
    this.captionsSettings.fontFamily = parseFontNameParsed.fontFamily;

    //if captions not initialized
    if (this.captions == null){
      return;
    }
    
    if (captionNeedBeInit){
      this.initCaptions();
    }
    this.checkCaptions(null, true);
    this.setReadyStatus(true);
  
  }

  async loadFont(fontName){
    let tentatives = 15;
    let stopFontChecking = false;
    let fondLoaded = false;
    while (!stopFontChecking){
      tentatives--;

      fondLoaded = document.fonts.check("12px "+fontName);
      
      if (tentatives == 0 || fondLoaded){
        stopFontChecking = true;
      } else {
        await sleep(200);
      }
    }

    return fondLoaded

  }

  //GETTERS
  get wordAnimation(){
    try {
      if (Object.keys(wordAnimations).includes(this.captionsSettings.wordAnimation)){
        return wordAnimations[this.captionsSettings.wordAnimation]
      } else {
        throw 'wordAnimation not found'
      }
    } catch (e){
      return wordAnimations.default
    }
  }

  get availableFonts(){
    return fontsList
  }

  static getAvailableFonts(){
    return fontsList
  }


  get index_previousVideo() {
    if (this.index_currentVideo - 1 == -1) {
      return this.nbVideoBalise - 1;
    } else {
      return this.index_currentVideo - 1;
    }
  }
  get index_currentVideo() {
    return this.currentBaliseVideo % this.nbVideoBalise;
  }

  get index_nextVideo() {
    if (this.index_currentVideo + 1 == this.nbVideoBalise) {
      return 0;
    } else {
      return this.index_currentVideo + 1;
    }
  }

  get_index_nextPlayerVideo(index = 1){
    if (this.index_currentVideo + index >= this.nbVideoBalise) {
      return (this.index_currentVideo + index) - this.nbVideoBalise;
    } else {
      return this.index_currentVideo + index;
    }
  }

  get index_nextVideo_2() {
    if (this.index_currentVideo + 2 >= this.nbVideoBalise) {
      return (this.index_currentVideo + 2) - this.nbVideoBalise;
    } else {
      return this.index_currentVideo + 2;
    }
  }

  get index_nextVideo_3() {
    if (this.index_currentVideo + 3 >= this.nbVideoBalise) {
      return (this.index_currentVideo + 3) - this.nbVideoBalise;
    } else {
      return this.index_currentVideo + 3;
    }
  }

  get currentCut() {
    return this.subClips[this.index_current_subClip].cuts[this.index_current_cut];
  }

  get nextCut() {
    if ( this.index_current_cut == this.subClips[this.index_current_subClip].cuts.length - 1 ) {
      if (this.subClips[this.index_current_subClip + 1] != undefined) {
        return this.subClips[this.index_current_subClip + 1].cuts[0];
      } else {
        return undefined;
      }
    } else {
      return this.subClips[this.index_current_subClip].cuts[this.index_current_cut + 1];
    }
  }

  get lastCut() {
    let subClip = this.subClips[this.subClips.length - 1];
    let lastCut = subClip.cuts[subClip.cuts.length - 1];
    return lastCut;
  }

  get originalFormat() {
    if (this.originalSize.width > this.originalSize.height) {
      return "horizontal";
    } else if (this.originalSize.height > this.originalSize.width) {
      return "vertical";
    } else {
      return "square";
    }
  }
  get originalRatio() {
    return this.originalSize.width / this.originalSize.height;
  }

  get videoY() {
    if (this.originalFormat == "vertical" && this.ratio == 1 / 1 && this.media_type != "screen_record" ) {
      return -((this.videoDimensions.height * 120) / 550);
    } else {
      return (this.height - this.videoDimensions.height) / 2;
    }
  }
  get videoDimensions() {
    var videoWidth, videoHeigth;
    if (this.ratio == 16 / 9 || this.media_type == "screen_record") {
      videoWidth = this.width;
      videoHeigth = this.width / this.originalRatio;

      if (videoHeigth > this.height) {
        videoHeigth = this.height;
        videoWidth = this.height * this.originalRatio;
      }
    } else if (this.ratio == 9 / 16) {
      videoHeigth = this.height;
      videoWidth = this.height * this.originalRatio;
    } else if (this.ratio == 1 / 1) {
      if (this.originalFormat == "vertical") {
        videoWidth = this.width;
        videoHeigth = this.width / this.originalRatio;
      } else {
        videoHeigth = this.height;
        videoWidth = this.height * this.originalRatio;
      }
    }
    return { width: videoWidth, height: videoHeigth };
  }

  setMakerData(data) {
    this.pausePlayer();
    this.subClips = data.subClips;
    
    this.totalRelativeDuration = data.relative_duration;
    this.seek(0);
    this.setReadyStatus(true);
  }

  setFormat(format) {
    if (format == "horizontal") {
      this.ratio = 16 / 9;
    } else if (format == "vertical") {
      this.ratio = 9 / 16;
    } else if (format == "square") {
      this.ratio = 1 / 1;
    }
    this.setSize();
    //this.emit('ready', this)
    this.setReadyStatus(true);
  }
  setSize(refreshLayers = true) {
    if(this.containerId.width != undefined){
      this.width = this.containerId.width;
    } else {
      this.width = document.getElementById(this.containerId).clientWidth;
    }

    this.height = this.width / this.ratio;
    if (this.colorBackground != undefined) {
      this.colorBackground.width(this.width);
      this.colorBackground.height(this.height);
    }

    if (this.videoBackground != undefined) {
      this.stage.width(this.width);
      this.stage.height(this.height);
      this.videoBackground.width(this.videoDimensions.width);
      this.videoBackground.height(this.videoDimensions.height);
      this.videoBackground.offsetX(this.videoBackground.width() / 2);
      this.videoBackground.x(this.stage.width() / 2);
      this.videoBackground.y(this.videoY);
    }
    this.overlayCornerRadius = (this.width * 8)/660;
    this.adapteOverlayBackground();
    this.resizeTextOverlays();

    if (refreshLayers){
      this.checkCaptions(null, true);
      this.checkOverlays(true);
    }
    
  }

  setSizeFullscreen() {
    if (this.ratio == 16 / 9) {
      this.width = window.screen.width;
      this.height = this.width / this.ratio;
      if (window.screen.height < this.height) {
        this.height = window.screen.height;
        this.width = this.height * this.ratio;
      }
    } else if (this.ratio == 9 / 16) {
      this.height = window.screen.height;
      this.width = this.height * this.ratio;
    } else if (this.ratio == 1 / 1) {
      this.height = window.screen.height;
      this.width = this.height;
      this.videoBackground.y(this.videoY);
    }

    this.stage.width(this.width);
    this.stage.height(this.height);

    this.colorBackground.width(this.width);
    this.colorBackground.height(this.height);
    this.videoBackground.width(this.videoDimensions.width);
    this.videoBackground.height(this.videoDimensions.height);
    this.videoBackground.offsetX(this.videoDimensions.width / 2);
    this.videoBackground.x(this.width / 2);
    this.videoBackground.y(this.videoY);

    this.checkCaptions(null, true);

    this.initOverlays();
    this.checkOverlays(true);
    this.resizeTextOverlays();
  }

  setMuted() {
    this.muted = !this.muted;
    this.videoList.forEach((video) => {
      video.muted = this.muted;
    });
  }

  async init() {
    //INIT STAGE
    this.stage = new Konva.Stage({
      container: this.containerId,
      width: this.width,
      height: this.height,
    });

    //this.stage.listening(false);
    if (!this.renderMode){
      document.querySelector("#" + this.containerId).firstChild.style.margin =  "auto";
    }

    //MAIN VIDEO
    this.videoLayer = new Konva.Layer({
      name : "VideoLayer",
      listening : false
    });

    this.stage.add(this.videoLayer);

    
    this.colorBackground = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.width,
      height: this.height,
      fill: this.background_color, //"#4fbecc",
      opacity: 1
    });
    

    this.videoLayer.add(this.colorBackground);
    
    await this.initMainVideo();

    //CAPTIONS
    this.initCaptions();

    await this.initOverlays();
    await this.checkOverlays();

    if (!this.renderMode){
      await this.seek(0);
      this.emit('initialized', this);
      document.getElementById(this.containerId).classList.add("initialized");
    }
 
  }

  process(img) {
    return new Promise((resolve) => {
      img.onload = () => resolve({ width: img.width, height: img.height });
    });
  }

  async updateSvg() {
    const xml = new XMLSerializer().serializeToString(this._lottieTempSvg);
    const svg64 = window.btoa(xml);
    const image64 = "data:image/svg+xml;base64," + svg64;
    if (this.canvasLib != undefined){
      var imageObj = new this.canvasLib.Image;
    } else {
      var imageObj = new Image({ width: this._lottieTempCanvas.width, height: this._lottieTempCanvas.height });
    }

    imageObj.src = image64;
    await this.process(imageObj);
    //console.log(image64)
    this._lottieTempCanvasContext.clearRect(0, 0, this._lottieTempCanvas.width, this._lottieTempCanvas.height);
    this._lottieTempCanvasContext.drawImage(imageObj, 0, 0, this._lottieTempCanvas.width, this._lottieTempCanvas.height);

    this.lottieLayer.draw();
    //updateSvg();
  };

  async initMainVideo() {
   //console.debug("Main ideo initialization..")
    if (!this.renderMode){

      var playerLoading = this.nbVideoBalise;

      this.playersState = [...(new Array(this.nbVideoBalise))].map(() => {return false});
      
      for (let i = 0; i < this.nbVideoBalise; i++) {
        let video = document.createElement("video");
        video.src = this.videoSrc;
        video.muted = this.muted;
        video.preload = "auto";
        video.crossOrigin = "Anonymous";
        video.setAttribute("playerIndex", i);

        this.videoList.push(video);

        video.addEventListener("canplaythrough", () => {
          playerLoading -= 1;
        }, { once: true });

        //video.addEventListener("waiting", this.handle_videoWaiting);
        //video.addEventListener("playing", this.handle_videoPlaying);
        video.addEventListener('timeupdate', this.handle_playerTimeUpdate);

      }

      while (playerLoading != 0){
        await sleep(50);
      }

    }

    //Init Video
    //var alreadyRedraw = false
    this.animationFrame = new Konva.Animation(()=>{
      //if (alreadyRedraw == false){
      //  alreadyRedraw = true;
      //}
    }, this.videoLayer);

    this.animationFrame.start();

    if (!this.renderMode){
      this.videoBackground = new Konva.Image({
        draggable: false,
        x: this.videoLayer.width() / 2,
        width: this.videoDimensions.width,
        height: this.videoDimensions.height,
        opacity : 1
      });

      
      this.videoBackground.listening(false);
      this.videoBackground.offsetX(this.videoBackground.width() / 2);
      this.videoBackground.y(this.videoY);
  
      this.videoLayer.add(this.videoBackground);

    }

    await this.videoLayer.draw();
    
    this.stage.draw();

    if (!this.renderMode){
      this.videoBackground.image(this.videoList[0]);
    }
  }

  

  async initLottie(canvas, jsdom, lottie){
    this.canvasLib = canvas;

    //LOTTIE TITLES
    const { JSDOM } = jsdom;
    const dom = new JSDOM(`<!DOCTYPE html><body></body>`);
    
    //console.log(dom.window.document.querySelector("p").textContent); // "Hello world"

    this.lottieLayer = new Konva.Layer({
      name : "lottieLayer",
      listening : false
    });

    this.stage.add(this.lottieLayer);

    this._lottieTempCanvas = dom.window.document.createElement("canvas");
    //this._lottieTempCanvas = createCanvas(this.width, this.height);
    

    this._lottieTempCanvas.style.width = this.width;
    this._lottieTempCanvas.style.height= this.height;
    this._lottieTempCanvas.setAttribute("id", "animationCanvas");
    this._lottieTempCanvasContext = this._lottieTempCanvas.getContext("2d");
    const div = dom.window.document.createElement("div");
    div.setAttribute("id", "animationContainer");
    dom.window.document.body.appendChild(div);

  
    
    //div.style.display = "none";
    //canvas.style.display = "none";

    this.lottieAnimation = null;
    let imageObj = null;
    imageObj = this.canvasLib != undefined ? new this.canvasLib.Image : new Image();
    

    
    
    imageObj.width = 500;
    imageObj.height = 500;
    

    this.lottieAnimation = lottie.loadAnimation({
      container: div, // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: false,
      animationData: this.animationData,
      rendererSettings: {
        scaleMode: "centerCrop",
        clearCanvas: true,
        progressiveLoad: false,
        hideOnTransparent: true,
        preserveAspectRatio: "xMinYMin slice",
      }
    });

    this._lottieTempSvg = await div.getElementsByTagName("svg")[0];
    console.log('this._lottieTempSvg', this._lottieTempSvg);

    console.log(this.lottieAnimation);


    
    
    //const animFrame = requestAnimationFrame(updateSvg);
    //  this.animations.push({ lottie: lottieAnimation, animFrame });
    imageObj = this._lottieTempCanvas;
    this._lottieTempCanvas.onload = async () => {
      this._lottieTempCanvas.parentNode.removeChild(this._lottieTempCanvas);
    };
      
    const image = new Konva.Image({
      x: 50,
      y: 50,
      image: imageObj,
      width: imageObj.width,
      height: imageObj.height,
      position: (0),
      strokeWidth: 10,
      stroke: "blue",
      strokeEnabled: false
    });

    this.lottieLayer.add(image);

    setTimeout(() => {
      this.lottieLayer.zIndex(3);
    }, 1000);
    
    var anim = new Konva.Animation(() => {}, this.lottieLayer);
    anim.start();

    /*
    //ANIMATION
    var lottieAnim = lottie.loadAnimation({
      //container: canvas,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: this.animationData,
      rendererSettings: {
        //scaleMode: "centerCrop",
        context: ctx,
        clearCanvas: false,
        //preserveAspectRatio: "xMinYMin slice",
        preserveAspectRatio: 'xMidYMid meet',
        
        filterSize: {
          width: "500px",
          height: "500px",
          x: this.width/2,
          y: this.height/2,
        }
      }
    })
    this.lottieLayer.add(konvaImageCanvas);
    
    
    
    setTimeout(() => {
      this.lottieLayer.zIndex(3);
    }, 1000);
    */
    var anim = new Konva.Animation(() => {}, this.lottieLayer);
    anim.start();
    
  }

  setFullscreen() {
    if (!this.fullscreen) {
      document
        .getElementById("playerPicasso")
        .requestFullscreen()
        .then(() => {
          this.fullscreen = true;
          this.setSizeFullscreen();
        });
    } else {
      new Promise((resolve) => {
        if (document.fullscreenElement) {
          document.exitFullscreen().then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      }).then(() => {
        this.fullscreen = false;
        this.setSize();
      });
    }
  }

  playPlayer() {
    if (this.currentMediaTime < this.lastCut.end) {
      
      this.videoList[this.index_currentVideo].play();
      this.startListener();
      this.paused = false;
      if (this.zoomTween != null) {
        this.zoomTween.play();
      }
    } else {
      this.seek(0);
      this.playPlayer();
    }
    this.playCurrentOverlay();
    this.resumeTextOverlays();
  }

  pausePlayer(markAsPause = true) {
    clearInterval(this.listener);
    //console.log("currentTime ", this.currentMediaTime);
    this.videoList[this.index_currentVideo].pause();
    //let canvas = document.querySelector("#" + this.containerId);
    //canvas.dispatchEvent(pauseEvent);
    this.emit("pause", this);
    if (markAsPause) {
      this.paused = true;
    }
    if (this.zoomTween != null) {
      this.zoomTween.pause();
    }

    this.pauseCurrentOverlay();
    this.resumeTextOverlays();
  }

  _retrieveCut(relativeTime = null, mediaTime = null, apply = true){
    let found = false;

    //Values found
    let _index_current_subClip;
    let _index_current_cut;
    let _currentMediaTime;

    this.subClips.forEach((subClip, idx_subClip) => {
      subClip.cuts.forEach((cut, idx_cut) => {
        if (found){
          return;
        }
        let itsHere = false;
        if (relativeTime != null){
          if (cut.start_relative <= relativeTime && relativeTime < cut.end_relative) {
            itsHere = true;
          }
        } else if (mediaTime != null){
          if (cut.start <= mediaTime && mediaTime < cut.end) {
            let offsetFromRelativeTime = mediaTime - cut.start;
            relativeTime = Math.floor((cut.start_relative + offsetFromRelativeTime));
            itsHere = true;
            
          }
        }

        if (itsHere == true){
          
          _index_current_subClip = idx_subClip;
          _index_current_cut = idx_cut;
          found = true;

        }
      });
    });
    if (found){

      if (apply == true){
        this.index_current_subClip = _index_current_subClip;
        this.index_current_cut = _index_current_cut;
        //this.currentBaliseVideo = _currentBaliseVideo;
        this.relativeTime = relativeTime;
      }
      _currentMediaTime = this.currentCut.start + (relativeTime - this.currentCut.start_relative);
      
      if (apply == true){
          this.currentMediaTime = _currentMediaTime;
      }
    }
    
    return { relativeTime, mediaTime : _currentMediaTime}
  }

  /**
  *  @param {Number} mediaTimeSeeked Give the real mediaTime to jump at time
  */
  seekRealTime(mediaTimeSeeked) {
    if (this.subClips[0].start > mediaTimeSeeked) {
      mediaTimeSeeked = this.subClips[0].start;
    }

    const { relativeTime } = this._retrieveCut(null, mediaTimeSeeked);
    this.seek(relativeTime);
  }

  /**
  *  @param {Number} relativeTime Give the relative time from the player progress bar to jump at time
  */
  async seek(relativeTime) {
    relativeTime = Number(relativeTime);

    if (!this.renderMode){
      this.pausePlayer(false);
    }

    let startTime = new Date();

    this._retrieveCut(relativeTime, null);

    if (!this.renderMode){

        if (this.videoList[this.index_currentVideo].getAttribute("seekTarget") == this.currentMediaTime / 1000); else {
          //this.videoList[this.index_currentVideo].currentTime = this.currentMediaTime / 1000;
          this.seekPlayer(this.index_currentVideo, this.currentMediaTime / 1000);
        }

        //PRE SEEK NEXT FRAMES
        if (this.puppeteerMode == true && this.nbVideoBalise > 1){
          
          for (let nextVideoBaliseIndex = 1; nextVideoBaliseIndex < this.nbVideoBalise; nextVideoBaliseIndex++){
            
            const mediaTime_nextFrame = this._retrieveCut(relativeTime + (nextVideoBaliseIndex*40), null, false).mediaTime;
            if (this.videoList[this.get_index_nextPlayerVideo(nextVideoBaliseIndex)].getAttribute("seekTarget") != mediaTime_nextFrame){
              this.seekPlayer(this.get_index_nextPlayerVideo(nextVideoBaliseIndex), mediaTime_nextFrame / 1000);
              //console.log(`Seeking player ${this.videoList[this.get_index_nextPlayerVideo(nextVideoBaliseIndex)].getAttribute("playerIndex")} to next frame : ${mediaTime_nextFrame / 1000}`)
            }
            /*
            const mediaTime_nextNextFrame = this._retrieveCut(relativeTime + 80, null, false).mediaTime;
            if (this.videoList[this.get_index_nextPlayerVideo(2)].getAttribute("seekTarget") != mediaTime_nextNextFrame){
              this.seekPlayer(this.get_index_nextPlayerVideo(2), mediaTime_nextNextFrame / 1000)
            }
  
            const mediaTime_nextFrame_3 = this._retrieveCut(relativeTime + 120, null, false).mediaTime;
            if (this.videoList[this.get_index_nextPlayerVideo(3)].getAttribute("seekTarget") != mediaTime_nextFrame_3){
              this.seekPlayer(this.get_index_nextPlayerVideo(3), mediaTime_nextFrame_3 / 1000)
            }
            */
          }

          
          

        } else if (this.nextCut != undefined) {
          this.videoList[this.index_nextVideo].currentTime = this.nextCut.start / 1000;
        }
      
      this.videoBackground.image(this.videoList[this.index_currentVideo]);

    }

   
    // REPLACE VIDEO SRC IN KONVA
    if (this.subClips[this.index_current_subClip].framing == "wide_shot") {
      this.uncrop();
      if (this.subClips[this.index_current_subClip].zoom) {
        this.zoom((this.subClips[this.index_current_subClip].end - this.subClips[this.index_current_subClip].start) /1000, (this.currentMediaTime - this.subClips[this.index_current_subClip].start) / 1000);
      } else if (this.zoomTween != null){
        this.zoomTween.destroy();
        this.zoomTween = null;
      }
    } else if (this.subClips[this.index_current_subClip].framing == "close_up") {
      this.crop();
    }


    startTime = new Date();
    this.checkCaptions();
    
    
    startTime = new Date();
    await this.checkOverlays(true);
    await this.seekTextOverlays(true);
    var overlayTiming = ((new Date()) - startTime).toFixed();
    this.timing_check_overlays.push(overlayTiming);
    
    
    startTime = new Date();

    if (!this.renderMode){
      //Wait for player time updates
      await this.waitForPlayerSeeking(this.index_currentVideo);
    }

    //await sleep(2000)


    var playerSeekingTime = ((new Date()) - startTime).toFixed();
    this.waitForPlayerTime.push(playerSeekingTime);

    //console.log(`TIMINGS REPORT :: Player seeking : ${playerSeekingTime}/${average(this.waitForPlayerTime)} | Checking overlay time : ${overlayTiming}/${average(this.timing_check_overlays)}`)
  

    if (!this.paused) {
      this.playPlayer();
    }

    //Change video player for next frame
    if (this.puppeteerMode == true){
      this.currentBaliseVideo = this.currentBaliseVideo + 1;
    }

    return relativeTime
  }

  startListener() {
    this.listener = setInterval(async () => {

      
      let cutChange = false;
      let cropChange = false;

      // TIMER
      // CROP & ZOOM
      let time = this.videoList[this.index_currentVideo].currentTime * 1000;
      if (time > this.lastCut.end) {
        time = this.lastCut.end;
      }

      this.currentMediaTime = time;


      //DEFINE IF CUTS CHANGE
      if (this.currentCut.end <= this.currentMediaTime && this.index_current_cut < this.subClips[this.index_current_subClip].cuts.length - 1 && this.nextCut != undefined ) {
        this.index_current_cut++;
        cutChange = true;
      } else if ( this.currentCut.end <= this.currentMediaTime && this.index_current_cut == this.subClips[this.index_current_subClip].cuts.length - 1 && this.nextCut != undefined ) {
        this.index_current_cut = 0;
        cutChange = true;
      }
      if ( this.subClips[this.index_current_subClip].end <= this.currentMediaTime && this.nextCut != undefined ) {
        this.index_current_subClip++;
        cutChange = true;
        cropChange = true;
      }

      // DO CUT
      if (cutChange) {
        this.check_cuts();
      }

      if (cropChange) {
        if (this.subClips[this.index_current_subClip].framing == "wide_shot") {
          this.uncrop();
          if (this.subClips[this.index_current_subClip].zoom) {
            this.zoom(
              (this.subClips[this.index_current_subClip].end -
                this.subClips[this.index_current_subClip].start) /
              1000
            );
          }
        } else if (this.subClips[this.index_current_subClip].framing == "close_up") {
          this.crop();
        }
      }


      const { relativeTime } = this._retrieveCut(null, this.currentMediaTime);
      if (relativeTime != null){
        this.relativeTime = relativeTime;
      }

      //SUBTITLE
      this.checkCaptions(this.currentMediaTime);

      //OVERLAYS
      this.checkOverlays();
      this.seekTextOverlays();

      // FINAL STOP
      if (this.currentMediaTime >= this.lastCut.end) {
        this.pausePlayer();
        this.seek(0);
      }

    }, 40);
  }

  check_cuts() {
    //CUTS
    this.pausePlayer(false);
    this.currentBaliseVideo++;
    this.videoList[this.index_previousVideo].pause();
    this.videoList[this.index_currentVideo].play();
    this.videoBackground.image(this.videoList[this.index_currentVideo]);
    if (this.nextCut != undefined) {
      this.videoList[this.index_nextVideo].currentTime = this.nextCut.start / 1000;
    }

    this.playPlayer();
  }

  zoom(duration, seekTime) {
    //let scale = 0.0015 * 25 * duration + 1;
    const scale = 0.0008 * 25 * duration + 1;

    this.zoomTween = new Konva.Tween({
      node: this.videoBackground,
      duration,
      scaleX: scale,
      scaleY: scale,
      onFinish: function () {
        //this.zoomTween.destroy();
        this.zoomTween = null;
      },
    });
    if (seekTime != undefined) {
      this.zoomTween.seek(seekTime);
    } else {
      this.zoomTween.play();
    }
  }

  crop() {
    if (this.zoomTween != null) {
      this.zoomTween.pause();
    }

    this.videoBackground.scale({
      x: CROP_SCALE,
      y: CROP_SCALE,
    });
  }

  uncrop() {
    this.videoBackground.setAttrs({
      y: this.videoY,
    });
    this.videoBackground.scale({
      x: 1,
      y: 1,
    });
  }
  

  destroy() {
    clearInterval(this.listener);
    if (!this.renderMode) {
      this.videoList.forEach((video) => {
        video.src = "";
        video.load();
        video.remove();

        //video.removeEventListener("waiting", this.handle_videoWaiting);
        //video.removeEventListener("playing", this.handle_videoPlaying);
        video.removeEventListener('timeupdate', this.handle_playerTimeUpdate);
      });
    }
    this.stage.destroyChildren();
    this.stage.clear();
    this.stage.destroy();
  }

  setReadyStatus(status){

    if (this.renderMode){
      return;
    }

    const container = document.getElementById(this.containerId);

    if (status == true){
      this.emit('ready', this);
      
      if (!container.classList.contains("ready")){
        container.classList.add("ready");
      }
    } else {
      container.classList.remove("ready");
    }
  }
}
const { renderFrame} = render;
Picasso.prototype.renderFrame = renderFrame;

const {loadKonvaImage, parseFontName} = utils;
Picasso.prototype.loadKonvaImage = loadKonvaImage;

const {initCaptions, createCaptionPage, checkCaptions, wordAnimations} = captions;
Picasso.prototype.initCaptions = initCaptions;
Picasso.prototype.createCaptionPage = createCaptionPage;
Picasso.prototype.checkCaptions = checkCaptions;

const overlays = overlays_assets;
Object.keys(overlays).forEach(fnName =>{
  Picasso.prototype[fnName] = overlays[fnName];
});

const overlaysText = overlays_texts;
Object.keys(overlaysText).forEach(fnName =>{
  Picasso.prototype[fnName] = overlaysText[fnName];
});

const mainVideoFunctions = mainVideo;
Object.keys(mainVideoFunctions).forEach(fnName =>{
  Picasso.prototype[fnName] = mainVideoFunctions[fnName];
});

if (typeof window !== 'undefined') {
  window.Picasso = Picasso;
  src.exports = Picasso;
} else {
  src.exports = Picasso;
}

var srcExports = src.exports;
var index = /*@__PURE__*/getDefaultExportFromCjs(srcExports);

export { index as default };
